(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@dutypay/store-modules"), require("@dutypay/utilities"), require("await-to-js"), require("element-plus"), require("lodash"), require("pinia"), require("vue-i18n"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["@dutypay/store-modules", "@dutypay/utilities", "await-to-js", "element-plus", "lodash", "pinia", "vue-i18n", ], factory);
	else if(typeof exports === 'object')
		exports["settings-pages"] = factory(require("@dutypay/store-modules"), require("@dutypay/utilities"), require("await-to-js"), require("element-plus"), require("lodash"), require("pinia"), require("vue-i18n"), require("vue"));
	else
		root["settings-pages"] = factory(root["@dutypay/store-modules"], root["@dutypay/utilities"], root["await-to-js"], root["element-plus"], root["lodash"], root["pinia"], root["vue-i18n"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__2706__, __WEBPACK_EXTERNAL_MODULE__3351__, __WEBPACK_EXTERNAL_MODULE__1169__, __WEBPACK_EXTERNAL_MODULE__5224__, __WEBPACK_EXTERNAL_MODULE__467__, __WEBPACK_EXTERNAL_MODULE__3085__, __WEBPACK_EXTERNAL_MODULE__1013__, __WEBPACK_EXTERNAL_MODULE__7203__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 7679:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ 9662:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var tryToString = __webpack_require__(6330);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 9483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isConstructor = __webpack_require__(4411);
var tryToString = __webpack_require__(6330);

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ 6077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 1223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);
var create = __webpack_require__(30);
var defineProperty = (__webpack_require__(3070).f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 1530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(8710).charAt);

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ 5787:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototypeOf = __webpack_require__(7976);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ 9670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(111);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 8533:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $forEach = (__webpack_require__(2092).forEach);
var arrayMethodIsStrict = __webpack_require__(2133);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es-x/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 8457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(9974);
var call = __webpack_require__(6916);
var toObject = __webpack_require__(7908);
var callWithSafeIterationClosing = __webpack_require__(3411);
var isArrayIteratorMethod = __webpack_require__(7659);
var isConstructor = __webpack_require__(4411);
var lengthOfArrayLike = __webpack_require__(6244);
var createProperty = __webpack_require__(6135);
var getIterator = __webpack_require__(4121);
var getIteratorMethod = __webpack_require__(1246);

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ 1318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(5656);
var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 2092:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var bind = __webpack_require__(9974);
var uncurryThis = __webpack_require__(1702);
var IndexedObject = __webpack_require__(8361);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var arraySpeciesCreate = __webpack_require__(5417);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 1194:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 2133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ 1589:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);
var createProperty = __webpack_require__(6135);

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ 206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis([].slice);


/***/ }),

/***/ 7475:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(3157);
var isConstructor = __webpack_require__(4411);
var isObject = __webpack_require__(111);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ 5417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__(7475);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 3411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(9670);
var iteratorClose = __webpack_require__(9212);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ 7072:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 4326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var isCallable = __webpack_require__(614);
var classofRaw = __webpack_require__(4326);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 9920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasOwn = __webpack_require__(2597);
var ownKeys = __webpack_require__(3887);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 8544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 8880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 9114:
/***/ (function(module) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 6135:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(4948);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 8052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var definePropertyModule = __webpack_require__(3070);
var makeBuiltIn = __webpack_require__(6339);
var defineGlobalProperty = __webpack_require__(3072);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 3072:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 9781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ 317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 7207:
/***/ (function(module) {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 8324:
/***/ (function(module) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 8509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(317);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 7871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var IS_DENO = __webpack_require__(3823);
var IS_NODE = __webpack_require__(5268);

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),

/***/ 3823:
/***/ (function(module) {

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),

/***/ 1528:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var userAgent = __webpack_require__(8113);
var global = __webpack_require__(7854);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;


/***/ }),

/***/ 6833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var userAgent = __webpack_require__(8113);

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ 5268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(4326);
var global = __webpack_require__(7854);

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ 1036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var userAgent = __webpack_require__(8113);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ 8113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ 7392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var userAgent = __webpack_require__(8113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 748:
/***/ (function(module) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 1060:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ 2914:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es-x/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ 2109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var createNonEnumerableProperty = __webpack_require__(8880);
var defineBuiltIn = __webpack_require__(8052);
var defineGlobalProperty = __webpack_require__(3072);
var copyConstructorProperties = __webpack_require__(9920);
var isForced = __webpack_require__(4705);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 7293:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 7007:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(4916);
var uncurryThis = __webpack_require__(1702);
var defineBuiltIn = __webpack_require__(8052);
var regexpExec = __webpack_require__(2261);
var fails = __webpack_require__(7293);
var wellKnownSymbol = __webpack_require__(5112);
var createNonEnumerableProperty = __webpack_require__(8880);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ 2104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es-x/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 9974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var aCallable = __webpack_require__(9662);
var NATIVE_BIND = __webpack_require__(4374);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 4374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);

module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 6916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(4374);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 6530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var hasOwn = __webpack_require__(2597);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 1702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var uncurryThis = NATIVE_BIND && bind.bind(call, call);

module.exports = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis(fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 5005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 1246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(648);
var getMethod = __webpack_require__(8173);
var isNullOrUndefined = __webpack_require__(8554);
var Iterators = __webpack_require__(7497);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 4121:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(6916);
var aCallable = __webpack_require__(9662);
var anObject = __webpack_require__(9670);
var tryToString = __webpack_require__(6330);
var getIteratorMethod = __webpack_require__(1246);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ 8173:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var aCallable = __webpack_require__(9662);
var isNullOrUndefined = __webpack_require__(8554);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 7854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();


/***/ }),

/***/ 2597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var toObject = __webpack_require__(7908);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 842:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ 490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);
var createElement = __webpack_require__(317);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ 8361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var classof = __webpack_require__(4326);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 9587:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var setPrototypeOf = __webpack_require__(7674);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 2788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var isCallable = __webpack_require__(614);
var store = __webpack_require__(5465);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 8340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(8880);

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ 9909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(4811);
var global = __webpack_require__(7854);
var uncurryThis = __webpack_require__(1702);
var isObject = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(8880);
var hasOwn = __webpack_require__(2597);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 7659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(7497);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 3157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(4326);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es-x/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ 614:
/***/ (function(module) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 4411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var classof = __webpack_require__(648);
var getBuiltIn = __webpack_require__(5005);
var inspectSource = __webpack_require__(2788);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 4705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 8554:
/***/ (function(module) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isCallable = __webpack_require__(614);

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var SPECIAL_DOCUMENT_ALL = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = SPECIAL_DOCUMENT_ALL ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 1913:
/***/ (function(module) {

module.exports = false;


/***/ }),

/***/ 7850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(111);
var classof = __webpack_require__(4326);
var wellKnownSymbol = __webpack_require__(5112);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ 2190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);
var isCallable = __webpack_require__(614);
var isPrototypeOf = __webpack_require__(7976);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var bind = __webpack_require__(9974);
var call = __webpack_require__(6916);
var anObject = __webpack_require__(9670);
var tryToString = __webpack_require__(6330);
var isArrayIteratorMethod = __webpack_require__(7659);
var lengthOfArrayLike = __webpack_require__(6244);
var isPrototypeOf = __webpack_require__(7976);
var getIterator = __webpack_require__(4121);
var getIteratorMethod = __webpack_require__(1246);
var iteratorClose = __webpack_require__(9212);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ 9212:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(6916);
var anObject = __webpack_require__(9670);
var getMethod = __webpack_require__(8173);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 3061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IteratorPrototype = (__webpack_require__(3383).IteratorPrototype);
var create = __webpack_require__(30);
var createPropertyDescriptor = __webpack_require__(9114);
var setToStringTag = __webpack_require__(8003);
var Iterators = __webpack_require__(7497);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 1656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var IS_PURE = __webpack_require__(1913);
var FunctionName = __webpack_require__(6530);
var isCallable = __webpack_require__(614);
var createIteratorConstructor = __webpack_require__(3061);
var getPrototypeOf = __webpack_require__(9518);
var setPrototypeOf = __webpack_require__(7674);
var setToStringTag = __webpack_require__(8003);
var createNonEnumerableProperty = __webpack_require__(8880);
var defineBuiltIn = __webpack_require__(8052);
var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(7497);
var IteratorsCore = __webpack_require__(3383);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ 3383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var create = __webpack_require__(30);
var getPrototypeOf = __webpack_require__(9518);
var defineBuiltIn = __webpack_require__(8052);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(1913);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es-x/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 7497:
/***/ (function(module) {

module.exports = {};


/***/ }),

/***/ 6244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toLength = __webpack_require__(7466);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 6339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var hasOwn = __webpack_require__(2597);
var DESCRIPTORS = __webpack_require__(9781);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(6530).CONFIGURABLE);
var inspectSource = __webpack_require__(2788);
var InternalStateModule = __webpack_require__(9909);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 4758:
/***/ (function(module) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 5948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var bind = __webpack_require__(9974);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var macrotask = (__webpack_require__(261).set);
var IS_IOS = __webpack_require__(6833);
var IS_IOS_PEBBLE = __webpack_require__(1528);
var IS_WEBOS_WEBKIT = __webpack_require__(1036);
var IS_NODE = __webpack_require__(5268);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ 8523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(9662);

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 6277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(1340);

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ 1574:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var uncurryThis = __webpack_require__(1702);
var call = __webpack_require__(6916);
var fails = __webpack_require__(7293);
var objectKeys = __webpack_require__(1956);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var propertyIsEnumerableModule = __webpack_require__(5296);
var toObject = __webpack_require__(7908);
var IndexedObject = __webpack_require__(8361);

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 30:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(9670);
var definePropertiesModule = __webpack_require__(6048);
var enumBugKeys = __webpack_require__(748);
var hiddenKeys = __webpack_require__(3501);
var html = __webpack_require__(490);
var documentCreateElement = __webpack_require__(317);
var sharedKey = __webpack_require__(6200);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 6048:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var definePropertyModule = __webpack_require__(3070);
var anObject = __webpack_require__(9670);
var toIndexedObject = __webpack_require__(5656);
var objectKeys = __webpack_require__(1956);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 3070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var IE8_DOM_DEFINE = __webpack_require__(4664);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var anObject = __webpack_require__(9670);
var toPropertyKey = __webpack_require__(4948);

var $TypeError = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 1236:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var call = __webpack_require__(6916);
var propertyIsEnumerableModule = __webpack_require__(5296);
var createPropertyDescriptor = __webpack_require__(9114);
var toIndexedObject = __webpack_require__(5656);
var toPropertyKey = __webpack_require__(4948);
var hasOwn = __webpack_require__(2597);
var IE8_DOM_DEFINE = __webpack_require__(4664);

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 1156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es-x/no-object-getownpropertynames -- safe */
var classof = __webpack_require__(4326);
var toIndexedObject = __webpack_require__(5656);
var $getOwnPropertyNames = (__webpack_require__(8006).f);
var arraySlice = __webpack_require__(1589);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 8006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 5181:
/***/ (function(__unused_webpack_module, exports) {

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 9518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasOwn = __webpack_require__(2597);
var isCallable = __webpack_require__(614);
var toObject = __webpack_require__(7908);
var sharedKey = __webpack_require__(6200);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(8544);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 7976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 6324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var hasOwn = __webpack_require__(2597);
var toIndexedObject = __webpack_require__(5656);
var indexOf = (__webpack_require__(1318).indexOf);
var hiddenKeys = __webpack_require__(3501);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 1956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 5296:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 7674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__(1702);
var anObject = __webpack_require__(9670);
var aPossiblePrototype = __webpack_require__(6077);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 288:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var classof = __webpack_require__(648);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 2140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(6916);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 3887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);
var uncurryThis = __webpack_require__(1702);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var anObject = __webpack_require__(9670);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);

module.exports = global;


/***/ }),

/***/ 2534:
/***/ (function(module) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ 3702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var NativePromiseConstructor = __webpack_require__(2492);
var isCallable = __webpack_require__(614);
var isForced = __webpack_require__(4705);
var inspectSource = __webpack_require__(2788);
var wellKnownSymbol = __webpack_require__(5112);
var IS_BROWSER = __webpack_require__(7871);
var IS_DENO = __webpack_require__(3823);
var IS_PURE = __webpack_require__(1913);
var V8_VERSION = __webpack_require__(7392);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);

module.exports = global.Promise;


/***/ }),

/***/ 9478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(9670);
var isObject = __webpack_require__(111);
var newPromiseCapability = __webpack_require__(8523);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 8368:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NativePromiseConstructor = __webpack_require__(2492);
var checkCorrectnessOfIteration = __webpack_require__(7072);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(3702).CONSTRUCTOR);

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ 2626:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = (__webpack_require__(3070).f);

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ 8572:
/***/ (function(module) {

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ 7651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(6916);
var anObject = __webpack_require__(9670);
var isCallable = __webpack_require__(614);
var classof = __webpack_require__(4326);
var regexpExec = __webpack_require__(2261);

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw $TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ 2261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__(6916);
var uncurryThis = __webpack_require__(1702);
var toString = __webpack_require__(1340);
var regexpFlags = __webpack_require__(7066);
var stickyHelpers = __webpack_require__(2999);
var shared = __webpack_require__(2309);
var create = __webpack_require__(30);
var getInternalState = (__webpack_require__(9909).get);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(7168);

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ 7066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9670);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 2999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ 9441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ 7168:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ 4488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__(8554);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 6340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var definePropertyModule = __webpack_require__(3070);
var wellKnownSymbol = __webpack_require__(5112);
var DESCRIPTORS = __webpack_require__(9781);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ 8003:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = (__webpack_require__(3070).f);
var hasOwn = __webpack_require__(2597);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 6200:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shared = __webpack_require__(2309);
var uid = __webpack_require__(9711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var defineGlobalProperty = __webpack_require__(3072);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 2309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var IS_PURE = __webpack_require__(1913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.25.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.25.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 6707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var anObject = __webpack_require__(9670);
var aConstructor = __webpack_require__(9483);
var isNullOrUndefined = __webpack_require__(8554);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ 8710:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);
var toIntegerOrInfinity = __webpack_require__(9303);
var toString = __webpack_require__(1340);
var requireObjectCoercible = __webpack_require__(4488);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 6293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(7293);

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 6532:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(6916);
var getBuiltIn = __webpack_require__(5005);
var wellKnownSymbol = __webpack_require__(5112);
var defineBuiltIn = __webpack_require__(8052);

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ 2015:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__(6293);

/* eslint-disable es-x/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ 261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var apply = __webpack_require__(2104);
var bind = __webpack_require__(9974);
var isCallable = __webpack_require__(614);
var hasOwn = __webpack_require__(2597);
var fails = __webpack_require__(7293);
var html = __webpack_require__(490);
var arraySlice = __webpack_require__(206);
var createElement = __webpack_require__(317);
var validateArgumentsLength = __webpack_require__(8053);
var IS_IOS = __webpack_require__(6833);
var IS_NODE = __webpack_require__(5268);

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ 1400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(9303);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 5656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(8361);
var requireObjectCoercible = __webpack_require__(4488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 9303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trunc = __webpack_require__(4758);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 7466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(9303);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 7908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(4488);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 7593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var call = __webpack_require__(6916);
var isObject = __webpack_require__(111);
var isSymbol = __webpack_require__(2190);
var getMethod = __webpack_require__(8173);
var ordinaryToPrimitive = __webpack_require__(2140);
var wellKnownSymbol = __webpack_require__(5112);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 4948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPrimitive = __webpack_require__(7593);
var isSymbol = __webpack_require__(2190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 1694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 1340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var classof = __webpack_require__(648);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 6330:
/***/ (function(module) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 9711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var uncurryThis = __webpack_require__(1702);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 3307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(6293);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 3353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ 8053:
/***/ (function(module) {

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 4811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 6800:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var path = __webpack_require__(857);
var hasOwn = __webpack_require__(2597);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineProperty = (__webpack_require__(3070).f);

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 6061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(5112);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 5112:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var shared = __webpack_require__(2309);
var hasOwn = __webpack_require__(2597);
var uid = __webpack_require__(9711);
var NATIVE_SYMBOL = __webpack_require__(6293);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 9191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var hasOwn = __webpack_require__(2597);
var createNonEnumerableProperty = __webpack_require__(8880);
var isPrototypeOf = __webpack_require__(7976);
var setPrototypeOf = __webpack_require__(7674);
var copyConstructorProperties = __webpack_require__(9920);
var proxyAccessor = __webpack_require__(2626);
var inheritIfRequired = __webpack_require__(9587);
var normalizeStringArgument = __webpack_require__(6277);
var installErrorCause = __webpack_require__(8340);
var clearErrorStack = __webpack_require__(1060);
var ERROR_STACK_INSTALLABLE = __webpack_require__(2914);
var DESCRIPTORS = __webpack_require__(9781);
var IS_PURE = __webpack_require__(1913);

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(result, 'stack', clearErrorStack(result.stack, 2));
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ 2222:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var fails = __webpack_require__(7293);
var isArray = __webpack_require__(3157);
var isObject = __webpack_require__(111);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var doesNotExceedSafeInteger = __webpack_require__(7207);
var createProperty = __webpack_require__(6135);
var arraySpeciesCreate = __webpack_require__(5417);
var arrayMethodHasSpeciesSupport = __webpack_require__(1194);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 7327:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var $filter = (__webpack_require__(2092).filter);
var arrayMethodHasSpeciesSupport = __webpack_require__(1194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 9826:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var $find = (__webpack_require__(2092).find);
var addToUnscopables = __webpack_require__(1223);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ 1038:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(2109);
var from = __webpack_require__(8457);
var checkCorrectnessOfIteration = __webpack_require__(7072);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es-x/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ 6992:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(5656);
var addToUnscopables = __webpack_require__(1223);
var Iterators = __webpack_require__(7497);
var InternalStateModule = __webpack_require__(9909);
var defineProperty = (__webpack_require__(3070).f);
var defineIterator = __webpack_require__(1656);
var IS_PURE = __webpack_require__(1913);
var DESCRIPTORS = __webpack_require__(9781);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ 9600:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var uncurryThis = __webpack_require__(1702);
var IndexedObject = __webpack_require__(8361);
var toIndexedObject = __webpack_require__(5656);
var arrayMethodIsStrict = __webpack_require__(2133);

var nativeJoin = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ 7042:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var isArray = __webpack_require__(3157);
var isConstructor = __webpack_require__(4411);
var isObject = __webpack_require__(111);
var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);
var toIndexedObject = __webpack_require__(5656);
var createProperty = __webpack_require__(6135);
var wellKnownSymbol = __webpack_require__(5112);
var arrayMethodHasSpeciesSupport = __webpack_require__(1194);
var nativeSlice = __webpack_require__(206);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ 1703:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var apply = __webpack_require__(2104);
var wrapErrorConstructorWithCause = __webpack_require__(9191);

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://github.com/tc39/proposal-error-cause
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ 8309:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(9781);
var FUNCTION_NAME_EXISTS = (__webpack_require__(6530).EXISTS);
var uncurryThis = __webpack_require__(1702);
var defineProperty = (__webpack_require__(3070).f);

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ 8862:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(2109);
var getBuiltIn = __webpack_require__(5005);
var apply = __webpack_require__(2104);
var call = __webpack_require__(6916);
var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var isArray = __webpack_require__(3157);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var isSymbol = __webpack_require__(2190);
var arraySlice = __webpack_require__(206);
var NATIVE_SYMBOL = __webpack_require__(6293);

var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')();
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = replacer;
  if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
  if (!isArray(replacer)) replacer = function (key, value) {
    if (isCallable($replacer)) value = call($replacer, this, key, value);
    if (!isSymbol(value)) return value;
  };
  args[1] = replacer;
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ 3706:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var setToStringTag = __webpack_require__(8003);

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 408:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var setToStringTag = __webpack_require__(8003);

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ 9601:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(2109);
var assign = __webpack_require__(1574);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ 5003:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(2109);
var fails = __webpack_require__(7293);
var toIndexedObject = __webpack_require__(5656);
var nativeGetOwnPropertyDescriptor = (__webpack_require__(1236).f);
var DESCRIPTORS = __webpack_require__(9781);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ 9337:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(2109);
var DESCRIPTORS = __webpack_require__(9781);
var ownKeys = __webpack_require__(3887);
var toIndexedObject = __webpack_require__(5656);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var createProperty = __webpack_require__(6135);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ 9660:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(2109);
var NATIVE_SYMBOL = __webpack_require__(6293);
var fails = __webpack_require__(7293);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var toObject = __webpack_require__(7908);

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ 489:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(2109);
var fails = __webpack_require__(7293);
var toObject = __webpack_require__(7908);
var nativeGetPrototypeOf = __webpack_require__(9518);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(8544);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ 7941:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(2109);
var toObject = __webpack_require__(7908);
var nativeKeys = __webpack_require__(1956);
var fails = __webpack_require__(7293);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 8304:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(2109);
var setPrototypeOf = __webpack_require__(7674);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ 1539:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var defineBuiltIn = __webpack_require__(8052);
var toString = __webpack_require__(288);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 821:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var aCallable = __webpack_require__(9662);
var newPromiseCapabilityModule = __webpack_require__(8523);
var perform = __webpack_require__(2534);
var iterate = __webpack_require__(612);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(8368);

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 4164:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var IS_PURE = __webpack_require__(1913);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(3702).CONSTRUCTOR);
var NativePromiseConstructor = __webpack_require__(2492);
var getBuiltIn = __webpack_require__(5005);
var isCallable = __webpack_require__(614);
var defineBuiltIn = __webpack_require__(8052);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ 3401:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var IS_PURE = __webpack_require__(1913);
var IS_NODE = __webpack_require__(5268);
var global = __webpack_require__(7854);
var call = __webpack_require__(6916);
var defineBuiltIn = __webpack_require__(8052);
var setPrototypeOf = __webpack_require__(7674);
var setToStringTag = __webpack_require__(8003);
var setSpecies = __webpack_require__(6340);
var aCallable = __webpack_require__(9662);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var anInstance = __webpack_require__(5787);
var speciesConstructor = __webpack_require__(6707);
var task = (__webpack_require__(261).set);
var microtask = __webpack_require__(5948);
var hostReportErrors = __webpack_require__(842);
var perform = __webpack_require__(2534);
var Queue = __webpack_require__(8572);
var InternalStateModule = __webpack_require__(9909);
var NativePromiseConstructor = __webpack_require__(2492);
var PromiseConstructorDetection = __webpack_require__(3702);
var newPromiseCapabilityModule = __webpack_require__(8523);

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ 8674:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(3401);
__webpack_require__(821);
__webpack_require__(4164);
__webpack_require__(6027);
__webpack_require__(683);
__webpack_require__(6294);


/***/ }),

/***/ 6027:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var aCallable = __webpack_require__(9662);
var newPromiseCapabilityModule = __webpack_require__(8523);
var perform = __webpack_require__(2534);
var iterate = __webpack_require__(612);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(8368);

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 683:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var newPromiseCapabilityModule = __webpack_require__(8523);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(3702).CONSTRUCTOR);

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});


/***/ }),

/***/ 6294:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var getBuiltIn = __webpack_require__(5005);
var IS_PURE = __webpack_require__(1913);
var NativePromiseConstructor = __webpack_require__(2492);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(3702).CONSTRUCTOR);
var promiseResolve = __webpack_require__(9478);

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ 4916:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var exec = __webpack_require__(2261);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ 7601:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(4916);
var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var isCallable = __webpack_require__(614);
var anObject = __webpack_require__(9670);
var toString = __webpack_require__(1340);

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject(this);
    var string = toString(S);
    var exec = R.exec;
    if (!isCallable(exec)) return call(nativeTest, R, string);
    var result = call(exec, R, string);
    if (result === null) return false;
    anObject(result);
    return true;
  }
});


/***/ }),

/***/ 8783:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(8710).charAt);
var toString = __webpack_require__(1340);
var InternalStateModule = __webpack_require__(9909);
var defineIterator = __webpack_require__(1656);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ 3123:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__(2104);
var call = __webpack_require__(6916);
var uncurryThis = __webpack_require__(1702);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(7007);
var anObject = __webpack_require__(9670);
var isNullOrUndefined = __webpack_require__(8554);
var isRegExp = __webpack_require__(7850);
var requireObjectCoercible = __webpack_require__(4488);
var speciesConstructor = __webpack_require__(6707);
var advanceStringIndex = __webpack_require__(1530);
var toLength = __webpack_require__(7466);
var toString = __webpack_require__(1340);
var getMethod = __webpack_require__(8173);
var arraySlice = __webpack_require__(1589);
var callRegExpExec = __webpack_require__(7651);
var regexpExec = __webpack_require__(2261);
var stickyHelpers = __webpack_require__(2999);
var fails = __webpack_require__(7293);

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ 2443:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(6800);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ 4032:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var call = __webpack_require__(6916);
var uncurryThis = __webpack_require__(1702);
var IS_PURE = __webpack_require__(1913);
var DESCRIPTORS = __webpack_require__(9781);
var NATIVE_SYMBOL = __webpack_require__(6293);
var fails = __webpack_require__(7293);
var hasOwn = __webpack_require__(2597);
var isPrototypeOf = __webpack_require__(7976);
var anObject = __webpack_require__(9670);
var toIndexedObject = __webpack_require__(5656);
var toPropertyKey = __webpack_require__(4948);
var $toString = __webpack_require__(1340);
var createPropertyDescriptor = __webpack_require__(9114);
var nativeObjectCreate = __webpack_require__(30);
var objectKeys = __webpack_require__(1956);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertyNamesExternal = __webpack_require__(1156);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var definePropertyModule = __webpack_require__(3070);
var definePropertiesModule = __webpack_require__(6048);
var propertyIsEnumerableModule = __webpack_require__(5296);
var defineBuiltIn = __webpack_require__(8052);
var shared = __webpack_require__(2309);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);
var uid = __webpack_require__(9711);
var wellKnownSymbol = __webpack_require__(5112);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineWellKnownSymbol = __webpack_require__(6800);
var defineSymbolToPrimitive = __webpack_require__(6532);
var setToStringTag = __webpack_require__(8003);
var InternalStateModule = __webpack_require__(9909);
var $forEach = (__webpack_require__(2092).forEach);

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 1817:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(2109);
var DESCRIPTORS = __webpack_require__(9781);
var global = __webpack_require__(7854);
var uncurryThis = __webpack_require__(1702);
var hasOwn = __webpack_require__(2597);
var isCallable = __webpack_require__(614);
var isPrototypeOf = __webpack_require__(7976);
var toString = __webpack_require__(1340);
var defineProperty = (__webpack_require__(3070).f);
var copyConstructorProperties = __webpack_require__(9920);

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ 763:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(2109);
var getBuiltIn = __webpack_require__(5005);
var hasOwn = __webpack_require__(2597);
var toString = __webpack_require__(1340);
var shared = __webpack_require__(2309);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(2015);

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ 2165:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(6800);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ 2526:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(4032);
__webpack_require__(763);
__webpack_require__(6620);
__webpack_require__(8862);
__webpack_require__(9660);


/***/ }),

/***/ 6620:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(2109);
var hasOwn = __webpack_require__(2597);
var isSymbol = __webpack_require__(2190);
var tryToString = __webpack_require__(6330);
var shared = __webpack_require__(2309);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(2015);

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ 9341:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(5005);
var defineWellKnownSymbol = __webpack_require__(6800);
var setToStringTag = __webpack_require__(8003);

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ }),

/***/ 4747:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var DOMIterables = __webpack_require__(8324);
var DOMTokenListPrototype = __webpack_require__(8509);
var forEach = __webpack_require__(8533);
var createNonEnumerableProperty = __webpack_require__(8880);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 3948:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var global = __webpack_require__(7854);
var DOMIterables = __webpack_require__(8324);
var DOMTokenListPrototype = __webpack_require__(8509);
var ArrayIteratorMethods = __webpack_require__(6992);
var createNonEnumerableProperty = __webpack_require__(8880);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ 8552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(1789),
    hashDelete = __webpack_require__(401),
    hashGet = __webpack_require__(7667),
    hashHas = __webpack_require__(1327),
    hashSet = __webpack_require__(1866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 8407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(7040),
    listCacheDelete = __webpack_require__(4125),
    listCacheGet = __webpack_require__(2117),
    listCacheHas = __webpack_require__(7518),
    listCacheSet = __webpack_require__(3399);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 7071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 3369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(4785),
    mapCacheDelete = __webpack_require__(1285),
    mapCacheGet = __webpack_require__(6000),
    mapCacheHas = __webpack_require__(9916),
    mapCacheSet = __webpack_require__(5265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 3818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 8525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 8668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3369),
    setCacheAdd = __webpack_require__(619),
    setCacheHas = __webpack_require__(2385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 6384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(8407),
    stackClear = __webpack_require__(7465),
    stackDelete = __webpack_require__(3779),
    stackGet = __webpack_require__(7599),
    stackHas = __webpack_require__(6783),
    stackSet = __webpack_require__(4309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 2705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(5639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 1149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(5639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852),
    root = __webpack_require__(5639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 7412:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 4963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 4636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(2545),
    isArguments = __webpack_require__(5694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(4144),
    isIndex = __webpack_require__(5776),
    isTypedArray = __webpack_require__(6719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 9932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 2488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 2908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 8470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(7813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 9881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(7816),
    createBaseEach = __webpack_require__(9291);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(9881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 1848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 8483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(5063);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 7816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(8483),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 7786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1811),
    toKey = __webpack_require__(327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 8866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(2488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 4239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705),
    getRawTag = __webpack_require__(9607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 13:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 2118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1848),
    baseIsNaN = __webpack_require__(2722),
    strictIndexOf = __webpack_require__(2351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isObjectLike = __webpack_require__(7005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1299),
    isObjectLike = __webpack_require__(7005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 1299:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(6384),
    equalArrays = __webpack_require__(7114),
    equalByTag = __webpack_require__(8351),
    equalObjects = __webpack_require__(6096),
    getTag = __webpack_require__(4160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(4144),
    isTypedArray = __webpack_require__(6719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 2958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(6384),
    baseIsEqual = __webpack_require__(939);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 2722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 8458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(3560),
    isMasked = __webpack_require__(5346),
    isObject = __webpack_require__(3218),
    toSource = __webpack_require__(346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 8749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isLength = __webpack_require__(1780),
    isObjectLike = __webpack_require__(7005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 7206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(1573),
    baseMatchesProperty = __webpack_require__(6432),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469),
    property = __webpack_require__(1733);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(5726),
    nativeKeys = __webpack_require__(9850);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 9199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(9881),
    isArrayLike = __webpack_require__(8612);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 1573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2958),
    getMatchData = __webpack_require__(1499),
    matchesStrictComparable = __webpack_require__(2634);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 6432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(939),
    get = __webpack_require__(7361),
    hasIn = __webpack_require__(9095),
    isKey = __webpack_require__(5403),
    isStrictComparable = __webpack_require__(9162),
    matchesStrictComparable = __webpack_require__(2634),
    toKey = __webpack_require__(327);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 371:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 9152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7786);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 2545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705),
    arrayMap = __webpack_require__(9932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(3448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 7561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(7990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 1717:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 4757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 4290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 1811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(5403),
    stringToPath = __webpack_require__(5514),
    toString = __webpack_require__(9833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 4429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(5639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 9291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(8612);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 5063:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 7114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(8668),
    arraySome = __webpack_require__(2908),
    cacheHas = __webpack_require__(4757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 8351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705),
    Uint8Array = __webpack_require__(1149),
    eq = __webpack_require__(7813),
    equalArrays = __webpack_require__(7114),
    mapToArray = __webpack_require__(8776),
    setToArray = __webpack_require__(1814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 6096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(8234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 1957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 8234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(8866),
    getSymbols = __webpack_require__(9551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 5050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(7019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 1499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(9162),
    keys = __webpack_require__(3674);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(8458),
    getValue = __webpack_require__(7801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 9607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 9551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(4963),
    stubArray = __webpack_require__(479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 4160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(8552),
    Map = __webpack_require__(7071),
    Promise = __webpack_require__(3818),
    Set = __webpack_require__(8525),
    WeakMap = __webpack_require__(577),
    baseGetTag = __webpack_require__(4239),
    toSource = __webpack_require__(346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 7801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(1811),
    isArguments = __webpack_require__(5694),
    isArray = __webpack_require__(1469),
    isIndex = __webpack_require__(5776),
    isLength = __webpack_require__(1780),
    toKey = __webpack_require__(327);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 1789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(4536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 7667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(4536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 1327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(4536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 1866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(4536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 5776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 5403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(3448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 7019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 5346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(4429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 5726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 9162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3218);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 7040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 4125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(8470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 2117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(8470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 7518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(8470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 3399:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(8470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 4785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(8407),
    Map = __webpack_require__(7071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 1285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(5050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 6000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(5050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 9916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(5050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 5265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(5050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 8776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 2634:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 4523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(8306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 4536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 9850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 1167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(1957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 5639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 2385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 1814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 7465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(8407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 3779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 7599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 6783:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 4309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(8407),
    Map = __webpack_require__(7071),
    MapCache = __webpack_require__(3369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 2351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 5514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(4523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(3448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 7990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 3279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(3218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(4841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 6073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(4486);


/***/ }),

/***/ 7813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 3105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(4963),
    baseFilter = __webpack_require__(760),
    baseIteratee = __webpack_require__(7206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 998:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1848),
    baseIteratee = __webpack_require__(7206),
    toInteger = __webpack_require__(554);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ 4486:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(7412),
    baseEach = __webpack_require__(9881),
    castFunction = __webpack_require__(4290),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 7361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(7786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 9095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(13),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 6557:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 3651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(2118),
    toInteger = __webpack_require__(554);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseIndexOf(array, value, index);
}

module.exports = indexOf;


/***/ }),

/***/ 5694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(7005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 8612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(3560),
    isLength = __webpack_require__(1780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 4144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(5639),
    stubFalse = __webpack_require__(5062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 1609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(280),
    getTag = __webpack_require__(4160),
    isArguments = __webpack_require__(5694),
    isArray = __webpack_require__(1469),
    isArrayLike = __webpack_require__(8612),
    isBuffer = __webpack_require__(4144),
    isPrototype = __webpack_require__(5726),
    isTypedArray = __webpack_require__(6719);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 3560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isObject = __webpack_require__(3218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 1780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 3218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 7005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 3448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(4239),
    isObjectLike = __webpack_require__(7005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 6719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(8749),
    baseUnary = __webpack_require__(1717),
    nodeUtil = __webpack_require__(1167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(4636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(8612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 5161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(9932),
    baseIteratee = __webpack_require__(7206),
    baseMap = __webpack_require__(9199),
    isArray = __webpack_require__(1469);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 8306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(3369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(5639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 1733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(371),
    basePropertyDeep = __webpack_require__(9152),
    isKey = __webpack_require__(5403),
    toKey = __webpack_require__(327);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 5062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 3493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var debounce = __webpack_require__(3279),
    isObject = __webpack_require__(3218);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),

/***/ 8601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(4841);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(8601);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 4841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(7561),
    isObject = __webpack_require__(3218),
    isSymbol = __webpack_require__(3448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 9833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 3744:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
// runtime helper for setting properties on components
// in a tree-shakable way
exports.Z = (sfc, props) => {
    const target = sfc.__vccOpts || sfc;
    for (const [key, val] of props) {
        target[key] = val;
    }
    return target;
};


/***/ }),

/***/ 2706:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__2706__;

/***/ }),

/***/ 3351:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3351__;

/***/ }),

/***/ 1169:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__1169__;

/***/ }),

/***/ 5224:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__5224__;

/***/ }),

/***/ 467:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__467__;

/***/ }),

/***/ 3085:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3085__;

/***/ }),

/***/ 1013:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__1013__;

/***/ }),

/***/ 7203:
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__7203__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ReminderEnterCompanyInformation": function() { return /* reexport */ reminder_ReminderEnterCompanyInformation; },
  "ReminderEnterUserName": function() { return /* reexport */ reminder_ReminderEnterUserName; },
  "ReminderSelectCompany": function() { return /* reexport */ reminder_ReminderSelectCompany; },
  "accountSettingsRoutes": function() { return /* reexport */ routes_accountSettingsRoutes; },
  "adminSettingsRoutes": function() { return /* reexport */ routes_adminSettingsRoutes; },
  "companySettingsRoutes": function() { return /* reexport */ routes_companySettingsRoutes; },
  "developerSettingsRoutes": function() { return /* reexport */ routes_developerSettingsRoutes; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__(7679)
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(9601);
// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__(7203);
// EXTERNAL MODULE: external "vue-i18n"
var external_vue_i18n_ = __webpack_require__(1013);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings.vue?vue&type=script&setup=true&lang=js


var __default__ = {
  name: 'AccountSettings'
};

/* harmony default export */ var AccountSettingsvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_router_view = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("router-view");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h1", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('accountSettings.title')), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_router_view)]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function AccountSettingsvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkontoeinstellungen"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkontoeinstellungen"])}
        }
      },
      "de-AT": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkontoeinstellungen"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkontoeinstellungen"])}
        }
      },
      "de-CH": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkontoeinstellungen"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkontoeinstellungen"])}
        }
      },
      "en-US": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User account settings"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User account settings"])}
        }
      },
      "en-GB": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User account settings"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User account settings"])}
        }
      },
      "it-IT": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni acconto utente"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni acconto utente"])}
        }
      },
      "fr-FR": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du compte utilisateur"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du compte utilisateur"])}
        }
      },
      "es-ES": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de la Cuenta de Usuario"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de la Cuenta de Usuario"])}
        }
      },
      "pl-PL": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia konta użytkownika"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia konta użytkownika"])}
        }
      },
      "nl-NL": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instellingen gebruikersaccount"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Instellingen gebruikersaccount"])}
        }
      },
      "bg-BG": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на потребителския акаунт"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на потребителския акаунт"])}
        }
      },
      "bs-BA": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke korisničkog računa"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke korisničkog računa"])}
        }
      },
      "zh-CN": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用户帐号设置"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用户帐号设置"])}
        }
      },
      "da-DK": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brugerkontoindstillinger"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brugerkontoindstillinger"])}
        }
      },
      "et-EE": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kasutajakonto Seaded"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kasutajakonto Seaded"])}
        }
      },
      "fi-FI": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käyttäjätilin Asetukset"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käyttäjätilin Asetukset"])}
        }
      },
      "el-GR": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις λογαριασμού χρήστη"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις λογαριασμού χρήστη"])}
        }
      },
      "he-IL": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות חשבון משתמש"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות חשבון משתמש"])}
        }
      },
      "ga-IE": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe cuntais úsáideora"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe cuntais úsáideora"])}
        }
      },
      "ja-JP": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザーアカウント設定"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザーアカウント設定"])}
        }
      },
      "hr-HR": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke korisničkog računa"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke korisničkog računa"])}
        }
      },
      "lv-LV": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lietotāja konta iestatījumi"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lietotāja konta iestatījumi"])}
        }
      },
      "lt-LT": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vartotojo paskyros nustatymai"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vartotojo paskyros nustatymai"])}
        }
      },
      "pt-PT": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Definições da conta de utilizador"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Definições da conta de utilizador"])}
        }
      },
      "ro-RO": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări cont de utilizator"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări cont de utilizator"])}
        }
      },
      "ru-RU": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки учетной записи пользователя"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки учетной записи пользователя"])}
        }
      },
      "sv-SE": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inställningar för användarkonto"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inställningar för användarkonto"])}
        }
      },
      "sk-SK": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia používateľského účtu"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia používateľského účtu"])}
        }
      },
      "cs-CZ": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení uživatelského účtu"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení uživatelského účtu"])}
        }
      },
      "tr-TR": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı Hesabı Ayarları"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı Hesabı Ayarları"])}
        }
      },
      "hu-HU": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Felhasználói fiók beállításai"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Felhasználói fiók beállításai"])}
        }
      },
      "ar-AE": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات حساب المستخدم"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات حساب المستخدم"])}
        }
      },
      "fr-BE": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du compte utilisateur"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du compte utilisateur"])}
        }
      },
      "fr-LU": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du compte utilisateur"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du compte utilisateur"])}
        }
      },
      "mt-MT": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tal-kont tal-utent"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tal-kont tal-utent"])}
        }
      },
      "sl-SI": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve uporabniškega računa"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve uporabniškega računa"])}
        }
      },
      "el-CY": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις λογαριασμού χρήστη"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις λογαριασμού χρήστη"])}
        }
      },
      "tr-CY": {
        "accountSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı Hesabı Ayarları"])},
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı Hesabı Ayarları"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings.vue


/* custom blocks */
;
if (typeof AccountSettingsvue_type_custom_index_0_blockType_i18n === 'function') AccountSettingsvue_type_custom_index_0_blockType_i18n(AccountSettingsvue_type_script_setup_true_lang_js)


const __exports__ = AccountSettingsvue_type_script_setup_true_lang_js;

/* harmony default export */ var AccountSettings = (__exports__);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(2526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(1817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(1539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(2165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(6992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(8783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(3948);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js







function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(7042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(8309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(1038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(4916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(7601);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js








function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(1703);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.async-iterator.js
var es_symbol_async_iterator = __webpack_require__(2443);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-string-tag.js
var es_symbol_to_string_tag = __webpack_require__(9341);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.to-string-tag.js
var es_json_to_string_tag = __webpack_require__(3706);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.to-string-tag.js
var es_math_to_string_tag = __webpack_require__(408);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(4747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(8304);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(8674);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js



















function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(7941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(7327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(5003);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(9337);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
// EXTERNAL MODULE: external "await-to-js"
var external_await_to_js_ = __webpack_require__(1169);
var external_await_to_js_default = /*#__PURE__*/__webpack_require__.n(external_await_to_js_);
// EXTERNAL MODULE: external "pinia"
var external_pinia_ = __webpack_require__(3085);
// EXTERNAL MODULE: external "@dutypay/store-modules"
var store_modules_ = __webpack_require__(2706);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/AccountInformation/DeleteAccountForm.vue?vue&type=script&setup=true&lang=js






var _hoisted_1 = ["innerHTML"];




var DeleteAccountFormvue_type_script_setup_true_lang_js_default_ = {
  name: "DeleteAccountForm",
  computed: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useAuthStore, ['user'])), (0,external_pinia_.mapState)(store_modules_.useEnvStore, ["apiUrls", "ssoUrl"])),
  methods: _objectSpread2(_objectSpread2(_objectSpread2({}, (0,external_pinia_.mapActions)(store_modules_.useAuthStore, ["logout"])), (0,external_pinia_.mapActions)(store_modules_.useEnvStore, ["setGlobalLoading"])), {}, {
    deleteAccount: function deleteAccount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var err, res, log, _yield$to, _yield$to2, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,external_await_to_js_.to)(_this.$http.post("".concat(_this.apiUrls.dutypay, "/api/v0/revoke-consent")));

              case 2:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];

                if (!err) {
                  _context.next = 8;
                  break;
                }

                throw err;

              case 8:
                _context.next = 10;
                return (0,external_await_to_js_.to)(_this.$http.post("".concat(_this.apiUrls.dutypay, "/api/v0/send/consent-revoked-mail"), _this.user));

              case 10:
                _yield$to3 = _context.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 2);
                err = _yield$to4[0];
                res = _yield$to4[1];

                if (!err) {
                  _context.next = 16;
                  break;
                }

                throw err;

              case 16:
                if (log) log(res);

                _this.setGlobalLoading();

                _context.next = 20;
                return _this.logout();

              case 20:
                return _context.abrupt("return", window.location.href = _this.ssoUrl + '/logout');

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  })
};

/* harmony default export */ var DeleteAccountFormvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(DeleteAccountFormvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_DpFormDeletionConfirmationUserInput = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFormDeletionConfirmationUserInput");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
        innerHTML: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('deleteAccount.textBlock.content')
      }, null, 8, _hoisted_1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpFormDeletionConfirmationUserInput, {
        action: _ctx.deleteAccount,
        reference: "delete-account-form",
        confirmationPhrase: _ctx.user.email,
        notificationError: {
          message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('input.notification.error.message'),
          title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('input.notification.error.title')
        },
        notificationAsyncError: {
          message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('input.notification.asyncError.message'),
          title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('input.notification.asyncError.title')
        },
        disableNotification: ['success'],
        deleteButtonLabel: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('deleteAccount.buttonLabel'),
        keepButtonLabel: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('keepAccount.buttonLabel')
      }, {
        instructions: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('instructions.label')), 1)];
        }),
        _: 1
      }, 8, ["action", "confirmationPhrase", "notificationError", "notificationAsyncError", "deleteButtonLabel", "keepButtonLabel"])]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/AccountInformation/DeleteAccountForm.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/AccountInformation/DeleteAccountForm.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DeleteAccountFormvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto löschen"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto löschen und Widerruf der Einwilligung zum Speichern der E-Mail-Adresse für dieses Benutzerkonto."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto verwenden"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehlender oder ungültiger Eintrag. Anweisung im Formular beachten."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zur Bestätigung die untenstehende E-Mail-Adresse im Eingabefeld eintragen."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto löschen und Widerruf der Einwilligung zum Speichern der E-Mail-Adresse für dieses Benutzerkonto."])}
        }
      },
      "de-AT": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto löschen"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto löschen und Widerruf der Einwilligung zum Speichern der E-Mail-Adresse für dieses Benutzerkonto."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto verwenden"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehlender oder ungültiger Eintrag. Anweisung im Formular beachten."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zur Bestätigung die untenstehende E-Mail-Adresse im Eingabefeld eintragen."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto löschen und Widerruf der Einwilligung zum Speichern der E-Mail-Adresse für dieses Benutzerkonto."])}
        }
      },
      "de-CH": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto löschen"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto löschen und Widerruf der Einwilligung zum Speichern der E-Mail-Adresse für dieses Benutzerkonto."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto verwenden"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehlender oder ungültiger Eintrag. Anweisung im Formular beachten."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zur Bestätigung die untenstehende E-Mail-Adresse im Eingabefeld eintragen."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto löschen und Widerruf der Einwilligung zum Speichern der E-Mail-Adresse für dieses Benutzerkonto."])}
        }
      },
      "en-US": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete user account"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete user account and revoke consent to save the e-mail address for this user account."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Use user account"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Missing or invalid entry. Follow the instructions in the form."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To confirm, enter the email address below in the input field."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete user account and revoke consent to save the e-mail address for this user account."])}
        }
      },
      "en-GB": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete user account"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete user account and revoke consent to save the e-mail address for this user account."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Use user account"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Missing or invalid entry. Follow the instructions in the form."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To confirm, enter the email address below in the input field."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete user account and revoke consent to save the e-mail address for this user account."])}
        }
      },
      "it-IT": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elimina account utente"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elimina l'account utente e revoca il consenso al salvataggio dell'indirizzo e-mail per questo account utente."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usa account utente"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voce mancante o non valida. Segui le istruzioni nel modulo."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Per confermare, inserisci l'indirizzo email sottostante nel campo di inserimento."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elimina l'account utente e revoca il consenso al salvataggio dell'indirizzo e-mail per questo account utente."])}
        }
      },
      "fr-FR": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer le compte utilisateur"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimez le compte d'utilisateur et révoquez le consentement pour enregistrer l'adresse e-mail de ce compte d'utilisateur."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utiliser le compte utilisateur"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrée manquante ou invalide. Suivez les instructions du formulaire"])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pour confirmer, entrez l'adresse e-mail ci-dessous dans le champ de saisie."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimez le compte d'utilisateur et révoquez le consentement pour enregistrer l'adresse e-mail de ce compte d'utilisateur."])}
        }
      },
      "es-ES": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar cuenta de usuario"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elimine la cuenta de usuario y revoque el consentimiento para guardar la dirección de correo electrónico de esta cuenta de usuario."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usar cuenta de usuario"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siga las instrucciones del formulario."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Para confirmar, ingrese la dirección de correo electrónico a continuación en el campo de entrada."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elimine la cuenta de usuario y revoque el consentimiento para guardar la dirección de correo electrónico de esta cuenta de usuario."])}
        }
      },
      "pl-PL": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuń konto użytkownika"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuń konto użytkownika i cofnij zgodę na zapisanie adresu e-mail dla tego konta użytkownika."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Użyj konta użytkownika"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brakujący lub nieprawidłowy wpis. Postępuj zgodnie z instrukcjami w formularzu."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aby potwierdzić, wprowadź adres e-mail poniżej w polu wejściowym."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuń konto użytkownika i cofnij zgodę na zapisanie adresu e-mail dla tego konta użytkownika."])}
        }
      },
      "nl-NL": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruikersaccount verwijderen"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruikersaccount verwijderen en toestemming intrekken om het e-mailadres voor dit gebruikersaccount op te slaan."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruik gebruikersaccount"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontbrekende of ongeldige invoer. Volg de instructies op het formulier."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Om te bevestigen vult u het onderstaande e-mailadres in het invoerveld in."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruikersaccount verwijderen en toestemming intrekken om het e-mailadres voor dit gebruikersaccount op te slaan."])}
        }
      },
      "bg-BG": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изтриване на потребителски акаунт"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изтрийте потребителски акаунт и отменете съгласието за запазване на имейл адреса за този потребителски акаунт."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Използвайте потребителски акаунт"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Липсващ или невалиден запис. Следвайте инструкциите във формуляра."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["За да потвърдите, въведете имейл адреса по-долу в полето за въвеждане."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изтрийте потребителски акаунт и отменете съгласието за запазване на имейл адреса за този потребителски акаунт."])}
        }
      },
      "bs-BA": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrišite korisnički nalog"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrišite korisnički nalog i opozovite saglasnost da sačuvate e-mail adresu za ovaj korisnički nalog."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koristite korisnički račun"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unos nedostaje ili je nevažeći. Slijedite upute u obrascu."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Za potvrdu unesite adresu e-pošte ispod u polje za unos."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrišite korisnički nalog i opozovite saglasnost da sačuvate e-mail adresu za ovaj korisnički nalog."])}
        }
      },
      "zh-CN": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除用户帐户"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除用户帐户并撤销同意保存此用户帐户的电子邮件地址。"])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用用户帐号"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["条目缺失或无效。请按窗体中的说明操作。"])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["要确认，请在输入字段中输入下面的电子邮件地址。"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除用户帐户并撤销同意保存此用户帐户的电子邮件地址。"])}
        }
      },
      "da-DK": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slet brugerkonto"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slet brugerkonto og tilbagekald samtykke til at gemme e-mailadressen for denne brugerkonto."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brug brugerkonto"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manglende eller ugyldig indtastning. Følg instruktionerne i formularen."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["For at bekræfte skal du indtaste e-mailadressen nedenfor i indtastningsfeltet."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slet brugerkonto og tilbagekald samtykke til at gemme e-mailadressen for denne brugerkonto."])}
        }
      },
      "et-EE": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kustuta kasutajakonto"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kustutage kasutajakonto ja tühistage nõusolek selle kasutajakonto e-posti aadressi salvestamiseks."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kasuta kasutajakontot"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puuduv või kehtetu sisestus. Järgige vormis olevaid juhiseid."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinnitamiseks sisestage allolevale sisestusväljale e-posti aadress."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kustutage kasutajakonto ja tühistage nõusolek selle kasutajakonto e-posti aadressi salvestamiseks."])}
        }
      },
      "fi-FI": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista käyttäjätili"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista käyttäjätili ja peruuta suostumus tämän käyttäjätilin sähköpostiosoitteen tallentamiseen."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käytä käyttäjätiliä"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puuttuva tai virheellinen merkintä. Noudata lomakkeen ohjeita."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vahvista kirjoittamalla alla oleva sähköpostiosoite syöttökenttään."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista käyttäjätili ja peruuta suostumus tämän käyttäjätilin sähköpostiosoitteen tallentamiseen."])}
        }
      },
      "el-GR": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγραφή λογαριασμού χρήστη"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγραφή λογαριασμού χρήστη και ανάκληση της συγκατάθεσης για αποθήκευση της διεύθυνσης ηλεκτρονικού ταχυδρομείου για αυτόν τον λογαριασμό χρήστη."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Χρήση λογαριασμού χρήστη"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λείπει ή δεν είναι έγκυρη η καταχώριση. Ακολουθήστε τις οδηγίες στη φόρμα."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Για επιβεβαίωση, εισαγάγετε τη διεύθυνση email παρακάτω στο πεδίο εισαγωγής."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγραφή λογαριασμού χρήστη και ανάκληση της συγκατάθεσης για αποθήκευση της διεύθυνσης ηλεκτρονικού ταχυδρομείου για αυτόν τον λογαριασμό χρήστη."])}
        }
      },
      "he-IL": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מחק חשבון משתמש"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מחק חשבון משתמש ובטל את ההסכמה לשמירת כתובת הדואר האלקטרוני של חשבון משתמש זה."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["השתמש בחשבון משתמש"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ערך חסר או לא חוקי. עקוב אחר ההוראות בטופס."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["כדי לאשר, הזן את כתובת הדוא＂ל למטה בשדה הקלט."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מחק חשבון משתמש ובטל את ההסכמה לשמירת כתובת הדואר האלקטרוני של חשבון משתמש זה."])}
        }
      },
      "ga-IE": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scrios cuntas úsáideora"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scrios cuntas úsáideora agus cúlghairm toiliú chun an seoladh r-phoist don chuntas úsáideora seo a shábháil."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úsáid cuntas úsáideora"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iontráil ar iarraidh nó neamhbhailí. Lean na treoracha san fhoirm."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chun a dhearbhú, iontráil an seoladh ríomhphoist thíos sa réimse ionchuir."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scrios cuntas úsáideora agus cúlghairm toiliú chun an seoladh r-phoist don chuntas úsáideora seo a shábháil."])}
        }
      },
      "ja-JP": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザーアカウントを削除する"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザーアカウントを削除し、同意を取り消して、このユーザーアカウントの電子メールアドレスを保存します。"])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザーアカウントを使用する"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エントリがないか無効です。 フォームの指示に従ってください。"])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認するには、以下のメールアドレスを入力フィールドに入力してください。"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザーアカウントを削除し、同意を取り消して、このユーザーアカウントの電子メールアドレスを保存します。"])}
        }
      },
      "hr-HR": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrišite korisnički račun"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrišite korisnički račun i opozovite pristanak za spremanje e-mail adrese za ovaj korisnički račun."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koristite korisnički račun"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unos nedostaje ili je nevažeći. Slijedite upute u obrascu."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Za potvrdu unesite adresu e-pošte ispod u polje za unos."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrišite korisnički račun i opozovite pristanak za spremanje e-mail adrese za ovaj korisnički račun."])}
        }
      },
      "lv-LV": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dzēst lietotāja kontu"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dzēst lietotāja kontu un atsaukt piekrišanu saglabāt šī lietotāja konta e-pasta adresi."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izmantojiet lietotāja kontu"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trūkstošs vai nederīgs ieraksts. Izpildiet veidlapā sniegtos norādījumus."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lai apstiprinātu, ievadiet tālāk norādīto e-pasta adresi ievades laukā."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dzēst lietotāja kontu un atsaukt piekrišanu saglabāt šī lietotāja konta e-pasta adresi."])}
        }
      },
      "lt-LT": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ištrinti vartotojo abonementą"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ištrinti vartotojo abonementą ir atšaukti sutikimą išsaugoti šios vartotojo paskyros el. pašto adresą."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naudokite vartotojo abonementą"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trūksta arba neteisingas įrašas. Vykdykite instrukcijas formoje."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Norėdami patvirtinti, toliau esančiame laukelyje įveskite el. pašto adresą."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ištrinti vartotojo abonementą ir atšaukti sutikimą išsaugoti šios vartotojo paskyros el. pašto adresą."])}
        }
      },
      "pt-PT": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excluir conta de usuário"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exclua a conta do usuário e revogue o consentimento para salvar o endereço de e-mail para esta conta do usuário."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usar conta de usuário"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrada ausente ou inválida. Siga as instruções do formulário."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Para confirmar, insira o endereço de e-mail abaixo no campo de entrada."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exclua a conta do usuário e revogue o consentimento para salvar o endereço de e-mail para esta conta do usuário."])}
        }
      },
      "ro-RO": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ștergeți contul de utilizator"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ștergeți contul de utilizator și revocați consimțământul pentru a salva adresa de e-mail pentru acest cont de utilizator."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilizați contul de utilizator"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valori lipsă sau incorecte. Urmați instrucțiunile din formular."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pentru a confirma, introduceți adresa de e-mail de mai jos în câmpul de introducere."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ștergeți contul de utilizator și revocați consimțământul pentru a salva adresa de e-mail pentru acest cont de utilizator."])}
        }
      },
      "ru-RU": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Удалить учетную запись пользователя"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Удалить учетную запись пользователя и отозвать согласие на сохранение адреса электронной почты для этой учетной записи."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Использовать учетную запись пользователя"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Данные отсутствуют или недействительны. Следуйте инструкциям в форме."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Для подтверждения введите адрес электронной почты ниже в поле ввода."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Удалить учетную запись пользователя и отозвать согласие на сохранение адреса электронной почты для этой учетной записи."])}
        }
      },
      "sv-SE": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ta bort användarkonto"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ta bort användarkonto och återkalla samtycke för att spara e-postadressen för detta användarkonto."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Använd användarkonto"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saknad eller felaktig inmatning. Följ instruktionerna i formuläret."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["För att bekräfta, ange e-postadressen nedan i inmatningsfältet."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ta bort användarkonto och återkalla samtycke för att spara e-postadressen för detta användarkonto."])}
        }
      },
      "sk-SK": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odstrániť používateľský účet"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odstrániť používateľský účet a odvolať súhlas s uložením e-mailovej adresy pre tento používateľský účet."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Použiť používateľský účet"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chýbajúci alebo neplatný záznam. Postupujte podľa pokynov vo formulári."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pre potvrdenie zadajte e-mailovú adresu nižšie do vstupného poľa."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odstrániť používateľský účet a odvolať súhlas s uložením e-mailovej adresy pre tento používateľský účet."])}
        }
      },
      "cs-CZ": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Smazat uživatelský účet"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Smazat uživatelský účet a odvolat souhlas s uložením e-mailové adresy pro tento uživatelský účet."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Použít uživatelský účet"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chybějící nebo neplatný záznam. Postupujte podle pokynů ve formuláři."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pro potvrzení zadejte e-mailovou adresu níže do vstupního pole."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Smazat uživatelský účet a odvolat souhlas s uložením e-mailové adresy pro tento uživatelský účet."])}
        }
      },
      "tr-TR": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı hesabını sil"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı hesabını silin ve bu kullanıcı hesabının e-posta adresini kaydetme iznini iptal edin."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı hesabını kullan"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eksik veya geçersiz giriş. Formdaki talimatları izleyin."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onaylamak için aşağıdaki giriş alanına e-posta adresini girin."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı hesabını silin ve bu kullanıcı hesabının e-posta adresini kaydetme iznini iptal edin."])}
        }
      },
      "hu-HU": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Felhasználói fiók törlése"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Törölje a felhasználói fiókot, és vonja vissza a hozzájárulást a felhasználói fiók e-mail címének mentéséhez."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Felhasználói fiók használata"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiányzó vagy érvénytelen bejegyzés. Kövesse az űrlapon található utasításokat."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A megerősítéshez írja be az alábbi e-mail címet a beviteli mezőbe."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Törölje a felhasználói fiókot, és vonja vissza a hozzájárulást a felhasználói fiók e-mail címének mentéséhez."])}
        }
      },
      "ar-AE": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حذف حساب المستخدم"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["احذف حساب المستخدم وألغي الموافقة لحفظ عنوان البريد الإلكتروني لحساب المستخدم هذا."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["استخدم حساب المستخدم"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إدخال مفقود أو غير صالح. اتبع التعليمات الواردة في النموذج."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["للتأكيد ، أدخل عنوان البريد الإلكتروني أدناه في حقل الإدخال."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["احذف حساب المستخدم وألغي الموافقة لحفظ عنوان البريد الإلكتروني لحساب المستخدم هذا."])}
        }
      },
      "fr-BE": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer le compte utilisateur"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimez le compte d'utilisateur et révoquez le consentement pour enregistrer l'adresse e-mail de ce compte d'utilisateur."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utiliser le compte utilisateur"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrée manquante ou invalide. Suivez les instructions du formulaire."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pour confirmer, entrez l'adresse e-mail ci-dessous dans le champ de saisie."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimez le compte d'utilisateur et révoquez le consentement pour enregistrer l'adresse e-mail de ce compte d'utilisateur."])}
        }
      },
      "fr-LU": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer le compte utilisateur"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimez le compte d'utilisateur et révoquez le consentement pour enregistrer l'adresse e-mail de ce compte d'utilisateur."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utiliser le compte utilisateur"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrée manquante ou invalide. Suivez les instructions du formulaire."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pour confirmer, entrez l'adresse e-mail ci-dessous dans le champ de saisie."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimez le compte d'utilisateur et révoquez le consentement pour enregistrer l'adresse e-mail de ce compte d'utilisateur."])}
        }
      },
      "mt-MT": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ħassar kont tal-utent"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ħassar kont tal-utent u irrevoka l-kunsens biex issalva l-indirizz tal-email għal dan il-kont tal-utent."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uża kont tal-utent"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dħul nieqes jew invalidu. Segwi l-istruzzjonijiet fil-formolae."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biex tikkonferma, daħħal l-indirizz tal-email hawn taħt fil-qasam tal-input."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ħassar kont tal-utent u irrevoka l-kunsens biex issalva l-indirizz tal-email għal dan il-kont tal-utent."])}
        }
      },
      "sl-SI": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbriši uporabniški račun"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrišite uporabniški račun in prekličite soglasje za shranjevanje e-poštnega naslova za ta uporabniški račun."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uporabi uporabniški račun"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnos manjka ali ni veljaven. Upoštevajte navodila v obrazcu."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Za potrditev vnesite spodnji e-poštni naslov v vnosno polje."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrišite uporabniški račun in prekličite soglasje za shranjevanje e-poštnega naslova za ta uporabniški račun."])}
        }
      },
      "el-CY": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγραφή λογαριασμού χρήστη"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγραφή λογαριασμού χρήστη και ανάκληση της συγκατάθεσης για αποθήκευση της διεύθυνσης ηλεκτρονικού ταχυδρομείου για αυτόν τον λογαριασμό χρήστη."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Χρήση λογαριασμού χρήστη"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λείπει ή δεν είναι έγκυρη η καταχώριση. Ακολουθήστε τις οδηγίες στη φόρμα."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Για επιβεβαίωση, εισαγάγετε τη διεύθυνση email παρακάτω στο πεδίο εισαγωγής."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγραφή λογαριασμού χρήστη και ανάκληση της συγκατάθεσης για αποθήκευση της διεύθυνσης ηλεκτρονικού ταχυδρομείου για αυτόν τον λογαριασμό χρήστη."])}
        }
      },
      "tr-CY": {
        "deleteAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı hesabını sil"])},
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı hesabını silin ve bu kullanıcı hesabının e-posta adresini kaydetme iznini iptal edin."])}
          }
        },
        "keepAccount": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı hesabını kullan"])}
        },
        "input": {
          "notification": {
            "error": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eksik veya geçersiz giriş. Formdaki talimatları izleyin."])}
            }
          }
        },
        "instructions": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onaylamak için aşağıdaki giriş alanına e-posta adresini girin."])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı hesabını silin ve bu kullanıcı hesabının e-posta adresini kaydetme iznini iptal edin."])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/AccountInformation/DeleteAccountForm.vue


/* custom blocks */
;
if (typeof DeleteAccountFormvue_type_custom_index_0_blockType_i18n === 'function') DeleteAccountFormvue_type_custom_index_0_blockType_i18n(DeleteAccountFormvue_type_script_setup_true_lang_js)


const DeleteAccountForm_exports_ = DeleteAccountFormvue_type_script_setup_true_lang_js;

/* harmony default export */ var DeleteAccountForm = (DeleteAccountForm_exports_);
// EXTERNAL MODULE: external "@dutypay/utilities"
var utilities_ = __webpack_require__(3351);
// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(467);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/AccountInformation.vue?vue&type=script&setup=true&lang=js





var AccountInformationvue_type_script_setup_true_lang_js_default_ = {
  name: "AccountInformation"
};







/* harmony default export */ var AccountInformationvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(AccountInformationvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables');

    var _composables$useViewp = composables.useViewportSize(),
        isMobile = _composables$useViewp.isMobile;

    var envStore = (0,store_modules_.useEnvStore)();

    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    var _useI18n2 = (0,external_vue_i18n_.useI18n)({
      useScope: 'global'
    }),
        locale = _useI18n2.locale;

    var loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    var userData = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)({});

    function getUserMasterData() {
      return _getUserMasterData.apply(this, arguments);
    }

    function _getUserMasterData() {
      _getUserMasterData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var error, response, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loading.value = true;
                _context2.next = 3;
                return (0,external_await_to_js_.to)(utilities_.interceptor.get("".concat(envStore.apiUrls.dutypay, "/api/v0/me")));

              case 3:
                _yield$to = _context2.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                error = _yield$to2[0];
                response = _yield$to2[1];

                if (!error) {
                  _context2.next = 9;
                  break;
                }

                throw error;

              case 9:
                userData.value = response.data;
                loading.value = false;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getUserMasterData.apply(this, arguments);
    }

    var userName = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return (0,external_lodash_.get)(userData.value, "master.data.".concat(locale.value, ".name"), {});
    });
    var userEmail = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return {
        email: (0,external_lodash_.get)(userData.value, 'email', '')
      };
    });
    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getUserMasterData();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      var _component_DpSimpleCrud = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpSimpleCrud");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('accountInformation.title')), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpSimpleCrud, {
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.label'),
        "screen-size-is-mobile": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile),
        modelValue: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(userName),
        "key-map": {
          given: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.given.label'),
          family: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.family.label')
        },
        "read-only": ""
      }, null, 8, ["headline", "screen-size-is-mobile", "modelValue", "key-map"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpSimpleCrud, {
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('emailAddresses.label'),
        "screen-size-is-mobile": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile),
        modelValue: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(userEmail),
        "key-map": {
          email: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('emailAddresses.primaryEmailAddress.label')
        },
        "read-only": ""
      }, null, 8, ["headline", "screen-size-is-mobile", "modelValue", "key-map"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(envStore).appEnv === 'demo' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpSimpleCrud, {
        key: 0,
        modelValue: {},
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('deleteAccount.label'),
        "screen-size-is-mobile": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile),
        "read-only": ""
      }, {
        read: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(DeleteAccountForm))];
        }),
        _: 1
      }, 8, ["headline", "screen-size-is-mobile"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])), [[_directive_loading, loading.value]]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/AccountInformation.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/AccountInformation.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function AccountInformationvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familienname"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorname"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Namen"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primäre E-Mail-Adresse"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto löschen"])}
        }
      },
      "de-AT": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familienname"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorname"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Namen"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primäre E-Mail-Adresse"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto löschen"])}
        }
      },
      "de-CH": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familienname"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorname"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Namen"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primäre E-Mail-Adresse"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerkonto löschen"])}
        }
      },
      "en-US": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Family name"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Given name"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Names"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telephone"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobile Number"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primary e-mail address"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete user account"])}
        }
      },
      "en-GB": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Family name"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Given name"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Names"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telephone"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobile Number"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primary e-mail address"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete user account"])}
        }
      },
      "it-IT": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cognome"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome di battesimo"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nomi"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefono"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numero di telefono"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indirizzo e-mail principale"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elimina account utente"])}
        }
      },
      "fr-FR": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Des noms"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Téléphoner"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de téléphone mobile"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail principale"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renseignements personnels"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer le compte utilisateur"])}
        }
      },
      "es-ES": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apellido"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre propio"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombres"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teléfono"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de teléfono"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dirección de correo principal"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Correo electrónico"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar cuenta de usuario"])}
        }
      },
      "pl-PL": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwisko rodowe"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Imię"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwy"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numer telefonu komórkowego"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podstawowy adres e-mail"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuń konto użytkownika"])}
        }
      },
      "nl-NL": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Achternaam"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voornaam"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Namen"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefoon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiel nummer"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primaire email adres"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruikersaccount verwijderen"])}
        }
      },
      "bg-BG": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фамилно име"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Първо име"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имена"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Телефон"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мобилен номер"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Основен имейл адрес"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имейл"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изтриване на потребителски акаунт"])}
        }
      },
      "bs-BA": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prezime"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ime"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Imena"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj mobitela"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primarna adresa e-pošte"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pošta"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrišite korisnički nalog"])}
        }
      },
      "zh-CN": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["姓"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["姓名"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电话"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手机号码"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["主要电子邮件地址"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子邮件"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["个人信息"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除用户帐户"])}
        }
      },
      "da-DK": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familie navn"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fornavn"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Navne"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primær e-mail-adresse"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slet brugerkonto"])}
        }
      },
      "et-EE": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Perekonnanimi"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eesnimi"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nimed"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiili number"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Peamine e-posti aadress"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-post"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kustuta kasutajakonto"])}
        }
      },
      "fi-FI": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sukunimi"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etunimi"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nimet"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Puhelin"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Matkapuhelinnumero"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ensisijainen sähköpostiosoite"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sähköposti"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista käyttäjätili"])}
        }
      },
      "el-GR": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οικογενειακό όνομα"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ονομα"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ονόματα"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Τηλέφωνο"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αριθμός κινητού"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κύρια διεύθυνση email"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγραφή λογαριασμού χρήστη"])}
        }
      },
      "he-IL": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם משפחה"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם פרטי"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שמות"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["טֵלֵפוֹן"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מספר טלפון נייד"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["כתובת דוא＂ל ראשית"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אימייל"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מחק חשבון משתמש"])}
        }
      },
      "ga-IE": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ainm clainne"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ainm"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ainmneacha"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fón"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uimhir fóin póca"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seoladh ríomhphoist bunscoile"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ríomhphost"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eolas pearsanta"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scrios cuntas úsáideora"])}
        }
      },
      "ja-JP": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["苗字"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ファーストネーム"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名前"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["電話"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["携帯電話番号"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["プライマリメールアドレス"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eメール"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザーアカウントを削除する"])}
        }
      },
      "hr-HR": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prezime"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ime"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Imena"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj mobitela"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primarna adresa e-pošte"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pošta"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrišite korisnički račun"])}
        }
      },
      "lv-LV": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uzvārds"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vārds"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vārdi"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tālrunis"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilā tālruņa numurs"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Galvenā e-pasta adrese"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pasts"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dzēst lietotāja kontu"])}
        }
      },
      "lt-LT": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pavardė"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pirmas vardas"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vardai"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefonas"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiliojo telefono numeris"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagrindinis el. Pašto adresas"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El. paštas"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ištrinti vartotojo abonementą"])}
        }
      },
      "pt-PT": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sobrenome"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primeiro nome"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nomes"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefone"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de telemóvel"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Endereço de email primário"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excluir conta de usuário"])}
        }
      },
      "ro-RO": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nume de familie"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nume"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numele"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Număr de telefon mobil"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresa principala de email"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ștergeți contul de utilizator"])}
        }
      },
      "ru-RU": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фамилия"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имена"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Телефон"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер мобильного телефона"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Основной адрес электронной почты"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Эл. почта"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Персональные данные"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Удалить учетную запись пользователя"])}
        }
      },
      "sv-SE": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Efternamn"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Förnamn"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Namn"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primär e-postadress"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-post"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ta bort användarkonto"])}
        }
      },
      "sk-SK": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Priezvisko"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Krstné meno"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mená"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefón"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilné číslo"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primárna e-mailová adresa"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odstrániť používateľský účet"])}
        }
      },
      "cs-CZ": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rodinné jméno"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jméno"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jména"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Číslo mobilního telefonu"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primární e-mailová adresa"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailem"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Smazat uživatelský účet"])}
        }
      },
      "tr-TR": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soyadı"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İsim"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İsimler"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cep numarası"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Birincil e-posta adresi"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı hesabını sil"])}
        }
      },
      "hu-HU": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Családnév"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keresztnév"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nevek"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobil szám"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elsődleges e-mail cím"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Felhasználói fiók törlése"])}
        }
      },
      "ar-AE": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اسم العائلة"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الاسم الأول"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الأسماء"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["هاتف"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف المحمول"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان البريد الإلكتروني الرئيسي"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["البريد الإلكتروني"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حذف حساب المستخدم"])}
        }
      },
      "fr-BE": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Des noms"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Téléphoner"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de téléphone mobile"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail principale"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renseignements personnels"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer le compte utilisateur"])}
        }
      },
      "fr-LU": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Des noms"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Téléphoner"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de téléphone mobile"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail principale"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Renseignements personnels"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Supprimer le compte utilisateur"])}
        }
      },
      "mt-MT": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isem tal-familja"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isem"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ismijiet"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In-numru tal-Mowbajl"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indirizz tal-email primarju"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ħassar kont tal-utent"])}
        }
      },
      "sl-SI": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Priimek"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ime"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Imena"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefonska številka"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primarni e-poštni naslov"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pošta"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbriši uporabniški račun"])}
        }
      },
      "el-CY": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οικογενειακό όνομα"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ονομα"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ονόματα"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Τηλέφωνο"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αριθμός κινητού"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κύρια διεύθυνση email"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγραφή λογαριασμού χρήστη"])}
        }
      },
      "tr-CY": {
        "userName": {
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soyadı"])}
          },
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İsim"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İsimler"])}
        },
        "phoneNumbers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
          "mobileNumber": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cep numarası"])}
          }
        },
        "emailAddresses": {
          "primaryEmailAddress": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Birincil e-posta adresi"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta"])}
        },
        "accountInformation": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Persönliche Informationen"])}
        },
        "deleteAccount": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı hesabını sil"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/AccountInformation.vue


/* custom blocks */
;
if (typeof AccountInformationvue_type_custom_index_0_blockType_i18n === 'function') AccountInformationvue_type_custom_index_0_blockType_i18n(AccountInformationvue_type_script_setup_true_lang_js)


const AccountInformation_exports_ = AccountInformationvue_type_script_setup_true_lang_js;

/* harmony default export */ var AccountInformation = (AccountInformation_exports_);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var lodash_get = __webpack_require__(7361);
var get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateAuthenticatorAppForm.vue?vue&type=script&setup=true&lang=js







var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-92fa93b0"), n = n(), _popScopeId(), n;
};

var ActivateAuthenticatorAppFormvue_type_script_setup_true_lang_js_hoisted_1 = ["src"];
var _hoisted_2 = {
  style: {
    "margin": "1em auto",
    "width": "228px"
  }
};
var _hoisted_3 = {
  class: "monospace authenticator-setup-code"
};




var ActivateAuthenticatorAppFormvue_type_script_setup_true_lang_js_default_ = {
  name: "ActivateAuthenticatorAppForm",
  data: function data() {
    return {
      form: {
        mode: 'authenticator',
        totp: ''
      },
      loading: false,
      errorLoadingQrCode: false,
      secretQrCode: '',
      secretText: ''
    };
  },
  computed: _objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ['apiUrls'])),
  methods: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapActions)(store_modules_.useAuthStore, ['validate'])), {}, {
    resetFields: function resetFields() {
      this.form.totp = '';
    },
    fetchSecret: function fetchSecret() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var err, qrCode, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.errorLoadingQrCode = false;
                _this.loading = true;
                _context.next = 4;
                return external_await_to_js_default()(_this.$http.post("".concat(_this.apiUrls.dutypay, "/api/v0/generate/secret")));

              case 4:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                qrCode = _yield$to2[1];
                _this.loading = false;

                if (!err) {
                  _context.next = 12;
                  break;
                }

                _this.errorLoadingQrCode = true;
                throw err;

              case 12:
                _this.secretQrCode = qrCode.data.qr;
                _this.secretText = qrCode.data.plaintext;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    activateAuthenticator: function activateAuthenticator() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var err, res, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return external_await_to_js_default()(_this2.$http.post("".concat(_this2.apiUrls.dutypay, "/api/v0/activate/authenticator"), _objectSpread2({}, _this2.form)));

              case 3:
                _yield$to3 = _context2.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 2);
                err = _yield$to4[0];
                res = _yield$to4[1];

                if (!err) {
                  _context2.next = 10;
                  break;
                }

                _this2.loading = false;
                throw err;

              case 10:
                _context2.next = 12;
                return _this2.cancelForm();

              case 12:
                _this2.resetFields();

                _context2.next = 15;
                return _this2.validate({});

              case 15:
                _this2.loading = false;
                return _context2.abrupt("return", res);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    cancelForm: function cancelForm() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$emit('cancel-form');

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.fetchSecret();

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};

/* harmony default export */ var ActivateAuthenticatorAppFormvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(ActivateAuthenticatorAppFormvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_DpCopyToClipboard = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCopyToClipboard");

      var _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_DpNotificationPersist = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpNotificationPersist");

      var _component_DpInputMultiFactorAuthenticationCode = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpInputMultiFactorAuthenticationCode");

      var _component_DpForm = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpForm");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpForm, {
        modelValue: _ctx.form,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(form) ? form.value = $event : null;
        }),
        reference: "activate-authenticator",
        action: _ctx.activateAuthenticator,
        primaryButtonLabel: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('confirmCode.buttonLabel'),
        "notification-success": {
          title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activateAuthenticator.notification.success.title'),
          message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activateAuthenticator.notification.success.message')
        },
        "notification-async-error": {
          title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activateAuthenticator.notification.asyncError.title'),
          message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activateAuthenticator.notification.asyncError.message')
        }
      }, {
        secondaryButton: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            purpose: "secondaryAction",
            onClick: _ctx.cancelForm
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('cancel.buttonLabel')), 1)];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('scanCode.label')), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, {
            class: "text-align-center"
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("img", {
                src: _ctx.secretQrCode,
                height: "228",
                width: "228"
              }, null, 8, ActivateAuthenticatorAppFormvue_type_script_setup_true_lang_js_hoisted_1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", _hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCopyToClipboard, {
                value: _ctx.secretText
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", _hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.secretText), 1)];
                }),
                _: 1
              }, 8, ["value"])])];
            }),
            _: 1
          }, 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, !!_ctx.secretQrCode]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpNotificationPersist, {
            type: "error",
            title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('fetchSecret.notificationPersist.asyncError.title'),
            message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('fetchSecret.notificationPersist.asyncError.message')
          }, {
            controls: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                onClick: _ctx.fetchSecret
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('tryAgain.buttonLabel')), 1)];
                }),
                _: 1
              }, 8, ["onClick"])];
            }),
            _: 1
          }, 8, ["title", "message"]), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.errorLoadingQrCode]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('afterYouScannedCode.label')), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpInputMultiFactorAuthenticationCode, {
            modelValue: _ctx.form.totp,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.form.totp = $event;
            }),
            prop: "totp",
            required: ""
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["modelValue", "action", "primaryButtonLabel", "notification-success", "notification-async-error"])), [[_directive_loading, _ctx.loading]]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateAuthenticatorAppForm.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-66.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-66.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-66.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-66.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateAuthenticatorAppForm.vue?vue&type=style&index=0&id=92fa93b0&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateAuthenticatorAppForm.vue?vue&type=style&index=0&id=92fa93b0&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateAuthenticatorAppForm.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function ActivateAuthenticatorAppFormvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes. Der Code wird von der Authentifizierungs-App generiert."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scanne diesen QR-Code oder verwende den darunter stehenden Code, um deine Authentifizierungs-App zu verbinden."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungsmethode wurde aktiviert."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut laden"])}
        }
      },
      "de-AT": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes. Der Code wird von der Authentifizierungs-App generiert."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scanne diesen QR-Code oder verwende den darunter stehenden Code, um deine Authentifizierungs-App zu verbinden."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungsmethode wurde aktiviert."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut laden"])}
        }
      },
      "de-CH": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes. Der Code wird von der Authentifizierungs-App generiert."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scanne diesen QR-Code oder verwende den darunter stehenden Code, um deine Authentifizierungs-App zu verbinden."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungsmethode wurde aktiviert."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut laden"])}
        }
      },
      "en-US": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate two-factor authentication by entering and confirming the authentication code. The code is generated by the authentication app."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan this QR code or use the code below to connect your authenticator app."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code could not be confirmed."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication method has been activated."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error has occurred in our service. Please try again."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Load again"])}
        }
      },
      "en-GB": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate two-factor authentication by entering and confirming the authentication code. The code is generated by the authentication app."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan this QR code or use the code below to connect your authenticator app."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code could not be confirmed."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication method has been activated."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error has occurred in our service. Please try again."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Load again"])}
        }
      },
      "it-IT": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva l'autentificazione a due fattori inserendo e confermando il codice di autenticazione."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conferma"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effettua la scansione di questo codice QR o usa il codice di seguito per connetterti alla tua app di autenticazione."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non è stato possibile confermare il codice di autenticazione."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il metodo di autenticazione è stato attivato."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si è verificato un errore nel nostro servizio. Per favore riprova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Carica di nuovo"])}
        }
      },
      "fr-FR": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification. Ce code est généré par l'application d'authentification."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scannez ce code QR ou utilisez le code ci-dessous pour connecter votre application d'authentification."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La méthode d'authentification a été activée."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Charger à nouveau"])}
        }
      },
      "es-ES": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active la autenticación en dos pasos introduciendo y confirmando el código de autenticación. El código lo genera automáticamente la aplicación."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Escanee este código QR o use el código a continuación para conectar su aplicación de autenticación."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se pudo confirmar el código de autenticación."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se ha activado el método de autenticación."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ha habido un error en nuestro servicio. Inténtelo de nuevo, por favor."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cargar de nuevo"])}
        }
      },
      "pl-PL": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywuj uwierzytelnianie dwuskładnikowe, wprowadzając i potwierdzając kod uwierzytelniający. Kod jest generowany przez aplikację uwierzytelniającą."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdź"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zeskanuj ten kod QR lub użyj poniższego kodu, aby połączyć aplikację uwierzytelniającą."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie udało się potwierdzić kodu uwierzytelniającego."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metoda uwierzytelniania została aktywowana."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["W naszym serwisie wystąpił błąd. Prosimy, spróbuj ponownie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Załaduj ponownie"])}
        }
      },
      "nl-NL": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activeer de twee-factor authenticatie door de authenticatiecode in te voeren en te bevestigen. De code wordt gegenereerd door de verificatie-app."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan deze QR code of gebruik de onderstaande code om uw authenticatie app te verbinden."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afbreken"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authencitatiecode kon niet worden bevestigd."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificatiemethode is geactiveerd."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Er is een fout opgetreden in onze service. Gelieve opnieuw te proberen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opnieuw laden"])}
        }
      },
      "bg-BG": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирайте двуфакторно удостоверяване, като въведете и потвърдите кода за удостоверяване. Кодът се генерира от приложението за удостоверяване."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потвърждение"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сканирайте този QR код или използвайте кода по-долу, за да свържете приложението си за удостоверяване."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прекратяване"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване не може да бъде потвърден."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активиран е методът за удостоверяване."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Възникна грешка в нашата услуга. Моля, опитайте отново."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Заредете отново"])}
        }
      },
      "bs-BA": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirajte dvofaktorsku autentifikaciju unosom i potvrđivanjem autentifikacijskog koda. Kôd generira aplikacija za autentifikaciju."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdite"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skenirajte ovaj QR kôd ili upotrijebite donji kôd za povezivanje aplikacije za autentifikaciju."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće potvrditi autentifikacijski kôd."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran je način autentifikacije."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Došlo je do greške u našem servisu. Molimo pokušajte ponovo."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Učitaj ponovo"])}
        }
      },
      "zh-CN": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入并确认身份验证码以激活双重身份验证。该代码由身份验证应用程序生成。"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["扫描此二维码或使用以下代码连接您的身份验证应用程序。"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中止"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无法确认验证码。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["身份验证方法已激活。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我们的服务发生了错误。 请再试一遍。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新加载"])}
        }
      },
      "da-DK": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiver tofaktorautentificering ved at indtaste og bekræfte godkendelseskoden. Koden genereres af godkendelsesappen."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekræft"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan denne QR-kode, eller brug koden nedenfor til at forbinde din godkendelsesapp."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden kunne ikke bekræftes."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelsesmetode er aktiveret."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der opstod en fejl i vores service. Prøv igen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indlæs igen"])}
        }
      },
      "et-EE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveerige kaheastmeline autentimine, sisestades ja kinnitades autentimiskoodi. Koodi genereerib autentimisrakendus."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinnita"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skannige see QR-kood või kasutage oma autentimisrakenduse ühendamiseks allolevat koodi."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Katkesta"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskoodi ei õnnestunud kinnitada."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimismeetod on aktiveeritud."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meie teenuses on ilmnenud tõrge. Palun proovi uuesti."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Laadige uuesti"])}
        }
      },
      "fi-FI": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoi kaksivaiheinen todennus syöttämällä ja vahvistamalla todennuskoodi. Koodi on luotu todennussovelluksella."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vahvista"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skannaa tämä QR-koodi tai käytä alla olevaa koodia yhdistääksesi todennussovelluksesi."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keskeyttää"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodia ei voitu vahvistaa."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennusmenetelmä on aktivoitu."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Palvelussamme on tapahtunut virhe. Olkaa hyvä, ja yrittäkää uudelleen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lataa uudelleen"])}
        }
      },
      "el-GR": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων εισάγοντας και επιβεβαιώνοντας τον κωδικό ελέγχου ταυτότητας. Ο κώδικας δημιουργείται από την εφαρμογή ελέγχου ταυτότητας."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σαρώστε αυτόν τον κωδικό QR ή χρησιμοποιήστε τον παρακάτω κωδικό για να συνδέσετε την εφαρμογή ελέγχου ταυτότητας."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποβάλλω"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επιβεβαίωση του κωδικού ελέγχου ταυτότητας."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η μέθοδος ελέγχου ταυτότητας έχει ενεργοποιηθεί."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παρουσιάστηκε σφάλμα στην υπηρεσία μας. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Φορτώστε ξανά"])}
        }
      },
      "he-IL": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הפעל אימות דו-גורמי על ידי הזנת קוד האימות ואישורו. הקוד נוצר על ידי אפליקציית האימות."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְאַשֵׁר"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סרוק קוד QR זה או השתמש בקוד שלמטה כדי לחבר את אפליקציית האימות שלך."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפִּיל"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא ניתן היה לאשר את קוד האימות."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שיטת האימות הופעלה."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אירעה שגיאה בשירות שלנו. בבקשה נסה שוב."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["טען שוב"])}
        }
      },
      "ga-IE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fíordheimhniú dhá fhachtóir a ghníomhachtú tríd an gcód fíordheimhnithe a iontráil agus a dhearbhú. Gineann an aip fíordheimhnithe an cód."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deimhnigh"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scan an cód QR seo nó bain úsáid as an gcód thíos chun d’aip fíordheimhnithe a nascadh."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ginmhilleadh"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Níorbh fhéidir an cód fíordheimhnithe a dhearbhú."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuireadh modh fíordheimhnithe i ngníomh."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tharla earráid inár seirbhís. Arís, le d'thoil."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Luchtaigh arís"])}
        }
      },
      "ja-JP": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードを入力して確認することで、二要素認証を有効にします。 コードは認証アプリによって生成されます。"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["この QR コードをスキャンするか、以下のコードを使用して認証アプリに接続します。"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アボート"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードが確認できませんでした。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証方法が有効化されました。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["サービスでエラーが発生しました。 もう一度お試しください。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["再度ロード"])}
        }
      },
      "hr-HR": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirajte dvofaktorsku autentifikaciju unosom i potvrđivanjem autentifikacijskog koda. Kôd generira aplikacija za provjeru autentičnosti."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrda"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skenirajte ovaj QR kôd ili upotrijebite donji kod za povezivanje aplikacije za provjeru autentičnosti."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekid"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće potvrditi autentifikacijski kod."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirana je metoda autentifikacije."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Došlo je do pogreške u našoj usluzi. Molim vas pokušajte ponovno."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Učitaj ponovo"])}
        }
      },
      "lv-LV": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizējiet divfaktoru autentifikāciju, ievadot un apstiprinot autentifikācijas kodu. Kodu ģenerē autentifikācijas lietotne."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apstiprināt"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skenējiet šo QR kodu vai izmantojiet zemāk esošo kodu, lai izveidotu savienojumu ar savu autentifikācijas lietotni."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pārtraukt"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nevarēja apstiprināt autentifikācijas kodu."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas metode ir aktivizēta."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mūsu pakalpojumā ir radusies kļūda. Lūdzu, mēģiniet vēlreiz."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ielādējiet vēlreiz"])}
        }
      },
      "lt-LT": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinkite dviejų veiksnių autentifikavimą įvesdami ir patvirtindami autentifikavimo kodą. Kodą sugeneruoja autentifikavimo programa."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patvirtinti"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuskaitykite šį QR kodą arba naudokite toliau pateiktą kodą, kad susietumėte savo autentifikavimo programą."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutraukti"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nepavyko patvirtinti autentifikavimo kodo."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo metodas suaktyvintas."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mūsų tarnyboje įvyko klaida. Bandykite dar kartą."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pakraukite dar kartą"])}
        }
      },
      "pt-PT": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ative a autenticação de dois fatores inserindo e confirmando o código de autenticação. O código é gerado pela aplicação de autenticação."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Leia este código QR ou use o código abaixo para ligar a aplicação de autenticação."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abortar"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não foi possível confirmar o código de autenticação."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O método de autenticação foi ativado."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ocorreu um erro no nosso serviço. Tente novamente."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Carregue novamente"])}
        }
      },
      "ro-RO": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activați autentificarea cu doi factori introducând și confirmând codul de autentificare. Codul este generat de aplicația de autentificare."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmare"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scanați acest cod QR sau utilizați codul de mai jos pentru a vă conecta aplicația de autentificare."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abandonați"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare nu a putut fi confirmat."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A fost activată metoda de autentificare."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A apărut o eroare în serviciu. Încercați din nou."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Încărcați din nou"])}
        }
      },
      "ru-RU": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активируйте двухфакторную аутентификацию, введя и подтвердив код аутентификации. Код генерируется приложением для аутентификации."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтвердить"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отсканируйте этот QR-код или используйте приведенный ниже код для подключения приложения для аутентификации."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прервать"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации не подтвержден."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирован метод аутентификации."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Произошла ошибка в нашем сервисе. Пожалуйста, попробуйте еще раз."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Загрузить снова"])}
        }
      },
      "sv-SE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivera tvåfaktorautentisering genom att ange och bekräfta autentiseringskoden. Koden genereras av autentiseringsappen."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekräfta"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skanna den här QR-koden eller använd koden nedan för att ansluta din autentiseringsapp."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avbryta"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden kunde inte bekräftas."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verifieringsmetoden har aktiverats."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ett fel har uppstått i vår tjänst. Var god försök igen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ladda igen"])}
        }
      },
      "sk-SK": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivujte dvojfaktorové overenie zadaním a potvrdením overovacieho kódu. Kód je vygenerovaný overovacou aplikáciou."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdiť"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naskenujte tento QR kód alebo pomocou kódu nižšie pripojte vašu overovaciu aplikáciu."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód nebolo možné potvrdiť."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metóda overovania bola aktivovaná."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V našej službe sa vyskytla chyba. Prosím skúste znova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Znova načítať"])}
        }
      },
      "cs-CZ": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivujte dvoufaktorové ověřování zadáním a potvrzením ověřovacího kódu. Kód je generován ověřovací aplikací."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdit"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naskenujte tento QR kód nebo pomocí níže uvedeného kódu připojte svoji ověřovací aplikaci."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přerušit"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nelze potvrdit ověřovací kód."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metoda ověřování byla aktivována."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V naší službě se vyskytla chyba. Zkuste to prosím znovu."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Načíst znovu"])}
        }
      },
      "tr-TR": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodunu girip onaylayarak iki faktörlü kimlik doğrulamayı etkinleştirin. Kod, kimlik doğrulama uygulaması tarafından oluşturulur."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama uygulamanıza bağlanmak için bu QR kodunu taratın veya aşağıdaki kodu kullanın."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu onaylanamadı."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama yöntemi etkinleştirildi."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hizmetimizde bir hata oluştu. Lütfen tekrar deneyin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekrar yükle"])}
        }
      },
      "hu-HU": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiválja a kétfaktoros hitelesítést a hitelesítő kód megadásával és megerősítésével."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Megerősít"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szkennelje be a QR-kódot, vagy használja az alábbi kódot a hitelesítési alkalmazás csatlakoztatásához."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mégse"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítő kódot nem sikerült megerősíteni."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési módszer aktiválva van."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba történt a szolgáltatásunkban. Próbálja meg újra."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Töltse be újra"])}
        }
      },
      "ar-AE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قم بتنشيط المصادقة ذات العاملين عن طريق إدخال رمز المصادقة وتأكيده. يتم إنشاء الرمز بواسطة تطبيق المصادقة."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["امسح رمز الاستجابة السريعة هذا ضوئيًا أو استخدم الرمز أدناه لتوصيل تطبيق المصادقة الخاص بك."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إحباط"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن تأكيد رمز المصادقة."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم تفعيل طريقة المصادقة."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حدث خطأ في خدمتنا. حاول مرة اخرى."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحميل مرة أخرى"])}
        }
      },
      "fr-BE": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification. Ce code est généré par l'application d'authentification."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scannez ce code QR ou utilisez le code ci-dessous pour connecter votre application d'authentification."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La méthode d'authentification a été activée."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Charger à nouveau"])}
        }
      },
      "fr-LU": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification. Ce code est généré par l'application d'authentification."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scannez ce code QR ou utilisez le code ci-dessous pour connecter votre application d'authentification."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La méthode d'authentification a été activée."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Charger à nouveau"])}
        }
      },
      "mt-MT": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva awtentikazzjoni b'żewġ fatturi billi ddaħħal u tikkonferma l-kodiċi ta' awtentikazzjoni."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkonferma"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skennja dan il-kodiċi QR jew uża l-kodiċi hawn taħt biex tikkonnettja l-app ta' awtentikazzjoni tiegħek."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkanċella"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni ma setax jiġi kkonfermat."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-metodu ta 'awtentikazzjoni ġie attivat."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seħħ żball fis-servizz tagħna. Jekk jogħġbok erġa' pprova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Għabba mill-ġdid"])}
        }
      },
      "sl-SI": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dvofaktorsko preverjanje pristnosti aktivirajte tako, da vnesete in potrdite kodo za preverjanje pristnosti. Kodo generira aplikacija za preverjanje pristnosti."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potrdi"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Optično preberite to kodo QR ali uporabite spodnjo kodo za povezavo aplikacije za preverjanje pristnosti."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kode za preverjanje pristnosti ni bilo mogoče potrditi."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirana je metoda preverjanja pristnosti."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prišlo je do napake v naši storitvi. Poskusite ponovno."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ponovno naložite"])}
        }
      },
      "el-CY": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων εισάγοντας και επιβεβαιώνοντας τον κώδικα που δημιουργήθηκε από την εφαρμογή ελέγχου ταυτότητας."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σαρώστε αυτόν τον κωδικό QR ή χρησιμοποιήστε τον παρακάτω κωδικό για να συνδέσετε την εφαρμογή ελέγχου ταυτότητας."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Άκυρο"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επιβεβαίωση του κωδικού ελέγχου ταυτότητας."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η μέθοδος ελέγχου ταυτότητας έχει ενεργοποιηθεί."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παρουσιάστηκε σφάλμα στην υπηρεσία μας. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Φορτώστε ξανά"])}
        }
      },
      "tr-CY": {
        "afterYouScannedCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodunu girip onaylayarak iki faktörlü kimlik doğrulamayı etkinleştirin. Kod, kimlik doğrulama uygulaması tarafından oluşturulur."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "scanCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama uygulamanıza bağlanmak için bu QR kodunu taratın veya aşağıdaki kodu kullanın."])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        },
        "activateAuthenticator": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu onaylanamadı."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama yöntemi etkinleştirildi."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          }
        },
        "fetchSecret": {
          "notificationPersist": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hizmetimizde bir hata oluştu. Lütfen tekrar deneyin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          }
        },
        "tryAgain": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekrar yükle"])}
        }
      }
    }
  })
}

// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(3744);
;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateAuthenticatorAppForm.vue



;
/* custom blocks */

if (typeof ActivateAuthenticatorAppFormvue_type_custom_index_0_blockType_i18n === 'function') ActivateAuthenticatorAppFormvue_type_custom_index_0_blockType_i18n(ActivateAuthenticatorAppFormvue_type_script_setup_true_lang_js)


;
const ActivateAuthenticatorAppForm_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ActivateAuthenticatorAppFormvue_type_script_setup_true_lang_js, [['__scopeId',"data-v-92fa93b0"]])

/* harmony default export */ var ActivateAuthenticatorAppForm = (ActivateAuthenticatorAppForm_exports_);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(3123);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(9600);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/RemoveMultiFactorAuthenticationForm.vue?vue&type=script&setup=true&lang=js









var RemoveMultiFactorAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 0
};
var RemoveMultiFactorAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_2 = {
  key: 1
};
var RemoveMultiFactorAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_3 = {
  key: 2
};
var _hoisted_4 = {
  key: 0
};
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  key: 0
};
var _hoisted_7 = {
  key: 1
};
var _hoisted_8 = {
  key: 0
};
var _hoisted_9 = {
  key: 1
};
var _hoisted_10 = {
  key: 2
};
var _hoisted_11 = {
  key: 3
};
var _hoisted_12 = {
  key: 4
};





var RemoveMultiFactorAuthenticationFormvue_type_script_setup_true_lang_js_default_ = {
  name: "RemoveMultiFactorAuthenticationForm",
  props: {
    authenticationMethod: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      method: this.authenticationMethod,
      form: {
        totp: ''
      },
      loading: false,
      countdownResendEmail: 0,
      countdownResendSMS: 0,
      sendEmailDisabled: false,
      sendSMSDisabled: false
    };
  },
  computed: _objectSpread2(_objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ['apiUrls'])), (0,external_pinia_.mapState)(store_modules_.useAuthStore, ['user'])), {}, {
    hasAuthenticatorApp: function hasAuthenticatorApp() {
      return get_default()(this.user, 'mfaModes.authenticator', false);
    },
    hasEmailAuthentication: function hasEmailAuthentication() {
      return get_default()(this.user, 'mfaModes.email', false);
    },
    hasSMSAuthentication: function hasSMSAuthentication() {
      return get_default()(this.user, 'mfaModes.sms', false);
    },
    emailDisguised: function emailDisguised() {
      // Show only first three characters of email address name
      var email = this.user.email.split('@');
      email[0] = email[0].substr(0, 3) + '...';
      return email.join('@');
    },
    phraseWithMobileNumber: function phraseWithMobileNumber() {
      return this.$t('verifyMobileNumber.label', {
        mobileNumber: "<bdo dir=\"ltr\">".concat(this.user.mfaSettings.mobileNumber, "</bdo>")
      });
    }
  }),
  methods: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapActions)(store_modules_.useAuthStore, ['validate'])), {}, {
    resetAllFields: function resetAllFields() {
      this.form.totp = '';
    },
    removeAuthentication: function removeAuthentication() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var err, res, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return external_await_to_js_default()(_this.$http.delete("".concat(_this.apiUrls.dutypay, "/api/v0/mfa"), {
                  data: {
                    mode: _this.method,
                    modeToRemove: _this.authenticationMethod,
                    totp: _this.form.totp
                  }
                }));

              case 3:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];

                if (!err) {
                  _context.next = 10;
                  break;
                }

                _this.loading = false;
                throw err;

              case 10:
                _context.next = 12;
                return _this.cancelForm();

              case 12:
                _this.resetAllFields();

                _context.next = 15;
                return _this.validate({});

              case 15:
                _this.loading = false;
                return _context.abrupt("return", res);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    sendAuthenticationEmail: function sendAuthenticationEmail() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var err, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.sendEmailDisabled = true;
                _context2.next = 3;
                return external_await_to_js_default()(_this2.$http.post("".concat(_this2.apiUrls.dutypay, "/api/v0/send/auth-email")));

              case 3:
                _yield$to3 = _context2.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 1);
                err = _yield$to4[0];

                if (!err) {
                  _context2.next = 10;
                  break;
                }

                _this2.$notify.error({
                  title: _this2.$t('sendAuthenticationEmail.notification.asyncError.title'),
                  message: _this2.$t('sendAuthenticationEmail.notification.asyncError.message')
                });

                _this2.sendEmailDisabled = false;
                throw err;

              case 10:
                _this2.countdownResendEmail = 20;

                _this2.countDownTimerEmail();

                _this2.$notify.success({
                  title: _this2.$t('sendAuthenticationEmail.notification.success.title'),
                  message: _this2.$t('sendAuthenticationEmail.notification.success.message')
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    countDownTimerEmail: function countDownTimerEmail() {
      var _this3 = this;

      if (this.countdownResendEmail > 0) {
        setTimeout(function () {
          _this3.countdownResendEmail -= 1;

          _this3.countDownTimerEmail();
        }, 1000);
      } else {
        this.sendEmailDisabled = false;
      }
    },
    sendAuthenticationSMS: function sendAuthenticationSMS() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var err, _yield$to5, _yield$to6;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.sendSMSDisabled = true;
                _context3.next = 3;
                return external_await_to_js_default()(_this4.$http.post("".concat(_this4.apiUrls.dutypay, "/api/v0/send/auth-sms")));

              case 3:
                _yield$to5 = _context3.sent;
                _yield$to6 = _slicedToArray(_yield$to5, 1);
                err = _yield$to6[0];

                if (!err) {
                  _context3.next = 10;
                  break;
                }

                _this4.$notify.error({
                  title: _this4.$t('sendAuthenticationSMS.notification.asyncError.title'),
                  message: _this4.$t('sendAuthenticationSMS.notification.asyncError.message')
                });

                _this4.sendSMSDisabled = false;
                throw err;

              case 10:
                _this4.countdownResendSMS = 20;

                _this4.countDownTimerSMS();

                _this4.$notify.success({
                  title: _this4.$t('sendAuthenticationSMS.notification.success.title'),
                  message: _this4.$t('sendAuthenticationSMS.notification.success.message')
                });

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    countDownTimerSMS: function countDownTimerSMS() {
      var _this5 = this;

      if (this.countdownResendSMS > 0) {
        setTimeout(function () {
          _this5.countdownResendSMS -= 1;

          _this5.countDownTimerSMS();
        }, 1000);
      } else {
        this.sendSMSDisabled = false;
      }
    },
    useAuthenticator: function useAuthenticator() {
      this.method = 'authenticator';
    },
    useSMSAuthentication: function useSMSAuthentication() {
      this.method = 'sms';
      this.sendAuthenticationSMS();
    },
    useEmailAuthentication: function useEmailAuthentication() {
      this.method = 'email';
      this.sendAuthenticationEmail();
    },
    cancelForm: function cancelForm() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this6.$emit('cancel-form');

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  })
};

/* harmony default export */ var RemoveMultiFactorAuthenticationFormvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(RemoveMultiFactorAuthenticationFormvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_DpFeedforward = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFeedforward");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse");

      var _component_el_form_item = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-form-item");

      var _component_DpInputMultiFactorAuthenticationCode = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpInputMultiFactorAuthenticationCode");

      var _component_DpForm = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpForm");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpFeedforward, {
        type: "warning"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [_ctx.method === 'authenticator' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", RemoveMultiFactorAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthenticatorApp.feedforward.enterCode.message')), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.method === 'email' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", RemoveMultiFactorAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeEmailAuthentication.feedforward.enterCode.message')), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.method === 'sms' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", RemoveMultiFactorAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeSMSAuthentication.feedforward.enterCode.message')), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)];
        }),
        _: 1
      }), _ctx.method === 'email' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", _hoisted_4, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('verifyEmailAddress.label', {
        email: _ctx.emailDisguised
      })), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.method === 'sms' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", {
        key: 1,
        innerHTML: _ctx.phraseWithMobileNumber
      }, null, 8, _hoisted_5)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpForm, {
        modelValue: _ctx.form,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(form) ? form.value = $event : null;
        }),
        reference: "remove-authentication",
        action: _ctx.removeAuthentication,
        "primary-button-label": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('deactivateAuthentication.buttonLabel'),
        "primary-button-parameter": {
          type: 'danger'
        },
        "notification-success": {
          title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthentication.notification.success.title'),
          message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthentication.notification.success.message')
        },
        "notification-async-error": {
          title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthentication.notification.asyncError.title'),
          message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthentication.notification.asyncError.message')
        }
      }, {
        secondaryButton: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            purpose: "secondaryAction",
            onClick: _ctx.cancelForm
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('cancel.buttonLabel')), 1)];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form_item, null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [_ctx.method === 'email' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dp_button, {
                    key: 0,
                    purpose: "primary",
                    disabled: _ctx.sendEmailDisabled,
                    onClick: _ctx.sendAuthenticationEmail
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [_ctx.sendEmailDisabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", _hoisted_6, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('resendEmailInSeconds.buttonLabel', {
                        seconds: _ctx.countdownResendEmail
                      })), 1)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", _hoisted_7, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('sendEmail.buttonLabel')), 1))];
                    }),
                    _: 1
                  }, 8, ["disabled", "onClick"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.method === 'sms' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dp_button, {
                    key: 1,
                    purpose: "primary",
                    disabled: _ctx.sendSMSDisabled,
                    onClick: _ctx.sendAuthenticationSMS
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [_ctx.sendSMSDisabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", _hoisted_8, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('resendSMSInSeconds.buttonLabel', {
                        seconds: _ctx.countdownResendSMS
                      })), 1)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", _hoisted_9, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('sendSMS.buttonLabel')), 1))];
                    }),
                    _: 1
                  }, 8, ["disabled", "onClick"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)];
                }),
                _: 1
              }, 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.method === 'email' || _ctx.method === 'sms']])];
            }),
            _: 1
          }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpInputMultiFactorAuthenticationCode, {
            modelValue: _ctx.form.totp,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.form.totp = $event;
            }),
            prop: "totp",
            required: ""
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["modelValue", "action", "primary-button-label", "notification-success", "notification-async-error"])), [[_directive_loading, _ctx.loading]]), _ctx.hasAuthenticatorApp && _ctx.method !== 'authenticator' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_10, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
        type: "text",
        onClick: _ctx.useAuthenticator
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('useAuthenticator.buttonLabel')), 1)];
        }),
        _: 1
      }, 8, ["onClick"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.hasSMSAuthentication && _ctx.method !== 'sms' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_11, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
        type: "text",
        onClick: _ctx.useSMSAuthentication
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('useSMSAuthentication.buttonLabel')), 1)];
        }),
        _: 1
      }, 8, ["onClick"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), _ctx.hasEmailAuthentication && _ctx.method !== 'email' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_12, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
        type: "text",
        onClick: _ctx.useEmailAuthentication
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('useEmailAuthentication.buttonLabel')), 1)];
        }),
        _: 1
      }, 8, ["onClick"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/RemoveMultiFactorAuthenticationForm.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/RemoveMultiFactorAuthenticationForm.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function RemoveMultiFactorAuthenticationFormvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde erfolgreich gesendet."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde erfolgreich gesendet."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("seconds")), " Sekunden"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("seconds")), " Sekunden"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes. Der Code wird von der Authentifizierungs-App generiert."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Code wird an die gespeicherte Mobilnummer ", _interpolate(_named("mobileNumber")), " per SMS gesendet."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Code wird an ", _interpolate(_named("email")), " gesendet."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifzierungscode per Authentifizierungs-App"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifzierungscode per E-Mail"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifzierungscode per SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungsmethode wurde deaktiviert."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        }
      },
      "de-AT": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde erfolgreich gesendet."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde erfolgreich gesendet."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("seconds")), " Sekunden"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("seconds")), " Sekunden"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes. Der Code wird von der Authentifizierungs-App generiert."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Code wird an die gespeicherte Mobilnummer ", _interpolate(_named("mobileNumber")), " per SMS gesendet."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Code wird an ", _interpolate(_named("email")), " gesendet."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifzierungscode per Authentifizierungs-App"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifzierungscode per E-Mail"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifzierungscode per SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungsmethode wurde deaktiviert."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        }
      },
      "de-CH": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde erfolgreich gesendet."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde erfolgreich gesendet."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("seconds")), " Sekunden"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("seconds")), " Sekunden"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes. Der Code wird von der Authentifizierungs-App generiert."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Code wird an die gespeicherte Mobilnummer ", _interpolate(_named("mobileNumber")), " per SMS gesendet."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Der Code wird an ", _interpolate(_named("email")), " gesendet."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifzierungscode per Authentifizierungs-App"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifzierungscode per E-Mail"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifzierungscode per SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungsmethode wurde deaktiviert."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        }
      },
      "en-US": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error has occurred in our service. Please try again."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent successfully."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error has occurred in our service. Please try again."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent successfully."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend in 59 seconds"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend in 59 seconds"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate two-factor authentication by entering and confirming the authentication code. The code is generated by the authentication app."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate two-factor authentication by entering and confirming the authentication code."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate two-factor authentication by entering and confirming the authentication code."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The code is sent to the saved mobile number ", _interpolate(_named("mobileNumber")), " sent by SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The code will be sent to ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code by authentication app"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code by E-mail"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code by SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code could not be confirmed."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication method has been deactivated."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
            }
          }
        }
      },
      "en-GB": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error has occurred in our service. Please try again."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent successfully."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error has occurred in our service. Please try again."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent successfully."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend in 59 seconds"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend in 59 seconds"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate two-factor authentication by entering and confirming the authentication code. The code is generated by the authentication app."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate two-factor authentication by entering and confirming the authentication code."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate two-factor authentication by entering and confirming the authentication code."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The code is sent to the saved mobile number ", _interpolate(_named("mobileNumber")), " sent by SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["The code will be sent to ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code by authentication app"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code by E-mail"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication code by SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code could not be confirmed."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication method has been deactivated."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
            }
          }
        }
      },
      "it-IT": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si è verificato un errore nel nostro servizio. Per favore riprova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione è stato inviato con successo."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si è verificato un errore nel nostro servizio. Per favore riprova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione è stato inviato con successo."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Invia nuovamente tra ", _interpolate(_named("seconds")), " secondi"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Invia nuovamente tra ", _interpolate(_named("seconds")), " secondi"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disattivare l'autenticazione a due fattori inserendo e confermando il codice di autenticazione. Il codice viene generato dall'app di autenticazione."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disattivare l'autenticazione a due fattori inserendo e confermando il codice di autenticazione."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disattivare l'autenticazione a due fattori inserendo e confermando il codice di autenticazione."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il codice viene inviato al numero di cellulare memorizzato ", _interpolate(_named("mobileNumber")), " inviato tramite SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il codice verrà inviato a ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione tramite app di autenticazione"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione via e-mail"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice di autenticazione via SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conferma"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non è stato possibile confermare il codice di autenticazione."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il metodo di autenticazione è stato disattivato."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])}
            }
          }
        }
      },
      "fr-FR": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé avec succès."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé avec succès."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("seconds")), " secondes"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("seconds")), " secondes"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification. Le code est généré par l'application d'authentification."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code est envoyé au numéro de mobile enregistré ", _interpolate(_named("mobileNumber")), " envoyé par SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code sera envoyé à ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification via l'application d'authentification"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par email"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La méthode d'authentification a été désactivée."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        }
      },
      "es-ES": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ha habido un error en nuestro servicio. Inténtelo de nuevo, por favor."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación se envió correctamente."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ha habido un error en nuestro servicio. Inténtelo de nuevo, por favor."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación se envió correctamente."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Enviar de nuevo en ", _interpolate(_named("seconds")), " segundos"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Enviar de nuevo en ", _interpolate(_named("seconds")), " segundos"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desactive la autenticación de dos factores ingresando y confirmando el código de autenticación. El código es generado por la aplicación de autenticación."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desactive la autenticación de dos factores ingresando y confirmando el código de autenticación."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desactive la autenticación de dos factores ingresando y confirmando el código de autenticación."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["El código se envía al número de móvil almacenado ", _interpolate(_named("mobileNumber")), " enviado por SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["El código se enviará a ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticación a través de la aplicación de autenticación"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticación por correo electrónico"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticación por SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se pudo confirmar el código de autenticación."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se ha desactivado el método de autenticación."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])}
            }
          }
        }
      },
      "pl-PL": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["W naszym serwisie wystąpił błąd. Prosimy, spróbuj ponownie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający został pomyślnie wysłany."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyślij"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["W naszym serwisie wystąpił błąd. Prosimy, spróbuj ponownie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający został pomyślnie wysłany."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyślij"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Wyślij ponownie za ", _interpolate(_named("seconds")), " s"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Wyślij ponownie za ", _interpolate(_named("seconds")), " s"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyłącz uwierzytelnianie dwuskładnikowe, wprowadzając i potwierdzając kod uwierzytelniający. Kod jest generowany przez aplikację uwierzytelniającą."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyłącz uwierzytelnianie dwuskładnikowe, wprowadzając i potwierdzając kod uwierzytelniający."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyłącz uwierzytelnianie dwuskładnikowe, wprowadzając i potwierdzając kod uwierzytelniający."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kod wysyłany jest na zapisany numer telefonu ", _interpolate(_named("mobileNumber")), " wysłane SMS-em."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kod zostanie wysłany na adres ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający za pośrednictwem aplikacji uwierzytelniającej"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający przez e-mail"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający przez SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdź"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie udało się potwierdzić kodu uwierzytelniającego."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metoda uwierzytelniania została dezaktywowana."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])}
            }
          }
        }
      },
      "nl-NL": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afbreken"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Er is een fout opgetreden in onze service. Gelieve opnieuw te proberen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authenticatiecode is succesvol verzonden."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verzenden"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Er is een fout opgetreden in onze service. Gelieve opnieuw te proberen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authenticatiecode is succesvol verzonden."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verzenden"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Verzenden over ", _interpolate(_named("seconds")), " seconden"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Verzenden over ", _interpolate(_named("seconds")), " seconden"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactiveer tweefactorauthenticatie door de authenticatiecode in te voeren en te bevestigen. De code wordt gegenereerd door de authenticatie-app."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactiveer tweefactorauthenticatie door de authenticatiecode in te voeren en te bevestigen."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactiveer tweefactorauthenticatie door de authenticatiecode in te voeren en te bevestigen."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["De code wordt verzonden naar het opgeslagen mobiele nummer ", _interpolate(_named("mobileNumber")), " per sms verzonden."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["De code wordt naar ", _interpolate(_named("email")), " gestuurd."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode via authenticatie-app"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode per e-mail"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticatiecode via sms"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authencitatiecode kon niet worden bevestigd."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenicatie methode is gedeactiveerd."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            }
          }
        }
      },
      "bg-BG": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прекратяване"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Възникна грешка в нашата услуга. Моля, опитайте отново."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване е изпратен успешно."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изпращане"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Възникна грешка в нашата услуга. Моля, опитайте отново."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване е изпратен успешно."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изпращане"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Изпращане след ", _interpolate(_named("seconds")), " секунди"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Изпращане след ", _interpolate(_named("seconds")), " секунди"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивирайте двуфакторното удостоверяване, като въведете и потвърдите кода за удостоверяване. Кодът се генерира от приложението за удостоверяване."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивирайте двуфакторното удостоверяване, като въведете и потвърдите кода за удостоверяване."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивирайте двуфакторното удостоверяване, като въведете и потвърдите кода за удостоверяване."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Кодът се изпраща на съхранения мобилен номер ", _interpolate(_named("mobileNumber")), " изпратени чрез SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Кодът ще бъде изпратен на ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код за удостоверяване чрез приложение за удостоверяване"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код за удостоверяване по имейл"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код за удостоверяване чрез SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потвърждение"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване не може да бъде потвърден."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Методът за удостоверяване е деактивиран."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])}
            }
          }
        }
      },
      "bs-BA": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Došlo je do greške u našem servisu. Molimo pokušajte ponovo."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za provjeru autentičnosti je uspješno poslan."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošalji"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Došlo je do greške u našem servisu. Molimo pokušajte ponovo."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za provjeru autentičnosti je uspješno poslan."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošalji"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovo pošalji za ", _interpolate(_named("seconds")), " sekundi"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovo pošalji za ", _interpolate(_named("seconds")), " sekundi"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirajte dvofaktorsku autentifikaciju unošenjem i potvrđivanjem autentifikacijskog koda. Kôd generira aplikacija za provjeru autentičnosti."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirajte dvofaktorsku autentifikaciju unošenjem i potvrđivanjem autentifikacijskog koda."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirajte dvofaktorsku autentifikaciju unošenjem i potvrđivanjem autentifikacijskog koda."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kôd se šalje na pohranjeni broj mobitela ", _interpolate(_named("mobileNumber")), " poslati SMS-om."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kôd će biti poslan na ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za provjeru autentičnosti putem aplikacije za provjeru autentičnosti"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod e-poštom"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod putem SMS-a"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdite"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće potvrditi autentifikacijski kôd."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metoda autentifikacije je deaktivirana."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])}
            }
          }
        }
      },
      "zh-CN": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中止"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我们的服务发生了错误。 请再试一遍。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["验证码发送成功。"])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发送"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我们的服务发生了错误。 请再试一遍。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["验证码发送成功。"])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发送"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["在", _interpolate(_named("seconds")), "内重新发送"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["在", _interpolate(_named("seconds")), "内重新发送"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过输入并确认身份验证代码来停用双因素身份验证。 该代码由身份验证应用程序生成。"])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过输入并确认身份验证代码来停用双因素身份验证。"])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过输入并确认身份验证代码来停用双因素身份验证。"])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["代码发送到存储的手机号码", _interpolate(_named("mobileNumber")), " 通过短信发送。"])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["代码将发送至 ", _interpolate(_named("email")), "。"])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过身份验证应用程序的身份验证代码"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过电子邮件验证代码"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通过短信验证码"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无法确认验证码。"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["身份验证方法已停用。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])}
            }
          }
        }
      },
      "da-DK": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der opstod en fejl i vores service. Prøv igen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden blev sendt med succes."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der opstod en fejl i vores service. Prøv igen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden blev sendt med succes."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Send igen om ", _interpolate(_named("seconds")), " sekunder"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Send igen om ", _interpolate(_named("seconds")), " sekunder"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiver tofaktorautentificering ved at indtaste og bekræfte godkendelseskoden. Koden genereres af godkendelsesappen."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiver tofaktorautentificering ved at indtaste og bekræfte godkendelseskoden."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiver tofaktorautentificering ved at indtaste og bekræfte godkendelseskoden."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Koden sendes til det gemte mobilnummer ", _interpolate(_named("mobileNumber")), " sendt via SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Koden sendes til ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskode via godkendelsesapp"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskode via e-mail"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskode via SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekræft"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden kunne ikke bekræftes."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelsesmetoden er deaktiveret."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            }
          }
        }
      },
      "et-EE": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Katkesta"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meie teenuses on ilmnenud tõrge. Palun proovi uuesti."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskoodi saatmine õnnestus."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saada"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meie teenuses on ilmnenud tõrge. Palun proovi uuesti."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskoodi saatmine õnnestus."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saada"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Saada uuesti ", _interpolate(_named("seconds")), " sekundi pärast"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Saada uuesti ", _interpolate(_named("seconds")), " sekundi pärast"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveerige kaheastmeline autentimine, sisestades ja kinnitades autentimiskoodi. Koodi genereerib autentimisrakendus."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveerige kaheastmeline autentimine, sisestades ja kinnitades autentimiskoodi."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveerige kaheastmeline autentimine, sisestades ja kinnitades autentimiskoodi."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kood saadetakse salvestatud mobiilinumbrile ", _interpolate(_named("mobileNumber")), " saadetakse SMS-iga."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kood saadetakse aadressile ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood autentimisrakenduse kaudu"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood e-posti teel"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood SMS-i teel"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinnita"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskoodi ei õnnestunud kinnitada."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimismeetod on desaktiveeritud."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])}
            }
          }
        }
      },
      "fi-FI": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keskeyttää"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Palvelussamme on tapahtunut virhe. Olkaa hyvä, ja yrittäkää uudelleen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi lähetettiin onnistuneesti."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähetä"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Palvelussamme on tapahtunut virhe. Olkaa hyvä, ja yrittäkää uudelleen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi lähetettiin onnistuneesti."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähetä"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Lähetä uudelleen ", _interpolate(_named("seconds")), " sekunnissa"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Lähetä uudelleen ", _interpolate(_named("seconds")), " sekunnissa"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista kaksivaiheinen todennus käytöstä syöttämällä ja vahvistamalla todennuskoodi. Koodi on luotu todennussovelluksella."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista kaksivaiheinen todennus käytöstä syöttämällä ja vahvistamalla todennuskoodi."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista kaksivaiheinen todennus käytöstä syöttämällä ja vahvistamalla todennuskoodi."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Koodi lähetetään tallennettuun matkapuhelinnumeroon ", _interpolate(_named("mobileNumber")), " lähetetään tekstiviestillä."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Koodi lähetetään osoitteeseen ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi todennussovelluksen kautta"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi sähköpostitse"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi tekstiviestillä"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vahvista"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodia ei voitu vahvistaa."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennusmenetelmä on poistettu käytöstä."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])}
            }
          }
        }
      },
      "el-GR": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποβάλλω"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παρουσιάστηκε σφάλμα στην υπηρεσία μας. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε με επιτυχία."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποστολή"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παρουσιάστηκε σφάλμα στην υπηρεσία μας. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε με επιτυχία."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποστολή"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("seconds")), " δευτερόλεπτα"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("seconds")), " δευτερόλεπτα"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων εισάγοντας και επιβεβαιώνοντας τον κωδικό ελέγχου ταυτότητας. Ο κώδικας δημιουργείται από την εφαρμογή ελέγχου ταυτότητας."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων εισάγοντας και επιβεβαιώνοντας τον κωδικό ελέγχου ταυτότητας."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων εισάγοντας και επιβεβαιώνοντας τον κωδικό ελέγχου ταυτότητας."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ο κωδικός αποστέλλεται στον αποθηκευμένο αριθμό κινητού ", _interpolate(_named("mobileNumber")), " αποστέλλεται με SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ο κωδικός θα σταλεί στη διεύθυνση ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας μέσω εφαρμογής ελέγχου ταυτότητας"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας μέσω email"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας μέσω SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επιβεβαίωση του κωδικού ελέγχου ταυτότητας."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η μέθοδος ελέγχου ταυτότητας έχει απενεργοποιηθεί."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          }
        }
      },
      "he-IL": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפִּיל"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אירעה שגיאה בשירות שלנו. בבקשה נסה שוב."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות נשלח בהצלחה."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אירעה שגיאה בשירות שלנו. בבקשה נסה שוב."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות נשלח בהצלחה."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["שלח מחדש בתוך ", _interpolate(_named("seconds")), " שניות"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["שלח מחדש בתוך ", _interpolate(_named("seconds")), " שניות"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["השבת אימות דו-גורמי על ידי הזנת קוד האימות ואישורו. הקוד נוצר על ידי אפליקציית האימות."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["השבת אימות דו-גורמי על ידי הזנת קוד האימות ואישורו."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["השבת אימות דו-גורמי על ידי הזנת קוד האימות ואישורו."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["הקוד נשלח למספר הנייד השמור ", _interpolate(_named("mobileNumber")), " נשלח בסמס."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["הקוד יישלח אל ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד אימות באמצעות אפליקציית אימות"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד אימות במייל"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד אימות באמצעות SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְאַשֵׁר"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא ניתן היה לאשר את קוד האימות."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שיטת האימות בוטלה."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])}
            }
          }
        }
      },
      "ga-IE": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ginmhilleadh"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tharla earráid inár seirbhís. Arís, le d'thoil."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuireadh an cód fíordheimhnithe go rathúil."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seol"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tharla earráid inár seirbhís. Arís, le d'thoil."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuireadh an cód fíordheimhnithe go rathúil."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seol"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Athsheol i gceann ", _interpolate(_named("seconds")), " soicind"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Athsheol i gceann ", _interpolate(_named("seconds")), " soicind"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fíordheimhniú dhá fhachtóir a dhíghníomhachtú tríd an gcód fíordheimhnithe a iontráil agus a dhearbhú. Gineann an aip fíordheimhnithe an cód."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fíordheimhniú dhá fhachtóir a dhíghníomhachtú tríd an gcód fíordheimhnithe a iontráil agus a dhearbhú."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fíordheimhniú dhá fhachtóir a dhíghníomhachtú tríd an gcód fíordheimhnithe a iontráil agus a dhearbhú."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Seoltar an cód chuig an uimhir soghluaiste stóráilte ", _interpolate(_named("mobileNumber")), " seolta ag SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Seolfar an cód chuig ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód fíordheimhnithe trí aip fíordheimhnithe"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód fíordheimhnithe trí ríomhphost"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód fíordheimhnithe trí SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deimhnigh"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Níorbh fhéidir an cód fíordheimhnithe a dhearbhú."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tá an modh fíordheimhnithe díghníomhachtaithe."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])}
            }
          }
        }
      },
      "ja-JP": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アボート"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["サービスでエラーが発生しました。 もう一度お試しください。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードは正常に送信されました。"])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["送信"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["サービスでエラーが発生しました。 もう一度お試しください。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードは正常に送信されました。"])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["送信"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("seconds")), "秒で再送信"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("seconds")), "秒で再送信"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードを入力して確認することで、二要素認証を無効にします。 コードは認証アプリによって生成されます。"])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードを入力して確認することで、二要素認証を無効にします。"])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードを入力して確認することで、二要素認証を無効にします。"])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["コードは保存されている携帯電話番号 ", _interpolate(_named("mobileNumber")), " に送信されます SMS で送信されます。"])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["コードは ", _interpolate(_named("email")), " に送信されます。"])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証アプリによる認証コード"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メールによる認証コード"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS経由の認証コード"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードが確認できませんでした。"])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証方法が無効化されました。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])}
            }
          }
        }
      },
      "hr-HR": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekid"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Došlo je do pogreške u našoj usluzi. Molim vas pokušajte ponovno."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za ovjeru uspješno je poslan."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slati"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Došlo je do pogreške u našoj usluzi. Molim vas pokušajte ponovno."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za ovjeru uspješno je poslan."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slati"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno slanje u ", _interpolate(_named("seconds")), " sekundama"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno slanje u ", _interpolate(_named("seconds")), " sekundama"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirajte dvofaktorsku autentifikaciju unosom i potvrđivanjem autentifikacijskog koda. Kôd generira aplikacija za provjeru autentičnosti."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirajte dvofaktorsku autentifikaciju unosom i potvrđivanjem autentifikacijskog koda."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirajte dvofaktorsku autentifikaciju unosom i potvrđivanjem autentifikacijskog koda."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kôd se šalje na pohranjeni broj mobitela ", _interpolate(_named("mobileNumber")), " poslano SMS-om."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kôd će se poslati na ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za provjeru autentičnosti putem aplikacije za provjeru autentičnosti"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod e-poštom"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kod putem SMS-a"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrda"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće potvrditi autentifikacijski kod."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Način autentifikacije je deaktiviran."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])}
            }
          }
        }
      },
      "lv-LV": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pārtraukt"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mūsu pakalpojumā ir radusies kļūda. Lūdzu, mēģiniet vēlreiz."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods tika veiksmīgi nosūtīts."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sūtīt"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mūsu pakalpojumā ir radusies kļūda. Lūdzu, mēģiniet vēlreiz."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods tika veiksmīgi nosūtīts."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sūtīt"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Atkārtoti nosūtīt pēc ", _interpolate(_named("seconds")), " sek."])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Atkārtoti nosūtīt pēc ", _interpolate(_named("seconds")), " sek."])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivizējiet divfaktoru autentifikāciju, ievadot un apstiprinot autentifikācijas kodu. Kodu ģenerē autentifikācijas lietotne."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivizējiet divfaktoru autentifikāciju, ievadot un apstiprinot autentifikācijas kodu."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivizējiet divfaktoru autentifikāciju, ievadot un apstiprinot autentifikācijas kodu."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kods tiek nosūtīts uz saglabāto mobilā tālruņa numuru ", _interpolate(_named("mobileNumber")), " nosūta ar īsziņu."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kods tiks nosūtīts uz ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods, izmantojot autentifikācijas lietotni"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods pa e-pastu"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods, izmantojot īsziņu"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apstiprināt"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nevarēja apstiprināt autentifikācijas kodu."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas metode ir deaktivizēta."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])}
            }
          }
        }
      },
      "lt-LT": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutraukti"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mūsų tarnyboje įvyko klaida. Bandykite dar kartą."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas sėkmingai išsiųstas."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siųsti"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mūsų tarnyboje įvyko klaida. Bandykite dar kartą."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas sėkmingai išsiųstas."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siųsti"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Iš naujo išsiųsti po ", _interpolate(_named("seconds")), " sek."])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Iš naujo išsiųsti po ", _interpolate(_named("seconds")), " sek."])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išjunkite dviejų veiksnių autentifikavimą įvesdami ir patvirtindami autentifikavimo kodą. Kodą sugeneruoja autentifikavimo programa."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išjunkite dviejų veiksnių autentifikavimą įvesdami ir patvirtindami autentifikavimo kodą."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išjunkite dviejų veiksnių autentifikavimą įvesdami ir patvirtindami autentifikavimo kodą."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kodas siunčiamas saugomu mobiliojo telefono numeriu ", _interpolate(_named("mobileNumber")), " siunčiama SMS žinute."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kodas bus išsiųstas į ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas per autentifikavimo programą"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas el. Paštu"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas SMS žinute"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patvirtinti"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nepavyko patvirtinti autentifikavimo kodo."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo metodas buvo išjungtas."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])}
            }
          }
        }
      },
      "pt-PT": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abortar"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ocorreu um erro no nosso serviço. Tente novamente."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação foi enviado com sucesso."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ocorreu um erro no nosso serviço. Tente novamente."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação foi enviado com sucesso."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Reenviar em ", _interpolate(_named("seconds")), " segundos"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Reenviar em ", _interpolate(_named("seconds")), " segundos"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desative a autenticação de dois fatores inserindo e confirmando o código de autenticação. O código é gerado pelo aplicativo de autenticação."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desative a autenticação de dois fatores inserindo e confirmando o código de autenticação."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desative a autenticação de dois fatores inserindo e confirmando o código de autenticação."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["O código é enviado para o número de celular armazenado ", _interpolate(_named("mobileNumber")), " enviado por SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["O código será enviado para ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticação via aplicativo de autenticação"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticação por email"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de autenticação via SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não foi possível confirmar o código de autenticação."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O método de autenticação foi desativado."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])}
            }
          }
        }
      },
      "ro-RO": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abandonați"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A apărut o eroare în serviciu. Încercați din nou."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare a fost trimis cu succes."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trimitere"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A apărut o eroare în serviciu. Încercați din nou."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare a fost trimis cu succes."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trimitere"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Retrimitere în ", _interpolate(_named("seconds")), " secunde"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Retrimitere în ", _interpolate(_named("seconds")), " secunde"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezactivați autentificarea cu doi factori introducând și confirmând codul de autentificare. Codul este generat de aplicația de autentificare."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezactivați autentificarea cu doi factori introducând și confirmând codul de autentificare."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezactivați autentificarea cu doi factori introducând și confirmând codul de autentificare."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Codul este trimis către numărul mobil stocat ", _interpolate(_named("mobileNumber")), " trimis prin SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Codul va fi trimis la ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cod de autentificare prin intermediul aplicației de autentificare"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cod de autentificare prin e-mail"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cod de autentificare prin SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmare"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare nu a putut fi confirmat."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metoda de autentificare a fost dezactivată."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])}
            }
          }
        }
      },
      "ru-RU": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прервать"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Произошла ошибка в нашем сервисе. Пожалуйста, попробуйте еще раз."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации был успешно отправлен."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отправить"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Произошла ошибка в нашем сервисе. Пожалуйста, попробуйте еще раз."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации был успешно отправлен."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отправить"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Отправить повторно через ", _interpolate(_named("seconds")), " секунд"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Отправить повторно через ", _interpolate(_named("seconds")), " секунд"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отключите двухфакторную аутентификацию, введя и подтвердив код аутентификации. Код создается приложением аутентификации."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отключите двухфакторную аутентификацию, введя и подтвердив код аутентификации."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отключите двухфакторную аутентификацию, введя и подтвердив код аутентификации."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Код отправляется на сохраненный номер мобильного телефона ", _interpolate(_named("mobileNumber")), ". отправлено по SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Код будет отправлен на адрес ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации через приложение аутентификации"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации по электронной почте"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации по SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтвердить"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации не подтвержден."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Метод аутентификации отключен."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])}
            }
          }
        }
      },
      "sv-SE": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avbryta"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ett fel har uppstått i vår tjänst. Var god försök igen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden skickades framgångsrikt."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skicka"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ett fel har uppstått i vår tjänst. Var god försök igen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden skickades framgångsrikt."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skicka"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Skicka igen om ", _interpolate(_named("seconds")), " sekunder"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Skicka igen om ", _interpolate(_named("seconds")), " sekunder"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inaktivera tvåfaktorautentisering genom att ange och bekräfta autentiseringskoden. Koden genereras av autentiseringsappen."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inaktivera tvåfaktorautentisering genom att ange och bekräfta autentiseringskoden."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inaktivera tvåfaktorautentisering genom att ange och bekräfta autentiseringskoden."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Koden skickas till det lagrade mobilnumret ", _interpolate(_named("mobileNumber")), " skickas via SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Koden skickas till ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskod via autentiseringsapp"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskod via e-post"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskod via SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekräfta"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden kunde inte bekräftas."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringsmetoden är avaktiverad."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])}
            }
          }
        }
      },
      "sk-SK": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V našej službe sa vyskytla chyba. Prosím skúste znova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód bol úspešne odoslaný."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odoslať"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V našej službe sa vyskytla chyba. Prosím skúste znova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód bol úspešne odoslaný."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odoslať"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Opäť odoslať o ", _interpolate(_named("seconds")), " sekúnd"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Opäť odoslať o ", _interpolate(_named("seconds")), " sekúnd"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dvojfaktorovú autentifikáciu deaktivujete zadaním a potvrdením autentifikačného kódu. Kód je generovaný autentifikačnou aplikáciou."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dvojfaktorovú autentifikáciu deaktivujete zadaním a potvrdením autentifikačného kódu."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dvojfaktorovú autentifikáciu deaktivujete zadaním a potvrdením autentifikačného kódu."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kód sa odošle na uložené mobilné číslo ", _interpolate(_named("mobileNumber")), " zaslaná SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kód bude odoslaný na ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačný kód prostredníctvom autentifikačnej aplikácie"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačný kód e-mailom"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikačný kód prostredníctvom SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdiť"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód nebolo možné potvrdiť."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metóda overovania bola deaktivovaná."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])}
            }
          }
        }
      },
      "cs-CZ": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přerušit"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V naší službě se vyskytla chyba. Zkuste to prosím znovu."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód byl úspěšně odeslán."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odeslat"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V naší službě se vyskytla chyba. Zkuste to prosím znovu."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód byl úspěšně odeslán."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odeslat"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Odeslat znovu za ", _interpolate(_named("seconds")), " s."])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Odeslat znovu za ", _interpolate(_named("seconds")), " s."])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivujte dvoufaktorové ověřování zadáním a potvrzením ověřovacího kódu. Kód je generován ověřovací aplikací."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivujte dvoufaktorové ověřování zadáním a potvrzením ověřovacího kódu."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivujte dvoufaktorové ověřování zadáním a potvrzením ověřovacího kódu."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kód je odeslán na uložené číslo mobilního telefonu ", _interpolate(_named("mobileNumber")), " zasláno pomocí SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kód bude odeslán na ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód prostřednictvím ověřovací aplikace"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód e-mailem"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód prostřednictvím SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdit"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nelze potvrdit ověřovací kód."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metoda ověřování byla deaktivována."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])}
            }
          }
        }
      },
      "tr-TR": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hizmetimizde bir hata oluştu. Lütfen tekrar deneyin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu başarıyla gönderildi."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gönder"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hizmetimizde bir hata oluştu. Lütfen tekrar deneyin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu başarıyla gönderildi."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gönder"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("seconds")), " saniye içinde yeniden gönder"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("seconds")), " saniye içinde yeniden gönder"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodunu girip onaylayarak iki faktörlü kimlik doğrulamayı devre dışı bırakın. Kod, kimlik doğrulama uygulaması tarafından oluşturulur."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodunu girip onaylayarak iki faktörlü kimlik doğrulamayı devre dışı bırakın."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodunu girip onaylayarak iki faktörlü kimlik doğrulamayı devre dışı bırakın."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kod, kayıtlı cep telefonu numarasına gönderilir ", _interpolate(_named("mobileNumber")), " SMS ile gönderildi."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kod ", _interpolate(_named("email")), " adresine gönderilecektir."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama uygulaması aracılığıyla kimlik doğrulama kodu"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta ile kimlik doğrulama kodu"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS ile doğrulama kodu"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu onaylanamadı."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama yöntemi devre dışı bırakıldı."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          }
        }
      },
      "hu-HU": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mégse"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba történt a szolgáltatásunkban. Próbálja meg újra."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési kód sikeresen elküldve."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elküld"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba történt a szolgáltatásunkban. Próbálja meg újra."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési kód sikeresen elküldve."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elküld"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Újraküldés ", _interpolate(_named("seconds")), " másodperc múlva"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Újraküldés ", _interpolate(_named("seconds")), " másodperc múlva"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiválja a kétfaktoros hitelesítést a hitelesítési kód megadásával és megerősítésével. A kódot a hitelesítési alkalmazás generálja."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiválja a kétfaktoros hitelesítést a hitelesítési kód megadásával és megerősítésével."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiválja a kétfaktoros hitelesítést a hitelesítési kód megadásával és megerősítésével."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["A kódot elküldjük a tárolt ", _interpolate(_named("mobileNumber")), " mobilszámra SMS-ben küldte."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["A kódot elküldjük a következő címre: ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítési kód a hitelesítési alkalmazáson keresztül"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítési kód e-mailben"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítési kód SMS-ben"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Megerősít"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítő kódot nem sikerült megerősíteni."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési mód kikapcsolva."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])}
            }
          }
        }
      },
      "ar-AE": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إحباط"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حدث خطأ في خدمتنا. حاول مرة اخرى."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة بنجاح."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إرسال"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حدث خطأ في خدمتنا. حاول مرة اخرى."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة بنجاح."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إرسال"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة إرسال في ", _interpolate(_named("seconds")), " ثوان"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة إرسال في ", _interpolate(_named("seconds")), " ثوان"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قم بإلغاء تنشيط المصادقة ذات العاملين عن طريق إدخال رمز المصادقة وتأكيده. يتم إنشاء الرمز بواسطة تطبيق المصادقة."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قم بإلغاء تنشيط المصادقة ذات العاملين عن طريق إدخال رمز المصادقة وتأكيده."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قم بإلغاء تنشيط المصادقة ذات العاملين عن طريق إدخال رمز المصادقة وتأكيده."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["يتم إرسال الرمز إلى رقم الهاتف المحمول المخزن ", _interpolate(_named("mobileNumber")), " مرسلة عن طريق الرسائل القصيرة."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["سيتم إرسال الرمز إلى ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عبر تطبيق المصادقة"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عن طريق البريد الإلكتروني"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رمز المصادقة عبر الرسائل القصيرة"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن تأكيد رمز المصادقة."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إلغاء تنشيط طريقة المصادقة."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        }
      },
      "fr-BE": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé avec succès."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé avec succès."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("seconds")), " secondes"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("seconds")), " secondes"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification. Le code est généré par l'application d'authentification."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code est envoyé au numéro de mobile enregistré ", _interpolate(_named("mobileNumber")), " envoyé par SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code sera envoyé à ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification via l'application d'authentification"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par email"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La méthode d'authentification a été désactivée."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        }
      },
      "fr-LU": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé avec succès."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé avec succès."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("seconds")), " secondes"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("seconds")), " secondes"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification. Le code est généré par l'application d'authentification."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code est envoyé au numéro de mobile enregistré ", _interpolate(_named("mobileNumber")), " envoyé par SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Le code sera envoyé à ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification via l'application d'authentification"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par email"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'authentification par SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La méthode d'authentification a été désactivée."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        }
      },
      "mt-MT": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkanċella"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seħħ żball fis-servizz tagħna. Jekk jogħġbok erġa' pprova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta 'awtentikazzjoni ntbagħat b'suċċess."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ibgħat"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seħħ żball fis-servizz tagħna. Jekk jogħġbok erġa' pprova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta 'awtentikazzjoni ntbagħat b'suċċess."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ibgħat"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erġa' ibgħat fi ", _interpolate(_named("seconds")), " sekondi"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erġa' ibgħat fi ", _interpolate(_named("seconds")), " sekondi"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iddiżattiva l-awtentikazzjoni b'żewġ fatturi billi ddaħħal u tikkonferma l-kodiċi ta 'awtentikazzjoni. Il-kodiċi huwa ġġenerat mill-app ta 'awtentikazzjoni."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iddiżattiva l-awtentikazzjoni b'żewġ fatturi billi ddaħħal u tikkonferma l-kodiċi ta' awtentikazzjoni."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iddiżattiva l-awtentikazzjoni b'żewġ fatturi billi ddaħħal u tikkonferma l-kodiċi ta' awtentikazzjoni."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il-kodiċi jintbagħat lin-numru mobbli maħżun ", _interpolate(_named("mobileNumber")), " mibgħuta bl-SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il-kodiċi jintbagħat lil ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi ta 'awtentikazzjoni permezz ta' app ta 'awtentikazzjoni"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi ta 'awtentikazzjoni bl-email"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi ta 'awtentikazzjoni permezz ta' SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkonferma"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni ma setax jiġi kkonfermat."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni ntbagħat b'suċċess."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])}
            }
          }
        }
      },
      "sl-SI": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prišlo je do napake v naši storitvi. Poskusite ponovno."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti je bila uspešno poslana."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošlji"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prišlo je do napake v naši storitvi. Poskusite ponovno."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti je bila uspešno poslana."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošlji"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošlji v ", _interpolate(_named("seconds")), " sekundah"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošlji v ", _interpolate(_named("seconds")), " sekundah"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dvofaktorsko preverjanje pristnosti izključite tako, da vnesete in potrdite kodo za preverjanje pristnosti. Kodo generira aplikacija za preverjanje pristnosti."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dvofaktorsko preverjanje pristnosti izključite tako, da vnesete in potrdite kodo za preverjanje pristnosti."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dvofaktorsko preverjanje pristnosti izključite tako, da vnesete in potrdite kodo za preverjanje pristnosti."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Koda se pošlje na shranjeno številko mobilnega telefona ", _interpolate(_named("mobileNumber")), " poslano s SMS-om."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Koda bo poslana na ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti prek aplikacije za preverjanje pristnosti"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti po e-pošti"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti prek SMS-a"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potrdi"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kode za preverjanje pristnosti ni bilo mogoče potrditi."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Način preverjanja pristnosti je deaktiviran."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])}
            }
          }
        }
      },
      "el-CY": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Άκυρο"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παρουσιάστηκε σφάλμα στην υπηρεσία μας. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε με επιτυχία."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποστολή"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παρουσιάστηκε σφάλμα στην υπηρεσία μας. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε με επιτυχία."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποστολή"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("seconds")), " δευτερόλεπτα"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("seconds")), " δευτερόλεπτα"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων εισάγοντας και επιβεβαιώνοντας τον κωδικό ελέγχου ταυτότητας. Ο κώδικας δημιουργείται από την εφαρμογή ελέγχου ταυτότητας."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων εισάγοντας και επιβεβαιώνοντας τον κωδικό ελέγχου ταυτότητας."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων εισάγοντας και επιβεβαιώνοντας τον κωδικό ελέγχου ταυτότητας."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ο κωδικός αποστέλλεται στον αποθηκευμένο αριθμό κινητού ", _interpolate(_named("mobileNumber")), " αποστέλλεται με SMS."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ο κωδικός θα σταλεί στη διεύθυνση ", _interpolate(_named("email")), "."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας μέσω εφαρμογής ελέγχου ταυτότητας"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας μέσω email"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός ελέγχου ταυτότητας μέσω SMS"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επιβεβαίωση του κωδικού ελέγχου ταυτότητας."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η μέθοδος ελέγχου ταυτότητας έχει απενεργοποιηθεί."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          }
        }
      },
      "tr-CY": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hizmetimizde bir hata oluştu. Lütfen tekrar deneyin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu başarıyla gönderildi."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gönder"])}
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hizmetimizde bir hata oluştu. Lütfen tekrar deneyin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu başarıyla gönderildi."])}
            }
          }
        },
        "sendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gönder"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("seconds")), " saniye içinde yeniden gönder"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("seconds")), " saniye içinde yeniden gönder"])}
        },
        "removeAuthenticatorApp": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodunu girip onaylayarak iki faktörlü kimlik doğrulamayı devre dışı bırakın. Kod, kimlik doğrulama uygulaması tarafından oluşturulur."])}
            }
          }
        },
        "removeEmailAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodunu girip onaylayarak iki faktörlü kimlik doğrulamayı devre dışı bırakın."])}
            }
          }
        },
        "removeSMSAuthentication": {
          "feedforward": {
            "enterCode": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodunu girip onaylayarak iki faktörlü kimlik doğrulamayı devre dışı bırakın."])}
            }
          }
        },
        "verifyMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kod, kayıtlı cep telefonu numarasına gönderilir ", _interpolate(_named("mobileNumber")), " SMS ile gönderildi."])}
        },
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kod ", _interpolate(_named("email")), " adresine gönderilecektir."])}
        },
        "useAuthenticator": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama uygulaması aracılığıyla kimlik doğrulama kodu"])}
        },
        "useEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta ile kimlik doğrulama kodu"])}
        },
        "useSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS ile doğrulama kodu"])}
        },
        "deactivateAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "removeAuthentication": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu onaylanamadı."])}
            },
            "success": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama yöntemi devre dışı bırakıldı."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          }
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/RemoveMultiFactorAuthenticationForm.vue


/* custom blocks */
;
if (typeof RemoveMultiFactorAuthenticationFormvue_type_custom_index_0_blockType_i18n === 'function') RemoveMultiFactorAuthenticationFormvue_type_custom_index_0_blockType_i18n(RemoveMultiFactorAuthenticationFormvue_type_script_setup_true_lang_js)


const RemoveMultiFactorAuthenticationForm_exports_ = RemoveMultiFactorAuthenticationFormvue_type_script_setup_true_lang_js;

/* harmony default export */ var RemoveMultiFactorAuthenticationForm = (RemoveMultiFactorAuthenticationForm_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/AuthenticatorApp.vue?vue&type=script&setup=true&lang=js



var AuthenticatorAppvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 0,
  class: "dp-color__font__success"
};

var AuthenticatorAppvue_type_script_setup_true_lang_js_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
  class: "el-icon-success"
}, null, -1);

var AuthenticatorAppvue_type_script_setup_true_lang_js_hoisted_3 = {
  key: 0
};
var AuthenticatorAppvue_type_script_setup_true_lang_js_hoisted_4 = {
  key: 1
};





var AuthenticatorAppvue_type_script_setup_true_lang_js_default_ = {
  name: "AuthenticatorApp",
  components: {
    RemoveMultiFactorAuthenticationForm: RemoveMultiFactorAuthenticationForm,
    ActivateAuthenticatorAppForm: ActivateAuthenticatorAppForm
  },
  data: function data() {
    return {
      editAuthentication: false,
      simpleCrudModel: {}
    };
  },
  computed: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useAuthStore, ['user'])), {}, {
    hasAuthenticatorApp: function hasAuthenticatorApp() {
      return get_default()(this.user, 'mfaModes.authenticator', false);
    },
    simpleCrudButtonLabel: function simpleCrudButtonLabel() {
      return this.hasAuthenticatorApp ? this.$t('removeAuthentication.buttonLabel') : this.$t('addAuthenticatorApp.buttonLabel');
    },
    simpleCrudButtonIcon: function simpleCrudButtonIcon() {
      return this.hasAuthenticatorApp ? 'el-icon-remove-outline' : 'el-icon-circle-plus-outline';
    }
  })
};


/* harmony default export */ var AuthenticatorAppvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(AuthenticatorAppvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    var composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables');

    var _composables$useViewp = composables.useViewportSize(),
        isMobile = _composables$useViewp.isMobile;

    return function (_ctx, _cache) {
      var _component_DpSimpleCrud = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpSimpleCrud");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpSimpleCrud, {
        modelValue: _ctx.simpleCrudModel,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(simpleCrudModel) ? simpleCrudModel.value = $event : null;
        }),
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('authenticatorApp.title'),
        showDefaultSlot: _ctx.editAuthentication,
        buttonLabel: _ctx.simpleCrudButtonLabel,
        buttonIcon: _ctx.simpleCrudButtonIcon,
        onActivateSlot: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.editAuthentication = true;
        }),
        screenSizeIsMobile: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
      }, {
        read: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [_ctx.hasAuthenticatorApp ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", AuthenticatorAppvue_type_script_setup_true_lang_js_hoisted_1, [AuthenticatorAppvue_type_script_setup_true_lang_js_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('active.label')), 1)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('authenticatorExplain.label')), 1)];
        }),
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [_ctx.hasAuthenticatorApp ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", AuthenticatorAppvue_type_script_setup_true_lang_js_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(RemoveMultiFactorAuthenticationForm), {
            "authentication-method": "authenticator",
            onCancelForm: _cache[0] || (_cache[0] = function ($event) {
              return _ctx.editAuthentication = false;
            })
          })])) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", AuthenticatorAppvue_type_script_setup_true_lang_js_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(ActivateAuthenticatorAppForm), {
            onCancelForm: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.editAuthentication = false;
            })
          })]))];
        }),
        _: 1
      }, 8, ["modelValue", "headline", "showDefaultSlot", "buttonLabel", "buttonIcon", "screenSizeIsMobile"]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/AuthenticatorApp.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/AuthenticatorApp.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function AuthenticatorAppvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivieren"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wird in einer App auf deinem Gerät erzeugt. Wichtig: Aktiviere mindestens eine zweite Authentifzierungsmethode, falls der Zugriff auf das Gerät nicht möglich ist."])}
        }
      },
      "de-AT": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivieren"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wird in einer App auf deinem Gerät erzeugt. Wichtig: Aktiviere mindestens eine zweite Authentifizierungsmethode, falls der Zugriff auf das Gerät nicht möglich ist."])}
        }
      },
      "de-CH": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungs-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivieren"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wird in einer App auf deinem Gerät erzeugt. Wichtig: Aktiviere mindestens eine zweite Authentifizierungsmethode, falls der Zugriff auf das Gerät nicht möglich ist."])}
        }
      },
      "en-US": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticator-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is generated in an app on your device. Important: Activate at least a second authentication method if the device cannot be accessed."])}
        }
      },
      "en-GB": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticator-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is generated in an app on your device. Important: Activate at least a second authentication method if the device cannot be accessed."])}
        }
      },
      "it-IT": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticator-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disattivare"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione viene generato in un'app del tuo dispositivo. Importante: attiva almeno un secondo metodo di autenticazione nel caso tu non riesca ad accedere al tuo dispositivo."])}
        }
      },
      "fr-FR": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentificateur-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactiver"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est généré dans une application sur votre appareil. Important : activez au moins une deuxième méthode d'authentification si l'appareil n'est pas accessible."])}
        }
      },
      "es-ES": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicación de autenticación"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activar"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desactivar"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activada"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación se genera en una aplicación en tu dispositivo. Importante: active al menos un segundo método de autenticación si no puede acceder a su dispositivo."])}
        }
      },
      "pl-PL": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacja Authenticator"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywuj"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zdezaktywuj"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowano"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający jest generowany w aplikacji na Twoim urządzeniu. Ważne: aktywuj co najmniej drugą metodę uwierzytelniania, jeśli nie można uzyskać dostępu do urządzenia."])}
        }
      },
      "nl-NL": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticator-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activeren"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactiveren"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De verificatiecode wordt gegenereerd in een app op uw apparaat. Belangrijk: Activeer ten minste een tweede authenticatiemethode als het apparaat niet kan worden benaderd."])}
        }
      },
      "bg-BG": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приложение за удостоверяване"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активиране"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивиране"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирано"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване се генерира в приложение на Wашето устройство. Важно: Активирайте поне втори метод за удостоверяване, ако нямате достъп до устройството."])}
        }
      },
      "bs-BA": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija za autentifikaciju"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirajte"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviraj"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kôd generira se u aplikaciji na vašem uređaju. Važno: Aktivirajte barem još jednu metodu autentifikacije ako ne možete pristupiti uređaju."])}
        }
      },
      "zh-CN": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["身份验证器应用"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["激活"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["停用"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已激活"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您设备上的应用程序会生成验证码。重要提示：如果无法访问设备，请至少激活两种身份验证方法。"])}
        }
      },
      "da-DK": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticator-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivér"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiver"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveret"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden genereres i en app på din enhed. Vigtigt: Aktivér mindst en anden godkendelsesmetode, hvis der ikke er adgang til enheden."])}
        }
      },
      "et-EE": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticator-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeri"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desaktiveeri"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeritud"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood genereeritakse teie seadme rakenduses. Oluline: kui seadmele juurde ei pääse, aktiveerige vähemalt teine autentimismeetod."])}
        }
      },
      "fi-FI": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticator-Sovellus"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoi"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista käytöstä"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoitu"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi luodaan laitteesi sovelluksessa. Tärkeää: Ota käyttöön vähintään toinen todennustapa, jos laitetta ei voida käyttää."])}
        }
      },
      "el-GR": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εφαρμογή ελέγχου ταυτότητας"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποίηση"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας δημιουργείται σε μια εφαρμογή στη συσκευή σας. Σημαντικό: Ενεργοποιήστε τουλάχιστον μια δεύτερη μέθοδο ελέγχου ταυτότητας εάν δεν είναι δυνατή η πρόσβαση στη συσκευή."])}
        }
      },
      "he-IL": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מאמת-אפליקציה"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפְעִיל"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["בטל הפעלה"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מופעל"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות נוצר באפליקציה במכשיר שלך. חשוב: הפעל שיטת אימות שנייה לפחות אם לא ניתן לגשת למכשיר."])}
        }
      },
      "ga-IE": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aip fíordheimhnitheora"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaigh"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Díghníomhachtaigh"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaithe"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gintear an cód fíordheimhnithe in aip ar do ghléas. Tábhachtach: Gníomhachtaigh an dara modh fíordheimhnithe ar a laghad mura féidir an gléas a rochtain."])}
        }
      },
      "ja-JP": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証アプリ"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティベート"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["非アクティブ化"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティブ化"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードは、デバイス上のアプリで生成されます。 重要: デバイスにアクセスできない場合は、少なくとも 2 番目の認証方法を有効にしてください。"])}
        }
      },
      "hr-HR": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikator-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviraj"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obustaviti"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikacijski kôd generira se u aplikaciji na vašem uređaju. Važno: aktivirajte barem drugu metodu provjere autentičnosti ako uređaju nije moguće pristupiti."])}
        }
      },
      "lv-LV": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikators-lietotne"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēt"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivizēt"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēts"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods tiek ģenerēts jūsu ierīces lietotnē. Svarīgi! Aktivizējiet vismaz otru autentifikācijas metodi gadījumam, ja nevarat piekļūt ierīcei."])}
        }
      },
      "lt-LT": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["„Authenticator“ programa"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinti"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išjungti"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinta"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas sugeneruojamas jūsų įrenginio programoje. Svarbu: suaktyvinkite bent antrą autentifikavimo metodą, jei nepavyksta pasiekti įrenginio."])}
        }
      },
      "pt-PT": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authenticator-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativar"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desativar"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativado"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação é gerado numa aplicação no seu dispositivo. Importante: ative pelo menos um segundo método de autenticação caso não seja possível aceder ao dispositivo."])}
        }
      },
      "ro-RO": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicație de autentificare"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activare"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezactivare"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activat"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare este generat de o aplicație de pe dispozitivul dvs. Important: activați cel puțin o a doua metodă de autentificare, pentru situațiile în care nu puteți accesa dispozitivul."])}
        }
      },
      "ru-RU": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приложение для аутентификации"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировать"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивировать"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировано"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации генерируется в приложении на вашем устройстве. Важно: активируйте хотя бы второй метод аутентификации, если к устройству нет доступа."])}
        }
      },
      "sv-SE": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringsapp"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivera"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avaktivera"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiverad"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden genereras i en app på din enhet. Viktigt! Aktivera minst en andra autentiseringsmetod om enheten inte kan nås."])}
        }
      },
      "sk-SK": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikácia Authenticator"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovať"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivovať"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivované"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód sa generuje v aplikácii na vašom zariadení. Dôležité: Ak nie je k zariadeniu prístup, aktivujte aspoň druhú metódu overenia."])}
        }
      },
      "cs-CZ": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikace Authenticator"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovat"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivovat"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivováno"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód je generován v aplikaci na vašem zařízení. Důležité: Pokud k zařízení nelze získat přístup, aktivujte alespoň druhou metodu ověřování."])}
        }
      },
      "tr-TR": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik Doğrulayıcı-Uygulama"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştir"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırak"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu, cihazınızdaki bir uygulamada oluşturulur. Önemli: Cihaza erişilemiyorsa en az ikinci bir kimlik doğrulama yöntemini etkinleştirin."])}
        }
      },
      "hu-HU": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hitelesítő app"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiválja"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivál"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivált"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítő kódot az alkalmazás generálja a készülékén. Fontos: Aktiváljon legalább egy második hitelesítési módot, ha nem tudja elérni az eszközt."])}
        }
      },
      "ar-AE": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تطبيق المصادقة"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إلغاء تنشيط"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يتم إنشاء رمز المصادقة في تطبيق على جهازك. هام: قم بتنشيط طريقة مصادقة ثانية على الأقل إذا تعذر الوصول إلى الجهاز."])}
        }
      },
      "fr-BE": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentificateur-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactiver"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est généré dans une application sur votre appareil. Important : activez au moins une deuxième méthode d'authentification si l'appareil n'est pas accessible."])}
        }
      },
      "fr-LU": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentificateur-App"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactiver"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est généré dans une application sur votre appareil. Important : activez au moins une deuxième méthode d'authentification si l'appareil n'est pas accessible."])}
        }
      },
      "mt-MT": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App tal-Awtentikatur"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iddiżattiva"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivat"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni huwa ġġenerat f'app fuq it-tagħmir tiegħek. Importanti: Attiva mill-inqas it-tieni metodu ta' awtentikazzjoni jekk it-tagħmir ma jistax jiġi aċċessat."])}
        }
      },
      "sl-SI": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija za preverjanje pristnosti"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviraj"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviraj"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti se ustvari v aplikaciji v vaši napravi. Pomembno: Če do naprave ni mogoče dostopati, aktivirajte vsaj drugi način preverjanja pristnosti."])}
        }
      },
      "el-CY": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εφαρμογή ελέγχου ταυτότητας"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποίηση"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας δημιουργείται σε μια εφαρμογή στη συσκευή σας. Σημαντικό: Ενεργοποιήστε τουλάχιστον μια δεύτερη μέθοδο ελέγχου ταυτότητας εάν δεν είναι δυνατή η πρόσβαση στη συσκευή."])}
        }
      },
      "tr-CY": {
        "authenticatorApp": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik Doğrulayıcı-Uygulama"])}
        },
        "addAuthenticatorApp": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştir"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırak"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
        },
        "authenticatorExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu, cihazınızdaki bir uygulamada oluşturulur. Önemli: Cihaza erişilemiyorsa en az ikinci bir kimlik doğrulama yöntemini etkinleştirin."])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/AuthenticatorApp.vue


/* custom blocks */
;
if (typeof AuthenticatorAppvue_type_custom_index_0_blockType_i18n === 'function') AuthenticatorAppvue_type_custom_index_0_blockType_i18n(AuthenticatorAppvue_type_script_setup_true_lang_js)


const AuthenticatorApp_exports_ = AuthenticatorAppvue_type_script_setup_true_lang_js;

/* harmony default export */ var AuthenticatorApp = (AuthenticatorApp_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateEmailAuthenticationForm.vue?vue&type=script&setup=true&lang=js









var ActivateEmailAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 0
};
var ActivateEmailAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_2 = {
  key: 1
};




var ActivateEmailAuthenticationFormvue_type_script_setup_true_lang_js_default_ = {
  name: "ActivateEmailAuthenticationForm",
  data: function data() {
    return {
      form: {
        mode: 'email',
        totp: ''
      },
      loading: false,
      sendEmailDisabled: false,
      countdown: 0
    };
  },
  computed: _objectSpread2(_objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ['apiUrls'])), (0,external_pinia_.mapState)(store_modules_.useAuthStore, ['user'])), {}, {
    emailDisguised: function emailDisguised() {
      // Show only first three characters of email address name
      var email = this.user.email.split('@');
      email[0] = email[0].substr(0, 3) + '...';
      return email.join('@');
    }
  }),
  methods: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapActions)(store_modules_.useAuthStore, ['validate'])), {}, {
    resetFields: function resetFields() {
      this.form.totp = '';
    },
    activateEmailAuthentication: function activateEmailAuthentication() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var err, res, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return external_await_to_js_default()(_this.$http.post("".concat(_this.apiUrls.dutypay, "/api/v0/activate/auth-email"), _objectSpread2({}, _this.form)));

              case 3:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];

                if (!err) {
                  _context.next = 10;
                  break;
                }

                _this.loading = false;
                throw err;

              case 10:
                _context.next = 12;
                return _this.cancelForm();

              case 12:
                _this.resetFields();

                _context.next = 15;
                return _this.validate({});

              case 15:
                _this.loading = false;
                return _context.abrupt("return", res);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    sendAuthenticationEmail: function sendAuthenticationEmail() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var err, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.sendEmailDisabled = true;
                _context2.next = 3;
                return external_await_to_js_default()(_this2.$http.post("".concat(_this2.apiUrls.dutypay, "/api/v0/send/auth-email")));

              case 3:
                _yield$to3 = _context2.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 1);
                err = _yield$to4[0];

                if (!err) {
                  _context2.next = 10;
                  break;
                }

                _this2.$notify.error({
                  title: _this2.$t('sendAuthenticationEmail.notification.asyncError.title'),
                  message: _this2.$t('sendAuthenticationEmail.notification.asyncError.message')
                });

                _this2.sendEmailDisabled = false;
                throw err;

              case 10:
                _this2.countdown = 20;

                _this2.countDownTimer();

                _this2.$notify.success({
                  title: _this2.$t('sendAuthenticationEmail.notification.success.title'),
                  message: _this2.$t('sendAuthenticationEmail.notification.success.message')
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    countDownTimer: function countDownTimer() {
      var _this3 = this;

      if (this.countdown > 0) {
        setTimeout(function () {
          _this3.countdown -= 1;

          _this3.countDownTimer();
        }, 1000);
      } else {
        this.sendEmailDisabled = false;
      }
    },
    cancelForm: function cancelForm() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.$emit('cancel-form');

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  })
};

/* harmony default export */ var ActivateEmailAuthenticationFormvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(ActivateEmailAuthenticationFormvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_el_form_item = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-form-item");

      var _component_DpInputMultiFactorAuthenticationCode = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpInputMultiFactorAuthenticationCode");

      var _component_DpForm = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpForm");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpForm, {
        modelValue: _ctx.form,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(form) ? form.value = $event : null;
        }),
        reference: "activate-email-authentication",
        action: _ctx.activateEmailAuthentication,
        primaryButtonLabel: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('confirmCode.buttonLabel'),
        "notification-success": {
          title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activateEmailAuthentication.notification.success.title'),
          message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activateEmailAuthentication.notification.success.message')
        },
        "notification-async-error": {
          title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activateEmailAuthentication.notification.asyncError.title'),
          message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activateEmailAuthentication.notification.asyncError.message')
        }
      }, {
        secondaryButton: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            purpose: "secondaryAction",
            onClick: _ctx.cancelForm
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('cancel.buttonLabel')), 1)];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('verifyEmailAddress.label', {
            email: _ctx.emailDisguised
          })), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form_item, null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                purpose: "primaryAction",
                disabled: _ctx.sendEmailDisabled,
                onClick: _ctx.sendAuthenticationEmail
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [_ctx.sendEmailDisabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", ActivateEmailAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('resendEmailInSeconds.buttonLabel', {
                    seconds: _ctx.countdown
                  })), 1)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", ActivateEmailAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('sendEmail.buttonLabel')), 1))];
                }),
                _: 1
              }, 8, ["disabled", "onClick"])];
            }),
            _: 1
          }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpInputMultiFactorAuthenticationCode, {
            modelValue: _ctx.form.totp,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.form.totp = $event;
            }),
            prop: "totp",
            required: ""
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["modelValue", "action", "primaryButtonLabel", "notification-success", "notification-async-error"])), [[_directive_loading, _ctx.loading]]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateEmailAuthenticationForm.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateEmailAuthenticationForm.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function ActivateEmailAuthenticationFormvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes. Der Code wird an ", _interpolate(_named("email")), " gesendet."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungsmethode wurde aktiviert."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde erfolgreich gesendet."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("seconds")), " Sekunden"])}
        }
      },
      "de-AT": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes. Der Code wird an ", _interpolate(_named("email")), " gesendet."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungsmethode wurde aktiviert."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde erfolgreich gesendet."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("seconds")), " Sekunden"])}
        }
      },
      "de-CH": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes. Der Code wird an ", _interpolate(_named("email")), " gesendet."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungsmethode wurde aktiviert."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde erfolgreich gesendet."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("seconds")), " Sekunden"])}
        }
      },
      "en-US": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Activate two-factor authentication by entering and confirming the authentication code. The code will be sent to ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code could not be confirmed."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication method has been activated."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error has occurred in our service. Please try again."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent successfully."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend in 59 seconds"])}
        }
      },
      "en-GB": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Activate two-factor authentication by entering and confirming the authentication code. The code will be sent to ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code could not be confirmed."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication method has been activated."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error has occurred in our service. Please try again."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent successfully."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend in 59 seconds"])}
        }
      },
      "it-IT": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Attiva l'autenticazione a due fattori inserendo e confermando il codice di autenticazione. Il codice verrà inviato a ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conferma"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non è stato possibile confermare il codice di autenticazione."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il metodo di autenticazione è stato attivato."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si è verificato un errore nel nostro servizio. Per favore riprova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione è stato inviato con successo."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Invia nuovamente tra ", _interpolate(_named("seconds")), " secondi"])}
        }
      },
      "fr-FR": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Activez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification. Le code sera envoyé à ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La méthode d'authentification a été activée."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé avec succès."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("seconds")), " secondes"])}
        }
      },
      "es-ES": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Active la autenticación en dos pasos introduciendo y confirmando el código de autenticación. El código se enviará a ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se pudo confirmar el código de autenticación."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se ha activado el método de autenticación."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ha habido un error en nuestro servicio. Inténtelo de nuevo, por favor."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación se envió correctamente."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Enviar de nuevo en ", _interpolate(_named("seconds")), " segundos"])}
        }
      },
      "pl-PL": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktywuj uwierzytelnianie dwuskładnikowe, wprowadzając i potwierdzając kod uwierzytelniający. Kod zostanie wysłany na adres ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdź"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie udało się potwierdzić kodu uwierzytelniającego."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metoda uwierzytelniania została aktywowana."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["W naszym serwisie wystąpił błąd. Prosimy, spróbuj ponownie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający został pomyślnie wysłany."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyślij"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Wyślij ponownie za ", _interpolate(_named("seconds")), " s"])}
        }
      },
      "nl-NL": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Activeer de twee-factor authenticatie door de authenticatiecode in te voeren en te bevestigen. De code zal naar ", _interpolate(_named("email")), " worden gestuurd."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afbreken"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authencitatiecode kon niet worden bevestigd."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificatiemethode is geactiveerd."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Er is een fout opgetreden in onze service. Gelieve opnieuw te proberen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authenticatiecode is succesvol verzonden."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verzenden"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Verzenden over ", _interpolate(_named("seconds")), " seconden"])}
        }
      },
      "bg-BG": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Активирайте двуфакторно удостоверяване, като въведете и потвърдите кода за удостоверяване. Кодът ще бъде изпратен на ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потвърждение"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прекратяване"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване не може да бъде потвърден."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активиран е методът за удостоверяване."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Възникна грешка в нашата услуга. Моля, опитайте отново."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване е изпратен успешно."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изпращане"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Изпращане след ", _interpolate(_named("seconds")), " секунди"])}
        }
      },
      "bs-BA": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktivirajte dvofaktorsku autentifikaciju unosom i potvrđivanjem autentifikacijskog koda. Kôd će biti poslan na ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdite"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće potvrditi autentifikacijski kôd."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran je način autentifikacije."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Došlo je do greške u našem servisu. Molimo pokušajte ponovo."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za provjeru autentičnosti je uspješno poslan."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošalji"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovo pošalji za ", _interpolate(_named("seconds")), " sekundi"])}
        }
      },
      "zh-CN": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["输入并确认身份验证码以激活双重身份验证。代码将发送至", _interpolate(_named("email")), "。"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中止"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无法确认验证码。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["身份验证方法已激活。"])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我们的服务发生了错误。 请再试一遍。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["验证码发送成功。"])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发送"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["在", _interpolate(_named("seconds")), "内重新发送"])}
        }
      },
      "da-DK": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktiver tofaktorautentificering ved at indtaste og bekræfte godkendelseskoden. Koden sendes til ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekræft"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden kunne ikke bekræftes."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelsesmetode er aktiveret."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der opstod en fejl i vores service. Prøv igen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden blev sendt med succes."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Send igen om ", _interpolate(_named("seconds")), " sekunder"])}
        }
      },
      "et-EE": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktiveerige kaheastmeline autentimine, sisestades ja kinnitades autentimiskoodi. Kood saadetakse aadressile ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinnita"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Katkesta"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskoodi ei õnnestunud kinnitada."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimismeetod on aktiveeritud."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meie teenuses on ilmnenud tõrge. Palun proovi uuesti."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskoodi saatmine õnnestus."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saada"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Saada uuesti ", _interpolate(_named("seconds")), " sekundi pärast"])}
        }
      },
      "fi-FI": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktivoi kaksivaiheinen todennus syöttämällä ja vahvistamalla todennuskoodi. Koodi lähetetään osoitteeseen ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vahvista"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keskeyttää"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodia ei voitu vahvistaa."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennusmenetelmä on aktivoitu."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Palvelussamme on tapahtunut virhe. Olkaa hyvä, ja yrittäkää uudelleen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi lähetettiin onnistuneesti."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähetä"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Lähetä uudelleen ", _interpolate(_named("seconds")), " sekunnissa"])}
        }
      },
      "el-GR": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων εισάγοντας και επιβεβαιώνοντας τον κωδικό ελέγχου ταυτότητας. Ο κωδικός θα σταλεί στη διεύθυνση ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποβάλλω"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επιβεβαίωση του κωδικού ελέγχου ταυτότητας."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η μέθοδος ελέγχου ταυτότητας έχει ενεργοποιηθεί."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παρουσιάστηκε σφάλμα στην υπηρεσία μας. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λάθος"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε με επιτυχία."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποστολή"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("seconds")), " δευτερόλεπτα"])}
        }
      },
      "he-IL": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["הפעל אימות דו-גורמי על ידי הזנת קוד האימות ואישורו. הקוד יישלח אל ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְאַשֵׁר"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפִּיל"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא ניתן היה לאשר את קוד האימות."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שיטת האימות הופעלה."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אירעה שגיאה בשירות שלנו. בבקשה נסה שוב."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות נשלח בהצלחה."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["שלח מחדש בתוך ", _interpolate(_named("seconds")), " שניות"])}
        }
      },
      "ga-IE": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Gníomhachtaigh fíordheimhniú dhá fhachtóir tríd an gcód fíordheimhnithe a iontráil agus a dhearbhú. Seolfar an cód chuig ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deimhnigh"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ginmhilleadh"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Níorbh fhéidir an cód fíordheimhnithe a dhearbhú."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuireadh modh fíordheimhnithe i ngníomh."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tharla earráid inár seirbhís. Arís, le d'thoil."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuireadh an cód fíordheimhnithe go rathúil."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seol"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Athsheol i gceann ", _interpolate(_named("seconds")), " soicind"])}
        }
      },
      "ja-JP": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["認証コードを入力して確認することで、二要素認証を有効にします。 コードは ", _interpolate(_named("email")), " に送信されます。"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アボート"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードが確認できませんでした。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証方法が有効化されました。"])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["サービスでエラーが発生しました。 もう一度お試しください。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードは正常に送信されました。"])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["送信"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("seconds")), "秒で再送信"])}
        }
      },
      "hr-HR": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktivirajte dvofaktorsku autentifikaciju unosom i potvrđivanjem autentifikacijskog koda. Kôd će se poslati na ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrda"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekid"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće potvrditi autentifikacijski kod."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirana je metoda autentifikacije."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Došlo je do pogreške u našoj usluzi. Molim vas pokušajte ponovno."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za ovjeru uspješno je poslan."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slati"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno slanje u ", _interpolate(_named("seconds")), " sekundama"])}
        }
      },
      "lv-LV": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktivizējiet divfaktoru autentifikāciju, ievadot un apstiprinot autentifikācijas kodu. Kods tiks nosūtīts uz ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apstiprināt"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pārtraukt"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nevarēja apstiprināt autentifikācijas kodu."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas metode ir aktivizēta."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mūsu pakalpojumā ir radusies kļūda. Lūdzu, mēģiniet vēlreiz."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods tika veiksmīgi nosūtīts."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sūtīt"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Atkārtoti nosūtīt pēc ", _interpolate(_named("seconds")), " sek."])}
        }
      },
      "lt-LT": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Suaktyvinkite dviejų veiksnių autentifikavimą įvesdami ir patvirtindami autentifikavimo kodą. Kodas bus išsiųstas į ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patvirtinti"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutraukti"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nepavyko patvirtinti autentifikavimo kodo."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo metodas suaktyvintas."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mūsų tarnyboje įvyko klaida. Bandykite dar kartą."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas sėkmingai išsiųstas."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siųsti"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Iš naujo išsiųsti po ", _interpolate(_named("seconds")), " sek."])}
        }
      },
      "pt-PT": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ative a autenticação de dois fatores inserindo e confirmando o código de autenticação. O código será enviado para ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abortar"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não foi possível confirmar o código de autenticação."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O método de autenticação foi ativado."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ocorreu um erro no nosso serviço. Tente novamente."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação foi enviado com sucesso."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Reenviar em ", _interpolate(_named("seconds")), " segundos"])}
        }
      },
      "ro-RO": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Activați autentificarea cu doi factori introducând și confirmând codul de autentificare. Codul va fi trimis la ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmare"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abandonați"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare nu a putut fi confirmat."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A fost activată metoda de autentificare."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A apărut o eroare în serviciu. Încercați din nou."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare a fost trimis cu succes."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trimitere"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Retrimitere în ", _interpolate(_named("seconds")), " secunde"])}
        }
      },
      "ru-RU": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Активируйте двухфакторную аутентификацию, введя и подтвердив код аутентификации. Код будет отправлен на адрес ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтвердить"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прервать"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации не подтвержден."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирован метод аутентификации."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Произошла ошибка в нашем сервисе. Пожалуйста, попробуйте еще раз."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ошибка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации был успешно отправлен."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отправить"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Отправить повторно через ", _interpolate(_named("seconds")), " секунд"])}
        }
      },
      "sv-SE": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktivera tvåfaktorautentisering genom att ange och bekräfta autentiseringskoden. Koden skickas till ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekräfta"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avbryta"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden kunde inte bekräftas."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verifieringsmetoden har aktiverats."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ett fel har uppstått i vår tjänst. Var god försök igen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden skickades framgångsrikt."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skicka"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Skicka igen om ", _interpolate(_named("seconds")), " sekunder"])}
        }
      },
      "sk-SK": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktivujte dvojfaktorové overenie zadaním a potvrdením overovacieho kódu. Kód bude odoslaný na ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdiť"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód nebolo možné potvrdiť."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metóda overovania bola aktivovaná."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V našej službe sa vyskytla chyba. Prosím skúste znova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód bol úspešne odoslaný."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odoslať"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Opäť odoslať o ", _interpolate(_named("seconds")), " sekúnd"])}
        }
      },
      "cs-CZ": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktivujte dvoufaktorové ověřování zadáním a potvrzením ověřovacího kódu. Kód bude odeslán na ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdit"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přerušit"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nelze potvrdit ověřovací kód."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metoda ověřování byla aktivována."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V naší službě se vyskytla chyba. Zkuste to prosím znovu."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód byl úspěšně odeslán."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odeslat"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Odeslat znovu za ", _interpolate(_named("seconds")), " s."])}
        }
      },
      "tr-TR": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kimlik doğrulama kodunu girip onaylayarak iki faktörlü kimlik doğrulamayı etkinleştirin. Kod ", _interpolate(_named("email")), " adresine gönderilecektir."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu onaylanamadı."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama yöntemi etkinleştirildi."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hizmetimizde bir hata oluştu. Lütfen tekrar deneyin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu başarıyla gönderildi."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gönder"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("seconds")), " saniye içinde yeniden gönder"])}
        }
      },
      "hu-HU": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Aktiválja a kétfaktoros hitelesítést a hitelesítő kód megadásával és megerősítésével. A kódot elküldjük a következő címre: ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Megerősít"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mégse"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítő kódot nem sikerült megerősíteni."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési módszer aktiválva van."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba történt a szolgáltatásunkban. Próbálja meg újra."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési kód sikeresen elküldve."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elküld"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Újraküldés ", _interpolate(_named("seconds")), " másodperc múlva"])}
        }
      },
      "ar-AE": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["قم بتنشيط المصادقة ذات العاملين عن طريق إدخال رمز المصادقة وتأكيده. سيتم إرسال الرمز إلى ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إحباط"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن تأكيد رمز المصادقة."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم تفعيل طريقة المصادقة."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حدث خطأ في خدمتنا. حاول مرة اخرى."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة بنجاح."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إرسال"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة إرسال في ", _interpolate(_named("seconds")), " ثوان"])}
        }
      },
      "fr-BE": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Activez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification. Le code sera envoyé à ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La méthode d'authentification a été activée."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé avec succès."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("seconds")), " secondes"])}
        }
      },
      "fr-LU": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Activez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification. Le code sera envoyé à ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La méthode d'authentification a été activée."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé avec succès."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("seconds")), " secondes"])}
        }
      },
      "mt-MT": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Attiva awtentikazzjoni b'żewġ fatturi billi ddaħħal u tikkonferma l-kodiċi ta' awtentikazzjoni. Il-kodiċi jintbagħat lil ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkonferma"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkanċella"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni ma setax jiġi kkonfermat."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-metodu ta 'awtentikazzjoni ġie attivat."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seħħ żball fis-servizz tagħna. Jekk jogħġbok erġa' pprova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta 'awtentikazzjoni ntbagħat b'suċċess."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ibgħat"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erġa' ibgħat fi ", _interpolate(_named("seconds")), " sekondi"])}
        }
      },
      "sl-SI": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Dvakratno preverjanje pristnosti aktivirajte tako, da vnesete in potrdite kodo za preverjanje pristnosti. Koda bo poslana na naslov ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potrdi"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kode za preverjanje pristnosti ni bilo mogoče potrditi."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirana je metoda preverjanja pristnosti."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prišlo je do napake v naši storitvi. Poskusite ponovno."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti je bila uspešno poslana."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošlji"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošlji v ", _interpolate(_named("seconds")), " sekundah"])}
        }
      },
      "el-CY": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων εισάγοντας και επιβεβαιώνοντας τον κωδικό ελέγχου ταυτότητας. Ο κωδικός θα σταλεί στη διεύθυνση ", _interpolate(_named("email")), "."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Άκυρο"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επιβεβαίωση του κωδικού ελέγχου ταυτότητας."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η μέθοδος ελέγχου ταυτότητας έχει ενεργοποιηθεί."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παρουσιάστηκε σφάλμα στην υπηρεσία μας. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λάθος"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε με επιτυχία."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποστολή"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("seconds")), " δευτερόλεπτα"])}
        }
      },
      "tr-CY": {
        "verifyEmailAddress": {
          "label": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Kimlik doğrulama kodunu girip onaylayarak iki faktörlü kimlik doğrulamayı etkinleştirin. Kod ", _interpolate(_named("email")), " adresine gönderilecektir."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        },
        "activateEmailAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu onaylanamadı."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama yöntemi etkinleştirildi."])}
            }
          }
        },
        "sendAuthenticationEmail": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hizmetimizde bir hata oluştu. Lütfen tekrar deneyin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu başarıyla gönderildi."])}
            }
          }
        },
        "sendEmail": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gönder"])}
        },
        "resendEmailInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("seconds")), " saniye içinde yeniden gönder"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateEmailAuthenticationForm.vue


/* custom blocks */
;
if (typeof ActivateEmailAuthenticationFormvue_type_custom_index_0_blockType_i18n === 'function') ActivateEmailAuthenticationFormvue_type_custom_index_0_blockType_i18n(ActivateEmailAuthenticationFormvue_type_script_setup_true_lang_js)


const ActivateEmailAuthenticationForm_exports_ = ActivateEmailAuthenticationFormvue_type_script_setup_true_lang_js;

/* harmony default export */ var ActivateEmailAuthenticationForm = (ActivateEmailAuthenticationForm_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/EmailAuthentication.vue?vue&type=script&setup=true&lang=js



var EmailAuthenticationvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 0,
  class: "dp-color__font__success"
};

var EmailAuthenticationvue_type_script_setup_true_lang_js_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
  class: "el-icon-success"
}, null, -1);

var EmailAuthenticationvue_type_script_setup_true_lang_js_hoisted_3 = {
  key: 0
};
var EmailAuthenticationvue_type_script_setup_true_lang_js_hoisted_4 = {
  key: 1
};





var EmailAuthenticationvue_type_script_setup_true_lang_js_default_ = {
  name: "EmailAuthentication",
  components: {
    ActivateEmailAuthenticationForm: ActivateEmailAuthenticationForm,
    RemoveMultiFactorAuthenticationForm: RemoveMultiFactorAuthenticationForm
  },
  data: function data() {
    return {
      editAuthentication: false,
      simpleCrudModel: {}
    };
  },
  computed: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useAuthStore, ['user'])), {}, {
    hasEmailAuthentication: function hasEmailAuthentication() {
      return get_default()(this.user, 'mfaModes.email', false);
    },
    simpleCrudButtonLabel: function simpleCrudButtonLabel() {
      return this.hasEmailAuthentication ? this.$t('removeAuthentication.buttonLabel') : this.$t('addEmailAuthentication.buttonLabel');
    },
    simpleCrudButtonIcon: function simpleCrudButtonIcon() {
      return this.hasEmailAuthentication ? 'el-icon-remove-outline' : 'el-icon-circle-plus-outline';
    }
  })
};


/* harmony default export */ var EmailAuthenticationvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(EmailAuthenticationvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    var composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables');

    var _composables$useViewp = composables.useViewportSize(),
        isMobile = _composables$useViewp.isMobile;

    return function (_ctx, _cache) {
      var _component_DpSimpleCrud = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpSimpleCrud");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpSimpleCrud, {
        modelValue: _ctx.simpleCrudModel,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(simpleCrudModel) ? simpleCrudModel.value = $event : null;
        }),
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('emailAuthentication.title'),
        showDefaultSlot: _ctx.editAuthentication,
        buttonLabel: _ctx.simpleCrudButtonLabel,
        buttonIcon: _ctx.simpleCrudButtonIcon,
        onActivateSlot: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.editAuthentication = true;
        }),
        screenSizeIsMobile: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
      }, {
        read: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [_ctx.hasEmailAuthentication ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", EmailAuthenticationvue_type_script_setup_true_lang_js_hoisted_1, [EmailAuthenticationvue_type_script_setup_true_lang_js_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('active.label')), 1)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('emailAuthenticationExplain.label')), 1)];
        }),
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [_ctx.hasEmailAuthentication ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", EmailAuthenticationvue_type_script_setup_true_lang_js_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(RemoveMultiFactorAuthenticationForm), {
            "authentication-method": "email",
            onCancelForm: _cache[0] || (_cache[0] = function ($event) {
              return _ctx.editAuthentication = false;
            })
          })])) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", EmailAuthenticationvue_type_script_setup_true_lang_js_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(ActivateEmailAuthenticationForm), {
            onCancelForm: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.editAuthentication = false;
            })
          })]))];
        }),
        _: 1
      }, 8, ["modelValue", "headline", "showDefaultSlot", "buttonLabel", "buttonIcon", "screenSizeIsMobile"]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/EmailAuthentication.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/EmailAuthentication.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function EmailAuthenticationvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivieren"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wird an deine Benutzer E-Mail-Adresse gesendet. Wichtig: Aktiviere mindestens eine zweite Authentifzierungsmethode, falls der Zugriff auf deine E-Mail nicht möglich ist."])}
        }
      },
      "de-AT": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivieren"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wird an deine Benutzer E-Mail-Adresse gesendet. Wichtig: Aktiviere mindestens eine zweite Authentifizierungsmethode, falls der Zugriff auf deine E-Mail nicht möglich ist."])}
        }
      },
      "de-CH": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivieren"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wird an deine Benutzer E-Mail-Adresse gesendet. Wichtig: Aktiviere mindestens eine zweite Authentifizierungsmethode, falls der Zugriff auf deine E-Mail nicht möglich ist."])}
        }
      },
      "en-US": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code will be sent to your user email address. Important: Activate at least a second authentication method if you cannot access your e-mail."])}
        }
      },
      "en-GB": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code will be sent to your user email address. Important: Activate at least a second authentication method if you cannot access your e-mail."])}
        }
      },
      "it-IT": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disattivare"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione verrà inviato all'indirizzo email dell'utente. Importante: attiva almeno un secondo metodo di autenticazione se non riesci ad accedere alla tua posta elettronica."])}
        }
      },
      "fr-FR": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactiver"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification sera envoyé à votre adresse e-mail d'utilisateur. Important : activez au moins une deuxième méthode d'authentification si vous ne pouvez pas accéder à votre messagerie."])}
        }
      },
      "es-ES": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Correo electrónico"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activar"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desactivar"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activada"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación se enviará a su dirección de correo electrónico de usuario. Importante: active al menos un segundo método de autenticación si no puede acceder a su correo electrónico."])}
        }
      },
      "pl-PL": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywuj"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zdezaktywuj"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowano"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający zostanie wysłany na Twój adres e-mail użytkownika. Ważne: Aktywuj co najmniej drugą metodę uwierzytelniania, jeśli nie możesz uzyskać dostępu do poczty e-mail."])}
        }
      },
      "nl-NL": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activeren"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactiveren"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authenticatiecode wordt naar het e-mailadres van uw gebruiker verzonden. Belangrijk: Activeer minimaal een tweede authenticatiemethode als je geen toegang hebt tot je e-mail."])}
        }
      },
      "bg-BG": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имейл"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активиране"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивиране"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирано"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване ще бъде изпратен на вашия имейл адрес на потребителя. Важно: Активирайте поне втори метод за удостоверяване, ако не можете да осъществите достъп до електронната си поща."])}
        }
      },
      "bs-BA": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pošta"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirajte"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviraj"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za ovjeru bit će poslan na vašu adresu e-pošte korisnika. Važno: Aktivirajte barem drugi način provjere autentičnosti ako ne možete pristupiti svojoj e-pošti."])}
        }
      },
      "zh-CN": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子邮件"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["激活"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["停用"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已激活"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["验证码将发送到您的用户电子邮件地址。 重要提示：如果您无法访问您的电子邮件，请至少激活第二种身份验证方法。"])}
        }
      },
      "da-DK": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivér"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiver"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveret"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden sendes til din bruger-e-mail-adresse. Vigtigt: Aktivér mindst en anden godkendelsesmetode, hvis du ikke kan få adgang til din e-mail."])}
        }
      },
      "et-EE": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-post"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeri"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desaktiveeri"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeritud"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood saadetakse teie kasutaja e-posti aadressile. Oluline: kui te ei pääse oma e-postile juurde, aktiveerige vähemalt teine autentimismeetod."])}
        }
      },
      "fi-FI": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sähköposti"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoi"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista käytöstä"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoitu"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi lähetetään käyttäjän sähköpostiosoitteeseen. Tärkeää: Ota käyttöön vähintään toinen todennusmenetelmä, jos et pääse sähköpostiisi."])}
        }
      },
      "el-GR": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποίηση"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας θα σταλεί στη διεύθυνση email του χρήστη σας. Σημαντικό: Ενεργοποιήστε τουλάχιστον μια δεύτερη μέθοδο ελέγχου ταυτότητας εάν δεν μπορείτε να αποκτήσετε πρόσβαση στο e-mail σας."])}
        }
      },
      "he-IL": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אימייל"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפְעִיל"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["בטל הפעלה"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מופעל"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות יישלח לכתובת הדוא＂ל של המשתמש שלך. חשוב: הפעל שיטת אימות שנייה לפחות אם אינך יכול לגשת לדואר האלקטרוני שלך."])}
        }
      },
      "ga-IE": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ríomhphost"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaigh"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Díghníomhachtaigh"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaithe"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seolfar an cód fíordheimhnithe chuig do sheoladh ríomhphoist úsáideora. Tábhachtach: Gníomhaigh an dara modh fíordheimhnithe ar a laghad mura féidir leat rochtain a fháil ar do r-phost."])}
        }
      },
      "ja-JP": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eメール"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティベート"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["非アクティブ化"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティブ化"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードはユーザーのメールアドレスに送信されます。 重要: 電子メールにアクセスできない場合は、少なくとも 2 番目の認証方法をアクティブにしてください。"])}
        }
      },
      "hr-HR": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pošta"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviraj"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obustaviti"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za autentifikaciju poslat će se na vašu adresu e-pošte korisnika. Važno: Aktivirajte barem drugu metodu provjere autentičnosti ako ne možete pristupiti svojoj e-pošti."])}
        }
      },
      "lv-LV": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pasts"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēt"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivizēt"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēts"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods tiks nosūtīts uz jūsu lietotāja e-pasta adresi. Svarīgi! Ja nevarat piekļūt savam e-pastam, aktivizējiet vismaz otro autentifikācijas metodi."])}
        }
      },
      "lt-LT": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El. paštas"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinti"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išjungti"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinta"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patvirtinimo kodas bus išsiųstas jūsų vartotojo el. Pašto adresu. Svarbu: suaktyvinkite bent antrą autentifikavimo metodą, jei negalite pasiekti savo el. Pašto."])}
        }
      },
      "pt-PT": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativar"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desativar"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativado"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação será enviado para o endereço de e-mail do usuário. Importante: Ative pelo menos um segundo método de autenticação se não conseguir acessar seu e-mail."])}
        }
      },
      "ro-RO": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activare"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezactivare"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activat"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare va fi trimis la adresa de e-mail a utilizatorului. Important: Activați cel puțin o a doua metodă de autentificare dacă nu vă puteți accesa e-mailul."])}
        }
      },
      "ru-RU": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Эл. почта"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировать"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивировать"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировано"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации будет отправлен на ваш адрес электронной почты пользователя. Важно: активируйте хотя бы второй метод аутентификации, если вы не можете получить доступ к своей электронной почте."])}
        }
      },
      "sv-SE": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-post"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivera"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avaktivera"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiverad"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden skickas till din användares e-postadress. Viktigt: Aktivera minst en andra autentiseringsmetod om du inte kan komma åt ditt e-postmeddelande."])}
        }
      },
      "sk-SK": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovať"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivovať"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivované"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód bude zaslaný na vašu e-mailovú adresu používateľa. Dôležité: Ak nemáte prístup k svojim e-mailom, aktivujte aspoň druhú metódu overenia."])}
        }
      },
      "cs-CZ": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailem"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovat"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivovat"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivováno"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód bude zaslán na vaši e-mailovou adresu uživatele. Důležité: Pokud nemáte přístup k e-mailu, aktivujte alespoň druhou metodu ověřování."])}
        }
      },
      "tr-TR": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştir"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırak"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu, kullanıcı e-posta adresinize gönderilecektir. Önemli: E-postanıza erişemiyorsanız en az ikinci bir kimlik doğrulama yöntemini etkinleştirin."])}
        }
      },
      "hu-HU": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiválja"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivál"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivált"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési kódot elküldjük a felhasználó e-mail címére. Fontos: Aktiváljon legalább egy második hitelesítési módszert, ha nem tudja elérni az e-mailt."])}
        }
      },
      "ar-AE": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["البريد الإلكتروني"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إلغاء تنشيط"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["سيتم إرسال رمز المصادقة إلى عنوان البريد الإلكتروني للمستخدم الخاص بك. هام: قم بتنشيط طريقة مصادقة ثانية على الأقل إذا لم تتمكن من الوصول إلى بريدك الإلكتروني."])}
        }
      },
      "fr-BE": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactiver"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification sera envoyé à votre adresse électronique d'utilisateur. Important : Activez au moins une deuxième méthode d'authentification si vous ne pouvez pas accéder à votre courrier électronique."])}
        }
      },
      "fr-LU": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactiver"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification sera envoyé à votre adresse électronique d'utilisateur. Important : Activez au moins une deuxième méthode d'authentification si vous ne pouvez pas accéder à votre courrier électronique."])}
        }
      },
      "mt-MT": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iddiżattiva"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivat"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi tal-awtentikazzjoni jintbagħat lill-indirizz tal-email tal-utent tiegħek. Importanti: Attiva mill-inqas it-tieni metodu ta 'awtentikazzjoni jekk ma tistax taċċessa l-e-mail tiegħek."])}
        }
      },
      "sl-SI": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pošta"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviraj"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviraj"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti bo poslana na vaš e-poštni naslov uporabnika. Pomembno: Aktivirajte vsaj drugi način preverjanja pristnosti, če ne morete dostopati do e-pošte."])}
        }
      },
      "el-CY": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποίηση"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας θα σταλεί στη διεύθυνση email του χρήστη σας. Σημαντικό: Ενεργοποιήστε τουλάχιστον μια δεύτερη μέθοδο ελέγχου ταυτότητας εάν δεν μπορείτε να αποκτήσετε πρόσβαση στο e-mail σας."])}
        }
      },
      "tr-CY": {
        "emailAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta"])}
        },
        "addEmailAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştir"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırak"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
        },
        "emailAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu, kullanıcı e-posta adresinize gönderilecektir. Önemli: E-postanıza erişemiyorsanız en az ikinci bir kimlik doğrulama yöntemini etkinleştirin."])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/EmailAuthentication.vue


/* custom blocks */
;
if (typeof EmailAuthenticationvue_type_custom_index_0_blockType_i18n === 'function') EmailAuthenticationvue_type_custom_index_0_blockType_i18n(EmailAuthenticationvue_type_script_setup_true_lang_js)


const EmailAuthentication_exports_ = EmailAuthenticationvue_type_script_setup_true_lang_js;

/* harmony default export */ var EmailAuthentication = (EmailAuthentication_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateSMSAuthenticationForm.vue?vue&type=script&setup=true&lang=js






var ActivateSMSAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 0
};
var ActivateSMSAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_2 = {
  key: 1
};




var ActivateSMSAuthenticationFormvue_type_script_setup_true_lang_js_default_ = {
  name: "ActivateSMSAuthenticationForm",
  data: function data() {
    return {
      form: {
        mode: 'sms',
        totp: ''
      },
      mobileNumberForm: {
        mobileNumber: ''
      },
      loading: false,
      loadingSaveMobileNumber: false,
      resendDisabled: true,
      countdown: 0,
      mobileNumberAvailable: false
    };
  },
  computed: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ['apiUrls'])), (0,external_pinia_.mapState)(store_modules_.useAuthStore, ['user'])),
  methods: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapActions)(store_modules_.useAuthStore, ['validate'])), {}, {
    resetFields: function resetFields() {
      this.form.totp = '';
      this.mobileNumberForm.mobileNumber = '';
    },
    saveMobileNumber: function saveMobileNumber() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var err, res, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loadingSaveMobileNumber = true;
                _context.next = 3;
                return external_await_to_js_default()(_this.$http.post("".concat(_this.apiUrls.dutypay, "/api/v0/setup/auth-sms"), {
                  mobileNumber: _this.$dp.utils.mobileNumber.formatMobileNumber(_this.mobileNumberForm.mobileNumber)
                }));

              case 3:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];

                if (!err) {
                  _context.next = 10;
                  break;
                }

                _this.loadingSaveMobileNumber = false;
                throw err;

              case 10:
                _context.next = 12;
                return _this.sendAuthenticationSMS();

              case 12:
                _this.loadingSaveMobileNumber = false;
                return _context.abrupt("return", res);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    sendAuthenticationSMS: function sendAuthenticationSMS() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var err, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.resendDisabled = true;
                _context2.next = 3;
                return external_await_to_js_default()(_this2.$http.post("".concat(_this2.apiUrls.dutypay, "/api/v0/send/auth-sms")));

              case 3:
                _yield$to3 = _context2.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 1);
                err = _yield$to4[0];

                if (!err) {
                  _context2.next = 11;
                  break;
                }

                _this2.$notify.error({
                  title: _this2.$t('sendAuthenticationSMS.notification.asyncError.title'),
                  message: _this2.$t('sendAuthenticationSMS.notification.asyncError.message')
                });

                _this2.mobileNumberAvailable = false;
                _this2.resendDisabled = false;
                throw err;

              case 11:
                _this2.mobileNumberAvailable = true;
                _this2.countdown = 20;

                _this2.countDownTimer();

                _this2.$notify.success({
                  title: _this2.$t('sendAuthenticationSMS.notification.success.title'),
                  message: _this2.$t('sendAuthenticationSMS.notification.success.message')
                });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    activateSMSAuthentication: function activateSMSAuthentication() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var err, res, _yield$to5, _yield$to6;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;
                _context3.next = 3;
                return external_await_to_js_default()(_this3.$http.post("".concat(_this3.apiUrls.dutypay, "/api/v0/activate/auth-sms"), _objectSpread2({}, _this3.form)));

              case 3:
                _yield$to5 = _context3.sent;
                _yield$to6 = _slicedToArray(_yield$to5, 2);
                err = _yield$to6[0];
                res = _yield$to6[1];

                if (!err) {
                  _context3.next = 10;
                  break;
                }

                _this3.loading = false;
                throw err;

              case 10:
                _context3.next = 12;
                return _this3.cancelForm();

              case 12:
                _this3.resetFields();

                _context3.next = 15;
                return _this3.validate({});

              case 15:
                _this3.loading = false;
                return _context3.abrupt("return", res);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    countDownTimer: function countDownTimer() {
      var _this4 = this;

      if (this.countdown > 0) {
        setTimeout(function () {
          _this4.countdown -= 1;

          _this4.countDownTimer();
        }, 1000);
      } else {
        this.resendDisabled = false;
      }
    },
    cancelForm: function cancelForm() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.$emit('cancel-form');

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    reenterNumber: function reenterNumber() {
      this.mobileNumberAvailable = false;
    }
  })
};

/* harmony default export */ var ActivateSMSAuthenticationFormvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(ActivateSMSAuthenticationFormvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_DpNotificationPersist = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpNotificationPersist");

      var _component_DpInputMobileNumber = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpInputMobileNumber");

      var _component_DpForm = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpForm");

      var _component_dpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dpCollapse");

      var _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse");

      var _component_DpInputMultiFactorAuthenticationCode = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpInputMultiFactorAuthenticationCode");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('pleaseEnterMobileNumber.label')), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpNotificationPersist, {
        title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('saveMobileNumber.notificationPersist.success.title'),
        message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('saveMobileNumber.notificationPersist.success.message'),
        type: "success"
      }, {
        controls: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            purpose: "secondaryAction",
            onClick: _ctx.reenterNumber
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('retry.buttonLabel')), 1)];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        _: 1
      }, 8, ["title", "message"]), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.mobileNumberAvailable]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dpCollapse, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpForm, {
            action: _ctx.saveMobileNumber,
            reference: "save-mobile-number",
            modelValue: _ctx.mobileNumberForm,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(mobileNumberForm) ? mobileNumberForm.value = $event : null;
            }),
            "notification-success": {
              title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('saveMobileNumber.notification.success.title'),
              message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('saveMobileNumber.notification.success.message')
            },
            "notification-async-error": {
              title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('saveMobileNumber.notification.asyncError.title'),
              message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('saveMobileNumber.notification.asyncError.message')
            },
            "disable-notification": ['asyncError', 'success'],
            "primary-button-label": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('saveMobileNumber.buttonLabel')
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpInputMobileNumber, {
                label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('mobileNumber.label'),
                tooltip: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('mobileNumber.tooltip'),
                modelValue: _ctx.mobileNumberForm.mobileNumber,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.mobileNumberForm.mobileNumber = $event;
                }),
                prop: "mobileNumber",
                required: "",
                placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('mobileNumber.placeholder')
              }, null, 8, ["label", "tooltip", "modelValue", "placeholder"])];
            }),
            _: 1
          }, 8, ["action", "modelValue", "notification-success", "notification-async-error", "primary-button-label"])), [[_directive_loading, _ctx.loadingSaveMobileNumber]])];
        }),
        _: 1
      }, 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, !_ctx.mobileNumberAvailable]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            purpose: "secondaryAction",
            type: "text",
            disabled: _ctx.resendDisabled,
            onClick: _ctx.sendAuthenticationSMS
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [_ctx.resendDisabled ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", ActivateSMSAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('resendSMSInSeconds.buttonLabel', {
                seconds: _ctx.countdown
              })), 1)) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", ActivateSMSAuthenticationFormvue_type_script_setup_true_lang_js_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('resendSMS.buttonLabel')), 1))];
            }),
            _: 1
          }, 8, ["disabled", "onClick"])];
        }),
        _: 1
      }, 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.mobileNumberAvailable]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpForm, {
        modelValue: _ctx.form,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(form) ? form.value = $event : null;
        }),
        reference: "activate-sms-authentication",
        action: _ctx.activateSMSAuthentication,
        primaryButtonLabel: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('confirmCode.buttonLabel'),
        primaryButtonParameter: {
          disabled: !_ctx.mobileNumberAvailable
        },
        "notification-success": {
          title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activateSMSAuthentication.notification.success.title'),
          message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activateSMSAuthentication.notification.success.message')
        },
        "notification-async-error": {
          title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activateSMSAuthentication.notification.asyncError.title'),
          message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('activateSMSAuthentication.notification.asyncError.message')
        }
      }, {
        secondaryButton: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            purpose: "secondaryAction",
            onClick: _ctx.cancelForm
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('cancel.buttonLabel')), 1)];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpInputMultiFactorAuthenticationCode, {
            modelValue: _ctx.form.totp,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return _ctx.form.totp = $event;
            }),
            prop: "totp",
            required: "",
            "input-parameters": {
              disabled: !_ctx.mobileNumberAvailable
            }
          }, null, 8, ["modelValue", "input-parameters"])];
        }),
        _: 1
      }, 8, ["modelValue", "action", "primaryButtonLabel", "primaryButtonParameter", "notification-success", "notification-async-error"])), [[_directive_loading, _ctx.loading]])]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateSMSAuthenticationForm.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateSMSAuthenticationForm.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function ActivateSMSAuthenticationFormvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes. Speichere dazu deine Mobilnummer. Der Code wird an die gespeicherte Mobilnummer per SMS gesendet."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungsmethode wurde aktiviert."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulareingabe konnte nicht verarbeitet werden."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulareingabe wurde erfolgreich verarbeitet."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern und senden"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulareingabe wurde erfolgreich gespeichert."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde erfolgreich gesendet."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("seconds")), " Sekunden"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gib deine Mobilnummer im internationalen Format ein."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut speichern und senden"])}
        }
      },
      "de-AT": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes. Speichere dazu deine Mobilnummer. Der Code wird an die gespeicherte Mobilnummer per SMS gesendet."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungsmethode wurde aktiviert."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulareingabe konnte nicht verarbeitet werden."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulareingabe wurde erfolgreich verarbeitet."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern und senden"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulareingabe wurde erfolgreich gespeichert."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde erfolgreich gesendet."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("seconds")), " Sekunden"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gib deine Mobilnummer im internationalen Format ein."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut speichern und senden"])}
        }
      },
      "de-CH": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviere die Zwei-Faktor-Authentifizierung durch Eingabe und Bestätigung des Authentifizierungscodes. Speichere dazu deine Mobilnummer. Der Code wird an die gespeicherte Mobilnummer per SMS gesendet."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätigen"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode konnte nicht bestätigt werden."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentifizierungsmethode wurde aktiviert."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulareingabe konnte nicht verarbeitet werden."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulareingabe wurde erfolgreich verarbeitet."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern und senden"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulareingabe wurde erfolgreich gespeichert."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bei unserem Service ist ein Fehler aufgetreten. Bitte versuche es erneut."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wurde erfolgreich gesendet."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut senden"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erneut senden in ", _interpolate(_named("seconds")), " Sekunden"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gib deine Mobilnummer im internationalen Format ein."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erneut speichern und senden"])}
        }
      },
      "en-US": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate two-factor authentication by entering and confirming the authentication code. To do this, save your mobile number. The code is sent to the saved mobile number via SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code could not be confirmed."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication method has been activated."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form input could not be processed."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form input was processed successfully."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save and send"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form input was saved successfully."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error has occurred in our service. Please try again."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent successfully."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send again"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend in 59 seconds"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobile Number"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter your mobile number in international format."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobile Number"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save and send again"])}
        }
      },
      "en-GB": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate two-factor authentication by entering and confirming the authentication code. To do this, save your mobile number. The code is sent to the saved mobile number via SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code could not be confirmed."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentication method has been activated."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form input could not be processed."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form input was processed successfully."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save and send"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form input was saved successfully."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error has occurred in our service. Please try again."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code was sent successfully."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send again"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resend in 59 seconds"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobile Number"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter your mobile number in international format."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobile Number"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save and send again"])}
        }
      },
      "it-IT": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Per farlo, salva il tuo numero di telefono. Il codice viene inviato al numero di telefono salvato via SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conferma"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non è stato possibile confermare il codice di autenticazione."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il metodo di autenticazione è stato attivato."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossibile elaborare l'input del modulo."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il modulo è stato elaborato con successo."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salva e invia"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'input del modulo è stato salvato correttamente."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Si è verificato un errore nel nostro servizio. Per favore riprova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione è stato inviato con successo."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invia di nuovo"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Invia nuovamente tra ", _interpolate(_named("seconds")), " secondi"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numero di telefono"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci il tuo numero di cellulare in formato internazionale."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numero di telefono"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salva e invia di nuovo"])}
        }
      },
      "fr-FR": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification. Pour ce faire, enregistrez votre numéro de téléphone mobile. Le code est envoyé par SMS au numéro de téléphone mobile enregistré."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La méthode d'authentification a été activée."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La saisie du formulaire n'a pas pu être traitée."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La saisie du formulaire a été traitée avec succès."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer et envoyer"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La saisie du formulaire a été enregistrée avec succès."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé avec succès."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer à nouveau"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("seconds")), " secondes"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de téléphone mobile"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez votre numéro de portable au format international."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de téléphone mobile"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer et envoyer à nouveau"])}
        }
      },
      "es-ES": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Active la autenticación en dos pasos introduciendo y confirmando el código de autenticación. Para ello, guarde su número de teléfono. El código se envía por SMS al número de teléfono guardado."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se pudo confirmar el código de autenticación."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Se ha activado el método de autenticación."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se pudo procesar la entrada del formulario."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El formulario se ha procesado correctamente."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar y enviar"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La entrada del formulario se guardó correctamente."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ha habido un error en nuestro servicio. Inténtelo de nuevo, por favor."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación se envió correctamente."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enviar de nuevo"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Enviar de nuevo en ", _interpolate(_named("seconds")), " segundos"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de teléfono"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingrese su número de teléfono móvil en formato internacional."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de teléfono"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar y enviar de nuevo"])}
        }
      },
      "pl-PL": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywuj uwierzytelnianie dwuskładnikowe, wprowadzając i potwierdzając kod uwierzytelniający. Aby to zrobić, zapisz swój numer telefonu komórkowego. Kod jest wysyłany na zapisany numer telefonu komórkowego SMS-em."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdź"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie udało się potwierdzić kodu uwierzytelniającego."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metoda uwierzytelniania została aktywowana."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie można przetworzyć danych wejściowych formularza."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dane wejściowe formularza zostały pomyślnie przetworzone."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zapisz i wyślij"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dane wejściowe formularza zostały pomyślnie zapisane."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["W naszym serwisie wystąpił błąd. Prosimy, spróbuj ponownie."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający został pomyślnie wysłany."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyślij ponownie"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Wyślij ponownie za ", _interpolate(_named("seconds")), " s"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numer telefonu komórkowego"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wpisz swój numer telefonu komórkowego w formacie międzynarodowym."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numer telefonu komórkowego"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zapisz i wyślij ponownie"])}
        }
      },
      "nl-NL": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activeer de twee-factor authenticatie door de authenticatiecode in te voeren en te bevestigen. Om dit te doen, slaat u uw mobiele nummer op. De code wordt via sms naar het opgeslagen mobiele nummer gestuurd."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestigen"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afbreken"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authencitatiecode kon niet worden bevestigd."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificatiemethode is geactiveerd."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulierinvoer kan niet worden verwerkt."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulier invoer is succesvol verwerkt."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opslaan en verzenden"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulierinvoer is succesvol opgeslagen."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Er is een fout opgetreden in onze service. Gelieve opnieuw te proberen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authenticatiecode is succesvol verzonden."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opnieuw verzenden"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Verzenden over ", _interpolate(_named("seconds")), " seconden"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiel nummer"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voer uw mobiele nummer in internationaal formaat in."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiel nummer"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opslaan en opnieuw verzenden"])}
        }
      },
      "bg-BG": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирайте двуфакторно удостоверяване, като въведете и потвърдите кода за удостоверяване. За да направите това, запазете мобилния си номер. Кодът се изпраща на съхранения мобилен номер чрез SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потвърждение"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прекратяване"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване не може да бъде потвърден."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активиран е методът за удостоверяване."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въвеждането на формуляра не можа да бъде обработено."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въведените във формуляра данни са обработени успешно."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Съхраняване и изпращане"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въвеждането на формуляра беше запазено успешно."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Възникна грешка в нашата услуга. Моля, опитайте отново."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване е изпратен успешно."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изпрати отново"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Изпращане след ", _interpolate(_named("seconds")), " секунди"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мобилен номер"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Въведете мобилния си номер в международен формат."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мобилен номер"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Запазете и изпратете отново"])}
        }
      },
      "bs-BA": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirajte dvofaktorsku autentifikaciju unosom i potvrđivanjem autentifikacijskog koda. Da biste to učinili, spremite svoj broj mobitela. Kôd se putem SMS-a šalje na spremljeni broj mobitela."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdite"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće potvrditi autentifikacijski kôd."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran je način autentifikacije."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće obraditi unos obrasca."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unos obrasca je uspješno obrađen."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spremite i pošaljite"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unos obrasca uspješno je sačuvan."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Došlo je do greške u našem servisu. Molimo pokušajte ponovo."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za provjeru autentičnosti je uspješno poslan."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošalji ponovo"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovo pošalji za ", _interpolate(_named("seconds")), " sekundi"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj mobitela"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite svoj broj mobitela u međunarodnom formatu."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj mobitela"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sačuvajte i pošaljite ponovo"])}
        }
      },
      "zh-CN": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入并确认身份验证码以激活双重身份验证。为此，请保存手机号码。代码将通过短信发送到存储的手机号码。"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中止"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无法确认验证码。"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["身份验证方法已激活。"])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无法处理表单输入。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["窗体输入已成功处理。"])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存并发送"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["表单输入已成功保存。"])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["我们的服务发生了错误。 请再试一遍。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["验证码发送成功。"])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重新发送"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["在", _interpolate(_named("seconds")), "内重新发送"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手机号码"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["以国际格式输入您的手机号码。"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手机号码"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存并再次发送"])}
        }
      },
      "da-DK": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiver tofaktorautentificering ved at indtaste og bekræfte godkendelseskoden. For at gøre dette skal du gemme dit mobilnummer. Koden sendes til det gemte mobilnummer via SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekræft"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden kunne ikke bekræftes."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelsesmetode er aktiveret."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formularinput kunne ikke behandles."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formularinput blev behandlet med succes."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gem og send"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formularinput blev gemt."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der opstod en fejl i vores service. Prøv igen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden blev sendt med succes."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Send igen"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Send igen om ", _interpolate(_named("seconds")), " sekunder"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indtast dit mobilnummer i internationalt format."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gem og send igen"])}
        }
      },
      "et-EE": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveerige kaheastmeline autentimine, sisestades ja kinnitades autentimiskoodi. Selleks salvestage oma mobiilinumber. Kood saadetakse salvestatud mobiiltelefoninumbrile SMS-i teel."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinnita"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Katkesta"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskoodi ei õnnestunud kinnitada."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimismeetod on aktiveeritud."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vormi sisendit ei õnnestunud töödelda."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vormi sisendi töötlemine õnnestus."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salvesta ja saada"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vormi sisend salvestati edukalt."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meie teenuses on ilmnenud tõrge. Palun proovi uuesti."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskoodi saatmine õnnestus."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saada uuesti"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Saada uuesti ", _interpolate(_named("seconds")), " sekundi pärast"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiili number"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sisestage oma mobiiltelefoni number rahvusvahelises vormingus."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiili number"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salvestage ja saatke uuesti"])}
        }
      },
      "fi-FI": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoi kaksivaiheinen todennus syöttämällä ja vahvistamalla todennuskoodi. Tehdäksesi tämän, tallenna matkapuhelinnumerosi. Koodi lähetetään tallennettuun matkapuhelinnumeroon tekstiviestillä."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vahvista"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keskeyttää"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodia ei voitu vahvistaa."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennusmenetelmä on aktivoitu."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lomakkeen syötettä ei voitu käsitellä."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lomakkeen syötteen käsittely onnistui."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tallenna ja lähetä"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lomakkeen syöttö tallennettiin onnistuneesti."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Palvelussamme on tapahtunut virhe. Olkaa hyvä, ja yrittäkää uudelleen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi lähetettiin onnistuneesti."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähetä uudestaan"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Lähetä uudelleen ", _interpolate(_named("seconds")), " sekunnissa"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Matkapuhelinnumero"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anna matkapuhelinnumerosi kansainvälisessä muodossa."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Matkapuhelinnumero"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tallenna ja lähetä uudelleen"])}
        }
      },
      "el-GR": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων εισάγοντας και επιβεβαιώνοντας τον κωδικό ελέγχου ταυτότητας. Για να το κάνετε αυτό, αποθηκεύστε τον αριθμό του κινητού σας. Ο κωδικός αποστέλλεται στον αποθηκευμένο αριθμό κινητού μέσω SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποβάλλω"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επιβεβαίωση του κωδικού ελέγχου ταυτότητας."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η μέθοδος ελέγχου ταυτότητας έχει ενεργοποιηθεί."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επεξεργασία της εισαγωγής φόρμας."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η εισαγωγή της φόρμας υποβλήθηκε σε επεξεργασία με επιτυχία."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποθήκευση και αποστολή"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η εισαγωγή φόρμας αποθηκεύτηκε με επιτυχία."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παρουσιάστηκε σφάλμα στην υπηρεσία μας. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λάθος"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε με επιτυχία."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στείλε ξανά"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("seconds")), " δευτερόλεπτα"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αριθμός κινητού"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισαγάγετε τον αριθμό του κινητού σας σε διεθνή μορφή."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αριθμός κινητού"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποθήκευση και αποστολή ξανά"])}
        }
      },
      "he-IL": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הפעל אימות דו-גורמי על ידי הזנת קוד האימות ואישורו. לשם כך, שמור את מספר הנייד שלך. הקוד נשלח למספר הנייד המאוחסן באמצעות SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְאַשֵׁר"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפִּיל"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא ניתן היה לאשר את קוד האימות."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שיטת האימות הופעלה."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא ניתן היה לעבד קלט טופס."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קלט הטופס עבר עיבוד בהצלחה."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שמור ושלח"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קלט הטופס נשמר בהצלחה."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אירעה שגיאה בשירות שלנו. בבקשה נסה שוב."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות נשלח בהצלחה."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שלח שוב"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["שלח מחדש בתוך ", _interpolate(_named("seconds")), " שניות"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מספר טלפון נייד"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הזן את מספר הנייד שלך בפורמט בינלאומי."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מספר טלפון נייד"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שמור ושלח שוב"])}
        }
      },
      "ga-IE": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaigh fíordheimhniú dhá fhachtóir tríd an gcód fíordheimhnithe a iontráil agus a dhearbhú. Chun é seo a dhéanamh, sábháil d’uimhir fóin póca. Seoltar an cód chuig an uimhir fóin póca stóráilte trí SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deimhnigh"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ginmhilleadh"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Níorbh fhéidir an cód fíordheimhnithe a dhearbhú."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuireadh modh fíordheimhnithe i ngníomh."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ní fhéadfaí ionchur foirme a phróiseáil."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Próiseáladh an t-ionchur foirme go rathúil."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sábháil agus seol"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sábháladh ionchur foirme go rathúil."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tharla earráid inár seirbhís. Arís, le d'thoil."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuireadh an cód fíordheimhnithe go rathúil."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seol arís"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Athsheol i gceann ", _interpolate(_named("seconds")), " soicind"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uimhir fóin póca"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iontráil d’uimhir soghluaiste i bhformáid idirnáisiúnta."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uimhir fóin póca"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sábháil agus seol arís"])}
        }
      },
      "ja-JP": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードを入力して確認することで、二要素認証を有効にします。 これを行うには、携帯電話番号を保存します。 コードは SMS 経由で保存されている携帯電話番号に送信されます。"])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["確認"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アボート"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードが確認できませんでした。"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証方法が有効化されました。"])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["フォーム入力を処理できませんでした。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["フォーム入力は正常に処理されました。"])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存して送信"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["フォーム入力は正常に保存されました。"])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["サービスでエラーが発生しました。 もう一度お試しください。"])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードは正常に送信されました。"])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["もう一度送信"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("seconds")), "秒で再送信"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["携帯電話番号"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["携帯電話番号を国際形式で入力してください。"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["携帯電話番号"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存して再送信"])}
        }
      },
      "hr-HR": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirajte dvofaktorsku autentifikaciju unosom i potvrđivanjem autentifikacijskog koda. Da biste to učinili, spremite svoj broj mobitela. Kôd se putem SMS-a šalje na pohranjeni broj mobitela."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrda"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekid"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije moguće potvrditi autentifikacijski kod."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirana je metoda autentifikacije."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unos obrasca nije se mogao obraditi."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unos obrasca uspješno je obrađen."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spremi i pošalji"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unos obrasca uspješno je spremljen."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Došlo je do pogreške u našoj usluzi. Molim vas pokušajte ponovno."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za ovjeru uspješno je poslan."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošalji opet"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno slanje u ", _interpolate(_named("seconds")), " sekundama"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj mobitela"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unesite svoj broj mobitela u međunarodnom formatu."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj mobitela"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spremite i pošaljite ponovo"])}
        }
      },
      "lv-LV": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizējiet divfaktoru autentifikāciju, ievadot un apstiprinot autentifikācijas kodu.Lai to izdarītu, saglabājiet savu mobilā tālruņa numuru. Lai to izdarītu, saglabājiet savu mobilā tālruņa numuru."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apstiprināt"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pārtraukt"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nevarēja apstiprināt autentifikācijas kodu."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas metode ir aktivizēta."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nevarēja apstrādāt veidlapas ievadi."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veidlapas ievade tika veiksmīgi apstrādāta."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saglabāt un nosūtīt"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veidlapas ievade tika veiksmīgi saglabāta."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mūsu pakalpojumā ir radusies kļūda. Lūdzu, mēģiniet vēlreiz."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods tika veiksmīgi nosūtīts."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sūtīt vēlreiz"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Atkārtoti nosūtīt pēc ", _interpolate(_named("seconds")), " sek."])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilā tālruņa numurs"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ievadiet savu mobilā tālruņa numuru starptautiskā formātā."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilā tālruņa numurs"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saglabājiet un nosūtiet vēlreiz"])}
        }
      },
      "lt-LT": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinkite dviejų veiksnių autentifikavimą įvesdami ir patvirtindami autentifikavimo kodą. Norėdami tai padaryti, išsaugokite savo mobiliojo telefono numerį. Kodas išsiunčiamas išsaugotu mobiliojo telefono numeriu SMS žinute."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patvirtinti"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutraukti"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nepavyko patvirtinti autentifikavimo kodo."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo metodas suaktyvintas."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nepavyko apdoroti formos įvesties."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formos įvestis sėkmingai apdorota."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išsaugoti ir siųsti"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formos įvestis sėkmingai išsaugota."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mūsų tarnyboje įvyko klaida. Bandykite dar kartą."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas sėkmingai išsiųstas."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siųsti dar kartą"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Iš naujo išsiųsti po ", _interpolate(_named("seconds")), " sek."])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiliojo telefono numeris"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įveskite savo mobiliojo telefono numerį tarptautiniu formatu."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobiliojo telefono numeris"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išsaugokite ir siųskite dar kartą"])}
        }
      },
      "pt-PT": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ative a autenticação de dois fatores inserindo e confirmando o código de autenticação. Para fazer isso, guarde o número do seu telemóvel O código é enviado por SMS para o número de telemóvel armazenado."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abortar"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não foi possível confirmar o código de autenticação."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O método de autenticação foi ativado."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A entrada do formulário não pôde ser processada."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A entrada do formulário foi processada com sucesso."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar e enviar"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A entrada do formulário foi salva com sucesso."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ocorreu um erro no nosso serviço. Tente novamente."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação foi enviado com sucesso."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envie novamente"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Reenviar em ", _interpolate(_named("seconds")), " segundos"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de telemóvel"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Digite seu número de celular no formato internacional."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de telemóvel"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salve e envie novamente"])}
        }
      },
      "ro-RO": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activați autentificarea cu doi factori introducând și confirmând codul de autentificare. În acest scop, trebuie să salvați numărul de telefon mobil. Codul va fi trimis prin SMS, la numărul de telefon mobil salvat."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmare"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abandonați"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare nu a putut fi confirmat."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A fost activată metoda de autentificare."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introducerea formularului nu a putut fi procesată."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valorile introduse în formular au fost prelucrate cu succes."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salvare și trimitere"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introducerea formularului a fost salvată cu succes."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A apărut o eroare în serviciu. Încercați din nou."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare a fost trimis cu succes."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trimite din nou"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Retrimitere în ", _interpolate(_named("seconds")), " secunde"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Număr de telefon mobil"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Introduceți numărul dvs. de mobil în format internațional."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Număr de telefon mobil"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salvați și trimiteți din nou"])}
        }
      },
      "ru-RU": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активируйте двухфакторную аутентификацию, введя и подтвердив код аутентификации. Для этого сохраните номер своего мобильного телефона. Код отправляется на сохраненный номер мобильного телефона по SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтвердить"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прервать"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации не подтвержден."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирован метод аутентификации."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ввод формы не может быть обработан."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ввод формы произведен успешно."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сохранить и отправить"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ввод формы успешно сохранен."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Произошла ошибка в нашем сервисе. Пожалуйста, попробуйте еще раз."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ошибка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации был успешно отправлен."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отправь еще раз"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Отправить повторно через ", _interpolate(_named("seconds")), " секунд"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер мобильного телефона"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите номер своего мобильного телефона в международном формате."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер мобильного телефона"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сохранить и отправить еще раз"])}
        }
      },
      "sv-SE": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivera tvåfaktorautentisering genom att ange och bekräfta autentiseringskoden. Spara ditt mobilnummer för att göra detta. Koden skickas till det sparade mobilnumret via SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekräfta"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avbryta"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden kunde inte bekräftas."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verifieringsmetoden har aktiverats."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulärinmatning kunde inte bearbetas."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formuläret fylldes i korrekt."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spara och skicka"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formulärinmatning sparades."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ett fel har uppstått i vår tjänst. Var god försök igen."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden skickades framgångsrikt."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skicka igen"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Skicka igen om ", _interpolate(_named("seconds")), " sekunder"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ange ditt mobilnummer i internationellt format."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilnummer"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spara och skicka igen"])}
        }
      },
      "sk-SK": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivujte dvojfaktorové overenie zadaním a potvrdením overovacieho kódu. Uložte pre to vaše mobilné číslo. Kód sa odošle na uložené mobilné číslo prostredníctvom SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdiť"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód nebolo možné potvrdiť."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metóda overovania bola aktivovaná."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vstup formulára nebolo možné spracovať."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadanie formulára bolo úspešne spracované."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložiť a odoslať"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vstup formulára bol úspešne uložený."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V našej službe sa vyskytla chyba. Prosím skúste znova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód bol úspešne odoslaný."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poslať znova"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Opäť odoslať o ", _interpolate(_named("seconds")), " sekúnd"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilné číslo"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadajte svoje mobilné číslo v medzinárodnom formáte."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobilné číslo"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložiť a odoslať znova"])}
        }
      },
      "cs-CZ": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivujte dvoufaktorové ověřování zadáním a potvrzením ověřovacího kódu. Chcete-li to provést, uložte své mobilní číslo. Kód je odeslán na uložené číslo mobilního telefonu prostřednictvím SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdit"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přerušit"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nelze potvrdit ověřovací kód."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Metoda ověřování byla aktivována."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadání formuláře nebylo možné zpracovat."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadání formuláře bylo úspěšně zpracováno."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložit a odeslat"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadání formuláře bylo úspěšně uloženo."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["V naší službě se vyskytla chyba. Zkuste to prosím znovu."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód byl úspěšně odeslán."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poslat znovu"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Odeslat znovu za ", _interpolate(_named("seconds")), " s."])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Číslo mobilního telefonu"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zadejte své mobilní číslo v mezinárodním formátu."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Číslo mobilního telefonu"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložit a odeslat znovu"])}
        }
      },
      "tr-TR": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodunu girip onaylayarak iki faktörlü kimlik doğrulamayı etkinleştirin. Bunu yapmak için cep telefonu numaranızı kaydedin. Kod, kayıtlı cep telefonu numarasına SMS ile gönderilir."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu onaylanamadı."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama yöntemi etkinleştirildi."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form girişi işlenemedi."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form girişi başarıyla işlendi."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaydet ve gönder"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form girişi başarıyla kaydedildi."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hizmetimizde bir hata oluştu. Lütfen tekrar deneyin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu başarıyla gönderildi."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekrar gönderin"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("seconds")), " saniye içinde yeniden gönder"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cep numarası"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cep telefonu numaranızı uluslararası formatta girin."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cep numarası"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaydet ve tekrar gönder"])}
        }
      },
      "hu-HU": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiválja a kétfaktoros hitelesítést a hitelesítő kód megadásával és megerősítésével. Ehhez mentse el mobilszámát. A kódot SMS-ben küldjük az elmentett mobilszámra."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Megerősít"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mégse"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítő kódot nem sikerült megerősíteni."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési módszer aktiválva van."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Az űrlapbevitelt nem sikerült feldolgozni."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Az űrlap bevitele sikeresen feldolgozva"])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mentés és küldés"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Az űrlapbevitel sikeresen mentve."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba történt a szolgáltatásunkban. Próbálja meg újra."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési kód sikeresen elküldve."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Küldd újra"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Újraküldés ", _interpolate(_named("seconds")), " másodperc múlva"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobil szám"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Írja be mobilszámát nemzetközi formátumban."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mobil szám"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mentés és újraküldés"])}
        }
      },
      "ar-AE": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قم بتنشيط المصادقة ذات العاملين عن طريق إدخال رمز المصادقة وتأكيده. للقيام بذلك ، احفظ رقم هاتفك المحمول. يتم إرسال الرمز إلى رقم الهاتف المحمول المخزن عبر الرسائل القصيرة."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إحباط"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن تأكيد رمز المصادقة."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم تفعيل طريقة المصادقة."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن معالجة إدخال النموذج."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تمت معالجة إدخال النموذج بنجاح."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حفظ وإرسال"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم حفظ إدخال النموذج بنجاح."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حدث خطأ في خدمتنا. حاول مرة اخرى."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إرسال رمز المصادقة بنجاح."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أعد الإرسال"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إعادة إرسال في ", _interpolate(_named("seconds")), " ثوان"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف المحمول"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل رقم هاتفك المحمول بصيغة دولية."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف المحمول"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["احفظ وأرسل مرة أخرى"])}
        }
      },
      "fr-BE": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification. Pour ce faire, enregistrez votre numéro de téléphone mobile. Le code est envoyé par SMS au numéro de téléphone mobile enregistré."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La méthode d'authentification a été activée."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La saisie du formulaire n'a pas pu être traitée."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La saisie du formulaire a été traitée avec succès."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer et envoyer"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La saisie du formulaire a été enregistrée avec succès."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé avec succès."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer à nouveau"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("seconds")), " secondes"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de téléphone mobile"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez votre numéro de portable au format international."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de téléphone mobile"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer et envoyer à nouveau"])}
        }
      },
      "fr-LU": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activez l'authentification à deux facteurs en saisissant et en confirmant le code d'authentification. Pour ce faire, enregistrez votre numéro de téléphone mobile. Le code est envoyé par SMS au numéro de téléphone mobile enregistré."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmer"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification n'a pas pu être confirmé."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La méthode d'authentification a été activée."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La saisie du formulaire n'a pas pu être traitée."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La saisie du formulaire a été traitée avec succès."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer et envoyer"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La saisie du formulaire a été enregistrée avec succès."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite dans notre service. Veuillez réessayer."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification a été envoyé avec succès."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Envoyer à nouveau"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Renvoyer dans ", _interpolate(_named("seconds")), " secondes"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de téléphone mobile"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez votre numéro de portable au format international."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de téléphone mobile"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer et envoyer à nouveau"])}
        }
      },
      "mt-MT": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva awtentikazzjoni b'żewġ fatturi billi ddaħħal u tikkonferma l-kodiċi ta' awtentikazzjoni. Biex tagħmel dan, issejvja n-numru tal-mowbajl tiegħek. Il-kodiċi jintbagħat lil n-numru tal-mowbajl issejvjat permezz ta' SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkonferma"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkanċella"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta' awtentikazzjoni ma setax jiġi kkonfermat."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-metodu ta 'awtentikazzjoni ġie attivat."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Id-dħul tal-formola ma setax jiġi pproċessat."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Id-dħul tal-formola ġie pproċessat b'suċċess."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ibgħat u ssejvja"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Id-dħul tal-formola ġie salvat b'suċċess."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seħħ żball fis-servizz tagħna. Jekk jogħġbok erġa' pprova."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi ta 'awtentikazzjoni ntbagħat b'suċċess."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ibgħat mill-ġdid"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Erġa' ibgħat fi ", _interpolate(_named("seconds")), " sekondi"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In-numru tal-Mowbajl"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Daħħal in-numru tal-mowbajl tiegħek f'format internazzjonali."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In-numru tal-Mowbajl"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Issejvja u ibgħat mill-ġdid"])}
        }
      },
      "sl-SI": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dvofaktorsko preverjanje pristnosti aktivirajte tako, da vnesete in potrdite kodo za preverjanje pristnosti. Če želite to narediti, shranite svojo številko mobilnega telefona. Koda se na shranjeno mobilno številko pošlje prek SMS-a."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potrdi"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kode za preverjanje pristnosti ni bilo mogoče potrditi."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirana je metoda preverjanja pristnosti."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnosa obrazca ni bilo mogoče obdelati."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnos obrazca je bil uspešno obdelan."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shrani in pošlji"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnos obrazca je bil uspešno shranjen."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prišlo je do napake v naši storitvi. Poskusite ponovno."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti je bila uspešno poslana."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pošlji ponovno"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Ponovno pošlji v ", _interpolate(_named("seconds")), " sekundah"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefonska številka"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnesite svojo številko mobilnega telefona v mednarodni obliki."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefonska številka"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shranite in pošljite znova"])}
        }
      },
      "el-CY": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήστε τον έλεγχο ταυτότητας δύο παραγόντων εισάγοντας και επιβεβαιώνοντας τον κωδικό ελέγχου ταυτότητας. Για να το κάνετε αυτό, αποθηκεύστε τον αριθμό του κινητού σας. Ο κωδικός αποστέλλεται στον αποθηκευμένο αριθμό κινητού μέσω SMS."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαίωση"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Άκυρο"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επιβεβαίωση του κωδικού ελέγχου ταυτότητας."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η μέθοδος ελέγχου ταυτότητας έχει ενεργοποιηθεί."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν ήταν δυνατή η επεξεργασία της εισαγωγής φόρμας."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η εισαγωγή της φόρμας υποβλήθηκε σε επεξεργασία με επιτυχία."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποθήκευση και αποστολή"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η εισαγωγή φόρμας αποθηκεύτηκε με επιτυχία."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παρουσιάστηκε σφάλμα στην υπηρεσία μας. ΠΑΡΑΚΑΛΩ προσπαθησε ξανα."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λάθος"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας στάλθηκε με επιτυχία."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στείλε ξανά"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Επανάληψη αποστολής σε ", _interpolate(_named("seconds")), " δευτερόλεπτα"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αριθμός κινητού"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εισαγάγετε τον αριθμό του κινητού σας σε διεθνή μορφή."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αριθμός κινητού"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποθήκευση και αποστολή ξανά"])}
        }
      },
      "tr-CY": {
        "pleaseEnterMobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodunu girip onaylayarak iki faktörlü kimlik doğrulamayı etkinleştirin. Bunu yapmak için cep telefonu numaranızı kaydedin. Kod, kayıtlı cep telefonu numarasına SMS ile gönderilir."])}
        },
        "confirmCode": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onayla"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        },
        "activateSMSAuthentication": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu onaylanamadı."])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama yöntemi etkinleştirildi."])}
            }
          }
        },
        "saveMobileNumber": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form girişi işlenemedi."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form girişi başarıyla işlendi."])}
            }
          },
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaydet ve gönder"])},
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Form girişi başarıyla kaydedildi."])}
            }
          }
        },
        "sendAuthenticationSMS": {
          "notification": {
            "asyncError": {
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hizmetimizde bir hata oluştu. Lütfen tekrar deneyin."])},
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu başarıyla gönderildi."])}
            }
          }
        },
        "resendSMS": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekrar gönderin"])}
        },
        "resendSMSInSeconds": {
          "buttonLabel": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("seconds")), " saniye içinde yeniden gönder"])}
        },
        "mobileNumber": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cep numarası"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cep telefonu numaranızı uluslararası formatta girin."])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cep numarası"])}
        },
        "retry": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaydet ve tekrar gönder"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/ActivateSMSAuthenticationForm.vue


/* custom blocks */
;
if (typeof ActivateSMSAuthenticationFormvue_type_custom_index_0_blockType_i18n === 'function') ActivateSMSAuthenticationFormvue_type_custom_index_0_blockType_i18n(ActivateSMSAuthenticationFormvue_type_script_setup_true_lang_js)


const ActivateSMSAuthenticationForm_exports_ = ActivateSMSAuthenticationFormvue_type_script_setup_true_lang_js;

/* harmony default export */ var ActivateSMSAuthenticationForm = (ActivateSMSAuthenticationForm_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/SMSAuthentication.vue?vue&type=script&setup=true&lang=js



var SMSAuthenticationvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 0,
  class: "dp-color__font__success"
};

var SMSAuthenticationvue_type_script_setup_true_lang_js_hoisted_2 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
  class: "el-icon-success"
}, null, -1);

var SMSAuthenticationvue_type_script_setup_true_lang_js_hoisted_3 = {
  key: 0
};
var SMSAuthenticationvue_type_script_setup_true_lang_js_hoisted_4 = {
  key: 1
};





var SMSAuthenticationvue_type_script_setup_true_lang_js_default_ = {
  name: "SMSAuthentication",
  components: {
    ActivateSMSAuthenticationForm: ActivateSMSAuthenticationForm,
    RemoveMultiFactorAuthenticationForm: RemoveMultiFactorAuthenticationForm
  },
  data: function data() {
    return {
      editAuthentication: false,
      simpleCrudModel: {}
    };
  },
  computed: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useAuthStore, ['user'])), {}, {
    hasSMSAuthentication: function hasSMSAuthentication() {
      return get_default()(this.user, 'mfaModes.sms', false);
    },
    simpleCrudButtonLabel: function simpleCrudButtonLabel() {
      return this.hasSMSAuthentication ? this.$t('removeAuthentication.buttonLabel') : this.$t('addSMSAuthentication.buttonLabel');
    },
    simpleCrudButtonIcon: function simpleCrudButtonIcon() {
      return this.hasSMSAuthentication ? 'el-icon-remove-outline' : 'el-icon-circle-plus-outline';
    }
  })
};


/* harmony default export */ var SMSAuthenticationvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(SMSAuthenticationvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    var composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables');

    var _composables$useViewp = composables.useViewportSize(),
        isMobile = _composables$useViewp.isMobile;

    return function (_ctx, _cache) {
      var _component_DpSimpleCrud = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpSimpleCrud");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpSimpleCrud, {
        modelValue: _ctx.simpleCrudModel,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(simpleCrudModel) ? simpleCrudModel.value = $event : null;
        }),
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('SMSAuthentication.title'),
        showDefaultSlot: _ctx.editAuthentication,
        buttonLabel: _ctx.simpleCrudButtonLabel,
        buttonIcon: _ctx.simpleCrudButtonIcon,
        onActivateSlot: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.editAuthentication = true;
        }),
        screenSizeIsMobile: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
      }, {
        read: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [_ctx.hasSMSAuthentication ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", SMSAuthenticationvue_type_script_setup_true_lang_js_hoisted_1, [SMSAuthenticationvue_type_script_setup_true_lang_js_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('active.label')), 1)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('SMSAuthenticationExplain.label')), 1)];
        }),
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [_ctx.hasSMSAuthentication ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", SMSAuthenticationvue_type_script_setup_true_lang_js_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(RemoveMultiFactorAuthenticationForm), {
            "authentication-method": "sms",
            onCancelForm: _cache[0] || (_cache[0] = function ($event) {
              return _ctx.editAuthentication = false;
            })
          })])) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", SMSAuthenticationvue_type_script_setup_true_lang_js_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(ActivateSMSAuthenticationForm), {
            onCancelForm: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.editAuthentication = false;
            })
          })]))];
        }),
        _: 1
      }, 8, ["modelValue", "headline", "showDefaultSlot", "buttonLabel", "buttonIcon", "screenSizeIsMobile"]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/SMSAuthentication.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/SMSAuthentication.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function SMSAuthenticationvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivieren"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wird an die gespeicherte Mobilnummer per SMS gesendet. Wichtig: Aktiviere mindestens eine zweite Authentifzierungsmethode, falls der Zugriff auf deine SMS nicht möglich ist."])}
        }
      },
      "de-AT": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivieren"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wird an die gespeicherte Mobilnummer per SMS gesendet. Wichtig: Aktiviere mindestens eine zweite Authentifzierungsmethode, falls der Zugriff auf deine SMS nicht möglich ist."])}
        }
      },
      "de-CH": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivieren"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Authentifizierungscode wird an die gespeicherte Mobilnummer per SMS gesendet. Wichtig: Aktiviere mindestens eine zweite Authentifzierungsmethode, falls der Zugriff auf deine SMS nicht möglich ist."])}
        }
      },
      "en-US": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is sent to the stored mobile number via SMS. Important: Activate at least a second authentication method if you cannot access your SMS."])}
        }
      },
      "en-GB": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivate"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The authentication code is sent to the stored mobile number via SMS. Important: Activate at least a second authentication method if you cannot access your SMS."])}
        }
      },
      "it-IT": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disattivare"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il codice di autenticazione viene inviato tramite SMS al numero di cellulare memorizzato. Importante: attiva almeno un secondo metodo di autenticazione se non riesci ad accedere ai tuoi SMS."])}
        }
      },
      "fr-FR": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactiver"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est envoyé au numéro de mobile enregistré par SMS. Important : activez au moins une deuxième méthode d'authentification si vous ne pouvez pas accéder à votre SMS."])}
        }
      },
      "es-ES": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activar"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desactivar"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activada"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El código de autenticación se envía al número de móvil almacenado a través de SMS. Importante: active al menos un segundo método de autenticación si no puede acceder a su SMS."])}
        }
      },
      "pl-PL": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywuj"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zdezaktywuj"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowano"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod uwierzytelniający jest wysyłany na zapisany numer telefonu komórkowego SMS-em. Ważne: Aktywuj co najmniej drugą metodę uwierzytelniania, jeśli nie możesz uzyskać dostępu do wiadomości SMS."])}
        }
      },
      "nl-NL": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activeren"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactiveren"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De authenticatiecode wordt via sms naar het opgeslagen mobiele nummer gestuurd. Belangrijk: Activeer ten minste een tweede authenticatiemethode als je geen toegang hebt tot je sms."])}
        }
      },
      "bg-BG": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активиране"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивиране"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирано"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кодът за удостоверяване се изпраща на съхранения мобилен номер чрез SMS. Важно: Активирайте поне втори метод за удостоверяване, ако не можете да осъществите достъп до вашия SMS."])}
        }
      },
      "bs-BA": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirajte"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviraj"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za autentifikaciju šalje se na uskladišteni mobilni broj putem SMS-a. Važno: Aktivirajte barem drugi način provjere autentičnosti ako ne možete pristupiti svom SMS-u."])}
        }
      },
      "zh-CN": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["激活"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["短信"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["停用"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已激活"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["验证码通过短信发送到存储的手机号码。 重要提示：如果您无法访问 SMS，请至少激活第二种身份验证方法。"])}
        }
      },
      "da-DK": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivér"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiver"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveret"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Godkendelseskoden sendes til det gemte mobilnummer via SMS. Vigtigt: Aktivér mindst en anden godkendelsesmetode, hvis du ikke kan få adgang til din SMS."])}
        }
      },
      "et-EE": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeri"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desaktiveeri"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeritud"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentimiskood saadetakse salvestatud mobiiltelefoninumbrile SMS-i teel. Oluline: kui te ei pääse oma SMS-ile juurde, aktiveerige vähemalt teine autentimismeetod."])}
        }
      },
      "fi-FI": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoi"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tekstiviesti"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista käytöstä"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoitu"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todennuskoodi lähetetään tallennettuun matkapuhelinnumeroon tekstiviestillä. Tärkeää: Ota käyttöön vähintään toinen todennustapa, jos et pääse tekstiviestiisi."])}
        }
      },
      "el-GR": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["γραπτό μήνυμα"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποίηση"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας αποστέλλεται στον αποθηκευμένο αριθμό κινητού μέσω SMS. Σημαντικό: Ενεργοποιήστε τουλάχιστον μια δεύτερη μέθοδο ελέγχου ταυτότητας εάν δεν μπορείτε να αποκτήσετε πρόσβαση στο SMS σας."])}
        }
      },
      "he-IL": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפְעִיל"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סמס"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["בטל הפעלה"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מופעל"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד האימות נשלח למספר הנייד המאוחסן באמצעות SMS. חשוב: הפעל שיטת אימות שנייה לפחות אם אינך יכול לגשת ל- SMS שלך."])}
        }
      },
      "ga-IE": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaigh"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Díghníomhachtaigh"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaithe"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seoltar an cód fíordheimhnithe chuig an uimhir soghluaiste stóráilte trí SMS. Tábhachtach: Gníomhaigh an dara modh fíordheimhnithe ar a laghad mura féidir leat rochtain a fháil ar do SMS."])}
        }
      },
      "ja-JP": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティベート"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["非アクティブ化"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティブ化"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["認証コードは、保存されている携帯電話番号に SMS 経由で送信されます。 重要: SMS にアクセスできない場合は、少なくとも 2 番目の認証方法をアクティブにしてください。"])}
        }
      },
      "hr-HR": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviraj"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obustaviti"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kôd za ovjeru šalje se na pohranjeni broj mobitela putem SMS-a. Važno: Aktivirajte barem drugu metodu provjere autentičnosti ako ne možete pristupiti svom SMS-u."])}
        }
      },
      "lv-LV": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēt"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Īsziņa"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivizēt"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēts"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikācijas kods tiek nosūtīts uz saglabāto mobilā tālruņa numuru, izmantojot īsziņu. Svarīgi! Ja nevarat piekļūt īsziņai, aktivizējiet vismaz otro autentifikācijas metodi."])}
        }
      },
      "lt-LT": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinti"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trumpoji žinutė"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išjungti"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinta"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentifikavimo kodas išsiunčiamas į saugomą mobiliojo telefono numerį SMS žinute. Svarbu: suaktyvinkite bent antrą autentifikavimo metodą, jei negalite pasiekti savo SMS."])}
        }
      },
      "pt-PT": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativar"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desativar"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativado"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["O código de autenticação é enviado para o número de celular armazenado por SMS. Importante: Ative pelo menos um segundo método de autenticação se não conseguir acessar seu SMS."])}
        }
      },
      "ro-RO": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activare"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezactivare"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activat"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codul de autentificare este trimis către numărul de telefon mobil stocat prin SMS. Important: Activați cel puțin a doua metodă de autentificare dacă nu vă puteți accesa SMS-ul."])}
        }
      },
      "ru-RU": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировать"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивировать"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировано"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Код аутентификации отправляется на сохраненный номер мобильного телефона через SMS. Важно: активируйте хотя бы второй метод аутентификации, если вы не можете получить доступ к своему SMS."])}
        }
      },
      "sv-SE": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivera"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avaktivera"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiverad"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentiseringskoden skickas till det lagrade mobilnumret via SMS. Viktigt: Aktivera minst en andra autentiseringsmetod om du inte kan komma åt ditt SMS."])}
        }
      },
      "sk-SK": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovať"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivovať"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivované"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Overovací kód sa odošle na uložené číslo mobilného telefónu prostredníctvom SMS. Dôležité: Ak nemáte prístup k svojim SMS, aktivujte aspoň druhú metódu overenia."])}
        }
      },
      "cs-CZ": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovat"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivovat"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivováno"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ověřovací kód je odeslán na uložené číslo mobilního telefonu prostřednictvím SMS. Důležité: Pokud nemáte přístup ke svým SMS, aktivujte alespoň druhou metodu ověřování."])}
        }
      },
      "tr-TR": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştir"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırak"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu, saklanan cep telefonu numarasına SMS ile gönderilir. Önemli: SMS'inize erişemiyorsanız en az ikinci bir kimlik doğrulama yöntemini etkinleştirin."])}
        }
      },
      "hu-HU": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiválja"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivál"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivált"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A hitelesítési kódot SMS-ben küldjük a tárolt mobilszámra. Fontos: Aktiváljon legalább egy második hitelesítési módszert, ha nem fér hozzá az SMS-hez."])}
        }
      },
      "ar-AE": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رسالة قصيرة"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إلغاء تنشيط"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يتم إرسال رمز المصادقة إلى رقم الهاتف المحمول المخزن عبر الرسائل القصيرة. هام: قم بتنشيط طريقة مصادقة ثانية على الأقل إذا لم تتمكن من الوصول إلى رسائل SMS الخاصة بك."])}
        }
      },
      "fr-BE": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactiver"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est envoyé au numéro de mobile enregistré par SMS. Important : activez au moins une deuxième méthode d'authentification si vous ne pouvez pas accéder à votre SMS."])}
        }
      },
      "fr-LU": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactiver"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le code d'authentification est envoyé au numéro de mobile enregistré par SMS. Important : activez au moins une deuxième méthode d'authentification si vous ne pouvez pas accéder à votre SMS."])}
        }
      },
      "mt-MT": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iddiżattiva"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivat"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-kodiċi tal-awtentikazzjoni jintbagħat lin-numru mobbli maħżun permezz ta 'SMS. Importanti: Attiva mill-inqas it-tieni metodu ta 'awtentikazzjoni jekk ma tistax taċċessa l-SMS tiegħek."])}
        }
      },
      "sl-SI": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviraj"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviraj"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Koda za preverjanje pristnosti se pošlje na shranjeno mobilno številko prek SMS-a. Pomembno: Če ne morete dostopati do sporočila SMS, aktivirajte vsaj drugi način preverjanja pristnosti."])}
        }
      },
      "el-CY": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["γραπτό μήνυμα"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποίηση"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ο κωδικός ελέγχου ταυτότητας αποστέλλεται στον αποθηκευμένο αριθμό κινητού μέσω SMS. Σημαντικό: Ενεργοποιήστε τουλάχιστον μια δεύτερη μέθοδο ελέγχου ταυτότητας εάν δεν μπορείτε να αποκτήσετε πρόσβαση στο SMS σας."])}
        }
      },
      "tr-CY": {
        "addSMSAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştir"])}
        },
        "SMSAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SMS"])}
        },
        "removeAuthentication": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırak"])}
        },
        "active": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
        },
        "SMSAuthenticationExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimlik doğrulama kodu, saklanan cep telefonu numarasına SMS ile gönderilir. Önemli: SMS'inize erişemiyorsanız en az ikinci bir kimlik doğrulama yöntemini etkinleştirin."])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication/SMSAuthentication.vue


/* custom blocks */
;
if (typeof SMSAuthenticationvue_type_custom_index_0_blockType_i18n === 'function') SMSAuthenticationvue_type_custom_index_0_blockType_i18n(SMSAuthenticationvue_type_script_setup_true_lang_js)


const SMSAuthentication_exports_ = SMSAuthenticationvue_type_script_setup_true_lang_js;

/* harmony default export */ var SMSAuthentication = (SMSAuthentication_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication.vue?vue&type=script&setup=true&lang=js



var MultiFactorAuthenticationvue_type_script_setup_true_lang_js_withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1abc2c16"), n = n(), _popScopeId(), n;
};

var MultiFactorAuthenticationvue_type_script_setup_true_lang_js_hoisted_1 = ["innerHTML"];
var MultiFactorAuthenticationvue_type_script_setup_true_lang_js_hoisted_2 = {
  class: "dp-flex wrap align-items__flex-start"
};



var MultiFactorAuthenticationvue_type_script_setup_true_lang_js_default_ = {
  name: "MultiFactorAuthentication",
  components: {
    AuthenticatorApp: AuthenticatorApp,
    EmailAuthentication: EmailAuthentication,
    SMSAuthentication: SMSAuthentication
  }
};

/* harmony default export */ var MultiFactorAuthenticationvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(MultiFactorAuthenticationvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h3", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('multiFactorAuthentication.title')), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
        class: "text-block",
        innerHTML: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('secureYourAccount.textBlock.content')
      }, null, 8, MultiFactorAuthenticationvue_type_script_setup_true_lang_js_hoisted_1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", MultiFactorAuthenticationvue_type_script_setup_true_lang_js_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(AuthenticatorApp, {
        class: "mfa-crud-item"
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(EmailAuthentication, {
        class: "mfa-crud-item"
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(SMSAuthentication, {
        class: "mfa-crud-item"
      })])]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-66.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-66.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-66.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-66.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication.vue?vue&type=style&index=0&id=1abc2c16&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication.vue?vue&type=style&index=0&id=1abc2c16&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function MultiFactorAuthenticationvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multi-Faktor-Authentifizierung"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erhöhe die Sicherheit deines Benutzerkontos durch eine Zwei-Faktor-Authentifizierung (2FA) beim Login.Der zweite Faktor  \"Authentifizierungscode\" ist ein zeitlich befristites Einmalpasswort (One-time password, OTP).Mit Aktivierung der 2FA wird bei jedem Login nach der Eingabe deiner Logindaten (erster Faktor) der Authentifizierungscode (zweiter Faktor) abgefragt."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Erhöhe die Sicherheit deines Benutzerkontos durch eine Zwei-Faktor-Authentifizierung (2FA).</p>"])}
          }
        }
      },
      "de-AT": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multi-Faktor-Authentifizierung"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erhöhe die Sicherheit deines Benutzerkontos durch eine Zwei-Faktor-Authentifizierung (2FA) beim Login.Der zweite Faktor  \"Authentifizierungscode\" ist ein zeitlich befristites Einmalpasswort (One-time password, OTP).Mit Aktivierung der 2FA wird bei jedem Login nach der Eingabe deiner Logindaten (erster Faktor) der Authentifizierungscode (zweiter Faktor) abgefragt."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Erhöhe die Sicherheit deines Benutzerkontos durch eine Zwei-Faktor-Authentifizierung (2FA).</p>"])}
          }
        }
      },
      "de-CH": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multi-Faktor-Authentifizierung"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erhöhe die Sicherheit deines Benutzerkontos durch eine Zwei-Faktor-Authentifizierung (2FA) beim Login.Der zweite Faktor  \"Authentifizierungscode\" ist ein zeitlich befristites Einmalpasswort (One-time password, OTP).Mit Aktivierung der 2FA wird bei jedem Login nach der Eingabe deiner Logindaten (erster Faktor) der Authentifizierungscode (zweiter Faktor) abgefragt."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Erhöhe die Sicherheit deines Benutzerkontos durch eine Zwei-Faktor-Authentifizierung (2FA).</p>"])}
          }
        }
      },
      "en-US": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multi-factor authentication"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Increase the security of your user account with two-factor authentication (2FA) at login.The second factor \"authentication code\" is a time-limited one-time password (OTP).With activation of the 2FA, the authentication code (second factor) is requested every time you log in after entering your login data (first factor)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Increase the security of your user account with two-factor authentication (2FA) at login.</p>"])}
          }
        }
      },
      "en-GB": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multi-Factor Authentication"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Increase the security of your user account with two-factor authentication (2FA) at login.The second factor \"authentication code\" is a time-limited one-time password (OTP).With activation of the 2FA, the authentication code (second factor) is requested every time you log in after entering your login data (first factor)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Increase the security of your user account with two-factor authentication (2FA) at login.</p>"])}
          }
        }
      },
      "it-IT": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autenticazione a più fattori"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aumenta la sicurezza del tuo account utente con l'autenticazione a due fattori (2FA) al momento dell'accesso.Il secondo fattore \"codice di autenticazione\" è una password monouso (OTP) limitata nel tempo.Con l'attivazione della 2FA, il codice di autenticazione (secondo fattore) viene richiesto ogni volta che accedi dopo aver inserito i tuoi dati di accesso (primo fattore)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Aumenta la sicurezza con l'autenticazione a due fattori (2FA) durante l'accesso.</p>"])}
          }
        }
      },
      "fr-FR": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentification multi-facteurs"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Augmentez la sécurité de votre compte utilisateur avec l'authentification à deux facteurs (2FA) lors de la connexion.Le deuxième facteur « code d'authentification » est un mot de passe à usage unique limité dans le temps (OTP).Avec l'activation du 2FA, le code d'authentification (deuxième facteur) est demandé à chaque fois que vous vous connectez après avoir saisi vos données de connexion (premier facteur)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Renforcez la sécurité de votre compte utilisateur grâce à l'authentification à deux facteurs (2FA) lors de la connexion.</p>"])}
          }
        }
      },
      "es-ES": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autenticación multifactor"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aumente la seguridad de su cuenta de usuario con la autenticación de dos factores (2FA) al iniciar sesión.El segundo factor \"código de autenticación\" es una contraseña de un solo uso (OTP) con límite de tiempo.Con la activación de 2FA, el código de autenticación (segundo factor) se solicita cada vez que inicia sesión después de ingresar sus datos de inicio de sesión (primer factor)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Aumente la seguridad de su cuenta con la autenticación en dos pasos al iniciar sesión.</p>"])}
          }
        }
      },
      "pl-PL": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uwierzytelnianie wieloskładnikowe"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zwiększ bezpieczeństwo swojego konta użytkownika dzięki uwierzytelnianiu dwuskładnikowemu (2FA) podczas logowania.Drugi czynnik „kod uwierzytelniający” to ograniczone czasowo jednorazowe hasło (OTP).Przy aktywacji 2FA kod uwierzytelniający (drugi czynnik) jest wymagany przy każdym logowaniu po wprowadzeniu danych logowania (pierwszy czynnik)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Zwiększ bezpieczeństwo swojego konta użytkownika dzięki uwierzytelnianiu dwuskładnikowemu (2FA) podczas logowania.</p>"])}
          }
        }
      },
      "nl-NL": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multi-Factor Authenticatie"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verhoog de veiligheid van uw gebruikersaccount met tweefactorauthenticatie (2FA) bij het inloggen.De tweede factor \"authenticatiecode\" is een in de tijd beperkt eenmalig wachtwoord (OTP).Bij activering van de 2FA wordt de authenticatiecode (tweede factor) gevraagd elke keer dat u inlogt na het invoeren van uw inloggegevens (eerste factor)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Verhoog de veiligheid van uw gebruikersaccount met twee-factorauthenticatie (2FA) bij het inloggen.</p>"])}
          }
        }
      },
      "bg-BG": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Многофакторно удостоверяване"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Увеличете защитата на вашия потребителски акаунт с двуфакторно удостоверяване (2FA) при влизане.Вторият фактор „код за удостоверяване“ е ограничена във времето еднократна парола (OTP).С активирането на 2FA, кодът за удостоверяване (втори фактор) се изисква всеки път, когато влезете след въвеждане на данните си за вход (първи фактор)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Увеличете защитата на Вашия потребителски акаунт с двуфакторно удостоверяване (2FA) при влизане.</p>"])}
          }
        }
      },
      "bs-BA": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Višefaktorska autentifikacija"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Povećajte sigurnost svog korisničkog računa pomoću dvofaktorske autentifikacije (2FA) prilikom prijavljivanja.Drugi faktor \"kod za provjeru autentičnosti\" je vremenski ograničena jednokratna lozinka (OTP).Aktivacijom 2FA kod za autentifikaciju (drugi faktor) traži se svaki put kada se prijavite nakon unosa podataka za prijavu (prvi faktor)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Povećajte sigurnost svog korisničkog računa pomoću dvofaktorske autentifikacije (2FA) prilikom prijavljivanja.</p>"])}
          }
        }
      },
      "zh-CN": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["多重身份验证"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登录时使用双因素身份验证 (2FA) 提高用户帐户的安全性。第二个因素“验证码”是有时间限制的一次性密码 (OTP)。激活 2FA 后，每次在输入登录数据（第一因素）后登录时，都会要求提供身份验证代码（第二因素）。"])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>登录时使用双重身份验证 (2FA) 提高用户帐户的安全性。</p>"])}
          }
        }
      },
      "da-DK": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multifaktorautentificering"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forøg sikkerheden på din brugerkonto med tofaktorautentificering (2FA), når du logger ind.Den anden faktor \"godkendelseskode\" er en tidsbegrænset engangskodeord (OTP).Ved aktivering af 2FA kræves godkendelseskoden (anden faktor) hver gang du logger ind efter indtastning af dine login-data (første faktor)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Forøg sikkerheden på din brugerkonto med tofaktorautentificering (2FA), når du logger ind.</p>"])}
          }
        }
      },
      "et-EE": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mitmeteguriline autentimine"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suurendage oma sisselogimisel oma kasutajakonto turvalisust kaheastmelise autentimisega (2FA).Teine tegur \"autentimiskood\" on ajaliselt piiratud ühekordne parool (OTP).2FA aktiveerimisel küsitakse autentimiskoodi (teine tegur) iga kord, kui logite sisse pärast sisselogimisandmete sisestamist (esimene tegur)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Suurendage oma sisselogimisel oma kasutajakonto turvalisust kaheastmelise autentimisega (2FA).</p>"])}
          }
        }
      },
      "fi-FI": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Monivaiheinen todennus"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paranna käyttäjätilisi turvallisuutta kaksivaiheisella todennuksella (2FA) kirjautumisen yhteydessä.Toinen tekijä \"todennuskoodi\" on aikarajoitettu kertaluonteinen salasana (OTP).Kun 2FA aktivoidaan, todennuskoodia (toinen tekijä) pyydetään joka kerta, kun kirjaudut sisään sisäänkirjautumistietojesi syöttämisen jälkeen (ensimmäinen kerroin)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Paranna käyttäjätilisi turvallisuutta kaksivaiheisella todennuksella (2FA) kirjautumisen yhteydessä.</p>"])}
          }
        }
      },
      "el-GR": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Έλεγχος ταυτότητας πολλών παραγόντων"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αυξήστε την ασφάλεια του λογαριασμού χρήστη σας με έλεγχο ταυτότητας δύο παραγόντων (2FA) κατά τη σύνδεση.Ο δεύτερος παράγοντας \"κωδικός ελέγχου ταυτότητας\" είναι ένας κωδικός πρόσβασης μίας χρήσης (OTP) περιορισμένου χρόνου.Με την ενεργοποίηση του 2FA, ζητείται ο κωδικός ελέγχου ταυτότητας (δεύτερος παράγοντας) κάθε φορά που συνδέεστε αφού εισαγάγετε τα δεδομένα σύνδεσής σας (πρώτος παράγοντας)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Αυξήστε την ασφάλεια του λογαριασμού χρήστη σας με έλεγχο ταυτότητας δύο παραγόντων (2FA) κατά τη σύνδεση.</p>"])}
          }
        }
      },
      "he-IL": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אימות רב גורמים"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדל את האבטחה של חשבון המשתמש שלך באמצעות אימות דו-גורמי (2FA) בעת הכניסה.הגורם השני \"קוד אימות\" הוא סיסמה חד פעמית מוגבלת בזמן (OTP).על ידי הפעלת ה- \"2FA\", קוד האימות (גורם שני) יתבקש בכל פעם שתתחבר לאחר הזנת נתוני הכניסה שלך (גורם ראשון)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>הגדל את האבטחה של חשבון המשתמש שלך באמצעות אימות דו-גורמי (2FA) בעת הכניסה.</p>"])}
          }
        }
      },
      "ga-IE": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fíordheimhniú ilfhachtóirí"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slándáil do chuntas úsáideora a mhéadú le fíordheimhniú dhá fhachtóir (2FA) agus tú ag logáil isteach.Is é an dara fachtóir \"cód fíordheimhnithe\" ná pasfhocal aon-uaire (OTP) a bhfuil teorainn ama leis.Le gníomhachtú an 2FA, iarrtar an cód fíordheimhnithe (an dara fachtóir) gach uair a logálann tú isteach tar éis duit do shonraí logála isteach (an chéad fhachtóir) a iontráil."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Slándáil do chuntas úsáideora a mhéadú le fíordheimhniú dhá fhachtóir (2FA) agus tú ag logáil isteach.</p>"])}
          }
        }
      },
      "ja-JP": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["多要素認証"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ログイン時の 2 要素認証 (2FA) を使用して、ユーザー アカウントのセキュリティを強化します。2つ目の要素「認証コード」は、期限付きのワンタイムパスワード(OTP)です。2FA を有効にすると、ログインデータ (第 1 要素) を入力した後、ログインするたびに認証コード (第 2 要素) が要求されます。"])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>ログイン時の 2 要素認証 (2FA) を使用して、ユーザー アカウントのセキュリティを強化します。</p>"])}
          }
        }
      },
      "hr-HR": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Višefaktorska autentifikacija"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Povećajte sigurnost svog korisničkog računa pomoću dvofaktorske provjere autentičnosti (2FA) prilikom prijave.Drugi faktor \"autentifikacijskog koda\" je vremenski ograničena jednokratna lozinka (OTP).Aktiviranjem 2FA kod za autentifikaciju (drugi faktor) zatražit će se svaki put kada se prijavite nakon unosa podataka za prijavu (prvi faktor)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Povećajte sigurnost svog korisničkog računa pomoću dvofaktorske provjere autentičnosti (2FA) prilikom prijave.</p>"])}
          }
        }
      },
      "lv-LV": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Daudzfaktoru autentifikācija"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Palieliniet sava lietotāja konta drošību, izmantojot divfaktoru autentifikāciju (2FA), piesakoties.Otrais faktors \"autentifikācijas kods\" ir ierobežota laika vienreizēja parole (OTP).Aktivizējot 2FA, autentifikācijas kods (otrais faktors) tiek pieprasīts katru reizi, kad piesakāties pēc pieteikšanās datu ievadīšanas (pirmais faktors)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Palieliniet sava lietotāja konta drošību, izmantojot divfaktoru autentifikāciju (2FA), piesakoties.</p>"])}
          }
        }
      },
      "lt-LT": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dviejų veiksnių autentifikavimas"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Padidinkite savo vartotojo paskyros saugumą naudodami dviejų veiksnių autentifikavimą (2FA) prisijungdami.Antrasis veiksnys „autentifikavimo kodas“ yra ribotas laiko vienkartinis slaptažodis (OTP).Suaktyvinus „2FA“, autentifikavimo kodas (antrasis veiksnys) bus prašomas kiekvieną kartą prisijungus, įvedus prisijungimo duomenis (pirmasis veiksnys)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Padidinkite vartotojo paskyros saugumą naudodami dviejų veiksnių autentifikavimą (2FA), kai prisijungiate.</p>"])}
          }
        }
      },
      "pt-PT": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autenticação multifator"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aumente a segurança da sua conta de usuário com a autenticação de dois fatores (2FA) ao fazer login.O segundo fator, \"código de autenticação\", é uma senha única com limite de tempo (OTP).Com a ativação do 2FA, o código de autenticação (segundo fator) é solicitado toda vez que você fizer o login após inserir seus dados de login (primeiro fator)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Aumente a segurança da sua conta de utilizador com a autenticação de dois fatores (2FA) ao iniciar sessão.</p>"])}
          }
        }
      },
      "ro-RO": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autentificare cu mai mulți factori"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creșteți securitatea contului dvs. de utilizator cu autentificare cu doi factori (2FA) la conectare.Al doilea factor „cod de autentificare” este o parolă limitată în timp (OTP).Odată cu activarea 2FA, codul de autentificare (al doilea factor) este solicitat de fiecare dată când vă conectați după introducerea datelor de conectare (primul factor)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Îmbunătățiți securitatea contului de utilizator prin autentificarea cu doi factori (2FA).</p>"])}
          }
        }
      },
      "ru-RU": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Многофакторная аутентификация"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Повысьте безопасность своей учетной записи с помощью двухфакторной аутентификации (2FA) при входе в систему.Второй фактор «код аутентификации» - это ограниченный по времени одноразовый пароль (OTP).При активации 2FA код аутентификации (второй фактор) запрашивается каждый раз, когда вы входите в систему после ввода данных для входа (первый фактор)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Повысьте безопасность своей учетной записи с помощью двухфакторной аутентификации (2FA) при входе в систему.</p>"])}
          }
        }
      },
      "sv-SE": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Multifaktorautentisering"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Öka säkerheten för ditt användarkonto med tvåfaktorautentisering (2FA) när du loggar in.Den andra faktorn \"autentiseringskod\" är ett tidsbegränsat engångslösenord (OTP).Vid aktivering av 2FA begärs autentiseringskoden (andra faktor) varje gång du loggar in efter att du har angett inloggningsdata (första faktor)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Öka säkerheten för ditt användarkonto med tvåfaktorautentisering (2FA) när du loggar in.</p>"])}
          }
        }
      },
      "sk-SK": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viacfaktorové overenie"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zvýšte zabezpečenie svojho používateľského účtu pomocou dvojfaktorovej autentifikácie (2FA) pri prihlasovaní.Druhým faktorom „autentifikačného kódu“ je časovo obmedzené jednorazové heslo (OTP).Pri aktivácii 2FA sa vyžaduje autentifikačný kód (druhý faktor) zakaždým, keď sa prihlásite po zadaní prihlasovacích údajov (prvý faktor)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Zvýšte zabezpečenie vášho používateľského účtu pomocou dvojfaktorového overenia (2FA) pri prihlasovaní.</p>"])}
          }
        }
      },
      "cs-CZ": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vícefaktorové ověřování"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zvyšte zabezpečení svého uživatelského účtu pomocí dvoufaktorového ověřování (2FA) při přihlašování.Druhým faktorem „ověřovacího kódu“ je časově omezené jednorázové heslo (OTP).Při aktivaci 2FA je vyžadován ověřovací kód (druhý faktor) pokaždé, když se přihlásíte po zadání přihlašovacích údajů (první faktor)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Zvyšte zabezpečení svého uživatelského účtu pomocí dvoufaktorového ověřování (2FA) při přihlašování.</p>"])}
          }
        }
      },
      "tr-TR": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çok faktörlü kimlik doğrulama"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oturum açarken iki faktörlü kimlik doğrulama (2FA) ile kullanıcı hesabınızın güvenliğini artırın.İkinci faktör \"kimlik doğrulama kodu\", zaman sınırlı bir kerelik şifredir (OTP).2FA'nın etkinleştirilmesiyle, oturum açma verilerinizi (birinci faktör) girdikten sonra her oturum açtığınızda kimlik doğrulama kodu (ikinci faktör) istenir."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Oturum açarken iki faktörlü kimlik doğrulama (2FA) ile kullanıcı hesabınızın güvenliğini artırın.</p>"])}
          }
        }
      },
      "hu-HU": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Többfaktoros hitelesítés"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Növelje felhasználói fiókjának biztonságát kétfaktoros hitelesítéssel (2FA) a bejelentkezéskor.A második tényező \"hitelesítési kód\" egy korlátozott időre szóló egyszeri jelszó (OTP).A 2FA aktiválásával minden alkalommal, amikor bejelentkezik, a bejelentkezési adatok megadása után (első tényező) a hitelesítési kódot (második tényező) kérjük."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Növelje felhasználói fiókjának biztonságát kétfaktoros hitelesítéssel (2FA) a bejelentkezéskor.</p>"])}
          }
        }
      },
      "ar-AE": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مصادقة متعددة العوامل"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قم بزيادة أمان حساب المستخدم الخاص بك باستخدام المصادقة الثنائية (2FA) عند تسجيل الدخول.العامل الثاني \"رمز المصادقة\" هو كلمة مرور لمرة واحدة محدودة الوقت (OTP).عند تفعيل المصادقة الثنائية (2FA) ، يُطلب رمز المصادقة (العامل الثاني) في كل مرة تقوم فيها بتسجيل الدخول بعد إدخال بيانات تسجيل الدخول الخاصة بك (العامل الأول)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>قم بزيادة أمان حساب المستخدم الخاص بك باستخدام المصادقة الثنائية (2FA) عند تسجيل الدخول.</p>"])}
          }
        }
      },
      "fr-BE": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentification multi-facteurs"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Augmentez la sécurité de votre compte utilisateur avec l'authentification à deux facteurs (2FA) lors de la connexion.Le deuxième facteur « code d'authentification » est un mot de passe à usage unique limité dans le temps (OTP).Avec l'activation du 2FA, le code d'authentification (deuxième facteur) est demandé à chaque fois que vous vous connectez après avoir saisi vos données de connexion (premier facteur)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Renforcez la sécurité de votre compte utilisateur grâce à l'authentification à deux facteurs (2FA) lors de la connexion.</p>"])}
          }
        }
      },
      "fr-LU": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Authentification multi-facteurs"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Augmentez la sécurité de votre compte utilisateur avec l'authentification à deux facteurs (2FA) lors de la connexion.Le deuxième facteur « code d'authentification » est un mot de passe à usage unique limité dans le temps (OTP).Avec l'activation du 2FA, le code d'authentification (deuxième facteur) est demandé à chaque fois que vous vous connectez après avoir saisi vos données de connexion (premier facteur)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Renforcez la sécurité de votre compte utilisateur grâce à l'authentification à deux facteurs (2FA) lors de la connexion.</p>"])}
          }
        }
      },
      "mt-MT": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Awtentikazzjoni b'Ħafna Fatturi"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żid is-sigurtà tal-kont tal-utent tiegħek b'awtentikazzjoni b'żewġ fatturi (2FA) meta tidħol.It-tieni fattur \"kodiċi ta 'awtentikazzjoni\" huwa password ta' darba limitata fiż-żmien (OTP).Bl-attivazzjoni tat-2FA, il-kodiċi tal-awtentikazzjoni (it-tieni fattur) huwa mitlub kull darba li tidħol wara li ddaħħal id-dejta tal-login tiegħek (l-ewwel fattur)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Żid is-sigurtà tal-kont tal-utent tiegħek b'awtentikazzjoni b'żewġ fatturi (2FA) meta tidħol.</p>"])}
          }
        }
      },
      "sl-SI": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Večkratno preverjanje pristnosti"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Povečajte varnost svojega uporabniškega računa z dvofaktorsko overitvijo (2FA) med prijavo.Drugi dejavnik \"kode za preverjanje pristnosti\" je časovno omejeno enkratno geslo (OTP).Z aktivacijo 2FA se zahteva kodo za preverjanje pristnosti (drugi faktor) vsakič, ko se prijavite po vnosu prijavnih podatkov (prvi faktor)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Varnost svojega uporabniškega računa izboljšajte z dvakratnim preverjanjem pristnosti (2FA) med prijavo.</p>"])}
          }
        }
      },
      "el-CY": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Έλεγχος ταυτότητας πολλών παραγόντων"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αυξήστε την ασφάλεια του λογαριασμού χρήστη σας με έλεγχο ταυτότητας δύο παραγόντων (2FA) κατά τη σύνδεση.Ο δεύτερος παράγοντας \"κωδικός ελέγχου ταυτότητας\" είναι ένας κωδικός πρόσβασης μίας χρήσης (OTP) περιορισμένου χρόνου.Με την ενεργοποίηση του 2FA, ζητείται ο κωδικός ελέγχου ταυτότητας (δεύτερος παράγοντας) κάθε φορά που συνδέεστε αφού εισαγάγετε τα δεδομένα σύνδεσής σας (πρώτος παράγοντας)."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Αυξήστε την ασφάλεια του λογαριασμού χρήστη σας με έλεγχο ταυτότητας δύο παραγόντων (2FA) κατά τη σύνδεση.</p>"])}
          }
        }
      },
      "tr-CY": {
        "multiFactorAuthentication": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çok faktörlü kimlik doğrulama"])}
        },
        "textBlock": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
          "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oturum açarken iki faktörlü kimlik doğrulama (2FA) ile kullanıcı hesabınızın güvenliğini artırın.İkinci faktör \"kimlik doğrulama kodu\", zaman sınırlı bir kerelik şifredir (OTP).2FA'nın etkinleştirilmesiyle, oturum açma verilerinizi (birinci faktör) girdikten sonra her oturum açtığınızda kimlik doğrulama kodu (ikinci faktör) istenir."])}
        },
        "secureYourAccount": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Oturum açarken iki faktörlü kimlik doğrulama (2FA) ile kullanıcı hesabınızın güvenliğini artırın.</p>"])}
          }
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/MultiFactorAuthentication.vue



;
/* custom blocks */

if (typeof MultiFactorAuthenticationvue_type_custom_index_0_blockType_i18n === 'function') MultiFactorAuthenticationvue_type_custom_index_0_blockType_i18n(MultiFactorAuthenticationvue_type_script_setup_true_lang_js)


;
const MultiFactorAuthentication_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(MultiFactorAuthenticationvue_type_script_setup_true_lang_js, [['__scopeId',"data-v-1abc2c16"]])

/* harmony default export */ var MultiFactorAuthentication = (MultiFactorAuthentication_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/PasswordSettings/ChangePassword.vue?vue&type=script&setup=true&lang=js









var ChangePasswordvue_type_script_setup_true_lang_js_default_ = {
  name: "ChangePassword",
  data: function data() {
    return {
      simpleCrudModel: {},
      change: false,
      form: {
        currentPassword: '',
        newPassword: ''
      },
      loading: false,
      passwordHasBeenChanged: false
    };
  },
  computed: _objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ['apiUrls'])),
  methods: {
    changePassword: function changePassword() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var err, res, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return external_await_to_js_default()(_this.$http.post("".concat(_this.apiUrls.dutypay, "/api/v0/change-password"), _objectSpread2({}, _this.form)));

              case 3:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];

                if (!err) {
                  _context.next = 10;
                  break;
                }

                _this.loading = false;
                throw err;

              case 10:
                _this.loading = false;
                _this.passwordHasBeenChanged = true;
                return _context.abrupt("return", res);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};


/* harmony default export */ var ChangePasswordvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(ChangePasswordvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    var composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables');

    var _composables$useViewp = composables.useViewportSize(),
        isMobile = _composables$useViewp.isMobile;

    return function (_ctx, _cache) {
      var _component_DpNotificationPersist = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpNotificationPersist");

      var _component_DpInputPassword = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpInputPassword");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_DpForm = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpForm");

      var _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse");

      var _component_DpSimpleCrud = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpSimpleCrud");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpSimpleCrud, {
        modelValue: _ctx.simpleCrudModel,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(simpleCrudModel) ? simpleCrudModel.value = $event : null;
        }),
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('changePassword.title'),
        showDefaultSlot: _ctx.change,
        buttonLabel: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('change.buttonLabel'),
        buttonIcon: false,
        onActivateSlot: _cache[5] || (_cache[5] = function ($event) {
          return _ctx.change = true;
        }),
        screenSizeIsMobile: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
      }, {
        read: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('changePasswordExplain.label')), 1)];
        }),
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpNotificationPersist, {
            type: "success",
            message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('changePassword.notificationPersist.success.message'),
            title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('changePassword.notificationPersist.success.title')
          }, null, 8, ["message", "title"]), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.passwordHasBeenChanged]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpForm, {
                modelValue: _ctx.form,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(form) ? form.value = $event : null;
                }),
                loading: _ctx.loading,
                action: _ctx.changePassword,
                "notification-success": {
                  title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('changePassword.notification.success.title'),
                  message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('changePassword.notification.success.message')
                },
                "notification-async-error": {
                  title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('changePassword.notification.asyncError.title'),
                  message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('changePassword.notification.asyncError.message')
                },
                "primary-button-label": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('saveNewPassword.buttonLabel'),
                reference: "change-password"
              }, {
                secondaryButton: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                    purpose: "secondaryAction",
                    onClick: _cache[2] || (_cache[2] = function ($event) {
                      return _ctx.change = false;
                    })
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('cancel.buttonLabel')), 1)];
                    }),
                    _: 1
                  })];
                }),
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpInputPassword, {
                    label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('currentPassword.label'),
                    required: "",
                    modelValue: _ctx.form.currentPassword,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return _ctx.form.currentPassword = $event;
                    }),
                    prop: "currentPassword"
                  }, null, 8, ["label", "modelValue"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpInputPassword, {
                    label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('newPassword.label'),
                    "label-repeat": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('repeatNewPassword.label'),
                    "input-parameters": {
                      placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('newPassword.placeholder')
                    },
                    "input-parameters-repeat": {
                      placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('repeatNewPassword.placeholder')
                    },
                    repeat: "",
                    required: "",
                    modelValue: _ctx.form.newPassword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return _ctx.form.newPassword = $event;
                    }),
                    prop: "newPassword"
                  }, null, 8, ["label", "label-repeat", "input-parameters", "input-parameters-repeat", "modelValue"])];
                }),
                _: 1
              }, 8, ["modelValue", "loading", "action", "notification-success", "notification-async-error", "primary-button-label"])];
            }),
            _: 1
          }, 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, !_ctx.passwordHasBeenChanged]])];
        }),
        _: 1
      }, 8, ["modelValue", "headline", "showDefaultSlot", "buttonLabel", "screenSizeIsMobile"]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/PasswordSettings/ChangePassword.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/PasswordSettings/ChangePassword.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function ChangePasswordvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort wiederholen"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort wiederholen"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktuelles Passwort"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erstelle ein starkes Passwort."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Passwort ändern"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bearbeiten"])}
        }
      },
      "de-AT": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort wiederholen"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort wiederholen"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktuelles Passwort"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erstelle ein starkes Passwort."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Passwort ändern"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bearbeiten"])}
        }
      },
      "de-CH": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort wiederholen"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort wiederholen"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktuelles Passwort"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erstelle ein starkes Passwort."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Passwort ändern"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Speichern"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bearbeiten"])}
        }
      },
      "en-US": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repeat new password"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repeat new password"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New password"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New password"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Current password"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create a strong password."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change password"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])}
        }
      },
      "en-GB": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repeat new password"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repeat new password"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New password"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New password"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Current password"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create a strong password."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Change password"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])}
        }
      },
      "it-IT": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ripeti nuova password"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ripeti nuova password"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuova password"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuova password"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password attuale"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crea una password sicura."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cambia password"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salva"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifica"])}
        }
      },
      "fr-FR": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisissez à nouveau le nouveau mot de passe"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisissez à nouveau le nouveau mot de passe"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau mot de passe"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau mot de passe"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mot de passe actuel"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créez un mot de passe fort."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Changer le mot de passe"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])}
        }
      },
      "es-ES": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repita la nueva contraseña"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repita la nueva contraseña"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nueva contraseña"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nueva contraseña"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contraseña actual"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crea una contraseña segura."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cambiar contraseña"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])}
        }
      },
      "pl-PL": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Powtórz nowe hasło"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Powtórz nowe hasło"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nowe hasło"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nowe hasło"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktualne hasło"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utwórz silne hasło."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zmień hasło"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zapisz"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edytuj"])}
        }
      },
      "nl-NL": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Herhaal nieuw wachtwoord"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Herhaal nieuw wachtwoord"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afbreken"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nieuw wachtwoord"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nieuw wachtwoord"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Huidig wachtwoord"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maak een sterk wachtwoord."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wachtwoord wijzigen"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opslaan"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bewerken"])}
        }
      },
      "bg-BG": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Повторете новата парола"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Повторете новата парола"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прекратяване"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нова парола"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нова парола"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настояща парола"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Създайте силна парола."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Промяна на паролата"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Запазване"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Редактиране"])}
        }
      },
      "bs-BA": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ponovite novu lozinku"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ponovite novu lozinku"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nova lozinka"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nova lozinka"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trenutna šifra"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stvorite jaku lozinku."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promijeni lozinku"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spremite"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uredi"])}
        }
      },
      "zh-CN": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["再次输入新密码"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["再次输入新密码"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中止"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新密码"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新密码"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["当前密码"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创建一个强密码。"])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["修改密码"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["编辑"])}
        }
      },
      "da-DK": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gentag nyt kodeord"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gentag nyt kodeord"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nyt kodeord"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nyt kodeord"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuværende kodeord"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opret en stærk adgangskode."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ændr adgangskode"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gem"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rediger"])}
        }
      },
      "et-EE": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korda uut parooli"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korda uut parooli"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Katkesta"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uus salasõna"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uus salasõna"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Praegune salasõna"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Looge kindel parool."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Muuda parooli"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salvesta"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Redigeeri"])}
        }
      },
      "fi-FI": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toista uusi salasana"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toista uusi salasana"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keskeyttää"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uusi salasana"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uusi salasana"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nykyinen salasana"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Luo vahva salasana."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vaihda salasana"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tallenna"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Muuta"])}
        }
      },
      "el-GR": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επαναλάβετε τον νέο κωδικό πρόσβασης"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επαναλάβετε τον νέο κωδικό πρόσβασης"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Άκυρο"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Νέος κωδικός πρόσβασης"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Νέος κωδικός πρόσβασης"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Τρέχων κωδικός πρόσβασης"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δημιουργήστε έναν ισχυρό κωδικό πρόσβασης."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αλλαγή κωδικού πρόσβασης"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποθήκευση"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επεξεργασία"])}
        }
      },
      "he-IL": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חזור על סיסמה חדשה"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חזור על סיסמה חדשה"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפִּיל"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סיסמה חדשה"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סיסמה חדשה"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סיסמה נוכחית"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["צור סיסמה חזקה."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שנה סיסמה"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לשמור"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ערוך"])}
        }
      },
      "ga-IE": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort wiederholen"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Passwort wiederholen"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ginmhilleadh"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pasfhocal nua"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pasfhocal nua"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pasfhocal reatha"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cruthaigh pasfhocal láidir."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Athraigh an pasfhocal"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sábháil"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir in eagar"])}
        }
      },
      "ja-JP": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新しいパスワードを繰り返す"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新しいパスワードを繰り返す"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アボート"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新しいパスワード"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["新しいパスワード"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["現在のパスワード"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["強力なパスワードを作成します。"])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワードの変更"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["保存する"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["編集"])}
        }
      },
      "hr-HR": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ponovite novu lozinku"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ponovite novu lozinku"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekid"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nova lozinka"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nova lozinka"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trenutna lozinka"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stvorite jaku lozinku."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Promijeni lozinku"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spremi"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Urediti"])}
        }
      },
      "lv-LV": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atkārtojiet jauno paroli"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atkārtojiet jauno paroli"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pārtraukt"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jauna parole"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jauna parole"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pašreizējā parole"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izveidojiet stingru paroli."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mainīt paroli"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saglabāt"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rediģēt"])}
        }
      },
      "lt-LT": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pakartokite naują slaptažodį"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pakartokite naują slaptažodį"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutraukti"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naujas slaptažodis"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naujas slaptažodis"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dabartinis slaptažodis"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sukurkite tvirtą slaptažodį."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keisti slaptažodį"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išsaugoti"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Redaguoti"])}
        }
      },
      "pt-PT": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repita a nova palavra-passe"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repita a nova palavra-passe"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abortar"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nova palavra-passe"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nova palavra-passe"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senha atual"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crie uma senha forte."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alterar palavra-passe"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])}
        }
      },
      "ro-RO": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repetați parola nouă"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repetați parola nouă"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abandonați"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parola nouă"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parola nouă"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parola actuală"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creați o parolă puternică."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schimbare parolă"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salvare"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editare"])}
        }
      },
      "ru-RU": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Повторите новый пароль"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Повторите новый пароль"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прервать"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новый пароль"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новый пароль"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Текущий пароль"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Создайте надежный пароль."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изменить пароль"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сохранить"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Редактировать"])}
        }
      },
      "sv-SE": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upprepa nytt lösenord"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upprepa nytt lösenord"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avbryta"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nytt lösenord"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nytt lösenord"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nuvarande lösenord"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skapa ett starkt lösenord."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ändra lösenord"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spara"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Redigera"])}
        }
      },
      "sk-SK": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zopakujte nové heslo"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zopakujte nové heslo"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nové heslo"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nové heslo"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktuálne heslo"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vytvorte si silné heslo."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zmeniť heslo"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložiť"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upraviť"])}
        }
      },
      "cs-CZ": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opakujte nové heslo"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opakujte nové heslo"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přerušit"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nové heslo"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nové heslo"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktuální heslo"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vytvořte silné heslo."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Změnit heslo"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uložit"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Upravit"])}
        }
      },
      "tr-TR": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yeni şifre (Tekrar)"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yeni şifre (Tekrar)"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yeni Şifre"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yeni Şifre"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şimdiki Şifre"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Güçlü bir parola oluşturun."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şifreyi değiştir"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaydet"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Düzenle"])}
        }
      },
      "hu-HU": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Új jelszó megismétlése"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Új jelszó megismétlése"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mégse"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Új jelszó"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Új jelszó"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jelenlegi jelszó"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hozzon létre egy erős jelszót."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jelszó módosítása"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mentés"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szerkeszt"])}
        }
      },
      "ar-AE": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كرر كلمة المرور الجديدة"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كرر كلمة المرور الجديدة"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إحباط"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كلمة مرور جديدة"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كلمة مرور جديدة"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كلمة السر الحالية"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أنشئ كلمة مرور قوية."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تغيير كلمة المرور"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حفظ"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحرير"])}
        }
      },
      "fr-BE": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisissez à nouveau le nouveau mot de passe"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisissez à nouveau le nouveau mot de passe"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau mot de passe"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau mot de passe"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mot de passe actuel"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créez un mot de passe fort."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Changer le mot de passe"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])}
        }
      },
      "fr-LU": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisissez à nouveau le nouveau mot de passe"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Saisissez à nouveau le nouveau mot de passe"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau mot de passe"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nouveau mot de passe"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mot de passe actuel"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créez un mot de passe fort."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Changer le mot de passe"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modifier"])}
        }
      },
      "mt-MT": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Irrepeti l-password il-ġdida"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Irrepeti l-password il-ġdida"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkanċella"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password ġdida"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password ġdida"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password kurrenti"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oħloq password qawwija."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ibdel il-Password"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Issejvja"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editja"])}
        }
      },
      "sl-SI": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ponovite novo geslo"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ponovite novo geslo"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Novo geslo"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Novo geslo"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trenutno geslo"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustvarite močno geslo."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprememba gesla"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Shrani"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uredi"])}
        }
      },
      "el-CY": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επαναλάβετε τον νέο κωδικό πρόσβασης"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επαναλάβετε τον νέο κωδικό πρόσβασης"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Άκυρο"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Νέος κωδικός πρόσβασης"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Νέος κωδικός πρόσβασης"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Τρέχων κωδικός πρόσβασης"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δημιουργήστε έναν ισχυρό κωδικό πρόσβασης."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αλλαγή κωδικού πρόσβασης"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποθήκευση"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επεξεργασία"])}
        }
      },
      "tr-CY": {
        "repeatNewPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yeni şifre (Tekrar)"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yeni şifre (Tekrar)"])}
        },
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        },
        "newPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yeni Şifre"])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yeni Şifre"])}
        },
        "currentPassword": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şimdiki Şifre"])}
        },
        "changePasswordExplain": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Güçlü bir parola oluşturun."])}
        },
        "changePassword": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          },
          "notificationPersist": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          },
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şifreyi değiştir"])}
        },
        "saveNewPassword": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaydet"])}
        },
        "change": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Düzenle"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/PasswordSettings/ChangePassword.vue


/* custom blocks */
;
if (typeof ChangePasswordvue_type_custom_index_0_blockType_i18n === 'function') ChangePasswordvue_type_custom_index_0_blockType_i18n(ChangePasswordvue_type_script_setup_true_lang_js)


const ChangePassword_exports_ = ChangePasswordvue_type_script_setup_true_lang_js;

/* harmony default export */ var ChangePassword = (ChangePassword_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/PasswordSettings.vue?vue&type=script&setup=true&lang=js



var PasswordSettingsvue_type_script_setup_true_lang_js_withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0eba25b3"), n = n(), _popScopeId(), n;
};

var PasswordSettingsvue_type_script_setup_true_lang_js_hoisted_1 = ["innerHTML"];
var PasswordSettingsvue_type_script_setup_true_lang_js_hoisted_2 = {
  class: "dp-flex wrap align-items__flex-start"
};

var PasswordSettingsvue_type_script_setup_true_lang_js_default_ = {
  name: "PasswordSettings",
  components: {
    ChangePassword: ChangePassword
  }
};

/* harmony default export */ var PasswordSettingsvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(PasswordSettingsvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h3", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('password.title')), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", {
        class: "text-block",
        innerHTML: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('changeYourPassword.textBlock.content')
      }, null, 8, PasswordSettingsvue_type_script_setup_true_lang_js_hoisted_1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", PasswordSettingsvue_type_script_setup_true_lang_js_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(ChangePassword), {
        class: "crud-item"
      })])]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/PasswordSettings.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-66.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-66.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-66.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-66.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/PasswordSettings.vue?vue&type=style&index=0&id=0eba25b3&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/PasswordSettings.vue?vue&type=style&index=0&id=0eba25b3&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings/PasswordSettings.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function PasswordSettingsvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Passwort"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hinweise zum Passwort"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Erhöhe die Sicherheit deines Benutzerkontos durch ein starkes Passwort. Verwende mindestens 12 Zeichen - mehr Zeichen erhöhen die Sicherheit.</p>"])}
          }
        }
      },
      "de-AT": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Passwort"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hinweise zum Passwort"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Erhöhe die Sicherheit deines Benutzerkontos durch ein starkes Passwort. Verwende mindestens 12 Zeichen - mehr Zeichen erhöhen die Sicherheit.</p>"])}
          }
        }
      },
      "de-CH": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Passwort"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hinweise zum Passwort"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Erhöhe die Sicherheit deines Benutzerkontos durch ein starkes Passwort. Verwende mindestens 12 Zeichen - mehr Zeichen erhöhen die Sicherheit.</p>"])}
          }
        }
      },
      "en-US": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notes on the password"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Increase the security of your user account with a strong password. Use at least 12 characters - more characters increase security.</p>"])}
          }
        }
      },
      "en-GB": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notes on the password"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Increase the security of your user account with a strong password. Use at least 12 characters - more characters increase security.</p>"])}
          }
        }
      },
      "it-IT": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Note sulla password"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Aumenta la sicurezza del tuo account utente con una password forte. Usa almeno 12 caratteri. Un numero maggiore di caratteri aumenta la sicurezza.</p>"])}
          }
        }
      },
      "fr-FR": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mot de passe"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remarques sur le mot de passe"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Augmentez la sécurité de votre compte utilisateur avec un mot de passe fort. Utilisez au moins 12 caractères - plus de caractères augmentent la sécurité.</p>"])}
          }
        }
      },
      "es-ES": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contraseña"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notas sobre la contraseña"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Aumente la seguridad de su cuenta utilizando una contraseña segura de al menos 12 caracteres.</p>"])}
          }
        }
      },
      "pl-PL": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hasło"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uwagi dotyczące hasła"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Zwiększ bezpieczeństwo swojego konta użytkownika za pomocą silnego hasła. Użyj co najmniej 12 znaków — więcej znaków zwiększa bezpieczeństwo.</p>"])}
          }
        }
      },
      "nl-NL": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wachtwoord"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opmerkingen over het wachtwoord"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Verhoog de veiligheid van uw gebruikersaccount met een sterk wachtwoord. Gebruik ten minste 12 tekens - meer tekens verhogen de veiligheid.</p>"])}
          }
        }
      },
      "bg-BG": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Парола"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бележки за паролата"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Увеличете сигурността на Вашия потребителски акаунт със силна парола. Използвайте поне 12 знака - повече знаци повишават сигурността.</p>"])}
          }
        }
      },
      "bs-BA": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lozinka"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napomene o lozinci"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Povećajte sigurnost svog korisničkog računa sa jakom lozinkom. Koristite najmanje 12 znakova - više znakova povećava sigurnost.</p>"])}
          }
        }
      },
      "zh-CN": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["密码"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["密码注意事项"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>使用强密码提高用户帐户的安全性。至少使用 12 个字符 — 字符越多，安全性越高。</p>"])}
          }
        }
      },
      "da-DK": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adgangskode"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bemærkninger om adgangskoden"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Forøg sikkerheden på din brugerkonto med en stærk adgangskode. Brug mindst 12 tegn - flere tegn øger sikkerheden.</p>"])}
          }
        }
      },
      "et-EE": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parool"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Märkused parooli kohta"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Suurendage oma kasutajakonto turvalisust tugeva parooliga. Kasutage vähemalt 12 tähemärki - rohkem märke suurendab turvalisust.</p>"])}
          }
        }
      },
      "fi-FI": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salasana"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Huomautuksia salasanasta"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Paranna käyttäjätilisi turvallisuutta vahvalla salasanalla. Käytä vähintään 12 merkkiä - useampi merkki lisää turvallisuutta.</p>"])}
          }
        }
      },
      "el-GR": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός πρόσβασης"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σημειώσεις σχετικά με τον κωδικό πρόσβασης"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Αυξήστε την ασφάλεια του λογαριασμού χρήστη σας με έναν ισχυρό κωδικό πρόσβασης. Χρησιμοποιήστε τουλάχιστον 12 χαρακτήρες - περισσότεροι χαρακτήρες αυξάνουν την ασφάλεια.</p>"])}
          }
        }
      },
      "he-IL": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סיסמה"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הערות על הסיסמה"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>הגדל את האבטחה<p>של חשבון המשתמש שלך באמצעות סיסמה חזקה. השתמשו לפחות ב -12 תווים - תווים נוספים מגבירים את האבטחה.</p>"])}
          }
        }
      },
      "ga-IE": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pasfhocal"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nótaí ar an bhfocal faire"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Méadaigh slándáil do chuntais úsáideora le pasfhocal láidir. Úsáid 12 charachtar ar a laghad – méadaíonn níos mó carachtar an tslándáil.</p>"])}
          }
        }
      },
      "ja-JP": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワード"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["パスワードに関するご注意"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>強力なパスワードでユーザー アカウントのセキュリティを強化します。 少なくとも 12 文字を使用してください - 文字数が多いほどセキュリティが向上します。</p>"])}
          }
        }
      },
      "hr-HR": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lozinka"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napomene o lozinci"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Povećajte sigurnost svog korisničkog računa s jakom lozinkom. Upotrijebite najmanje 12 znakova - više znakova povećava sigurnost.</p>"])}
          }
        }
      },
      "lv-LV": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parole"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piezīmes par paroli"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Palieliniet sava lietotāja konta drošību, izmantojot stipru paroli. Izmantojiet vismaz 12 rakstzīmes, jo lielāks rakstzīmju palielina drošību.</p>"])}
          }
        }
      },
      "lt-LT": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slaptažodis"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pastabos dėl slaptažodžio"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Padidinkite vartotojo paskyros saugumą naudodami sudėtingą slaptažodį. Naudokite bent 12 simbolių – didesnis simbolių skaičius padidina saugumą.</p>"])}
          }
        }
      },
      "pt-PT": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Palavra-passe"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notas sobre a senha"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Aumente a segurança da sua conta de utilizador com uma palavra-passe forte. Use pelo menos 12 caracteres; quanto maior for o número de caracteres, maior será a segurança.</p>"])}
          }
        }
      },
      "ro-RO": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parola"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Note privind parola"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Îmbunătățiți securitatea contului de utilizator cu o parolă complexă. Utilizați cel puțin 12 caractere - mai multe caractere înseamnă securitate mai bună.</p>"])}
          }
        }
      },
      "ru-RU": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пароль"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Примечания к паролю"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Повысьте безопасность своей учетной записи с помощью надежного пароля. Используйте не менее 12 символов — большее количество символов повышает безопасность.</p>"])}
          }
        }
      },
      "sv-SE": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lösenord"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anmärkningar om lösenordet"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Öka säkerheten för ditt användarkonto med ett starkt lösenord. Använd minst 12 tecken - fler tecken ökar säkerheten.</p>"])}
          }
        }
      },
      "sk-SK": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heslo"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poznámky k heslu"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Zvýšte zabezpečenie vášho používateľského účtu silným heslom. Použite najmenej 12 znakov - viac znakov zvyšuje bezpečnosť.</p>"])}
          }
        }
      },
      "cs-CZ": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Heslo"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poznámky k heslu"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Zvyšte zabezpečení svého uživatelského účtu silným heslem. Použijte alespoň 12 znaků - více znaků zvyšuje zabezpečení.</p>"])}
          }
        }
      },
      "tr-TR": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parola"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şifre ile ilgili notlar"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Güçlü bir parola ile kullanıcı hesabınızın güvenliğini artırın. En az 12 karakter kullanın - daha fazla karakter güvenliği artırır.</p>"])}
          }
        }
      },
      "hu-HU": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jelszó"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Megjegyzések a jelszóval kapcsolatban"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Növelje felhasználói fiókjának biztonságát erős jelszóval. Legalább 12 karaktert használjon - több karakter növeli a biztonságot.</p>"])}
          }
        }
      },
      "ar-AE": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كلمة السر"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ملاحظات على كلمة المرور"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>قم بزيادة أمان حساب المستخدم الخاص بك بكلمة مرور قوية. استخدم 12 حرفًا على الأقل - يزيد عدد الأحرف من الأمان.</p>"])}
          }
        }
      },
      "fr-BE": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mot de passe"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remarques sur le mot de passe"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Augmentez la sécurité de votre compte utilisateur avec un mot de passe fort. Utilisez au moins 12 caractères - plus de caractères augmentent la sécurité.</p>"])}
          }
        }
      },
      "fr-LU": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mot de passe"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remarques sur le mot de passe"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Augmentez la sécurité de votre compte utilisateur avec un mot de passe fort. Utilisez au moins 12 caractères - plus de caractères augmentent la sécurité.</p>"])}
          }
        }
      },
      "mt-MT": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Noti dwar il-password"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Żid is-sigurtà tal-kont tal-utent tiegħek b'password b'saħħitha. Uża mill-inqas 12-il karattru - aktar karattri jżidu s-sigurtà.</p>"])}
          }
        }
      },
      "sl-SI": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslo"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Opombe o geslu"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Povečajte varnost svojega uporabniškega računa z močnim geslom. Uporabite vsaj 12 znakov - več znakov poveča varnost.</p>"])}
          }
        }
      },
      "el-CY": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κωδικός πρόσβασης"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σημειώσεις σχετικά με τον κωδικό πρόσβασης"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Αυξήστε την ασφάλεια του λογαριασμού χρήστη σας με έναν ισχυρό κωδικό πρόσβασης. Χρησιμοποιήστε τουλάχιστον 12 χαρακτήρες - περισσότεροι χαρακτήρες αυξάνουν την ασφάλεια.</p>"])}
          }
        }
      },
      "tr-CY": {
        "password": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Parola"])}
        },
        "changeYourPassword": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şifre ile ilgili notlar"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Güçlü bir parola ile kullanıcı hesabınızın güvenliğini artırın. En az 12 karakter kullanın - daha fazla karakter güvenliği artırır.</p>"])}
          }
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings/PasswordSettings.vue



;
/* custom blocks */

if (typeof PasswordSettingsvue_type_custom_index_0_blockType_i18n === 'function') PasswordSettingsvue_type_custom_index_0_blockType_i18n(PasswordSettingsvue_type_script_setup_true_lang_js)


;
const PasswordSettings_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(PasswordSettingsvue_type_script_setup_true_lang_js, [['__scopeId',"data-v-0eba25b3"]])

/* harmony default export */ var PasswordSettings = (PasswordSettings_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings.vue?vue&type=script&setup=true&lang=js




var SecuritySettingsvue_type_script_setup_true_lang_js_default_ = {
  name: "SecuritySettings",
  components: {
    MultiFactorAuthentication: MultiFactorAuthentication,
    PasswordSettings: PasswordSettings
  }
};

/* harmony default export */ var SecuritySettingsvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(SecuritySettingsvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_DpPageSection = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpPageSection");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('securitySettings.title')), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpPageSection, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(MultiFactorAuthentication))];
        }),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpPageSection, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(PasswordSettings))];
        }),
        _: 1
      })]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/SecuritySettings.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function SecuritySettingsvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sicherheitseinstellungen"])}
        }
      },
      "de-AT": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sicherheitseinstellungen"])}
        }
      },
      "de-CH": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sicherheitseinstellungen"])}
        }
      },
      "en-US": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Security settings"])}
        }
      },
      "en-GB": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Security settings"])}
        }
      },
      "it-IT": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni di sicurezza"])}
        }
      },
      "fr-FR": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les paramètres de sécurité"])}
        }
      },
      "es-ES": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuraciones de seguridad"])}
        }
      },
      "pl-PL": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia bezpieczeństwa"])}
        }
      },
      "nl-NL": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beveiligingsinstellingen"])}
        }
      },
      "bg-BG": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на сигурността"])}
        }
      },
      "bs-BA": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sigurnosne postavke"])}
        }
      },
      "zh-CN": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["安全设定"])}
        }
      },
      "da-DK": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikkerhedsindstillinger"])}
        }
      },
      "et-EE": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Turvaseaded"])}
        }
      },
      "fi-FI": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Turvallisuusasetukset"])}
        }
      },
      "el-GR": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ασφαλείας"])}
        }
      },
      "he-IL": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות אבטחה"])}
        }
      },
      "ga-IE": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe slándála"])}
        }
      },
      "ja-JP": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["セキュリティ設定"])}
        }
      },
      "hr-HR": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sigurnosne postavke"])}
        }
      },
      "lv-LV": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Drošības iestatījumi"])}
        }
      },
      "lt-LT": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apsaugos nustatymai"])}
        }
      },
      "pt-PT": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Definições de segurança"])}
        }
      },
      "ro-RO": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări de securitate"])}
        }
      },
      "ru-RU": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки безопасности"])}
        }
      },
      "sv-SE": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Säkerhetsinställningar"])}
        }
      },
      "sk-SK": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bezpečnostné nastavenia"])}
        }
      },
      "cs-CZ": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bezpečnostní nastavení"])}
        }
      },
      "tr-TR": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Güvenlik ayarları"])}
        }
      },
      "hu-HU": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Biztonsági beállítások"])}
        }
      },
      "ar-AE": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الأمان"])}
        }
      },
      "fr-BE": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les paramètres de sécurité"])}
        }
      },
      "fr-LU": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Les paramètres de sécurité"])}
        }
      },
      "mt-MT": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tas-sigurtà"])}
        }
      },
      "sl-SI": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Varnostne nastavitve"])}
        }
      },
      "el-CY": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ασφαλείας"])}
        }
      },
      "tr-CY": {
        "securitySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Güvenlik ayarları"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/SecuritySettings.vue


/* custom blocks */
;
if (typeof SecuritySettingsvue_type_custom_index_0_blockType_i18n === 'function') SecuritySettingsvue_type_custom_index_0_blockType_i18n(SecuritySettingsvue_type_script_setup_true_lang_js)


const SecuritySettings_exports_ = SecuritySettingsvue_type_script_setup_true_lang_js;

/* harmony default export */ var SecuritySettings = (SecuritySettings_exports_);
;// CONCATENATED MODULE: ./src/routes/accountSettingsRoutes.js



var accountSettingsRoutes = [{
  path: '/account-settings',
  component: AccountSettings,
  children: [{
    path: 'account-information',
    component: AccountInformation
  }, {
    path: 'security-settings',
    component: SecuritySettings
  }]
}];
/* harmony default export */ var routes_accountSettingsRoutes = (accountSettingsRoutes);
// EXTERNAL MODULE: ./node_modules/lodash/findIndex.js
var findIndex = __webpack_require__(998);
var findIndex_default = /*#__PURE__*/__webpack_require__.n(findIndex);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/DeveloperSettings.vue?vue&type=script&setup=true&lang=js



var DeveloperSettingsvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 1
};



var DeveloperSettingsvue_type_script_setup_true_lang_js_default_ = {
  name: 'DeveloperSettings',
  computed: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useAuthStore, ['user'])), {}, {
    renderDeveloperSettings: function renderDeveloperSettings() {
      return findIndex_default()(this.user.roles, function (item) {
        return item === 'global:admin' || item === 'global:developer';
      }) !== -1;
    }
  })
};

/* harmony default export */ var DeveloperSettingsvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(DeveloperSettingsvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_router_view = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("router-view");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h1", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('developerSettings.title')), 1), _ctx.renderDeveloperSettings ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_router_view, {
        key: 0
      })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", DeveloperSettingsvue_type_script_setup_true_lang_js_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('noPermission.label')), 1))]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/DeveloperSettings.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/DeveloperSettings.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function DeveloperSettingsvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entwicklereinstellungen"])}
        }
      },
      "de-AT": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entwicklereinstellungen"])}
        }
      },
      "de-CH": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entwicklereinstellungen"])}
        }
      },
      "en-US": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Developer settings"])}
        }
      },
      "en-GB": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Developer settings"])}
        }
      },
      "it-IT": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni sviluppatore"])}
        }
      },
      "fr-FR": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du développeur"])}
        }
      },
      "es-ES": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de desarrollador"])}
        }
      },
      "pl-PL": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia programisty"])}
        }
      },
      "nl-NL": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontwikkelaarsinstellingen"])}
        }
      },
      "bg-BG": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки за програмисти"])}
        }
      },
      "bs-BA": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke programera"])}
        }
      },
      "zh-CN": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开发人员设定"])}
        }
      },
      "da-DK": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Udviklerindstillinger"])}
        }
      },
      "et-EE": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arendaja seaded"])}
        }
      },
      "fi-FI": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kehittäjän asetukset"])}
        }
      },
      "el-GR": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις προγραμματιστή"])}
        }
      },
      "he-IL": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות מפתח"])}
        }
      },
      "ga-IE": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe Forbróra"])}
        }
      },
      "ja-JP": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開発者設定"])}
        }
      },
      "hr-HR": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke programera"])}
        }
      },
      "lv-LV": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izstrādātāja iestatījumi"])}
        }
      },
      "lt-LT": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kūrėjo nustatymai"])}
        }
      },
      "pt-PT": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações do desenvolvedor"])}
        }
      },
      "ro-RO": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări pentru dezvoltatori"])}
        }
      },
      "ru-RU": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки разработчика"])}
        }
      },
      "sv-SE": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utvecklarinställningar"])}
        }
      },
      "sk-SK": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia pre vývojárov"])}
        }
      },
      "cs-CZ": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení vývojáře"])}
        }
      },
      "tr-TR": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geliştirici Ayarları"])}
        }
      },
      "hu-HU": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejlesztői beállítások"])}
        }
      },
      "ar-AE": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات المطور"])}
        }
      },
      "fr-BE": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du développeur"])}
        }
      },
      "fr-LU": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du développeur"])}
        }
      },
      "mt-MT": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tal-Iżviluppatur"])}
        }
      },
      "sl-SI": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve za razvijalce"])}
        }
      },
      "el-CY": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις προγραμματιστή"])}
        }
      },
      "tr-CY": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geliştirici Ayarları"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/DeveloperSettings.vue


/* custom blocks */
;
if (typeof DeveloperSettingsvue_type_custom_index_0_blockType_i18n === 'function') DeveloperSettingsvue_type_custom_index_0_blockType_i18n(DeveloperSettingsvue_type_script_setup_true_lang_js)


const DeveloperSettings_exports_ = DeveloperSettingsvue_type_script_setup_true_lang_js;

/* harmony default export */ var DeveloperSettings = (DeveloperSettings_exports_);
// EXTERNAL MODULE: external "element-plus"
var external_element_plus_ = __webpack_require__(5224);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/DeveloperSettings/TranslationReport.vue?vue&type=script&setup=true&lang=js




var TranslationReportvue_type_script_setup_true_lang_js_hoisted_1 = {
  class: "partition depth-1"
};
var TranslationReportvue_type_script_setup_true_lang_js_hoisted_2 = {
  class: "block"
};
var TranslationReportvue_type_script_setup_true_lang_js_hoisted_3 = {
  class: "block"
};
var TranslationReportvue_type_script_setup_true_lang_js_hoisted_4 = {
  class: "block"
};
var TranslationReportvue_type_script_setup_true_lang_js_hoisted_5 = {
  key: 0,
  class: "partition depth-1",
  style: {
    "padding": "2em"
  }
};
var TranslationReportvue_type_script_setup_true_lang_js_hoisted_6 = {
  class: "text-align-right",
  style: {
    "padding-inline-start": "1em"
  }
};
var TranslationReportvue_type_script_setup_true_lang_js_hoisted_7 = {
  class: "float-left"
};
var TranslationReportvue_type_script_setup_true_lang_js_hoisted_8 = {
  class: "float-right",
  style: {
    "padding-inline-start": "1em",
    "margin-bottom": "1em"
  }
};







/* harmony default export */ var TranslationReportvue_type_script_setup_true_lang_js = ({
  __name: 'TranslationReport',
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    var purpose = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)('taxhub');
    var type = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)("labels");
    var status = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)("anyIssue");
    var translationReport = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.reactive)({
      analysis: [],
      checked: []
    });
    var loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    var deleteLoading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    var search = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)("");
    var deleteConfirm = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)("");
    var purposeOptions = [{
      value: "taxhub",
      label: t("purpose.taxhub.label")
    }, {
      value: "dutypay",
      label: t("purpose.dutypay.label")
    }, {
      value: "sso",
      label: t("purpose.SSO.label")
    }, {
      value: "cl",
      label: t("purpose.componentsLibrary.label")
    }, {
      value: "ds",
      label: t("purpose.designSystem.label")
    }, {
      value: "sp",
      label: t("purpose.settingsPages.label")
    }, {
      value: "dutypayWebsite",
      label: t("purpose.dutypayWebsite.label")
    }];
    var typeOptions = [{
      value: "labels",
      label: t("type.labels.label")
    }, {
      value: "values",
      label: t("type.values.label")
    }];
    var statusOptions = [{
      value: "all",
      label: t("status.all.label")
    }, {
      value: "noIssue",
      label: t("status.noIssue.label")
    }, {
      value: "anyIssue",
      label: t("status.anyIssue.label")
    }, {
      value: "notInCode",
      label: t("status.notInCode.label")
    }, {
      value: "notInDb",
      label: t("status.notInDb.label")
    }];
    var columns = [{
      prop: "translationKeyAddress",
      label: t("translationKeyAddress.label")
    }, {
      prop: "value",
      label: t("value.label")
    }, {
      prop: "inCode",
      label: t("inCode.label"),
      align: "center"
    }, {
      prop: "inDb",
      label: t("inDb.label"),
      align: "center"
    }, {
      prop: "checked",
      label: t("checked.label"),
      align: "right"
    }];
    var envStore = (0,store_modules_.useEnvStore)();

    function getAnalysis() {
      return _getAnalysis.apply(this, arguments);
    }

    function _getAnalysis() {
      _getAnalysis = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var err, res, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                loading.value = true;
                _context6.next = 3;
                return (0,external_await_to_js_.to)(utilities_.interceptor.get("".concat(envStore.apiUrls.dutypay, "/api/v0/analyze-translations"), {
                  params: {
                    purpose: purpose.value,
                    type: type.value,
                    status: status.value,
                    search: search.value
                  }
                }));

              case 3:
                _yield$to = _context6.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];

                if (!err) {
                  _context6.next = 9;
                  break;
                }

                throw err;

              case 9:
                translationReport.analysis = res.data;
                translationReport.checked = [];
                loading.value = false;

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _getAnalysis.apply(this, arguments);
    }

    function selectAll() {
      (0,external_lodash_.map)(translationReport.analysis, function (d) {
        d.checked = true;
      });
    }

    function unselectAll() {
      (0,external_lodash_.map)(translationReport.analysis, function (d) {
        d.checked = false;
      });
    }

    function deleteTranslationKeyAddresses() {
      return _deleteTranslationKeyAddresses.apply(this, arguments);
    }

    function _deleteTranslationKeyAddresses() {
      _deleteTranslationKeyAddresses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var err, res, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                deleteLoading.value = true;
                _context7.next = 3;
                return (0,external_await_to_js_.to)(utilities_.interceptor["delete"]("".concat(envStore.apiUrls.dutypay, "/api/v0/translations"), {
                  data: translationReport.checked
                }));

              case 3:
                _yield$to3 = _context7.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 2);
                err = _yield$to4[0];
                res = _yield$to4[1];

                if (!err) {
                  _context7.next = 10;
                  break;
                }

                (0,external_element_plus_.ElNotification)({
                  title: t("delete.notification.error.title"),
                  message: t("delete.notification.error.message"),
                  duration: 5000,
                  type: 'error'
                });
                throw err;

              case 10:
                (0,external_element_plus_.ElNotification)({
                  title: t("delete.notification.success.title"),
                  message: t("delete.notification.success.message", {
                    count: res.data.deletedRecords,
                    keyCount: translationReport.checked.length
                  }),
                  duration: 5000,
                  type: 'success'
                });
                deleteLoading.value = false;
                translationReport.checked = [];
                (0,external_lodash_.map)(translationReport.analysis, function (d) {
                  d.checked = false;
                });
                deleteConfirm.value = "";

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return _deleteTranslationKeyAddresses.apply(this, arguments);
    }

    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAnalysis();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    function check() {
      translationReport.checked = (0,external_lodash_.map)((0,external_lodash_.filter)(translationReport.analysis, function (d) {
        return d.checked;
      }), "translationKeyAddress");
    }

    return function (_ctx, _cache) {
      var _component_el_option = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-option");

      var _component_el_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-select");

      var _component_el_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-col");

      var _component_el_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-row");

      var _component_el_form = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-form");

      var _component_el_form_item = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-form-item");

      var _component_el_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-input");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_DpCopyToClipboard = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCopyToClipboard");

      var _component_DpIcon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpIcon");

      var _component_el_checkbox = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-checkbox");

      var _component_DpTable = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpTable");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("translationReport.title")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", TranslationReportvue_type_script_setup_true_lang_js_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h4", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("filter.label")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form, {
        "label-position": "top"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, {
            gutter: 20
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
                xl: {
                  span: 8
                },
                sm: {
                  span: 12
                },
                xs: {
                  span: 24
                }
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", TranslationReportvue_type_script_setup_true_lang_js_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('purpose.label')), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_select, {
                    modelValue: purpose.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return purpose.value = $event;
                    }),
                    onChange: _cache[1] || (_cache[1] = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.next = 2;
                              return getAnalysis();

                            case 2:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }))),
                    size: "small",
                    "value-key": "value"
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(purposeOptions, function (item, index) {
                        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_option, {
                          key: "purpose-".concat(index),
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]);
                      }), 64))];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
                xl: {
                  span: 8
                },
                sm: {
                  span: 12
                },
                xs: {
                  span: 24
                }
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", TranslationReportvue_type_script_setup_true_lang_js_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('type.label')), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_select, {
                    modelValue: type.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return type.value = $event;
                    }),
                    onChange: _cache[3] || (_cache[3] = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              _context3.next = 2;
                              return getAnalysis();

                            case 2:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }))),
                    size: "small",
                    "value-key": "value"
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(typeOptions, function (item, index) {
                        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_option, {
                          key: "type-".concat(index),
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]);
                      }), 64))];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
                xl: {
                  span: 8
                },
                sm: {
                  span: 12
                },
                xs: {
                  span: 24
                }
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", TranslationReportvue_type_script_setup_true_lang_js_hoisted_4, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('status.label')), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_select, {
                    modelValue: status.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                      return status.value = $event;
                    }),
                    onChange: _cache[5] || (_cache[5] = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.next = 2;
                              return getAnalysis();

                            case 2:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    }))),
                    "value-key": "value",
                    size: "small"
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(statusOptions, function (item, index) {
                        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_option, {
                          key: "status-".concat(index),
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]);
                      }), 64))];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })]), translationReport.checked.length > 0 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", TranslationReportvue_type_script_setup_true_lang_js_hoisted_5, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(translationReport.checked, function (c, index) {
        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
          key: index
        }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("p", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(c), 1)]);
      }), 128)), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", TranslationReportvue_type_script_setup_true_lang_js_hoisted_6, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form, {
        inline: true
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form_item, null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("deleteConfirm.message", {
                count: translationReport.checked.length
              })), 1)];
            }),
            _: 1
          }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form_item, null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_input, {
                modelValue: deleteConfirm.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                  return deleteConfirm.value = $event;
                }),
                placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('deleteConfirm.placeholder')
              }, null, 8, ["modelValue", "placeholder"])];
            }),
            _: 1
          }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form_item, null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                purpose: "destructive",
                loading: deleteLoading.value,
                onClick: _cache[7] || (_cache[7] = function ($event) {
                  return deleteTranslationKeyAddresses();
                }),
                disabled: deleteConfirm.value !== 'OK'
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("delete.buttonLabel")), 1)];
                }),
                _: 1
              }, 8, ["loading", "disabled"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", TranslationReportvue_type_script_setup_true_lang_js_hoisted_7, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_input, {
        onChange: _cache[8] || (_cache[8] = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return getAnalysis();

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }))),
        modelValue: search.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
          return search.value = $event;
        }),
        clearable: true,
        placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('search.placeholder')
      }, null, 8, ["modelValue", "placeholder"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", TranslationReportvue_type_script_setup_true_lang_js_hoisted_8, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
        onClick: _cache[10] || (_cache[10] = function ($event) {
          return selectAll();
        })
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("selectAll.buttonLabel")), 1)];
        }),
        _: 1
      }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
        onClick: _cache[11] || (_cache[11] = function ($event) {
          return unselectAll();
        })
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("unselectAll.buttonLabel")), 1)];
        }),
        _: 1
      })])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpTable, {
        data: translationReport.analysis,
        size: "large",
        reference: "analysis",
        columns: columns,
        class: "settings-pages__admin-settings__translation-report__dp-table"
      }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
        translationKeyAddress: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.translationKeyAddress) + " ", 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCopyToClipboard, {
            value: prop.row.translationKeyAddress
          }, null, 8, ["value"])];
        }),
        inCode: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
          return [prop.row.inCode ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpIcon, {
            key: 0,
            icon: "check",
            color: "#4a8e29"
          })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpIcon, {
            key: 1,
            icon: "close",
            color: "#ff0000"
          }))];
        }),
        inDb: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
          return [prop.row.inDb ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpIcon, {
            key: 0,
            icon: "check",
            color: "#4a8e29"
          })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpIcon, {
            key: 1,
            icon: "close",
            color: "#ff0000"
          }))];
        }),
        checked: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_checkbox, {
            modelValue: prop.row.checked,
            "onUpdate:modelValue": function onUpdateModelValue($event) {
              return prop.row.checked = $event;
            },
            onChange: check
          }, null, 8, ["modelValue", "onUpdate:modelValue"])];
        }),
        _: 2
      }, [type.value === 'values' ? {
        name: "value",
        fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.value), 1)];
        })
      } : undefined]), 1032, ["data"])), [[_directive_loading, loading.value]])]);
    };
  }
});
;// CONCATENATED MODULE: ./src/pages/DeveloperSettings/TranslationReport.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-66.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-66.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-66.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-66.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/DeveloperSettings/TranslationReport.vue?vue&type=style&index=0&id=2400d603&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/pages/DeveloperSettings/TranslationReport.vue?vue&type=style&index=0&id=2400d603&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/DeveloperSettings/TranslationReport.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function TranslationReportvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Übersetzungsbericht"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicht in Datenbank"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreich angelegt"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicht im Quellcode"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / Bibliothek"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategorie"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quellcode"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenbank"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Auswahl"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätige durch Eingabe von: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle auswählen"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Auswahl aufheben"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Eintrag wurde gelöscht. Die Aktion wurde erfolgreich verarbeitet."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        }
      },
      "de-AT": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Übersetzungsbericht"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicht in Datenbank"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreich angelegt"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicht im Quellcode"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / Bibliothek"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategorie"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quellcode"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenbank"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Auswahl"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätige durch Eingabe von: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle auswählen"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Auswahl aufheben"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Eintrag wurde gelöscht. Die Aktion wurde erfolgreich verarbeitet."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        }
      },
      "de-CH": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Übersetzungsbericht"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicht in Datenbank"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreich angelegt"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicht im Quellcode"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / Bibliothek"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategorie"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quellcode"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datenbank"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Auswahl"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bestätige durch Eingabe von: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle auswählen"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Auswahl aufheben"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der Eintrag wurde gelöscht. Die Aktion wurde erfolgreich verarbeitet."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        }
      },
      "en-US": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Translation report"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not in Database"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successfully created"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not in Source Code"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Any"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / Library"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Website DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Category"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Source code"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Database"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selection"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm by entering: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select all"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deselect all"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The entry has been deleted. The action was processed successfully."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
        }
      },
      "en-GB": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Translation report"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not in Database"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successfully created"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not in Source Code"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Any"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / Library"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Website DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Category"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Source code"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Database"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selection"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirm by entering: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select all"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deselect all"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The entry has been deleted. The action was processed successfully."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
        }
      },
      "it-IT": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapporto di traduzione"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stato"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non nel database"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creato con successo"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non nel codice sorgente"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tutti"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / Libreria"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categoria"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Codice sorgente"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Banca dati"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selezione"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confermare inserendo: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona tutto"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deselezionare tutto"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtro"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elimina"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La voce è stata cancellata L'azione è stata elaborata correttamente."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricerca"])}
        }
      },
      "fr-FR": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport de traduction"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas dans la base de données"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créé avec succès"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas dans le code source"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / Bibliothèque"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Catégorie"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code source"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Base de données"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélection"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmez en saisissant: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout sélectionner"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout déselectionner"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtre"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'entrée a été supprimée. L'action a été traitée avec succès."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        }
      },
      "es-ES": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informe de traducción"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estado"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No en la base de datos"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creado con éxito"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No en el código fuente"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Todas"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicación / Biblioteca"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categoría"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código fuente"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Base de datos"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selección"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmar ingresando: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccionar todo"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deseleccionar todo"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrar"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["La entrada ha sido eliminada. La acción se procesó con éxito."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buscar"])}
        }
      },
      "pl-PL": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Raport z tłumaczenia"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie w bazie danych"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utworzono pomyślnie"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie w kodzie źródłowym"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacja / biblioteka"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategoria"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod źródłowy"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Baza danych"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybór"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdź wpisując: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zaznacz wszystko"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odznacz wszystkie"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtr"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usunąć"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wpis został usunięty. Działanie zostało pomyślnie przetworzone."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szukaj"])}
        }
      },
      "nl-NL": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vertaalrapport"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toestand"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niet in database"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Succesvol gemaakt"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niet in de broncode"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / bibliotheek"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categorie"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broncode"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Database"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selectie"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bevestig met: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecteer alles"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deselecteer alles"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verwijderen"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["De vermelding is verwijderd. De actie is succesvol verwerkt."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoeken"])}
        }
      },
      "bg-BG": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доклад за превода"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cтатус"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не е в базата данни"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно създаден"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не е в изходния код"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приложение / библиотека"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Категория"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Програмен код"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["База данни"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["подбор"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потвърдете, като въведете: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Избери всички"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Премахнете избора на всички"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["филтър"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изтрий"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Записът е изтрит. Действието бе обработено успешно."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Търсене"])}
        }
      },
      "bs-BA": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvještaj o prevođenju"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statusa"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije u bazi podataka"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno kreirano"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije u izvornom kodu"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / Library"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategorija"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvorni kod"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Baza podataka"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selekcija"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdite unosom: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Označi sve"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odznači sve"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbriši"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unos je izbrisan. Akcija je uspješno obrađena."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Traži"])}
        }
      },
      "zh-CN": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["翻译报告"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不在数据库中"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功创建"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不在源代码中"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["应用程序/库"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["类别"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["源代码"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据库"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选拔"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入确认：OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["全选"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["全部取消选择"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["过滤"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["该条目已被删除。 操作已成功处理。"])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索"])}
        }
      },
      "da-DK": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oversættelsesrapport"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikke i databasen"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oprettet med succes"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikke i kildekoden"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / bibliotek"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategori"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kildekode"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Database"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Udvælgelse"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekræft ved at indtaste: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vælg alle"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fravælg alle"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slet"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indtastningen er blevet slettet. Handlingen blev behandlet med succes."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Søg"])}
        }
      },
      "et-EE": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tõlkearuanne"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Staatus"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pole andmebaasis"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukalt loodud"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähtekoodis pole"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rakendus / kogu"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategooria"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähtekood"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Andmebaas"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valik"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kinnitage sisestades: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vali kõik"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tühistage kõigi valik"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtreeri"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kustuta"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kanne on kustutatud. Toiming töötleti edukalt."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otsing"])}
        }
      },
      "fi-FI": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käännösraportti"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tila"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei tietokannassa"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Luotu onnistuneesti"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei lähdekoodissa"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sovellus / kirjasto"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategoria"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähdekoodi"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tietokanta"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valinta"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vahvista kirjoittamalla: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valitse kaikki"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista kaikkien valinnat"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suodattaa"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poistaa"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Merkintä on poistettu. Toiminto käsiteltiin onnistuneesti."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hae"])}
        }
      },
      "el-GR": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Έκθεση μετάφρασης"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["κατάσταση"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Όχι στη βάση δεδομένων"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δημιουργήθηκε με επιτυχία"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Όχι στον πηγαίο κώδικα"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εφαρμογή / Βιβλιοθήκη"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κατηγορία"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Πηγαίος κώδικας"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Βάση δεδομένων"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["επιλογή"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαιώστε εισάγοντας: ΟΚ"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιλογή όλων"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποεπιλογή όλων"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Φίλτρο"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγράφω"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η καταχώριση διαγράφηκε. Η ενέργεια υποβλήθηκε σε επεξεργασία με επιτυχία."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αναζήτηση"])}
        }
      },
      "he-IL": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["דוח תרגום"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סטָטוּס"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא במאגר"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["נוצר בהצלחה"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לא בקוד המקור"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אפליקציה / ספריה"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קטגוריה"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["קוד מקור"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מאגר מידע"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["בְּחִירָה"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אישור על ידי הזנה: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["בחר הכל"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הסר סימון מהכל"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְסַנֵן"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לִמְחוֹק"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הרשומה נמחקה. הפעולה עובדה בהצלחה."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחפש"])}
        }
      },
      "ga-IE": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tuarascáil aistriúcháin"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stádas"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Níl sé sa Bhunachar Sonraí"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cruthaíodh go rathúil"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Níl sé sa Chód Foinse"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aip / Leabharlann"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Catagóir"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cód foinse"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bunachar Sonraí"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roghnú"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deimhnigh trí iontráil: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roghnú go léir"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déan gach ceann a dhí-roghnú"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scagaire"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scrios"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scriosadh an iontráil. Próiseáladh an gníomh go rathúil."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuardaigh"])}
        }
      },
      "ja-JP": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["翻訳レポート"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状態"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["データベースにありません"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正常に作成されました"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ソースコードにない"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アプリ/ライブラリ"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["カテゴリー"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ソースコード"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["データベース"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["選択"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["次のように入力して確認します：OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["すべて選択"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["すべての選択を解除"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["フィルタ"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["削除"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エントリが削除されました。 アクションは正常に処理されました。"])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["探す"])}
        }
      },
      "hr-HR": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvještaj o prijevodu"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije u bazi podataka"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno stvoreno"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nije u izvornom kodu"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija / biblioteka"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategorija"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvorni kod"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Baza podataka"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbor"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdite unosom: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odaberi sve"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odznači sve"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtar"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrisati"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unos je izbrisan. Radnja je uspješno obrađena."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Traži"])}
        }
      },
      "lv-LV": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tulkošanas ziņojums"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statusu"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nav datu bāzē"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīgi izveidots"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nav avota kodā"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lietotne / bibliotēka"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategorija"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avota kods"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datu bāze"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atlase"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apstipriniet, ievadot: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvēlēties visus"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atsijāt visu"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrēt"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dzēst"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ieraksts ir izdzēsts. Darbība tika veiksmīgi apstrādāta."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meklēt"])}
        }
      },
      "lt-LT": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vertimo ataskaita"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statusas"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ne duomenų bazėje"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingai sukurta"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nėra šaltinio kodo"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Programa / biblioteka"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategorija"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pirminis kodas"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duomenų bazė"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pasirinkimas"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Patvirtinkite įvesdami: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pasirinkti viską"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atzymeti visus pasirinkimus"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtras"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ištrinti"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įrašas buvo ištrintas. Veiksmas buvo sėkmingai apdorotas."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paieška"])}
        }
      },
      "pt-PT": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Relatório de tradução"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não está no banco de dados"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Criado com sucesso"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não está no código-fonte"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / Biblioteca"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categoria"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código fonte"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Base de dados"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleção"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirme digitando: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecionar tudo"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desmarcar todos"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtro"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excluir"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A entrada foi excluída. A ação foi processada com sucesso."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Procurar"])}
        }
      },
      "ro-RO": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Raport de traducere"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stare"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nu în baza de date"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Creat cu succes"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nu în codul sursă"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicație / Bibliotecă"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Categorie"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cod sursa"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bază de date"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecţie"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmați introducând: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selectează tot"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deselectați toate"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtru"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Șterge"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intrarea a fost ștearsă. Acțiunea a fost procesată cu succes."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Căutare"])}
        }
      },
      "ru-RU": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Отчет о переводе"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["положение дел"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет в базе данных"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно создано"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет в исходном коде"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приложение / Библиотека"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Категория"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Исходный код"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["База данных"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["отбор"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтвердите вводом: ОК"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выбрать все"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Убрать выделение со всего"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фильтр"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Удаление"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Запись была удалена. Действие было успешно обработано."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поиск"])}
        }
      },
      "sv-SE": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Översättningsrapport"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inte i databasen"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Framgångsrikt skapat"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inte i källkoden"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / bibliotek"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategori"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Källkod"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Databas"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Urval"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bekräfta genom att ange: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Välj alla"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avmarkera alla"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrera"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Radera"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Posten har tagits bort. Åtgärden behandlades framgångsrikt."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sök"])}
        }
      },
      "sk-SK": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa o preklade"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavenie"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie je v databáze"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešne vytvorené"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nie je v zdrojovom kóde"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikácia / knižnica"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategória"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zdrojový kód"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Databáza"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Výber"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrďte zadaním: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vybrať všetko"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odznačiť všetko"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odstrániť"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Záznam bol vymazaný. Akcia bola úspešne spracovaná."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhľadávanie"])}
        }
      },
      "cs-CZ": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zpráva o překladu"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavení"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Není v databázi"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšně vytvořeno"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Není ve zdrojovém kódu"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikace / knihovna"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategorie"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zdrojový kód"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Databáze"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Výběr"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrďte zadáním: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vybrat vše"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odznačit vše"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtr"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vymazat"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Záznam byl smazán. Akce byla úspěšně zpracována."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhledávání"])}
        }
      },
      "tr-TR": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çeviri raporu"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Durum"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veritabanında değil"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarıyla oluşturuldu"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaynak Kodda değil"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uygulama / kitaplık"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategori"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaynak kodu"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veri tabanı"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seçim"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Girerek onaylayın: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hepsini seç"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tüm seçimleri kaldır"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtre"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sil"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giriş silindi. İşlem başarıyla işlendi."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arama"])}
        }
      },
      "hu-HU": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fordítási jelentés"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Állapot"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nincs az adatbázisban"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeresen létrehozva"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A forráskódban nincs"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alkalmazás / könyvtár"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategória"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forráskód"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adatbázis"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kiválasztás"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erősítse meg a következővel: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mindet kiválaszt"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Az összes kijelölésének törlése"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szűrő"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Töröl"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A bejegyzés törölve. A művelet feldolgozása sikeres volt."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keresés"])}
        }
      },
      "ar-AE": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تقرير الترجمة"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الحالة"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ليس في قاعدة البيانات"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إنشاؤه بنجاح"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ليس في شفرة المصدر"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["التطبيق / المكتبة"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["فئة"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مصدر الرمز"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قاعدة البيانات"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختيار"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تأكيد من خلال إدخال: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختر الكل"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الغاء تحديد الكل"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["منقي"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حذف"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم حذف الإدخال. تمت معالجة الإجراء بنجاح."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بحث"])}
        }
      },
      "fr-BE": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport de traduction"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas dans la base de données"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créé avec succès"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas dans le code source"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / Bibliothèque"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Catégorie"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code source"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Base de données"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélection"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmez en saisissant: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout sélectionner"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout déselectionner"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtre"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'entrée a été supprimée. L'action a été traitée avec succès."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        }
      },
      "fr-LU": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport de traduction"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas dans la base de données"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Créé avec succès"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas dans le code source"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / Bibliothèque"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Catégorie"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code source"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Base de données"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélection"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmez en saisissant: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout sélectionner"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout déselectionner"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtre"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L'entrée a été supprimée. L'action a été traitée avec succès."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        }
      },
      "mt-MT": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport tat-traduzzjoni"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mhux fid-database"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["żball"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Investit b'suċċess"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mhux fil-Kodiċi tas-Sors"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kollha"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["App / Librerija"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Website DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategorija"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kodiċi tas-sors"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Database"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Għażla"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkonferma billi ddaħħal: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agħżel kollox"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ħassar kollox"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iffiltra"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ħassar"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L-entrata tħassret. L-azzjoni ġiet ipproċessata b'suċċess."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tfittxija"])}
        }
      },
      "sl-SI": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poročilo o prevodu"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stanje"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ni v zbirki podatkov"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno ustvarjeno"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ni v izvorni kodi"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplikacija / knjižnica"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategorija"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvorna koda"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zbirka podatkov"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbiro"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potrdite z vnosom: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izberi vse"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekliči izbor vseh"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbriši"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vnos je bil izbrisan. Dejanje je bilo uspešno obdelano."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iskanje"])}
        }
      },
      "el-CY": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Έκθεση μετάφρασης"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["κατάσταση"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Όχι στη βάση δεδομένων"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δημιουργήθηκε με επιτυχία"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Όχι στον πηγαίο κώδικα"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εφαρμογή / Βιβλιοθήκη"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κατηγορία"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Πηγαίος κώδικας"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Βάση δεδομένων"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["επιλογή"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιβεβαιώστε εισάγοντας: ΟΚ"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιλογή όλων"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποεπιλογή όλων"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Φίλτρο"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγράφω"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Η καταχώριση διαγράφηκε. Η ενέργεια υποβλήθηκε σε επεξεργασία με επιτυχία."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αναζήτηση"])}
        }
      },
      "tr-CY": {
        "translationReport": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Çeviri raporu"])}
        },
        "status": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Durum"])},
          "notInDb": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veritabanında değil"])}
          },
          "anyIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
          },
          "noIssue": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarıyla oluşturuldu"])}
          },
          "notInCode": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaynak Kodda değil"])}
          },
          "all": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])}
          }
        },
        "purpose": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uygulama / kitaplık"])},
          "settingsPages": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings Pages"])}
          },
          "componentsLibrary": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Components Library"])}
          },
          "SSO": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Single Sign-on"])}
          },
          "designSystem": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Design System"])}
          },
          "taxhub": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["TaxHub"])}
          },
          "dutypayWebsite": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Webseite DutyPay"])}
          },
          "dutypay": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["DutyPay Admin App"])}
          }
        },
        "type": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kategori"])},
          "labels": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])}
          },
          "values": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])}
          }
        },
        "translationKeyAddress": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["translationKeyAddress (tKA)"])}
        },
        "inCode": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaynak kodu"])}
        },
        "inDb": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veri tabanı"])}
        },
        "checked": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seçim"])}
        },
        "deleteConfirm": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["OK"])},
          "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Girerek onaylayın: OK"])}
        },
        "selectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hepsini seç"])}
        },
        "unselectAll": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tüm seçimleri kaldır"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtre"])}
        },
        "delete": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sil"])},
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])},
              "message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giriş silindi. İşlem başarıyla işlendi."])}
            }
          }
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arama"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/DeveloperSettings/TranslationReport.vue



;
/* custom blocks */

if (typeof TranslationReportvue_type_custom_index_0_blockType_i18n === 'function') TranslationReportvue_type_custom_index_0_blockType_i18n(TranslationReportvue_type_script_setup_true_lang_js)


const TranslationReport_exports_ = TranslationReportvue_type_script_setup_true_lang_js;

/* harmony default export */ var TranslationReport = (TranslationReport_exports_);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__(8862);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(9826);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(2222);
// EXTERNAL MODULE: ./node_modules/lodash/map.js
var lodash_map = __webpack_require__(5161);
var map_default = /*#__PURE__*/__webpack_require__.n(lodash_map);
// EXTERNAL MODULE: ./node_modules/lodash/filter.js
var filter = __webpack_require__(3105);
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/DeveloperSettings/TranslationEmailReportOverview.vue?vue&type=script&setup=true&lang=js











var TranslationEmailReportOverviewvue_type_script_setup_true_lang_js_hoisted_1 = {
  class: "partition depth-1"
};
var TranslationEmailReportOverviewvue_type_script_setup_true_lang_js_hoisted_2 = ["innerHTML"];
var TranslationEmailReportOverviewvue_type_script_setup_true_lang_js_hoisted_3 = {
  style: {
    "white-space": "pre-wrap",
    "border-bottom-style": "solid"
  }
};

var TranslationEmailReportOverviewvue_type_script_setup_true_lang_js_hoisted_4 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("Send");

var TranslationEmailReportOverviewvue_type_script_setup_true_lang_js_hoisted_5 = {
  key: 1
};






var TranslationEmailReportOverviewvue_type_script_setup_true_lang_js_default_ = {
  name: "TranslationReport",
  data: function data() {
    return {
      analysis: [],
      filteredData: {},
      email: "",
      selectedEmails: [],
      emailOptions: localStorage.getItem('emailOptions') ? JSON.parse(localStorage.getItem('emailOptions')) : [],
      loading: false,
      utcOffset: "+00:00",
      deleteLoading: false,
      search: "",
      deleteConfirm: "",
      filePath: "",
      filePathIndex: "0",
      filePathOptions: [{
        value: "dummyFile",
        label: "dummyFile"
      }],
      language: "",
      languageIndex: "0",
      languageOptions: [{
        value: "dummyLanguage",
        label: "dummyLanguage"
      }],
      status: "anyIssue",
      columns: [{
        prop: "translationKeyAddress",
        label: this.$t("translationKeyAddress.label")
      }, {
        prop: "value",
        label: this.$t("value.label")
      }, {
        prop: "inCode",
        label: this.$t("inCode.label"),
        align: "center"
      }, {
        prop: "inDb",
        label: this.$t("inDb.label"),
        align: "center"
      }]
    };
  },
  computed: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useAuthStore, ['user'])), (0,external_pinia_.mapState)(store_modules_.useEnvStore, ["apiUrls"])),
  methods: _objectSpread2(_objectSpread2(_objectSpread2({}, (0,external_pinia_.mapActions)(store_modules_.useEnvStore, ["fetchHosts"])), (0,external_pinia_.mapActions)(store_modules_.useAuthStore, ["tokenAuth"])), {}, {
    getAnalysis: function getAnalysis() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var err, res, _yield$to, _yield$to2, data;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // no emails are found in localstorage
                if (_this.emailOptions.length === 0) {
                  _this.emailOptions.push({
                    "value": _this.user.email,
                    "label": _this.user.email
                  });

                  localStorage.setItem("emailOptions", JSON.stringify(_this.emailOptions));
                } else {
                  // an user logged in but localstorage from another user exists
                  if (_this.emailOptions[0].value !== _this.user.email) {
                    _this.emailOptions = [{
                      "value": _this.user.email,
                      "label": _this.user.email
                    }];
                    localStorage.setItem("emailOptions", JSON.stringify(_this.emailOptions));
                  }
                }

                _this.loading = true;
                _this.utcOffset = _this.$dp.dayjs().format("Z");
                _context.next = 5;
                return (0,external_await_to_js_.to)(_this.$http.get("".concat(_this.apiUrls.dutypay, "/api/v0/send/report-mail-translation"), {
                  params: {
                    email: _this.user.email,
                    utcOffset: _this.utcOffset
                  }
                }));

              case 5:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];

                if (!err) {
                  _context.next = 11;
                  break;
                }

                throw err;

              case 11:
                data = res.data;
                _this.analysis = data;
                _this.filePathOptions = []; // search for the filePaths

                map_default()(data, function (row) {
                  var content = Object.keys(row)[0];
                  content = {
                    value: content,
                    label: content
                  };

                  _this.filePathOptions.push(content);
                });
                _this.loading = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addEmail: function addEmail() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var foundMail;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                foundMail = _this2.emailOptions.find(function (element) {
                  return element.value === _this2.email;
                });

                if (!foundMail) {
                  _this2.emailOptions.push({
                    "value": _this2.email,
                    "label": _this2.email
                  });

                  localStorage.setItem("emailOptions", JSON.stringify(_this2.emailOptions));
                } else {
                  alert(_this2.$t('notification.emailAddressExistsAlready.message'));
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    sendMail: function sendMail() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var path, body;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                path = "";
                body = {
                  //email: this.user.email,
                  languageTag: _this3.language,
                  mode: "test",
                  utcOffset: _this3.utcOffset //password: this.user,

                };

                if (_this3.filePath === "src/notifyAutomaticUpload.vue") {
                  body.recipients = _this3.selectedEmails;
                }

                if (_this3.filePath === "src/mfaEmail.vue") {
                  path = "auth-email/";
                  body.password = _this3.user.password;
                }

                if (_this3.filePath === "src/mfaSMS.vue") {
                  path = "auth-sms/";
                  body.password = _this3.user.password;
                  body.mobileNumber = _this3.user.mobileNumber;
                }

                if (_this3.filePath === "src/activationEmail.vue") {
                  path = "activation-mail/";
                }

                if (_this3.filePath === "src/resetPasswordEmail.vue") {
                  path = "password-reset-mail/";
                }

                if (_this3.filePath === "src/consentRevokedEmail.vue") {
                  path = "consent-revoked-mail/";
                }

                _this3.loading = true;
                map_default()(_this3.selectedEmails, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(email) {
                    var err, res, _yield$to3, _yield$to4;

                    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            body.email = email;
                            _context3.next = 3;
                            return (0,external_await_to_js_.to)(_this3.$http.post("".concat(_this3.apiUrls.dutypay, "/api/v0/send/").concat(path), body));

                          case 3:
                            _yield$to3 = _context3.sent;
                            _yield$to4 = _slicedToArray(_yield$to3, 2);
                            err = _yield$to4[0];
                            res = _yield$to4[1];

                            if (!(err || !res)) {
                              _context3.next = 10;
                              break;
                            }

                            _context3.next = 10;
                            return alert(err.message);

                          case 10:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }),
  watch: {
    filePath: function () {
      var _filePath = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this4 = this;

        var data;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.filePathOptions = [];
                this.languageOptions = [];
                _context5.next = 4;
                return this.getAnalysis();

              case 4:
                data = this.analysis;
                map_default()(data, function (row, i) {
                  var content = Object.keys(row)[0];

                  if (content === _this4.filePath) {
                    _this4.filePathIndex = i;
                    var languageData = data[i][_this4.filePath];
                    map_default()(languageData, function (lang) {
                      var langContent = Object.keys(lang)[0];
                      langContent = {
                        value: langContent,
                        label: langContent
                      };

                      _this4.languageOptions.push(langContent);
                    });
                  }
                });

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function filePath() {
        return _filePath.apply(this, arguments);
      }

      return filePath;
    }(),
    selectedEmails: function () {
      var _selectedEmails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.getAnalysis();

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function selectedEmails() {
        return _selectedEmails.apply(this, arguments);
      }

      return selectedEmails;
    }(),
    language: function () {
      var _language = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this5 = this;

        var data;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getAnalysis();

              case 2:
                data = this.analysis[this.filePathIndex][this.filePath];
                map_default()(data, function (row, i) {
                  var content = Object.keys(row)[0];

                  if (content === _this5.language) {
                    _this5.languageIndex = i;
                  }
                });

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function language() {
        return _language.apply(this, arguments);
      }

      return language;
    }(),
    analysis: {
      deep: true,
      handler: function handler() {
        this.checked = map_default()(filter_default()(this.analysis, function (d) {
          return d.checked;
        }), "translationKeyAddress");
      }
    }
  },
  created: function created() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this6.fetchHosts();

            case 2:
              _context8.next = 4;
              return _this6.tokenAuth();

            case 4:
              _context8.next = 6;
              return _this6.getAnalysis();

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  }
};

/* harmony default export */ var TranslationEmailReportOverviewvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(TranslationEmailReportOverviewvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_el_option = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-option");

      var _component_el_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-select");

      var _component_el_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-col");

      var _component_el_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-input");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_el_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-row");

      var _component_DpSelectCustom = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpSelectCustom");

      var _component_el_form = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-form");

      var _component_el_header = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-header");

      var _component_el_container = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-container");

      var _component_DpFeedforward = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFeedforward");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("translationEmailReportOverview.title")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", TranslationEmailReportOverviewvue_type_script_setup_true_lang_js_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h4", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("filter.label")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, {
        gutter: 20
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
            xl: {
              span: 8
            },
            sm: {
              span: 12
            },
            xs: {
              span: 24
            }
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h4", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("filter.selectionEmail.label")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_select, {
                modelValue: _ctx.selectedEmails,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(selectedEmails) ? selectedEmails.value = $event : null;
                }),
                multiple: "",
                filterable: "",
                "default-first-option": "",
                placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('selectEmailAddress.placeholder')
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.emailOptions, function (email) {
                    return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_option, {
                      key: email.value,
                      label: email.label,
                      value: email.value
                    }, null, 8, ["label", "value"]);
                  }), 128))];
                }),
                _: 1
              }, 8, ["modelValue", "placeholder"])];
            }),
            _: 1
          }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
            xl: {
              span: 8
            },
            sm: {
              span: 12
            },
            xs: {
              span: 24
            }
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h5", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("filter.createEmail.label")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_input, {
                placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('newEmailAddress.placeholder'),
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(email) ? email.value = $event : null;
                })
              }, null, 8, ["placeholder", "modelValue"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                onClick: _ctx.addEmail
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('addEmail.buttonLabel')), 1)];
                }),
                _: 1
              }, 8, ["onClick"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }), _ctx.selectedEmails.length > 0 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_form, {
        key: 0,
        "label-position": "top"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, {
            gutter: 20
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
                xl: {
                  span: 8
                },
                sm: {
                  span: 12
                },
                xs: {
                  span: 24
                }
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpSelectCustom, {
                    modelValue: _ctx.filePath,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(filePath) ? filePath.value = $event : null;
                    }),
                    label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('filePath.label'),
                    options: _ctx.filePathOptions,
                    prop: "filePath",
                    "t-function": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t),
                    inputParameters: {
                      size: 'small'
                    }
                  }, null, 8, ["modelValue", "label", "options", "t-function"])];
                }),
                _: 1
              }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
                xl: {
                  span: 8
                },
                sm: {
                  span: 12
                },
                xs: {
                  span: 24
                }
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpSelectCustom, {
                    modelValue: _ctx.language,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(language) ? language.value = $event : null;
                    }),
                    label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('language.label'),
                    options: _ctx.languageOptions,
                    prop: "language",
                    "t-function": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t),
                    inputParameters: {
                      size: 'small'
                    }
                  }, null, 8, ["modelValue", "label", "options", "t-function"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), _ctx.analysis.length > 0 && _ctx.filePath !== '' && _ctx.language !== '' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_container, {
        key: 0,
        class: "partition depth-1 width:200px;overflow:auto"
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_header, null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.analysis[_ctx.filePathIndex][_ctx.filePath][_ctx.languageIndex][_ctx.language]["subject"]), 1)];
            }),
            _: 1
          }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
            style: {
              "border-bottom-style": "solid"
            },
            innerHTML: _ctx.analysis[_ctx.filePathIndex][_ctx.filePath][_ctx.languageIndex][_ctx.language]['html']
          }, null, 8, TranslationEmailReportOverviewvue_type_script_setup_true_lang_js_hoisted_2), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("pre", TranslationEmailReportOverviewvue_type_script_setup_true_lang_js_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.analysis[_ctx.filePathIndex][_ctx.filePath][_ctx.languageIndex][_ctx.language]["message"]), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            onClick: _ctx.sendMail
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [TranslationEmailReportOverviewvue_type_script_setup_true_lang_js_hoisted_4];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        _: 1
      })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", TranslationEmailReportOverviewvue_type_script_setup_true_lang_js_hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpFeedforward, {
        type: "warning",
        message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('allFieldsHaveToBeFilled.feedforward.warning.message')
      }, null, 8, ["message"])]))]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/DeveloperSettings/TranslationEmailReportOverview.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/DeveloperSettings/TranslationEmailReportOverview.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function TranslationEmailReportOverviewvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Empfänger"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Empfänger hinzufügen"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprachbezeichner"])}
        }
      },
      "de-AT": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Empfänger"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Empfänger hinzufügen"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprachbezeichner"])}
        }
      },
      "de-CH": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Empfänger"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Empfänger hinzufügen"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprachbezeichner"])}
        }
      },
      "en-US": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbound Message"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email recipient"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add email recipient"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbound Message"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Language identifier"])}
        }
      },
      "en-GB": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbound Message"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email recipient"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add email recipient"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Outbound Message"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Language identifier"])}
        }
      },
      "it-IT": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messaggi in uscita"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destinatario dell'e-mail"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aggiungi destinatario e-mail"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtro"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messaggi in uscita"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identificatore della lingua"])}
        }
      },
      "fr-FR": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages sortants"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destinataire du courriel"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter un destinataire de courrier électronique"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtre"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages sortants"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identifiant de la langue"])}
        }
      },
      "es-ES": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mensajes salientes"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destinatario del correo electrónico"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar destinatario de correo electrónico"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrar"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mensajes salientes"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identificador de idioma"])}
        }
      },
      "pl-PL": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiadomości wychodzące"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odbiorca emaila"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj odbiorcę wiadomości e-mail"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtr"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wiadomości wychodzące"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identyfikator języka"])}
        }
      },
      "nl-NL": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uitgaande berichten"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail ontvanger"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailontvanger toevoegen"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uitgaande berichten"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Taal-ID"])}
        }
      },
      "bg-BG": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изходящи съобщения"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Получател на имейл"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавете получател на имейл"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["филтър"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изходящи съобщения"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Идентификатор на езика"])}
        }
      },
      "bs-BA": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odlazne poruke"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primalac e-pošte"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodajte primaoca e-pošte"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odlazne poruke"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identifikator jezika"])}
        }
      },
      "zh-CN": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外发邮件"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电邮收件者"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["添加电子邮件收件人"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["过滤"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外发邮件"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["语言标识符"])}
        }
      },
      "da-DK": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Udgående beskeder"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail-modtager"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilføj e-mail-modtager"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Udgående beskeder"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprogidentifikator"])}
        }
      },
      "et-EE": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Väljaminevad sõnumid"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posti adressaat"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lisage e-posti adressaat"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtreeri"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Väljaminevad sõnumid"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keele tunnus"])}
        }
      },
      "fi-FI": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähtevät viestit"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sähköpostin vastaanottaja"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lisää sähköpostin vastaanottaja"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suodattaa"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lähtevät viestit"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kielen tunniste"])}
        }
      },
      "el-GR": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εξερχόμενα μηνύματα"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παραλήπτης email"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προσθήκη παραλήπτη email"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Φίλτρο"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εξερχόμενα μηνύματα"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αναγνωριστικό γλώσσας"])}
        }
      },
      "he-IL": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הודעות יוצאות"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["נמען דוא＂ל"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הוסף נמען דוא＂ל"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְסַנֵן"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הודעות יוצאות"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מזהה שפה"])}
        }
      },
      "ga-IE": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teachtaireachtaí Amach"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faighteoir ríomhphoist"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir faighteoir ríomhphoist leis"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scagaire"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teachtaireachtaí Amach"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aitheantóir teanga"])}
        }
      },
      "ja-JP": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["送信メッセージ"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メールの受信者"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["メール受信者を追加する"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["フィルタ"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["送信メッセージ"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["言語識別子"])}
        }
      },
      "hr-HR": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odlazne poruke"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primatelj e-pošte"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodajte primatelja e-pošte"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtar"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odlazne poruke"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identifikator jezika"])}
        }
      },
      "lv-LV": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izejošie ziņojumi"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pasta adresāts"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pievienot e-pasta adresātu"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrēt"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izejošie ziņojumi"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valodas identifikators"])}
        }
      },
      "lt-LT": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išeinantys pranešimai"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El. Pašto gavėjas"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pridėti el. Pašto gavėją"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtras"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išeinantys pranešimai"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kalbos identifikatorius"])}
        }
      },
      "pt-PT": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mensagens de Saída"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destinatário do email"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adicionar destinatário de e-mail"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtro"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mensagens de Saída"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identificador de idioma"])}
        }
      },
      "ro-RO": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destinatar e-mail"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adăugați destinatar e-mail"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtru"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausgehende Nachricht"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identificator de limbă"])}
        }
      },
      "ru-RU": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Исходящие сообщения"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Получатель электронной почты"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавить получателя электронной почты"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фильтр"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Исходящие сообщения"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Идентификатор языка"])}
        }
      },
      "sv-SE": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utgående meddelanden"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email Mottagare"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lägg till e-postmottagare"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtrera"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utgående meddelanden"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Språkidentifierare"])}
        }
      },
      "sk-SK": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odchádzajúce správy"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Príjemca e-mailu"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pridajte príjemcu e-mailu"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odchádzajúce správy"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identifikátor jazyka"])}
        }
      },
      "cs-CZ": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odchozí zprávy"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Příjemce e-mailu"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přidat příjemce e-mailu"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtr"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odchozí zprávy"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identifikátor jazyka"])}
        }
      },
      "tr-TR": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giden Mesajlar"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta alıcısı"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta alıcısı ekle"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtre"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giden Mesajlar"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dil tanımlayıcı"])}
        }
      },
      "hu-HU": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimenő üzenetek"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail címzettje"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail címzett hozzáadása"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szűrő"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kimenő üzenetek"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nyelvazonosító"])}
        }
      },
      "ar-AE": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرسائل الصادرة"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["البريد الإلكتروني المستلم"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أضف مستلم البريد الإلكتروني"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["منقي"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرسائل الصادرة"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معرّف اللغة"])}
        }
      },
      "fr-BE": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages sortants"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destinataire du courriel"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter un destinataire de courrier électronique"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtre"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages sortants"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identifiant de la langue"])}
        }
      },
      "fr-LU": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages sortants"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destinataire du courriel"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter un destinataire de courrier électronique"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtre"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messages sortants"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identifiant de la langue"])}
        }
      },
      "mt-MT": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messaġġ li joħroġ"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Irċevi l-email"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żid ir-riċevitur tal-email"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iffiltra"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Messaġġ li joħroġ"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Identifikatur tal-lingwa"])}
        }
      },
      "sl-SI": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odhodna sporočila"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prejemnik e-pošte"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodajte prejemnika e-pošte"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odhodna sporočila"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jezikovni identifikator"])}
        }
      },
      "el-CY": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εξερχόμενα μηνύματα"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παραλήπτης email"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προσθήκη παραλήπτη email"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Φίλτρο"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εξερχόμενα μηνύματα"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αναγνωριστικό γλώσσας"])}
        }
      },
      "tr-CY": {
        "translationEmailReportOverview": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giden Mesajlar"])}
        },
        "filter": {
          "selectionEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta alıcısı"])}
          },
          "createEmail": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta alıcısı ekle"])}
          },
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtre"])}
        },
        "filePath": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Giden Mesajlar"])}
        },
        "language": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dil tanımlayıcı"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/DeveloperSettings/TranslationEmailReportOverview.vue


/* custom blocks */
;
if (typeof TranslationEmailReportOverviewvue_type_custom_index_0_blockType_i18n === 'function') TranslationEmailReportOverviewvue_type_custom_index_0_blockType_i18n(TranslationEmailReportOverviewvue_type_script_setup_true_lang_js)


const TranslationEmailReportOverview_exports_ = TranslationEmailReportOverviewvue_type_script_setup_true_lang_js;

/* harmony default export */ var TranslationEmailReportOverview = (TranslationEmailReportOverview_exports_);
;// CONCATENATED MODULE: ./src/routes/developerSettingsRoutes.js



var developerSettingsRoutes = [{
  path: '/developer-settings',
  component: DeveloperSettings,
  children: [{
    path: 'translation-report',
    component: TranslationReport,
    beforeEnter: function beforeEnter(to, from, next) {
      next();
    }
  }, {
    path: 'translation-email-report-overview',
    component: TranslationEmailReportOverview,
    beforeEnter: function beforeEnter(to, from, next) {
      next();
    }
  }]
}];
/* harmony default export */ var routes_developerSettingsRoutes = (developerSettingsRoutes);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings.vue?vue&type=script&setup=true&lang=js



var CompanySettingsvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 1
};


var CompanySettingsvue_type_script_setup_true_lang_js_default_ = {
  name: 'CompanySettings',
  computed: _objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useCompanyStore, ['hasSelectedCompany']))
};

/* harmony default export */ var CompanySettingsvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(CompanySettingsvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_router_view = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("router-view");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h1", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('companySettings.title')), 1), _ctx.hasSelectedCompany ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_router_view, {
        key: 0
      })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", CompanySettingsvue_type_script_setup_true_lang_js_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('noCompanySelected.label')), 1))]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/CompanySettings.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function CompanySettingsvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenseinstellungen"])}
        }
      },
      "de-AT": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenseinstellungen"])}
        }
      },
      "de-CH": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenseinstellungen"])}
        }
      },
      "en-US": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company settings"])}
        }
      },
      "en-GB": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company settings"])}
        }
      },
      "it-IT": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni Azienda"])}
        }
      },
      "fr-FR": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de l'entreprise"])}
        }
      },
      "es-ES": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de la Empresa"])}
        }
      },
      "pl-PL": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia Firmy"])}
        }
      },
      "nl-NL": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijfsinstellingen"])}
        }
      },
      "bg-BG": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на компанията"])}
        }
      },
      "bs-BA": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke Kompanije"])}
        }
      },
      "zh-CN": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司设定"])}
        }
      },
      "da-DK": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomhedsindstillinger"])}
        }
      },
      "et-EE": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte Seaded"])}
        }
      },
      "fi-FI": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yrityksen asetukset"])}
        }
      },
      "el-GR": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις εταιρείας"])}
        }
      },
      "he-IL": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות חברה"])}
        }
      },
      "ga-IE": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe Cuideachta"])}
        }
      },
      "ja-JP": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会社の設定"])}
        }
      },
      "hr-HR": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke Tvrtke"])}
        }
      },
      "lv-LV": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uzņēmuma Iestatījumi"])}
        }
      },
      "lt-LT": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės Nustatymai"])}
        }
      },
      "pt-PT": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações da Empresa"])}
        }
      },
      "ro-RO": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări Companie"])}
        }
      },
      "ru-RU": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки компании"])}
        }
      },
      "sv-SE": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företagsinställningar"])}
        }
      },
      "sk-SK": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia Spoločnosti"])}
        }
      },
      "cs-CZ": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení Společnosti"])}
        }
      },
      "tr-TR": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Ayarları"])}
        }
      },
      "hu-HU": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalati Beállítások"])}
        }
      },
      "ar-AE": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات الشركة"])}
        }
      },
      "fr-BE": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de l'entreprise"])}
        }
      },
      "fr-LU": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres de l'entreprise"])}
        }
      },
      "mt-MT": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tal-Kumpanija"])}
        }
      },
      "sl-SI": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve podjetja"])}
        }
      },
      "el-CY": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις εταιρείας"])}
        }
      },
      "tr-CY": {
        "companySettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Ayarları"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/CompanySettings.vue


/* custom blocks */
;
if (typeof CompanySettingsvue_type_custom_index_0_blockType_i18n === 'function') CompanySettingsvue_type_custom_index_0_blockType_i18n(CompanySettingsvue_type_script_setup_true_lang_js)


const CompanySettings_exports_ = CompanySettingsvue_type_script_setup_true_lang_js;

/* harmony default export */ var CompanySettings = (CompanySettings_exports_);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var lodash_isEmpty = __webpack_require__(1609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/each.js
var lodash_each = __webpack_require__(6073);
var each_default = /*#__PURE__*/__webpack_require__.n(lodash_each);
;// CONCATENATED MODULE: ./node_modules/mitt/dist/mitt.mjs
/* harmony default export */ function mitt(n){return{all:n=n||new Map,on:function(t,e){var i=n.get(t);i?i.push(e):n.set(t,[e])},off:function(t,e){var i=n.get(t);i&&(e?i.splice(i.indexOf(e)>>>0,1):n.set(t,[]))},emit:function(t,e){var i=n.get(t);i&&i.slice().map(function(n){n(e)}),(i=n.get("*"))&&i.slice().map(function(n){n(t,e)})}}}
//# sourceMappingURL=mitt.mjs.map

// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(3493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration/AddAuthorizationForm.vue?vue&type=script&setup=true&lang=js












var AddAuthorizationFormvue_type_script_setup_true_lang_js_withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3df69509"), n = n(), _popScopeId(), n;
};

var AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_1 = ["innerHTML"];
var AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_2 = {
  class: "dp-flex row wrap"
};
var AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_3 = {
  class: "dp-flex row wrap justify-content__space-between align-items__center"
};
var AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_4 = {
  class: "dp-flex row"
};
var AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_5 = ["href"];
var AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_6 = {
  key: 0
};








var AddAuthorizationFormvue_type_script_setup_true_lang_js_default_ = {
  name: "AddAuthorizationForm",
  props: {
    filledFormData: {
      type: Object
    }
  },
  data: function data() {
    return {
      formData: {
        sellerId: "",
        type: "amazon",
        mwsAuthorizationToken: "",
        marketplace: "",
        secretId: '',
        participations: {},
        region: ''
      },
      marketPlaceNames: {
        AE: "marketplaces.amazon.AE.label",
        DE: "marketplaces.amazon.DE.label",
        EG: "marketplaces.amazon.EG.label",
        ES: "marketplaces.amazon.ES.label",
        FR: "marketplaces.amazon.FR.label",
        GB: "marketplaces.amazon.GB.label",
        IN: "marketplaces.amazon.IN.label",
        IT: "marketplaces.amazon.IT.label",
        NL: "marketplaces.amazon.NL.label",
        PL: "marketplaces.amazon.PL.label",
        SA: "marketplaces.amazon.SA.label",
        SE: "marketplaces.amazon.SE.label",
        TR: "marketplaces.amazon.TR.label",
        BR: "marketplaces.amazon.BR.label",
        CA: "marketplaces.amazon.CA.label",
        MX: "marketplaces.amazon.MX.label",
        US: "marketplaces.amazon.US.label",
        SG: "marketplaces.amazon.SG.label",
        AU: "marketplaces.amazon.AU.label",
        JP: "marketplaces.amazon.JP.label"
      },
      marketPlaceNamesAlias: {
        AE: this.$t("marketplaces.amazon.AE.label"),
        DE: this.$t("marketplaces.amazon.DE.label"),
        EG: this.$t("marketplaces.amazon.EG.label"),
        ES: this.$t("marketplaces.amazon.ES.label"),
        FR: this.$t("marketplaces.amazon.FR.label"),
        GB: this.$t("marketplaces.amazon.GB.label"),
        IN: this.$t("marketplaces.amazon.IN.label"),
        IT: this.$t("marketplaces.amazon.IT.label"),
        NL: this.$t("marketplaces.amazon.NL.label"),
        PL: this.$t("marketplaces.amazon.PL.label"),
        SA: this.$t("marketplaces.amazon.SA.label"),
        SE: this.$t("marketplaces.amazon.SE.label"),
        TR: this.$t("marketplaces.amazon.TR.label"),
        BR: this.$t("marketplaces.amazon.BR.label"),
        CA: this.$t("marketplaces.amazon.CA.label"),
        MX: this.$t("marketplaces.amazon.MX.label"),
        US: this.$t("marketplaces.amazon.US.label"),
        SG: this.$t("marketplaces.amazon.SG.label"),
        AU: this.$t("marketplaces.amazon.AU.label"),
        JP: this.$t("marketplaces.amazon.JP.label")
      },
      primaryButtonLabel: '',
      errormessage: {
        title: "",
        message: ""
      },
      sellerInfo: {},
      loading: false,
      settings: {},
      primaryButtonLabelAlias: {
        AUTH: this.$t("authorizeAmazon.buttonLabel"),
        ADD: this.$t("addAuthorization.buttonLabel")
      }
    };
  },
  computed: _objectSpread2(_objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ["apiUrls", "debug"])), (0,external_pinia_.mapState)(store_modules_.useCompanyStore, ["selectedCompany"])), {}, {
    isVisible: function isVisible() {
      return 'hidden';
    },
    get: function get() {
      return (get_default());
    },
    listMarketplaces: function listMarketplaces() {
      var list = [],
          self = this;
      each_default()(this.settings, function (tKA, key) {
        list.push({
          translationKey: self.marketPlaceNames[key],
          value: key
        });
      });
      return list;
    },
    sellerCentralUrl: function sellerCentralUrl() {
      if (this.settings[this.formData.marketplace]) return this.settings[this.formData.marketplace].sellerCentralUrl;
      return "";
    },
    developerId: function developerId() {
      if (this.settings[this.formData.marketplace]) return this.settings[this.formData.marketplace].devId;
      return "";
    },
    developerName: function developerName() {
      if (this.settings[this.formData.marketplace]) return this.settings[this.formData.marketplace].developerName;
      return "";
    },
    addAmazonIntegrationExplanation: function addAmazonIntegrationExplanation() {
      return this.$t("addAmazonIntegrationExplanation.textBlock");
    },
    hasMarketplaceSelected: function hasMarketplaceSelected() {
      return !!this.formData.marketplace;
    },
    region: function region() {
      return this.settings[this.formData.marketplace].region || "";
    }
  }),
  methods: {
    cancelForm: function cancelForm() {
      this.formData = {};
      localStorage.removeItem('amazonAuth');
      this.$emit("cancel-form");
    },
    authorize: function authorize() {
      localStorage.amazonAuth = JSON.stringify(_objectSpread2(_objectSpread2({
        region: this.region
      }, this.formData), {}, {
        company: this.selectedCompany.id
      }));
      window.location = 'https://sellercentral.amazon.de/apps/authorize/consent?application_id=' + this.settings.applicationId + '&version=beta';
    },
    marketPlaceChanged: function marketPlaceChanged(val) {
      if (val) {
        this.data.region = this.settings[val].region;
        this.data.marketplace = val;
      }
    },
    validateSellerId: function validateSellerId(rule, value, callback) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var reqEx;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(value === "")) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", callback(new Error(_this.$t("sellerId.inputValidation.emptyField.message"))));

              case 2:
                // eslint-disable-next-line no-useless-escape
                reqEx = /[a-zA-Z0-9]{13,15}/;

                if (reqEx.test(value)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", callback(new Error(_this.$t("sellerId.inputValidation.regEx.message"))));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    validateMwsToken: function validateMwsToken(rule, value, callback) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var reqEx;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(value === "")) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", callback(new Error(_this2.$t("mwsToken.inputValidation.emptyField.message"))));

              case 2:
                // eslint-disable-next-line no-useless-escape
                reqEx = /[a-zA-Z0-9\.]{15,20}-[a-zA-Z0-9]{4,5}-[a-zA-Z0-9]{4,5}-[a-zA-Z0-9]{4,5}-[a-zAz0-9\.]{12,13}/gm;

                if (reqEx.test(value)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", callback(new Error(_this2.$t("mwsToken.inputValidation.regEx.message"))));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    saveAuthorization: function saveAuthorization() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var err, res, _yield$to, _yield$to2, thirdPartyAPIError, aliasThirdPartyAPIErrorMessages;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.formData.secretId) {
                  _context3.next = 4;
                  break;
                }

                _this3.loading = true;

                _this3.authorize();

                return _context3.abrupt("return", false);

              case 4:
                _this3.loading = true;
                _context3.next = 7;
                return (0,external_await_to_js_.to)(_this3.$http.post("".concat(_this3.apiUrls.dutypay, "/api/v0/markets/add"), {
                  new: _objectSpread2({
                    region: _this3.region,
                    status: "active"
                  }, _this3.formData),
                  company: _this3.selectedCompany.id,
                  type: "amazon"
                }));

              case 7:
                _yield$to = _context3.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];
                _this3.loading = false;

                if (!err) {
                  _context3.next = 17;
                  break;
                }

                _this3.errormessage.title = _this3.$t("saveAuthorization.notification.asyncError.title");
                thirdPartyAPIError = get_default()(err, "response.data.message", undefined);

                if (thirdPartyAPIError !== undefined) {
                  // eslint-disable-next-line no-unused-vars
                  aliasThirdPartyAPIErrorMessages = [_this3.$t("saveAuthorization.notification.asyncError.markets.add.companyRequired.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.typeRequired.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.newMissing.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.sellerIdRequired.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.notUnique.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mwsAuthorizationTokenRequired.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mws.getReportRequestListError.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mws.getReportError.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mws.listMarketplaceParticipationsError.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mws.ordersError.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mws.addSecret.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mws.addtoDB.message")];
                  _this3.errormessage.message = _this3.$t("saveAuthorization.notification.asyncError.".concat(thirdPartyAPIError, ".message"));
                } else {
                  _this3.errormessage.message = _this3.$t("saveAuthorization.notification.asyncError.message");
                }

                throw err;

              case 17:
                mitt.emit("integrations-amazon-authorization-saved");
                localStorage.removeItem('amazonAuth'); // this.emitVisibility(false);

                _this3.formData = {};

                _this3.$emit("cancel-form");

                return _context3.abrupt("return", res);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    fetchSellerInfo: throttle_default()( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var err, res, _yield$to3, _yield$to4;

      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0,external_await_to_js_.to)(this.$http.get("".concat(this.apiUrls.dutypay, "/api/v0/markets/sellerid/mws/").concat(this.region.toLowerCase(), "/").concat(this.formData.sellerId)));

            case 2:
              _yield$to3 = _context4.sent;
              _yield$to4 = _slicedToArray(_yield$to3, 2);
              err = _yield$to4[0];
              res = _yield$to4[1];

              if (!err) {
                _context4.next = 8;
                break;
              }

              throw err;

            case 8:
              if (res && res.data) {
                this.formData.company = this.sellerInfo = res.data;
              }

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    })), 1500),
    fetchSettings: function fetchSettings() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var err, res, _yield$to5, _yield$to6;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.loading = true;
                _context5.next = 3;
                return (0,external_await_to_js_.to)(_this4.$http.get("".concat(_this4.apiUrls.dutypay, "/api/v0/markets/settings/amazon")));

              case 3:
                _yield$to5 = _context5.sent;
                _yield$to6 = _slicedToArray(_yield$to5, 2);
                err = _yield$to6[0];
                res = _yield$to6[1];
                _this4.loading = false;

                if (!err) {
                  _context5.next = 11;
                  break;
                }

                _this4.$notify.error({
                  title: _this4.$t("fetchSettings.notification.asyncError.title"),
                  message: _this4.$t("fetchSettings.notification.asyncError.message")
                });

                throw err;

              case 11:
                if (get_default()(res, "data.result", undefined) !== undefined) _this4.settings = res.data.result;

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  },
  watch: {
    filledFormData: function filledFormData(newVal) {
      if (newVal !== undefined) {
        this.formData = newVal;
        if (this.formData.sellerId) this.fetchSellerInfo();
      }
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this5.fetchSettings();

            case 2:
              if (_this5.filledFormData !== undefined) _this5.formData = _this5.filledFormData;
              _this5.primaryButtonLabel = _this5.primaryButtonLabelAlias.AUTH;

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }
};


/* harmony default export */ var AddAuthorizationFormvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(AddAuthorizationFormvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables');

    var _composables$useJuris = composables.useJurisdictionSwitch(),
        isRTL = _composables$useJuris.isRTL;

    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_DpSelectCustom = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpSelectCustom");

      var _component_DpCopyToClipboard = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCopyToClipboard");

      var _component_DpReadValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpReadValue");

      var _component_DpInputCustom = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpInputCustom");

      var _component_DpIcon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpIcon");

      var _component_el_form_item = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-form-item");

      var _component_DpFeedforward = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFeedforward");

      var _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_center = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("center");

      var _component_DpForm = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpForm");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpForm, {
        modelValue: _ctx.formData,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(formData) ? formData.value = $event : null;
        }),
        reference: "add-amazon-authorization",
        action: _ctx.saveAuthorization,
        notificationAsyncError: _objectSpread2({}, _ctx.errormessage),
        "primary-button-label": _ctx.primaryButtonLabel,
        primaryButtonParameter: {
          disabled: !_ctx.hasMarketplaceSelected && !_ctx.formData.secretId
        }
      }, {
        secondaryButton: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            purpose: "secondaryAction",
            onClick: _ctx.cancelForm
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("cancelButton.buttonLabel")), 1)];
            }),
            _: 1
          }, 8, ["onClick"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_center, null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [_ctx.formData.secretId ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_6, "Authorized for " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.formData.sellerId) + " " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((get_default()))(_ctx.sellerInfo, "result.BusinessName", "")), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)];
            }),
            _: 1
          })];
        }),
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
            class: "text-block",
            innerHTML: _ctx.addAmazonIntegrationExplanation.content,
            style: {
              "margin-bottom": "1em"
            }
          }, null, 8, AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpSelectCustom, {
            options: _ctx.listMarketplaces,
            required: "",
            prop: "marketplace",
            filterable: true,
            "t-function": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t),
            label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('selectMarketplace.label'),
            modelValue: _ctx.formData.marketplace,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.formData.marketplace = $event;
            })
          }, null, 8, ["options", "t-function", "label", "modelValue"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpFeedforward, {
                title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('marketplaceExplanation.label'),
                "full-width-message": ""
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpReadValue, {
                    inline: "",
                    padding: "",
                    "data-key": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('developerName.label')
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCopyToClipboard, {
                        value: _ctx.developerName
                      }, {
                        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.developerName), 1)];
                        }),
                        _: 1
                      }, 8, ["value"])];
                    }),
                    _: 1
                  }, 8, ["data-key"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpReadValue, {
                    inline: "",
                    padding: "",
                    "data-key": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('developerId.label')
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCopyToClipboard, {
                        value: _ctx.developerId
                      }, {
                        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(_ctx.developerId), 1)];
                        }),
                        _: 1
                      }, 8, ["value"])];
                    }),
                    _: 1
                  }, 8, ["data-key"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpInputCustom, {
                    modelValue: _ctx.sellerCentralUrl,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(sellerCentralUrl) ? sellerCentralUrl.value = $event : null;
                    }),
                    label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('amazonSellerCentral.label'),
                    style: {
                      "margin-bottom": "0.5em"
                    },
                    "input-parameters": {
                      readonly: true
                    }
                  }, null, 8, ["modelValue", "label"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form_item, null, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCopyToClipboard, {
                        value: _ctx.sellerCentralUrl
                      }, null, 8, ["value"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("a", {
                        href: _ctx.sellerCentralUrl,
                        target: "_blank"
                      }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("visitLink.linkLabel")), 9, AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_5)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpIcon, {
                        icon: "open-external",
                        size: 14,
                        color: "#909399",
                        class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)({
                          'flip-icon': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isRTL)
                        })
                      }, null, 8, ["class"])])])])];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }, 8, ["title"])];
            }),
            _: 1
          }, 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.hasMarketplaceSelected && 1 == 0]]),  false ? (0) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, {
            class: "seller-info partition depth-1"
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((get_default()))(_ctx.sellerInfo, 'result', undefined) !== undefined ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpReadValue, {
                key: 0,
                inline: "",
                padding: "",
                "data-key": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('sellerInfo.label')
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((get_default()))(_ctx.sellerInfo, "result.BusinessName", "")), 1)];
                }),
                _: 1
              }, 8, ["data-key"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)];
            }),
            _: 1
          }, 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((get_default()))(_ctx.sellerInfo, 'result', undefined) !== undefined || _ctx.formData.company]]),  false ? (0) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)];
        }),
        _: 1
      }, 8, ["modelValue", "action", "notificationAsyncError", "primary-button-label", "primaryButtonParameter"])), [[_directive_loading, _ctx.loading]]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration/AddAuthorizationForm.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-66.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-66.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-66.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-66.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration/AddAuthorizationForm.vue?vue&type=style&index=0&id=3df69509&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration/AddAuthorizationForm.vue?vue&type=style&index=0&id=3df69509&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration/AddAuthorizationForm.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function AddAuthorizationFormvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon Autorizierung hinzufügen"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Bitte wähle den Amazon-Marktplatz aus, der mit deinem DutyPay Unternehmenskonto verknüpft werden soll.</p>"])}
          }
        }
      },
      "de-AT": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon Autorizierung hinzufügen"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Bitte wähle den Amazon-Marktplatz aus, der mit deinem DutyPay Unternehmenskonto verknüpft werden soll.</p>"])}
          }
        }
      },
      "de-CH": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon Autorizierung hinzufügen"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Bitte wähle den Amazon-Marktplatz aus, der mit deinem DutyPay Unternehmenskonto verknüpft werden soll.</p>"])}
          }
        }
      },
      "en-US": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Amazon authorization"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Please select the Amazon marketplace that should be linked to your DutyPay company account.</p>"])}
          }
        }
      },
      "en-GB": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add Amazon authorization"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Please select the Amazon marketplace that should be linked to your DutyPay company account.</p>"])}
          }
        }
      },
      "it-IT": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aggiungi l'autorizzazione Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Seleziona il Marketplace Amazon da associare al tuo account aziendale DutyPay.</p>"])}
          }
        }
      },
      "fr-FR": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter une autorisation Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Sélectionnez Amazon Marketplace à associer à votre compte d'entreprise DutyPay.</p>"])}
          }
        }
      },
      "es-ES": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar autorización de Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Seleccione el mercado de Amazon que debe estar vinculado a su cuenta de empresa de DutyPay.</p>"])}
          }
        }
      },
      "pl-PL": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj autoryzację Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Wybierz Amazon Marketplace, który ma być powiązany z Twoim kontem firmowym DutyPay.</p>"])}
          }
        }
      },
      "nl-NL": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afbreken"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voeg Amazon-autorisatie toe"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Selecteer de Amazon Marketplace die u wilt koppelen aan uw DutyPay Company-account.</p>"])}
          }
        }
      },
      "bg-BG": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прекратяване"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавете разрешение на Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Моля, изберете пазара на Amazon, който трябва да бъде свързан с вашия фирмен акаунт в DutyPay.</p>"])}
          }
        }
      },
      "bs-BA": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodajte Amazonovo ovlaštenje"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Odaberite Amazon tržište koje bi trebalo biti povezano s vašim računom kompanije DutyPay.</p>"])}
          }
        }
      },
      "zh-CN": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中止"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["添加亚马逊授权"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>选择要与您的DutyPay公司帐户关联的Amazon Marketplace。</p>"])}
          }
        }
      },
      "da-DK": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilføj Amazon-godkendelse"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Vælg Amazon Marketplace, der skal tilknyttes din DutyPay Company-konto.</p>"])}
          }
        }
      },
      "et-EE": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Katkesta"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lisage Amazoni volitus"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Valige Amazoni turg, mis peaks olema seotud teie DutyPay ettevõtte kontoga.</p>"])}
          }
        }
      },
      "fi-FI": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keskeyttää"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lisää Amazon-valtuutus"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Valitse Amazon Marketplace, joka liitetään DutyPay Company -tiliisi.</p>"])}
          }
        }
      },
      "el-GR": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Άκυρο"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προσθέστε εξουσιοδότηση Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Επιλέξτε το Amazon Marketplace που θα συσχετιστεί με τον εταιρικό σας λογαριασμό DutyPay.</p>"])}
          }
        }
      },
      "he-IL": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפִּיל"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הוסף הרשאה של אמזון"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>בחר בשוק אמזון שישויך לחשבון חברת DutyPay שלך.</p>"])}
          }
        }
      },
      "ga-IE": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ginmhilleadh"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir údarú Amazon leis"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Roghnaigh Margadh Amazon le bheith bainteach le do chuntas DutyPay Company.</p>"])}
          }
        }
      },
      "ja-JP": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アボート"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon認証を追加する"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>DutyPay企業アカウントにリンクする必要があるAmazonマーケットプレイスを選択してください。</p>"])}
          }
        }
      },
      "hr-HR": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekid"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodajte Amazonovo ovlaštenje"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Odaberite Amazon Marketplace da biste bili povezani s vašim računom tvrtke DutyPay.</p>"])}
          }
        }
      },
      "lv-LV": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pārtraukt"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pievienojiet Amazon autorizāciju"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Atlasiet Amazon Marketplace, kas tiks saistīts ar jūsu DutyPay uzņēmuma kontu.</p>"])}
          }
        }
      },
      "lt-LT": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutraukti"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pridėkite „Amazon“ įgaliojimą"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Pasirinkite „Amazon Marketplace“, kad būtų susieta su jūsų „DutyPay Company“ paskyra.</p>"])}
          }
        }
      },
      "pt-PT": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abortar"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adicionar autorização Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Selecione o Amazon Marketplace para ser associado à sua conta corporativa DutyPay.</p>"])}
          }
        }
      },
      "ro-RO": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abandonați"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adăugați autorizația Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Selectați Amazon Marketplace pentru a fi asociat contului dvs. de companie DutyPay.</p>"])}
          }
        }
      },
      "ru-RU": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прервать"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавить авторизацию Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Выберите Amazon Marketplace, который будет связан с вашей учетной записью DutyPay Company.</p>"])}
          }
        }
      },
      "sv-SE": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avbryta"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lägg till Amazon-auktorisering"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Välj Amazon Marketplace som ska kopplas till ditt DutyPay Company-konto.</p>"])}
          }
        }
      },
      "sk-SK": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["-Pridajte oprávnenie spoločnosti Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Vyberte si Amazon Marketplace, ktorý chcete priradiť k svojmu firemnému účtu DutyPay.</p>"])}
          }
        }
      },
      "cs-CZ": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přerušit"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přidejte autorizaci Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Vyberte Amazon Marketplace, který má být přidružen k vašemu firemnímu účtu DutyPay.</p>"])}
          }
        }
      },
      "tr-TR": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon yetkilendirmesi ekle"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>DutyPay Şirket hesabınızla ilişkilendirilecek Amazon Pazaryeri'ni seçin.</p>"])}
          }
        }
      },
      "hu-HU": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mégse"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adja hozzá az Amazon engedélyt"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Válassza ki az Amazon Marketplace-t, hogy társuljon a DutyPay Company-fiókkal.</p>"])}
          }
        }
      },
      "ar-AE": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إحباط"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إضافة إذن أمازون"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>الرجاء تحديد سوق Amazon الذي يجب ربطه بحساب شركة DutyPay الخاص بك.</p>"])}
          }
        }
      },
      "fr-BE": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter une autorisation Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Sélectionnez Amazon Marketplace à associer à votre compte d'entreprise DutyPay.</p>"])}
          }
        }
      },
      "fr-LU": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter une autorisation Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Sélectionnez Amazon Marketplace à associer à votre compte d'entreprise DutyPay.</p>"])}
          }
        }
      },
      "mt-MT": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkanċella"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żid l-awtorizzazzjoni tal-Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Agħżel is-Suq tal-Amazon biex tkun assoċjat mal-kont tal-Kumpanija DutyPay tiegħek.</p>"])}
          }
        }
      },
      "sl-SI": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodajte pooblastilo za Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Izberite Amazon Marketplace, ki bo povezan z vašim računom podjetja DutyPay.</p>"])}
          }
        }
      },
      "el-CY": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Άκυρο"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προσθέστε εξουσιοδότηση Amazon"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>Επιλέξτε το Amazon Marketplace που θα συσχετιστεί με τον εταιρικό σας λογαριασμό DutyPay.</p>"])}
          }
        }
      },
      "tr-CY": {
        "saveAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          }
        },
        "fetchSettings": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            }
          }
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        },
        "addAmazonIntegrationExplanation": {
          "textBlock": {
            "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon yetkilendirmesi ekle"])},
            "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["<p>DutyPay Şirket hesabınızla ilişkilendirilecek Amazon Pazaryeri'ni seçin.</p>"])}
          }
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration/AddAuthorizationForm.vue



;
/* custom blocks */

if (typeof AddAuthorizationFormvue_type_custom_index_0_blockType_i18n === 'function') AddAuthorizationFormvue_type_custom_index_0_blockType_i18n(AddAuthorizationFormvue_type_script_setup_true_lang_js)


;
const AddAuthorizationForm_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(AddAuthorizationFormvue_type_script_setup_true_lang_js, [['__scopeId',"data-v-3df69509"]])

/* harmony default export */ var AddAuthorizationForm = (AddAuthorizationForm_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration/ListAmazonAuthorizations.vue?vue&type=script&setup=true&lang=js










var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_withScopeId = function _withScopeId(n) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.pushScopeId)("data-v-a8fa59ee"), n = n(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.popScopeId)(), n;
};

var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 0,
  class: "dp-color__font__success"
};

var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_2 = /*#__PURE__*/ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_withScopeId(function () {
  return /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
    class: "el-icon-success"
  })], -1);
});

var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_3 = {
  style: {
    "margin": "0 0.5em"
  }
};
var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_4 = {
  key: 1,
  class: "dp-color__font__info"
};

var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_5 = /*#__PURE__*/ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_withScopeId(function () {
  return /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
    class: "el-icon-remove"
  })], -1);
});

var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_6 = {
  style: {
    "margin": "0 0.5em"
  }
};
var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_7 = {
  key: 2,
  class: "dp-color__font__danger"
};

var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_8 = /*#__PURE__*/ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_withScopeId(function () {
  return /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
    class: "el-icon-warning"
  })], -1);
});

var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_9 = {
  style: {
    "margin": "0 0.5em"
  }
};
var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_10 = {
  class: "dp-flex wrap"
};
var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_11 = {
  class: "history"
};
var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_12 = {
  key: 0
};
var _hoisted_13 = {
  key: 1
};
var _hoisted_14 = {
  key: 0
};
var _hoisted_15 = {
  key: 1
};
var _hoisted_16 = {
  key: 2
};











var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_default_ = {
  name: "ListAmazonAuthorizations",
  components: {
    AddAuthorizationForm: AddAuthorizationForm
  },
  data: function data() {
    return {
      authorizations: [],
      loading: false,
      removeAuthorizationSlot: [],
      refreshCredentialsSlot: [],
      authorizationLoading: {},
      integrationsPage: "/company-settings/integrations",
      participationMarkets: {
        A2VIGQ35RCS4UG: "AE",
        A1PA6795UKMFR9: "DE",
        ARBP9OOSHTCHU: "EG",
        A1RKKUPIHCS9HS: "ES",
        A13V1IB3VIYZZH: "FR",
        A1F83G8C2ARO7P: "GB",
        A21TJRUUN4KGV: "IN",
        APJ6JRA9NG5V4: "IT",
        A1805IZSGTT6HS: "NL",
        A1C3SOZRARQ6R3: "PL",
        A17E79C6D8DWNP: "SA",
        A2NODRKZP88ZB9: "SE",
        A33AVAJ2PDY3EV: "TR",
        A2Q3Y263D00KWC: "BR",
        A2EUQ1WTGCTBG2: "CA",
        A1AM78C64UM0Y8: "MX",
        ATVPDKIKX0DER: "US",
        A19VAU5U5O7RUS: "SG",
        A39IBJ37TRP1C6: "AU",
        A1VC38T7YXB528: "JP"
      },
      participationMarketsAlias: [this.$t("participation.AE.label"), this.$t("participation.DE.label"), this.$t("participation.EG.label"), this.$t("participation.ES.label"), this.$t("participation.FR.label"), this.$t("participation.GB.label"), this.$t("participation.IN.label"), this.$t("participation.IT.label"), this.$t("participation.NL.label"), this.$t("participation.PL.label"), this.$t("participation.SA.label"), this.$t("participation.SE.label"), this.$t("participation.TR.label"), this.$t("participation.BR.label"), this.$t("participation.CA.label"), this.$t("participation.MX.label"), this.$t("participation.US.label"), this.$t("participation.SG.label"), this.$t("participation.AU.label"), this.$t("participation.JP.label")]
    };
  },
  watch: {
    selectedCompany: function () {
      var _selectedCompany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(val) {
        var tmp, res, err, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!val.id) {
                  _context.next = 22;
                  break;
                }

                if (!this.$route.query.spapi_oauth_code) {
                  _context.next = 22;
                  break;
                }

                tmp = JSON.parse(localStorage.amazonAuth);

                if (!tmp.secretId) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", this.$router.push({
                  path: "/company-settings/integrations"
                }));

              case 5:
                _context.next = 7;
                return (0,external_await_to_js_.to)(this.spapiauth(this.$route.query.spapi_oauth_code, this.$route.query.selling_partner_id, tmp.region));

              case 7:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];

                if (!err) {
                  _context.next = 15;
                  break;
                }

                this.$notify.error({
                  title: this.$t("authorization.notification.asyncError.title"),
                  message: this.$t("authorization.notification.asyncError.message")
                });
                _context.next = 22;
                break;

              case 15:
                if (!res) {
                  _context.next = 22;
                  break;
                }

                tmp.secretId = res.data.secret_id;
                tmp.sellerId = res.data.sellerId;
                tmp.participations = res.data.participations;
                localStorage.amazonAuth = JSON.stringify(tmp);
                this.$emit("amazon-auth");
                return _context.abrupt("return", this.$router.push({
                  path: "/company-settings/integrations"
                }));

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function selectedCompany(_x) {
        return _selectedCompany.apply(this, arguments);
      }

      return selectedCompany;
    }()
  },
  computed: _objectSpread2(_objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ["apiUrls", "debug", "baseUrl"])), (0,external_pinia_.mapState)(store_modules_.useCompanyStore, ["selectedCompany"])), {}, {
    isEmpty: function isEmpty() {
      return (isEmpty_default());
    },
    map: function map() {
      return (map_default());
    },
    each: function each() {
      return (each_default());
    }
  }),
  methods: {
    initiateSlots: function initiateSlots() {
      var _this = this;

      var keys = Object.keys(this.authorizations);

      each_default()(keys, function (key) {
        _this.removeAuthorizationSlot[key] = false;
        _this.refreshCredentialsSlot[key] = false;
        _this.authorizationLoading[key] = false;
      });
    },
    cancelForm: function cancelForm(index) {
      localStorage.removeItem("amazonAuth");
      this.refreshCredentialsSlot[index] = false;
    },
    fetchAuthorizations: function fetchAuthorizations() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var err, res, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.apiUrls) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _this2.loading = true;
                _context2.next = 5;
                return (0,external_await_to_js_.to)(_this2.$http.get("".concat(_this2.apiUrls.dutypay, "/api/v0/markets/").concat(_this2.selectedCompany.id, "/amazon")));

              case 5:
                _yield$to3 = _context2.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 2);
                err = _yield$to4[0];
                res = _yield$to4[1];
                _this2.loading = false;

                if (!err) {
                  _context2.next = 12;
                  break;
                }

                throw err;

              case 12:
                _this2.authorizations = filter_default()(get_default()(res, "data.marketplaces", []), function (authorization) {
                  return authorization.status !== "deleted";
                });
                if (_this2.authorizations.length > 0 && (_this2.authorizations.length !== _this2.removeAuthorizationSlot.length || _this2.authorizations.length !== _this2.refreshCredentialsSlot.length || _this2.authorizations.length !== _this2.authorizationLoading.length)) _this2.initiateSlots();else _this2.$emit("empty-results");

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    updateAuthorization: function updateAuthorization(index) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var err, res, _yield$to5, _yield$to6;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0,external_await_to_js_.to)(_this3.$http.patch("".concat(_this3.apiUrls.dutypay, "/api/v0/markets/").concat(_this3.selectedCompany.id, "/amazon"), _this3.authorizations[index]));

              case 2:
                _yield$to5 = _context3.sent;
                _yield$to6 = _slicedToArray(_yield$to5, 2);
                err = _yield$to6[0];
                res = _yield$to6[1];

                if (!err) {
                  _context3.next = 8;
                  break;
                }

                throw err;

              case 8:
                return _context3.abrupt("return", res);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    pauseAuthorization: function pauseAuthorization(index) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.authorizationLoading[index] = true;
                _this4.authorizations[index].status = "paused";
                _context4.next = 4;
                return _this4.updateAuthorization(index);

              case 4:
                _this4.authorizationLoading[index] = false;

                _this4.$notify.success({
                  title: _this4.$t("pauseAuthorization.notification.success.title"),
                  message: _this4.$t("pauseAuthorization.notification.success.message")
                });

                _context4.next = 8;
                return _this4.fetchAuthorizations();

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    resumeAuthorization: function resumeAuthorization(index) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.authorizationLoading[index] = true;
                _this5.authorizations[index].status = "active";
                _context5.next = 4;
                return _this5.updateAuthorization(index);

              case 4:
                _this5.authorizationLoading[index] = false;

                _this5.$notify.success({
                  title: _this5.$t("resumeAuthorization.notification.success.title"),
                  message: _this5.$t("resumeAuthorization.notification.success.message")
                });

                _context5.next = 8;
                return _this5.fetchAuthorizations();

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    refreshAuthorization: function refreshAuthorization(index) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.refreshCredentialsSlot[index] = true;

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    removeAuthorization: function removeAuthorization(index) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var res;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.authorizationLoading[index] = true;
                _this7.authorizations[index].status = "deleted";
                _context7.next = 4;
                return _this7.updateAuthorization(index);

              case 4:
                res = _context7.sent;
                _this7.authorizationLoading[index] = false;
                _context7.next = 8;
                return _this7.fetchAuthorizations();

              case 8:
                return _context7.abrupt("return", res);

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    spapiauth: function spapiauth(spapi_oauth_code, sellerId, region) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var err, res, _yield$to7, _yield$to8;

        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return (0,external_await_to_js_.to)(_this8.$http.post("".concat(_this8.apiUrls.dutypay, "/api/v0/markets/spapiauth"), {
                  code: spapi_oauth_code,
                  company: _this8.selectedCompany.id,
                  sellerId: sellerId,
                  region: region
                }));

              case 2:
                _yield$to7 = _context8.sent;
                _yield$to8 = _slicedToArray(_yield$to7, 2);
                err = _yield$to8[0];
                res = _yield$to8[1];

                if (!err) {
                  _context8.next = 8;
                  break;
                }

                throw err;

              case 8:
                return _context8.abrupt("return", res);

              case 9:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var tmp, res, err, _yield$to9, _yield$to10;

      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              mitt.on("integrations-amazon-authorization-saved", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                  while (1) {
                    switch (_context9.prev = _context9.next) {
                      case 0:
                        localStorage.removeItem("amazonAuth");
                        _context9.next = 3;
                        return _this9.fetchAuthorizations();

                      case 3:
                      case "end":
                        return _context9.stop();
                    }
                  }
                }, _callee9);
              })));

              if (!(_this9.$route.query.spapi_oauth_code && _this9.selectedCompany.id)) {
                _context10.next = 22;
                break;
              }

              tmp = JSON.parse(localStorage.amazonAuth);

              if (!tmp.secretId) {
                _context10.next = 5;
                break;
              }

              return _context10.abrupt("return", _this9.$router.push({
                path: "/company-settings/integrations"
              }));

            case 5:
              _context10.next = 7;
              return (0,external_await_to_js_.to)(_this9.spapiauth(_this9.$route.query.spapi_oauth_code, _this9.$route.query.selling_partner_id, tmp.region));

            case 7:
              _yield$to9 = _context10.sent;
              _yield$to10 = _slicedToArray(_yield$to9, 2);
              err = _yield$to10[0];
              res = _yield$to10[1];

              if (!err) {
                _context10.next = 15;
                break;
              }

              _this9.$notify.error({
                title: _this9.$t("authorization.notification.asyncError.title"),
                message: _this9.$t("authorization.notification.asyncError.message")
              });

              _context10.next = 22;
              break;

            case 15:
              if (!res) {
                _context10.next = 22;
                break;
              }

              tmp.secretId = res.data.secret_id;
              tmp.sellerId = res.data.sellerId;
              tmp.participations = res.data.participations;
              localStorage.amazonAuth = JSON.stringify(tmp);

              _this9.$emit("amazon-auth");

              return _context10.abrupt("return", _this9.$router.push({
                path: "/company-settings/integrations"
              }));

            case 22:
              //  if (!this.baseUrl) this.baseUrl = process.env.VUE_APP_BASE_URL;
              //if (!this.baseUrl) this.baseUrl = 'https://' + window.location.hostname + '/';
              if (_this9.$route.query.amazon_callback_uri) window.location = _this9.$route.query.amazon_callback_uri + "?amazon_state=" + _this9.$route.query.amazon_state + "&version=beta&redirect_uri=" + _this9.baseUrl + _this9.integrationsPage;
              _context10.next = 25;
              return _this9.fetchAuthorizations();

            case 25:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  }
};


/* harmony default export */ var ListAmazonAuthorizationsvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _this10 = this;

    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    var composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables');

    var _composables$useViewp = composables.useViewportSize(),
        isMobile = _composables$useViewp.isMobile;

    return function (_ctx, _cache) {
      var _component_DpReadValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpReadValue");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse");

      var _component_DpFeedforward = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFeedforward");

      var _component_DpFormConfirmDeletion = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFormConfirmDeletion");

      var _component_DpListItem = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpListItem");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.authorizations, function (authorization, index) {
        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpListItem, {
          key: "amazon-authorizations-".concat(index),
          style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
            borderColor: authorization.status === 'inactive' ? '#FF4949' : ''
          })
        }, {
          headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
            return [authorization.status === 'active' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_1, [ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("status.active.label")), 1)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), authorization.status === 'paused' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_4, [ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_5, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_6, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("status.paused.label")), 1)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), authorization.status === 'inactive' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_7, [ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_8, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_9, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("status.inactive.label")), 1)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)];
          }),
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
            return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
                  class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["dp-flex row justify-content__space-between align-items__flex-start", {
                    wrap: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
                  }])
                }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_10, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpReadValue, {
                  "data-key": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('mwsSellerId.label'),
                  "data-value": authorization.sellerId,
                  padding: "",
                  inline: ""
                }, null, 8, ["data-key", "data-value"]), !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(authorization.company) ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpReadValue, {
                  key: 0,
                  "data-key": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.label'),
                  "data-value": authorization.company.Name,
                  padding: "",
                  inline: ""
                }, null, 8, ["data-key", "data-value"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(authorization.marketplace) ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpReadValue, {
                  key: 1,
                  "data-key": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('marketplace.label'),
                  "data-value": authorization.marketplace,
                  padding: "",
                  inline: ""
                }, null, 8, ["data-key", "data-value"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(authorization.history) ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpReadValue, {
                  key: 2,
                  "data-key": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('history.label'),
                  padding: "",
                  inline: ""
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_11, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(authorization.history, function (historyItem, historyIndex) {
                      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                        key: "authorization-".concat(index, "-history-").concat(historyIndex)
                      }, [historyItem.status === 'active' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
                        key: 0
                      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("history.activatedOn.label", {
                        date: _ctx.$dp.dayjs.unix(historyItem._ts).local().format("LLL")
                      })), 1)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), historyItem.status === 'deleted' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
                        key: 1
                      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("history.deletedOn.label", {
                        date: _ctx.$dp.dayjs.unix(historyItem._ts).local().format("LLL")
                      })), 1)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), historyItem.status === 'paused' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
                        key: 2
                      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("history.pausedOn.label", {
                        date: _ctx.$dp.dayjs.unix(historyItem._ts).local().format("LLL")
                      })), 1)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]);
                    }), 128))])];
                  }),
                  _: 2
                }, 1032, ["data-key"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(authorization.participations) ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpReadValue, {
                  key: 3,
                  "data-key": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('participations.label'),
                  padding: "",
                  inline: ""
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(authorization.participations, function (participation, index) {
                      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                        key: index
                      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("template", null, [!(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(_ctx.participationMarkets[participation]) && index !== 0 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", ListAmazonAuthorizationsvue_type_script_setup_true_lang_js_hoisted_12, ", ")) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(_ctx.participationMarkets[participation]) ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("span", _hoisted_13, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("participation.".concat(_ctx.participationMarkets[participation], ".label"))), 1)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])]);
                    }), 128))];
                  }),
                  _: 2
                }, 1032, ["data-key"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
                  class: "dp-flex column align-items__center controls partition depth-1",
                  style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
                    width: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile) ? '100%' : 'auto'
                  })
                }, [authorization.status === 'active' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_14, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                  purpose: "primary",
                  class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["block full-wdith", {
                    'mobile-button': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
                  }]),
                  onClick: function onClick($event) {
                    return _ctx.pauseAuthorization(index);
                  }
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("pause.buttonLabel")), 1)];
                  }),
                  _: 2
                }, 1032, ["class", "onClick"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), authorization.status === 'paused' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_15, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                  purpose: "primary",
                  class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["block full-wdith", {
                    'mobile-button': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
                  }]),
                  onClick: function onClick($event) {
                    return _ctx.resumeAuthorization(index);
                  }
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("resume.buttonLabel")), 1)];
                  }),
                  _: 2
                }, 1032, ["class", "onClick"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), authorization.status === 'inactive' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", _hoisted_16, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                  purpose: "primary",
                  class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["block full-wdith", {
                    'mobile-button': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
                  }]),
                  onClick: function onClick($event) {
                    return _ctx.refreshAuthorization(index);
                  }
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("refreshCredentials.buttonLabel")), 1)];
                  }),
                  _: 2
                }, 1032, ["class", "onClick"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                  purpose: "destructive",
                  class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["block full-wdith", {
                    'mobile-button': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
                  }]),
                  onClick: function onClick($event) {
                    return _this10.removeAuthorizationSlot[index] = true;
                  }
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("remove.buttonLabel")), 1)];
                  }),
                  _: 2
                }, 1032, ["class", "onClick"])])], 4)], 2)];
              }),
              _: 2
            }, 1536), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, !_ctx.refreshCredentialsSlot[index] && !_ctx.removeAuthorizationSlot[index]]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(AddAuthorizationForm), {
                  onCancelForm: function onCancelForm($event) {
                    return _ctx.cancelForm(index);
                  },
                  filledFormData: authorization
                }, null, 8, ["onCancelForm", "filledFormData"])];
              }),
              _: 2
            }, 1536), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.refreshCredentialsSlot[index]]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpFormConfirmDeletion, {
                  action: function action() {
                    _ctx.removeAuthorization(index);
                  },
                  reference: "authorization-".concat(index, "-remove"),
                  phrase: authorization.sellerId,
                  primaryButtonLabel: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('confirmRemoveAuthorization.buttonLabel'),
                  notificationSuccess: {
                    title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthorization.notification.success.title'),
                    message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthorization.notification.success.message')
                  },
                  notificationAsyncError: {
                    title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthorization.notification.asyncError.title'),
                    message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthorization.notification.asyncError.message')
                  }
                }, {
                  secondaryButton: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                      purpose: "secondaryAction",
                      onClick: function onClick($event) {
                        return _ctx.removeAuthorizationSlot[index] = false;
                      }
                    }, {
                      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                        return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("keepAuthorization.buttonLabel")), 1)];
                      }),
                      _: 2
                    }, 1032, ["onClick"])];
                  }),
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpFeedforward, {
                      title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthorization.feedforward.warning.title'),
                      message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthorization.feedforward.warning.message'),
                      type: "danger"
                    }, null, 8, ["title", "message"])];
                  }),
                  _: 2
                }, 1032, ["action", "reference", "phrase", "primaryButtonLabel", "notificationSuccess", "notificationAsyncError"])];
              }),
              _: 2
            }, 1536), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.removeAuthorizationSlot[index]]])];
          }),
          _: 2
        }, 1032, ["style"])), [[_directive_loading, _ctx.authorizationLoading[index]]]);
      }), 128))]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration/ListAmazonAuthorizations.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-66.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-66.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-66.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-66.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration/ListAmazonAuthorizations.vue?vue&type=style&index=0&id=a8fa59ee&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration/ListAmazonAuthorizations.vue?vue&type=style&index=0&id=a8fa59ee&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration/ListAmazonAuthorizations.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function ListAmazonAuthorizationsvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        }
      },
      "de-AT": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        }
      },
      "de-CH": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erfolgreiche Aktion"])}
            }
          }
        }
      },
      "en-US": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
            }
          }
        }
      },
      "en-GB": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Successful action"])}
            }
          }
        }
      },
      "it-IT": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elimina"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errore"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azione riuscita"])}
            }
          }
        }
      },
      "fr-FR": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        }
      },
      "es-ES": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activar"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Listo"])}
            }
          }
        }
      },
      "pl-PL": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywuj"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usunąć"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Błąd"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czynność zakończona powodzeniem"])}
            }
          }
        }
      },
      "nl-NL": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activeren"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verwijderen"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geslaagde actie"])}
            }
          }
        }
      },
      "bg-BG": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активиране"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изтрий"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грешка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешно действие"])}
            }
          }
        }
      },
      "bs-BA": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirajte"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbriši"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Greška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješno obavljeno"])}
            }
          }
        }
      },
      "zh-CN": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["激活"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错误"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作成功"])}
            }
          }
        }
      },
      "da-DK": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivér"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slet"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vellykket handling"])}
            }
          }
        }
      },
      "et-EE": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeri"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kustuta"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Viga"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edukas tegevus"])}
            }
          }
        }
      },
      "fi-FI": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoi"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poistaa"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virhe"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onnistunut toiminta"])}
            }
          }
        }
      },
      "el-GR": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγράφω"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          }
        }
      },
      "he-IL": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפְעִיל"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לִמְחוֹק"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שְׁגִיאָה"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פעולה מוצלחת"])}
            }
          }
        }
      },
      "ga-IE": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaigh"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scrios"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Earráid"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomh rathúil"])}
            }
          }
        }
      },
      "ja-JP": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティベート"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["削除"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["エラー"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["成功したアクション"])}
            }
          }
        }
      },
      "hr-HR": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviraj"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrisati"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pogreška"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspješna akcija"])}
            }
          }
        }
      },
      "lv-LV": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēt"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dzēst"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kļūda"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veiksmīga darbība"])}
            }
          }
        }
      },
      "lt-LT": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinti"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ištrinti"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klaida"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sėkmingas veiksmas"])}
            }
          }
        }
      },
      "pt-PT": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativar"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excluir"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ação bem-sucedida"])}
            }
          }
        }
      },
      "ro-RO": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activare"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Șterge"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eroare"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acțiune reușită"])}
            }
          }
        }
      },
      "ru-RU": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировать"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Удаление"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успешное действие"])}
            }
          }
        }
      },
      "sv-SE": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivera"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Radera"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fel"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Åtgärd utförd"])}
            }
          }
        }
      },
      "sk-SK": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovať"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odstrániť"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspešná akcia"])}
            }
          }
        }
      },
      "cs-CZ": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovat"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vymazat"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chyba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úspěšná akce"])}
            }
          }
        }
      },
      "tr-TR": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştir"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sil"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          }
        }
      },
      "hu-HU": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiválja"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Töröl"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hiba"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sikeres művelet"])}
            }
          }
        }
      },
      "ar-AE": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حذف"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خطأ"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عمل ناجح"])}
            }
          }
        }
      },
      "fr-BE": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        }
      },
      "fr-LU": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreur"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Action réussie"])}
            }
          }
        }
      },
      "mt-MT": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ħassar"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żball"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Azzjoni ta' suċċess"])}
            }
          }
        }
      },
      "sl-SI": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviraj"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbriši"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Napaka"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uspešno opravljeno"])}
            }
          }
        }
      },
      "el-CY": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγράφω"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σφάλμα"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιτυχημένη ενέργεια"])}
            }
          }
        }
      },
      "tr-CY": {
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştir"])}
        },
        "resumeAuthorization": {
          "notification": {
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          }
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sil"])}
        },
        "removeAuthorization": {
          "notification": {
            "asyncError": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hata"])}
            },
            "success": {
              "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Başarılı eylem"])}
            }
          }
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration/ListAmazonAuthorizations.vue



;
/* custom blocks */

if (typeof ListAmazonAuthorizationsvue_type_custom_index_0_blockType_i18n === 'function') ListAmazonAuthorizationsvue_type_custom_index_0_blockType_i18n(ListAmazonAuthorizationsvue_type_script_setup_true_lang_js)


;
const ListAmazonAuthorizations_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ListAmazonAuthorizationsvue_type_script_setup_true_lang_js, [['__scopeId',"data-v-a8fa59ee"]])

/* harmony default export */ var ListAmazonAuthorizations = (ListAmazonAuthorizations_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration.vue?vue&type=script&setup=true&lang=js




var AmazonIntegrationvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 0
};
var AmazonIntegrationvue_type_script_setup_true_lang_js_hoisted_2 = {
  class: "add-authorization-form"
};


var AmazonIntegrationvue_type_script_setup_true_lang_js_default_ = {
  name: "AmazonIntegration",
  components: {
    AddAuthorizationForm: AddAuthorizationForm,
    ListAmazonAuthorizations: ListAmazonAuthorizations
  },
  data: function data() {
    return {
      showFormAddNew: false,
      sAuthorization: {}
    };
  },
  methods: {
    showForm: function showForm() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var tmp;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.showFormAddNew = true;

                if (localStorage.amazonAuth) {
                  try {
                    tmp = JSON.parse(localStorage.amazonAuth);
                    _this.sAuthorization = tmp;
                  } catch (e) {
                    delete localStorage.amazonAuth;
                  }
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (localStorage.amazonAuth) {
                _this2.showFormAddNew = true;
                _this2.sAuthorization = JSON.parse(localStorage.amazonAuth);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};

/* harmony default export */ var AmazonIntegrationvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(AmazonIntegrationvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h3", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("amazonIntegration.title")), 1), !_ctx.showFormAddNew ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", AmazonIntegrationvue_type_script_setup_true_lang_js_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
        purpose: "primary",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.showFormAddNew = true;
        })
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("addNew.buttonLabel")), 1)];
        }),
        _: 1
      })])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", AmazonIntegrationvue_type_script_setup_true_lang_js_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h3", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("addAmazonAuthorization.title")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(AddAuthorizationForm), {
            onCancelForm: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.showFormAddNew = false;
            }),
            filledFormData: _ctx.sAuthorization
          }, null, 8, ["filledFormData"])])];
        }),
        _: 1
      }, 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.showFormAddNew]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(ListAmazonAuthorizations), {
        onEmptyResults: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.showFormAddNew = true;
        }),
        onAmazonAuth: _cache[3] || (_cache[3] = function ($event) {
          return _ctx.showForm();
        })
      })]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function AmazonIntegrationvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon Integration"])}
        }
      },
      "de-AT": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon Integration"])}
        }
      },
      "de-CH": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon Integration"])}
        }
      },
      "en-US": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon Integration"])}
        }
      },
      "en-GB": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon Integration"])}
        }
      },
      "it-IT": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrazione con Amazon"])}
        }
      },
      "fr-FR": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intégration Amazon"])}
        }
      },
      "es-ES": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integración de Amazon"])}
        }
      },
      "pl-PL": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integracja z Amazon"])}
        }
      },
      "nl-NL": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon-integratie"])}
        }
      },
      "bg-BG": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Интеграция на Amazon"])}
        }
      },
      "bs-BA": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon integracija"])}
        }
      },
      "zh-CN": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["亚马逊整合"])}
        }
      },
      "da-DK": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon-integration"])}
        }
      },
      "et-EE": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazoni integreerimine"])}
        }
      },
      "fi-FI": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon-integraatio"])}
        }
      },
      "el-GR": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενσωμάτωση του Amazon"])}
        }
      },
      "he-IL": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שילוב אמזון"])}
        }
      },
      "ga-IE": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comhtháthú Amazon"])}
        }
      },
      "ja-JP": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アマゾン統合"])}
        }
      },
      "hr-HR": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon integracija"])}
        }
      },
      "lv-LV": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon integrācija"])}
        }
      },
      "lt-LT": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon integracija"])}
        }
      },
      "pt-PT": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integração amazônica"])}
        }
      },
      "ro-RO": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrare Amazon"])}
        }
      },
      "ru-RU": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Интеграция с Amazon"])}
        }
      },
      "sv-SE": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon-integration"])}
        }
      },
      "sk-SK": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrácia Amazon"])}
        }
      },
      "cs-CZ": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrace Amazon"])}
        }
      },
      "tr-TR": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon entegrasyonu"])}
        }
      },
      "hu-HU": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon integráció"])}
        }
      },
      "ar-AE": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تكامل أمازون"])}
        }
      },
      "fr-BE": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intégration Amazon"])}
        }
      },
      "fr-LU": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intégration Amazon"])}
        }
      },
      "mt-MT": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrazzjoni tal-Amazon"])}
        }
      },
      "sl-SI": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon integracija"])}
        }
      },
      "el-CY": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενσωμάτωση του Amazon"])}
        }
      },
      "tr-CY": {
        "amazonIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amazon entegrasyonu"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/AmazonIntegration.vue


/* custom blocks */
;
if (typeof AmazonIntegrationvue_type_custom_index_0_blockType_i18n === 'function') AmazonIntegrationvue_type_custom_index_0_blockType_i18n(AmazonIntegrationvue_type_script_setup_true_lang_js)


const AmazonIntegration_exports_ = AmazonIntegrationvue_type_script_setup_true_lang_js;

/* harmony default export */ var AmazonIntegration = (AmazonIntegration_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/JtlIntegration/AddAuthorizationForm.vue?vue&type=script&setup=true&lang=js












var JtlIntegration_AddAuthorizationFormvue_type_script_setup_true_lang_js_withScopeId = function _withScopeId(n) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.pushScopeId)("data-v-6862a046"), n = n(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.popScopeId)(), n;
};

var JtlIntegration_AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_1 = ["innerHTML"];

var JtlIntegration_AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_2 = /*#__PURE__*/JtlIntegration_AddAuthorizationFormvue_type_script_setup_true_lang_js_withScopeId(function () {
  return /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("br", null, null, -1);
});










var JtlIntegration_AddAuthorizationFormvue_type_script_setup_true_lang_js_default_ = {
  name: "AddAuthorizationForm",
  props: {
    filledFormData: {
      type: Object
    }
  },
  data: function data() {
    return {
      formData: {
        name: "",
        startDate: "",
        type: "jtl",
        reports: []
      },
      allreports: [],
      errormessage: {
        title: "",
        message: ""
      },
      loading: false,
      settings: {}
    };
  },
  computed: _objectSpread2(_objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ["apiUrls", "debug"])), (0,external_pinia_.mapState)(store_modules_.useCompanyStore, ["selectedCompany"])), {}, {
    get: function get() {
      return (get_default());
    },
    listMarketplaces: function listMarketplaces() {
      var list = [],
          self = this;
      each_default()(this.settings, function (tKA, key) {
        list.push({
          translationKey: self.marketPlaceNames[key],
          value: key
        });
      });
      return list;
    },
    sellerCentralUrl: function sellerCentralUrl() {
      if (this.settings[this.formData.marketplace]) return this.settings[this.formData.marketplace].sellerCentralUrl;
      return "";
    },
    developerId: function developerId() {
      if (this.settings[this.formData.marketplace]) return this.settings[this.formData.marketplace].devId;
      return "";
    },
    developerName: function developerName() {
      if (this.settings[this.formData.marketplace]) return this.settings[this.formData.marketplace].developerName;
      return "";
    },
    addJtlIntegrationExplanation: function addJtlIntegrationExplanation() {
      return this.$t("addJtlIntegrationExplanation.textBlock");
    },
    hasMarketplaceSelected: function hasMarketplaceSelected() {
      return !!this.formData.marketplace;
    },
    region: function region() {
      return this.settings[this.formData.marketplace].region || "";
    }
  }),
  methods: {
    cancelForm: function cancelForm() {
      this.$emit("cancel-form");
    },
    marketPlaceChanged: function marketPlaceChanged(val) {
      if (val) {
        this.data.region = this.settings[val].region;
        this.data.marketplace = val;
      }
    },
    validateSellerId: function validateSellerId(rule, value, callback) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var reqEx;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(value === "")) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", callback(new Error(_this.$t("sellerId.inputValidation.emptyField.message"))));

              case 2:
                // eslint-disable-next-line no-useless-escape
                reqEx = /[a-zA-Z0-9]{13,15}/;

                if (reqEx.test(value)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", callback(new Error(_this.$t("sellerId.inputValidation.regEx.message"))));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    validateMwsToken: function validateMwsToken(rule, value, callback) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var reqEx;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(value === "")) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", callback(new Error(_this2.$t("mwsToken.inputValidation.emptyField.message"))));

              case 2:
                // eslint-disable-next-line no-useless-escape
                reqEx = /[a-zA-Z0-9\.]{15,20}-[a-zA-Z0-9]{4,5}-[a-zA-Z0-9]{4,5}-[a-zA-Z0-9]{4,5}-[a-zAz0-9\.]{12,13}/gm;

                if (reqEx.test(value)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", callback(new Error(_this2.$t("mwsToken.inputValidation.regEx.message"))));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    saveAuthorization: function saveAuthorization() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var err, res, _yield$to, _yield$to2, thirdPartyAPIError, aliasThirdPartyAPIErrorMessages;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;
                _context3.next = 3;
                return (0,external_await_to_js_.to)(_this3.$http.post("".concat(_this3.apiUrls.dutypay, "/api/v0/markets/add"), {
                  new: _objectSpread2({
                    status: "active"
                  }, _this3.formData),
                  company: _this3.selectedCompany.id,
                  type: "jtl"
                }));

              case 3:
                _yield$to = _context3.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];
                _this3.loading = false;

                if (!err) {
                  _context3.next = 13;
                  break;
                }

                _this3.errormessage.title = _this3.$t("saveAuthorization.notification.asyncError.title");
                thirdPartyAPIError = get_default()(err, "response.data.message", undefined);

                if (thirdPartyAPIError !== undefined) {
                  // eslint-disable-next-line no-unused-vars
                  aliasThirdPartyAPIErrorMessages = [_this3.$t("saveAuthorization.notification.asyncError.markets.add.companyRequired.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.typeRequired.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.newMissing.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.sellerIdRequired.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.notUnique.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mwsAuthorizationTokenRequired.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mws.getReportRequestListError.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mws.getReportError.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mws.listMarketplaceParticipationsError.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mws.ordersError.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mws.addSecret.message"), _this3.$t("saveAuthorization.notification.asyncError.markets.add.mws.addtoDB.message")];
                  _this3.errormessage.message = _this3.$t("saveAuthorization.notification.asyncError.".concat(thirdPartyAPIError, ".message"));
                } else {
                  _this3.errormessage.message = _this3.$t("saveAuthorization.notification.asyncError.message");
                }

                throw err;

              case 13:
                //this.emitVisibility(false);
                _this3.cancelForm();

                mitt.emit("integrations-jtl-authorization-saved");
                return _context3.abrupt("return", res);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    fetchSellerInfo: throttle_default()( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var err, res, _yield$to3, _yield$to4;

      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0,external_await_to_js_.to)(this.$http.get("".concat(this.apiUrls.dutypay, "/api/v0/markets/sellerid/mws/").concat(this.region.toLowerCase(), "/").concat(this.formData.sellerId)));

            case 2:
              _yield$to3 = _context4.sent;
              _yield$to4 = _slicedToArray(_yield$to3, 2);
              err = _yield$to4[0];
              res = _yield$to4[1];

              if (!err) {
                _context4.next = 8;
                break;
              }

              throw err;

            case 8:
              this.sellerInfo = res.data;

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    })), 1500),
    fetchSettings: function fetchSettings() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var err, res, _yield$to5, _yield$to6;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.loading = true;
                _context5.next = 3;
                return (0,external_await_to_js_.to)(_this4.$http.get("".concat(_this4.apiUrls.dutypay, "/api/v0/markets/settings/jtl")));

              case 3:
                _yield$to5 = _context5.sent;
                _yield$to6 = _slicedToArray(_yield$to5, 2);
                err = _yield$to6[0];
                res = _yield$to6[1];
                _this4.loading = false;

                if (!err) {
                  _context5.next = 11;
                  break;
                }

                _this4.$notify.error({
                  title: _this4.$t("fetchSettings.notification.asyncError.title"),
                  message: _this4.$t("fetchSettings.notification.asyncError.message")
                });

                throw err;

              case 11:
                if (get_default()(res, "data.result", undefined) !== undefined) _this4.settings = res.data.result;

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this5.fetchSettings();

            case 2:
              _this5.allreports = _this5.settings.allreports;
              if (_this5.filledFormData !== undefined) _this5.formData = _this5.filledFormData;else _this5.formData.reports = map_default()(_this5.settings.allreports, "name");

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }
};

/* harmony default export */ var JtlIntegration_AddAuthorizationFormvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(JtlIntegration_AddAuthorizationFormvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_el_date_picker = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-date-picker");

      var _component_el_form_item = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-form-item");

      var _component_el_checkbox = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-checkbox");

      var _component_el_checkbox_group = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-checkbox-group");

      var _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_DpForm = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpForm");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpForm, {
        modelValue: _ctx.formData,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(formData) ? formData.value = $event : null;
        }),
        reference: "add-jtl-authorization",
        action: _ctx.saveAuthorization,
        notificationAsyncError: _objectSpread2({}, _ctx.errormessage),
        "primary-button-label": _ctx.formData.id ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('updateAuthorization.buttonLabel') : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('addAuthorization.buttonLabel')
      }, {
        secondaryButton: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            purpose: "secondaryAction",
            onClick: _ctx.cancelForm
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("cancelButton.buttonLabel")), 1)];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
            class: "text-block",
            innerHTML: _ctx.addJtlIntegrationExplanation.content,
            style: {
              "margin-bottom": "1em"
            }
          }, null, 8, JtlIntegration_AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form_item, {
            label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('startDate.label')
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_date_picker, {
                modelValue: _ctx.formData.startDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.formData.startDate = $event;
                }),
                type: "date",
                placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('startDate.placeholder')
              }, null, 8, ["modelValue", "placeholder"])];
            }),
            _: 1
          }, 8, ["label"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form_item, {
                label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('reports.label')
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_checkbox_group, {
                    modelValue: _ctx.formData.reports,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return _ctx.formData.reports = $event;
                    })
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.allreports, function (item) {
                        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_checkbox, {
                          key: item.name,
                          label: item.name
                        }, {
                          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                            return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(item.label), 1)];
                          }),
                          _: 2
                        }, 1032, ["label"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }, 8, ["label"])];
            }),
            _: 1
          }), JtlIntegration_AddAuthorizationFormvue_type_script_setup_true_lang_js_hoisted_2];
        }),
        _: 1
      }, 8, ["modelValue", "action", "notificationAsyncError", "primary-button-label"])), [[_directive_loading, _ctx.loading]]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/JtlIntegration/AddAuthorizationForm.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-66.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-66.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-66.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-66.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/JtlIntegration/AddAuthorizationForm.vue?vue&type=style&index=0&id=6862a046&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/JtlIntegration/AddAuthorizationForm.vue?vue&type=style&index=0&id=6862a046&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/JtlIntegration/AddAuthorizationForm.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function JtlIntegration_AddAuthorizationFormvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorisierung hinzufügen"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        }
      },
      "de-AT": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorisierung hinzufügen"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        }
      },
      "de-CH": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorisierung hinzufügen"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        }
      },
      "en-US": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add authorization"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        }
      },
      "en-GB": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add authorization"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        }
      },
      "it-IT": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aggiungi autorizzazione"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])}
        }
      },
      "fr-FR": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter une autorisation"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        }
      },
      "es-ES": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar autorización"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        }
      },
      "pl-PL": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj autoryzację"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
        }
      },
      "nl-NL": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Autorisatie toevoegen"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afbreken"])}
        }
      },
      "bg-BG": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавете упълномощаване"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прекратяване"])}
        }
      },
      "bs-BA": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodajte autorizaciju"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        }
      },
      "zh-CN": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["添加授权"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中止"])}
        }
      },
      "da-DK": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilføj autorisation"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        }
      },
      "et-EE": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lisage autoriseerimine"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Katkesta"])}
        }
      },
      "fi-FI": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lisää valtuutus"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keskeyttää"])}
        }
      },
      "el-GR": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προσθέστε εξουσιοδότηση"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Άκυρο"])}
        }
      },
      "he-IL": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הוסף הרשאה"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפִּיל"])}
        }
      },
      "ga-IE": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir údarú leis"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ginmhilleadh"])}
        }
      },
      "ja-JP": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["承認を追加する"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アボート"])}
        }
      },
      "hr-HR": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodajte autorizaciju"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekid"])}
        }
      },
      "lv-LV": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pievienot autorizāciju"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pārtraukt"])}
        }
      },
      "lt-LT": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pridėti prieigos teisę"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutraukti"])}
        }
      },
      "pt-PT": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adicionar autorização"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abortar"])}
        }
      },
      "ro-RO": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adăugați autorizație"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abandonați"])}
        }
      },
      "ru-RU": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавить авторизацию"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прервать"])}
        }
      },
      "sv-SE": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lägg till auktorisering"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avbryta"])}
        }
      },
      "sk-SK": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pridajte oprávnenie"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        }
      },
      "cs-CZ": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přidat oprávnění"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přerušit"])}
        }
      },
      "tr-TR": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yetki ekle"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        }
      },
      "hu-HU": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Engedély hozzáadása"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mégse"])}
        }
      },
      "ar-AE": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أضف الإذن"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إحباط"])}
        }
      },
      "fr-BE": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter une autorisation"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        }
      },
      "fr-LU": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter une autorisation"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        }
      },
      "mt-MT": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żid l-awtorizzazzjoni"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkanċella"])}
        }
      },
      "sl-SI": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodajte pooblastilo"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        }
      },
      "el-CY": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προσθέστε εξουσιοδότηση"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Άκυρο"])}
        }
      },
      "tr-CY": {
        "addAuthorization": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yetki ekle"])}
        },
        "cancelButton": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/JtlIntegration/AddAuthorizationForm.vue



;
/* custom blocks */

if (typeof JtlIntegration_AddAuthorizationFormvue_type_custom_index_0_blockType_i18n === 'function') JtlIntegration_AddAuthorizationFormvue_type_custom_index_0_blockType_i18n(JtlIntegration_AddAuthorizationFormvue_type_script_setup_true_lang_js)


;
const JtlIntegration_AddAuthorizationForm_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(JtlIntegration_AddAuthorizationFormvue_type_script_setup_true_lang_js, [['__scopeId',"data-v-6862a046"]])

/* harmony default export */ var JtlIntegration_AddAuthorizationForm = (JtlIntegration_AddAuthorizationForm_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/JtlIntegration/ListJtlAuthorizations.vue?vue&type=script&setup=true&lang=js










var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_withScopeId = function _withScopeId(n) {
  return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.pushScopeId)("data-v-2e26c34f"), n = n(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.popScopeId)(), n;
};

var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 0,
  class: "dp-color__font__success"
};

var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_2 = /*#__PURE__*/ListJtlAuthorizationsvue_type_script_setup_true_lang_js_withScopeId(function () {
  return /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
    class: "el-icon-success"
  })], -1);
});

var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_3 = {
  style: {
    "margin": "0 0.5em"
  }
};
var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_4 = {
  key: 1,
  class: "dp-color__font__info"
};

var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_5 = /*#__PURE__*/ListJtlAuthorizationsvue_type_script_setup_true_lang_js_withScopeId(function () {
  return /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
    class: "el-icon-remove"
  })], -1);
});

var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_6 = {
  style: {
    "margin": "0 0.5em"
  }
};
var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_7 = {
  key: 2,
  class: "dp-color__font__danger"
};

var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_8 = /*#__PURE__*/ListJtlAuthorizationsvue_type_script_setup_true_lang_js_withScopeId(function () {
  return /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [/*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("i", {
    class: "el-icon-warning"
  })], -1);
});

var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_9 = {
  style: {
    "margin": "0 0.5em"
  }
};
var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_10 = {
  class: "dp-flex wrap"
};
var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_11 = {
  class: "history"
};

var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_12 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)();

var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_13 = {
  key: 0
};
var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_14 = {
  key: 1
};











var ListJtlAuthorizationsvue_type_script_setup_true_lang_js_default_ = {
  name: "ListJtlAuthorizations",
  components: {
    AddAuthorizationForm: JtlIntegration_AddAuthorizationForm
  },
  data: function data() {
    return {
      loadingDownload: false,
      authorizations: [],
      loading: false,
      removeAuthorizationSlot: [],
      refreshCredentialsSlot: [],
      authorizationLoading: {},
      gsettings: null
    };
  },
  computed: _objectSpread2(_objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ["apiUrls", "debug"])), (0,external_pinia_.mapState)(store_modules_.useCompanyStore, ["selectedCompany"])), {}, {
    isEmpty: function isEmpty() {
      return (isEmpty_default());
    },
    map: function map() {
      return (map_default());
    },
    each: function each() {
      return (each_default());
    }
  }),
  methods: {
    initiateSlots: function initiateSlots() {
      var _this = this;

      var keys = Object.keys(this.authorizations);

      each_default()(keys, function (key) {
        _this.removeAuthorizationSlot[key] = false;
        _this.refreshCredentialsSlot[key] = false;
        _this.authorizationLoading[key] = false;
      });
    },
    cancelForm: function cancelForm(index) {
      this.refreshCredentialsSlot[index] = false;
    },
    downloadSetUpFile: function downloadSetUpFile(fn) {
      window.open(fn, "_blank");
    },
    fetchAuthorizations: function fetchAuthorizations() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var err, res, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.apiUrls) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this2.loading = true;
                _context.next = 5;
                return (0,external_await_to_js_.to)(_this2.$http.get("".concat(_this2.apiUrls.dutypay, "/api/v0/markets/").concat(_this2.selectedCompany.id, "/jtl")));

              case 5:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];
                _this2.loading = false;

                if (!err) {
                  _context.next = 12;
                  break;
                }

                throw err;

              case 12:
                _this2.authorizations = filter_default()(get_default()(res, "data.marketplaces", []), function (authorization) {
                  return authorization.status !== "deleted";
                });
                if (_this2.authorizations.length > 0 && (_this2.authorizations.length !== Object.keys(_this2.removeAuthorizationSlot).length || _this2.authorizations.length !== Object.keys(_this2.refreshCredentialsSlot).length || _this2.authorizations.length !== Object.keys(_this2.authorizationLoading).length)) _this2.initiateSlots();else {
                  _this2.$emit("empty-results");
                }

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    updateAuthorization: function updateAuthorization(index) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var err, res, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0,external_await_to_js_.to)(_this3.$http.patch("".concat(_this3.apiUrls.dutypay, "/api/v0/markets/").concat(_this3.selectedCompany.id, "/jtl"), _this3.authorizations[index]));

              case 2:
                _yield$to3 = _context2.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 2);
                err = _yield$to4[0];
                res = _yield$to4[1];

                if (!err) {
                  _context2.next = 8;
                  break;
                }

                throw err;

              case 8:
                return _context2.abrupt("return", res);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    pauseAuthorization: function pauseAuthorization(index) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.authorizationLoading[index] = true;
                _this4.authorizations[index].status = "paused";
                _context3.next = 4;
                return _this4.updateAuthorization(index);

              case 4:
                _this4.authorizationLoading[index] = false;

                _this4.$notify.success({
                  title: _this4.$t("pauseAuthorization.notification.success.title"),
                  message: _this4.$t("pauseAuthorization.notification.success.message")
                });

                _context3.next = 8;
                return _this4.fetchAuthorizations();

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    resumeAuthorization: function resumeAuthorization(index) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.authorizationLoading[index] = true;
                _this5.authorizations[index].status = "active";
                _context4.next = 4;
                return _this5.updateAuthorization(index);

              case 4:
                _this5.authorizationLoading[index] = false;

                _this5.$notify.success({
                  title: _this5.$t("resumeAuthorization.notification.success.title"),
                  message: _this5.$t("resumeAuthorization.notification.success.message")
                });

                _context4.next = 8;
                return _this5.fetchAuthorizations();

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    refreshAuthorization: function refreshAuthorization(index) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.refreshCredentialsSlot[index] = true;

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    setSlot: function setSlot(name, index, val) {
      this[name][index] = val;
    },
    removeAuthorization2: function removeAuthorization2(index) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.removeAuthorizationSlot[index] = true;

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    removeAuthorization: function removeAuthorization(index) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var res;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this8.authorizationLoading[index] = true;
                _this8.authorizations[index].status = "deleted";
                _context7.next = 4;
                return _this8.updateAuthorization(index);

              case 4:
                res = _context7.sent;
                _this8.authorizationLoading[index] = false;
                _context7.next = 8;
                return _this8.fetchAuthorizations();

              case 8:
                return _context7.abrupt("return", res);

              case 9:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var self;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              self = _this9;
              mitt.on("integrations-jtl-authorization-saved", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        _context8.next = 2;
                        return _this9.fetchAuthorizations();

                      case 2:
                        self.$emit("cancel-form");

                      case 3:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              })));
              mitt.on("update-settings", /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(data) {
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          if (data) {
                            self.gsettings = data;
                          }

                        case 1:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
              _context10.next = 5;
              return _this9.fetchAuthorizations();

            case 5:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }))();
  }
};


/* harmony default export */ var ListJtlAuthorizationsvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(ListJtlAuthorizationsvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    var composables = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.inject)('composables');

    var _composables$useViewp = composables.useViewportSize(),
        isMobile = _composables$useViewp.isMobile;

    return function (_ctx, _cache) {
      var _component_DpCopyToClipboard = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCopyToClipboard");

      var _component_DpReadValue = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpReadValue");

      var _component_DpIcon = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpIcon");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse");

      var _component_DpFeedforward = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFeedforward");

      var _component_DpFormConfirmDeletion = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFormConfirmDeletion");

      var _component_DpListItem = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpListItem");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.authorizations, function (authorization, index) {
        return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpListItem, {
          key: "jtl-authorizations-".concat(index),
          style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
            borderColor: authorization.status === 'inactive' ? '#FF4949' : ''
          })
        }, {
          headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
            return [authorization.status === 'active' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_1, [ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_2, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_3, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("status.active.label")), 1)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), authorization.status === 'paused' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_4, [ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_5, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_6, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("status.paused.label")), 1)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), authorization.status === 'inactive' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_7, [ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_8, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_9, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("status.inactive.label")), 1)])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)];
          }),
          default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
            return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
                  class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["dp-flex row justify-content__space-between align-items__flex-start", {
                    wrap: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
                  }])
                }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_10, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpReadValue, {
                  "data-key": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('token.label'),
                  "data-value": authorization.id,
                  padding: "",
                  inline: ""
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCopyToClipboard, {
                      value: authorization.token,
                      rtl: _ctx.rtl
                    }, {
                      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                        return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(authorization.token), 1)];
                      }),
                      _: 2
                    }, 1032, ["value", "rtl"])];
                  }),
                  _: 2
                }, 1032, ["data-key", "data-value"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpReadValue, {
                  "data-key": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('startDate.label'),
                  "data-value": authorization.startDate,
                  padding: "",
                  inline: ""
                }, null, 8, ["data-key", "data-value"]), !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(authorization.history) ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpReadValue, {
                  key: 0,
                  "data-key": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('history.label'),
                  padding: "",
                  inline: ""
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("ul", ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_11, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(authorization.history, function (historyItem, historyIndex) {
                      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("li", {
                        key: "authorization-".concat(index, "-history-").concat(historyIndex)
                      }, [historyItem.status === 'active' && historyItem._ts ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
                        key: 0
                      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("history.activatedOn.label", {
                        date: _ctx.$dp.dayjs.unix(historyItem._ts).local().format("LLL")
                      })), 1)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), historyItem.status === 'deleted' && historyItem._ts ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
                        key: 1
                      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("history.deletedOn.label", {
                        date: _ctx.$dp.dayjs.unix(historyItem._ts).local().format("LLL")
                      })), 1)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), historyItem.status === 'paused' && historyItem._ts ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, {
                        key: 2
                      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("history.pausedOn.label", {
                        date: _ctx.$dp.dayjs.unix(historyItem._ts).local().format("LLL")
                      })), 1)], 64)) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]);
                    }), 128))])];
                  }),
                  _: 2
                }, 1032, ["data-key"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), !(0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)((isEmpty_default()))(authorization.reports) ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpReadValue, {
                  key: 1,
                  "data-key": (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('reports.label'),
                  padding: "",
                  inline: ""
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.gsettings.allreports, function (report) {
                      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                        key: report.name
                      }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("template", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("span", null, [authorization.reports.indexOf(report.name) > -1 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpIcon, {
                        key: 0,
                        icon: "check",
                        color: "green"
                      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_12, authorization.reports.indexOf(report.name) == -1 ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpIcon, {
                        key: 1,
                        icon: "close",
                        color: "red"
                      })) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)(" " + (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(report.label), 1)])])]);
                    }), 128))];
                  }),
                  _: 2
                }, 1032, ["data-key"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", {
                  class: "dp-flex column align-items__center controls partition depth-1",
                  style: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeStyle)({
                    width: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile) ? '100%' : 'auto'
                  })
                }, [authorization.status === 'active' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_13, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                  purpose: "primary",
                  class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["block full-wdith", {
                    'mobile-button': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
                  }]),
                  onClick: function onClick($event) {
                    return _ctx.pauseAuthorization(index);
                  }
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("pause.buttonLabel")), 1)];
                  }),
                  _: 2
                }, 1032, ["class", "onClick"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), authorization.status === 'paused' ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", ListJtlAuthorizationsvue_type_script_setup_true_lang_js_hoisted_14, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                  purpose: "primary",
                  class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["block full-wdith", {
                    'mobile-button': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
                  }]),
                  onClick: function onClick($event) {
                    return _ctx.resumeAuthorization(index);
                  }
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("resume.buttonLabel")), 1)];
                  }),
                  _: 2
                }, 1032, ["class", "onClick"])])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                  purpose: "primary",
                  class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["block full-wdith", {
                    'mobile-button': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
                  }]),
                  onClick: function onClick($event) {
                    return _ctx.refreshAuthorization(index);
                  }
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("updateSettings.buttonLabel")), 1)];
                  }),
                  _: 2
                }, 1032, ["class", "onClick"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                  purpose: "primary",
                  class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["block full-wdith", {
                    'mobile-button': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
                  }]),
                  onClick: _cache[0] || (_cache[0] = function ($event) {
                    return _ctx.downloadSetUpFile('https://threleases.z1.web.core.windows.net/jtl/JTL2DutyPay.exe');
                  })
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("download.buttonLabel")), 1)];
                  }),
                  _: 1
                }, 8, ["class"])]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                  purpose: "destructive",
                  class: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.normalizeClass)(["block full-wdith", {
                    'mobile-button': (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(isMobile)
                  }]),
                  onClick: function onClick($event) {
                    return _ctx.setSlot('removeAuthorizationSlot', index, true);
                  }
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("remove.buttonLabel")), 1)];
                  }),
                  _: 2
                }, 1032, ["class", "onClick"])])], 4)], 2)];
              }),
              _: 2
            }, 1536), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, !_ctx.refreshCredentialsSlot[index] && !_ctx.removeAuthorizationSlot[index]]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(JtlIntegration_AddAuthorizationForm), {
                  onCancelForm: function onCancelForm($event) {
                    return _ctx.cancelForm(index);
                  },
                  filledFormData: authorization
                }, null, 8, ["onCancelForm", "filledFormData"])];
              }),
              _: 2
            }, 1536), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.refreshCredentialsSlot[index]]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
              default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpFormConfirmDeletion, {
                  action: function action() {
                    _ctx.removeAuthorization(index);
                  },
                  reference: "authorization-".concat(index, "-remove"),
                  phrase: authorization.id,
                  primaryButtonLabel: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('confirmRemoveAuthorization.buttonLabel'),
                  notificationSuccess: {
                    title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthorization.notification.success.title'),
                    message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthorization.notification.success.message')
                  },
                  notificationAsyncError: {
                    title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthorization.notification.asyncError.title'),
                    message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthorization.notification.asyncError.message')
                  }
                }, {
                  secondaryButton: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
                      purpose: "secondaryAction",
                      onClick: function onClick($event) {
                        return _ctx.setSlot('removeAuthorizationSlot', index, false);
                      }
                    }, {
                      default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                        return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("keepAuthorization.buttonLabel")), 1)];
                      }),
                      _: 2
                    }, 1032, ["onClick"])];
                  }),
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpFeedforward, {
                      title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthorization.feedforward.warning.title'),
                      message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('removeAuthorization.feedforward.warning.message'),
                      type: "danger"
                    }, null, 8, ["title", "message"])];
                  }),
                  _: 2
                }, 1032, ["action", "reference", "phrase", "primaryButtonLabel", "notificationSuccess", "notificationAsyncError"])];
              }),
              _: 2
            }, 1536), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.removeAuthorizationSlot[index]]])];
          }),
          _: 2
        }, 1032, ["style"])), [[_directive_loading, _ctx.authorizationLoading[index]]]);
      }), 128))]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/JtlIntegration/ListJtlAuthorizations.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-66.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-66.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-66.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-66.use[3]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/JtlIntegration/ListJtlAuthorizations.vue?vue&type=style&index=0&id=2e26c34f&scoped=true&lang=scss
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/JtlIntegration/ListJtlAuthorizations.vue?vue&type=style&index=0&id=2e26c34f&scoped=true&lang=scss

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/JtlIntegration/ListJtlAuthorizations.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function ListJtlAuthorizationsvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pausiert"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationseinstellungen"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pausieren"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationstool herunterladen"])}
        }
      },
      "de-AT": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pausiert"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationseinstellungen"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pausieren"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationstool herunterladen"])}
        }
      },
      "de-CH": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pausiert"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationseinstellungen"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Löschen"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivieren"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pausieren"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationstool herunterladen"])}
        }
      },
      "en-US": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paused"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integration settings"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pause"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download integration tool"])}
        }
      },
      "en-GB": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paused"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integration Settings"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Delete"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activate"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pause"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download integration tool"])}
        }
      },
      "it-IT": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In pausa"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni di integrazione"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elimina"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pausa"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scarica lo strumento di integrazione"])}
        }
      },
      "fr-FR": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En pause"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'intégration"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pause"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Télécharger l'outil d'intégration"])}
        }
      },
      "es-ES": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activada"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pausado"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de integración"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activar"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pausa"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descarga la herramienta de integración"])}
        }
      },
      "pl-PL": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowano"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wstrzymano"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia integracji"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usunąć"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywuj"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pauza"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pobierz narzędzie do integracji"])}
        }
      },
      "nl-NL": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Onderbroken"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integratie-instellingen"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verwijderen"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activeren"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pauze"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integratietool downloaden"])}
        }
      },
      "bg-BG": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирано"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["На пауза"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки за интеграция"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изтрий"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активиране"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пауза"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изтеглете инструмента за интеграция"])}
        }
      },
      "bs-BA": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pauzirano"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke integracije"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbriši"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirajte"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pauza"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preuzmite alat za integraciju"])}
        }
      },
      "zh-CN": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已激活"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已暂停"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["集成设置"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["激活"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["暂停"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下载集成工具"])}
        }
      },
      "da-DK": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveret"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pauset"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationsindstillinger"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Slet"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivér"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pause"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hent integrationsværktøj"])}
        }
      },
      "et-EE": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeritud"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Peatatud"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integreerimise seaded"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kustuta"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeri"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paus"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Laadige alla integreerimistööriist"])}
        }
      },
      "fi-FI": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoitu"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keskeytetty"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrointiasetukset"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poistaa"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoi"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tauko"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lataa integrointityökalu"])}
        }
      },
      "el-GR": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σε παύση"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ενοποίησης"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγράφω"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παύση"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λήψη εργαλείου ενοποίησης"])}
        }
      },
      "he-IL": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מופעל"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מושהית"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות שילוב"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לִמְחוֹק"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפְעִיל"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הַפסָקָה"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הורד את כלי האינטגרציה"])}
        }
      },
      "ga-IE": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaithe"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ar sos"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe comhtháthaithe"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scrios"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaigh"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sos"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Íoslódáil uirlis comhtháthaithe"])}
        }
      },
      "ja-JP": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティブ化"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一時停止"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["統合設定"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["削除"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティベート"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ブレーク"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["統合ツールをダウンロードする"])}
        }
      },
      "hr-HR": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zastao"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke integracije"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbrisati"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviraj"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pauza"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Preuzmite alat za integraciju"])}
        }
      },
      "lv-LV": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēts"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pārtraukta"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrācijas iestatījumi"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dzēst"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēt"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pauze"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lejupielādējiet integrācijas rīku"])}
        }
      },
      "lt-LT": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinta"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pristabdyta"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integravimo parametrai"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ištrinti"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinti"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pauzė"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atsisiųskite integravimo įrankį"])}
        }
      },
      "pt-PT": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativado"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Em pausa"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações de integração"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Excluir"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativar"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pausa"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Baixar ferramenta de integração"])}
        }
      },
      "ro-RO": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activat"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Întrerupt"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări de integrare"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Șterge"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activare"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pauză"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descărcați instrumentul de integrare"])}
        }
      },
      "ru-RU": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировано"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приостановлено"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки интеграции"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Удаление"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировать"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пауза"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скачать инструмент интеграции"])}
        }
      },
      "sv-SE": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiverad"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pausad"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationsinställningar"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Radera"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivera"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paus"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ladda ner integrationsverktyg"])}
        }
      },
      "sk-SK": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivované"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pozastavené"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia integrácie"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odstrániť"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovať"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pauza"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stiahnite si integračný nástroj"])}
        }
      },
      "cs-CZ": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivováno"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pozastaveno"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení integrace"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vymazat"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivovat"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pauza"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stáhněte si integrační nástroj"])}
        }
      },
      "tr-TR": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duraklatıldı"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entegrasyon ayarları"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sil"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştir"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duraklat"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entegrasyon aracını indirin"])}
        }
      },
      "hu-HU": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivált"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szüneteltetve"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrációs beállítások"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Töröl"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiválja"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szünet"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Töltse le az integrációs eszközt"])}
        }
      },
      "ar-AE": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["متوقف مؤقتًا"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات التكامل"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حذف"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تفعيل"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يوقف"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنزيل أداة التكامل"])}
        }
      },
      "fr-BE": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En pause"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'intégration"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pause"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Télécharger l'outil d'intégration"])}
        }
      },
      "fr-LU": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En pause"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'intégration"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Effacer"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pause"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Télécharger l'outil d'intégration"])}
        }
      },
      "mt-MT": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivat"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Waqaf"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is-settings tal-integrazzjoni"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ħassar"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attiva"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nieqaf"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Niżżel l-għodda ta 'integrazzjoni"])}
        }
      },
      "sl-SI": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Začasno ustavljeno"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve integracije"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izbriši"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviraj"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pavza"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prenesite orodje za integracijo"])}
        }
      },
      "el-CY": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Σε παύση"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ενοποίησης"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαγράφω"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποίηση"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Παύση"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Λήψη εργαλείου ενοποίησης"])}
        }
      },
      "tr-CY": {
        "status": {
          "active": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
          },
          "paused": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duraklatıldı"])}
          }
        },
        "updateSettings": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entegrasyon ayarları"])}
        },
        "remove": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sil"])}
        },
        "resume": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştir"])}
        },
        "pause": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Duraklat"])}
        },
        "download": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entegrasyon aracını indirin"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/JtlIntegration/ListJtlAuthorizations.vue



;
/* custom blocks */

if (typeof ListJtlAuthorizationsvue_type_custom_index_0_blockType_i18n === 'function') ListJtlAuthorizationsvue_type_custom_index_0_blockType_i18n(ListJtlAuthorizationsvue_type_script_setup_true_lang_js)


;
const ListJtlAuthorizations_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(ListJtlAuthorizationsvue_type_script_setup_true_lang_js, [['__scopeId',"data-v-2e26c34f"]])

/* harmony default export */ var ListJtlAuthorizations = (ListJtlAuthorizations_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/JtlIntegration.vue?vue&type=script&setup=true&lang=js






var JtlIntegrationvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 0
};
var JtlIntegrationvue_type_script_setup_true_lang_js_hoisted_2 = {
  class: "add-authorization-form"
};







var JtlIntegrationvue_type_script_setup_true_lang_js_default_ = {
  name: "JtlIntegration",
  components: {
    AddAuthorizationForm: JtlIntegration_AddAuthorizationForm,
    ListJtlAuthorizations: ListJtlAuthorizations
  },
  data: function data() {
    return {
      showFormAddNew: false,
      settings: {}
    };
  },
  computed: _objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ["apiUrls", "debug"])),
  methods: {
    fetchSettings: function fetchSettings() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var err, res, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return (0,external_await_to_js_.to)(_this.$http.get("".concat(_this.apiUrls.dutypay, "/api/v0/markets/settings/jtl")));

              case 3:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];
                _this.loading = false;

                if (!err) {
                  _context.next = 11;
                  break;
                }

                _this.$notify.error({
                  title: _this.$t("fetchSettings.notification.asyncError.title"),
                  message: _this.$t("fetchSettings.notification.asyncError.message")
                });

                throw err;

              case 11:
                if (get_default()(res, "data.result", undefined) !== undefined) {
                  _this.settings = res.data.result;
                  mitt.emit("update-settings", _this.settings);
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.fetchSettings();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};

/* harmony default export */ var JtlIntegrationvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(JtlIntegrationvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_DpCollapse = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCollapse");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h3", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("jtlIntegration.title")), 1), !_ctx.showFormAddNew ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", JtlIntegrationvue_type_script_setup_true_lang_js_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
        purpose: "primary",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.showFormAddNew = true;
        })
      }, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("addNew.buttonLabel")), 1)];
        }),
        _: 1
      })])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCollapse, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", JtlIntegrationvue_type_script_setup_true_lang_js_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h3", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("addJtlAuthorization.title")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(JtlIntegration_AddAuthorizationForm), {
            onCancelForm: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.showFormAddNew = false;
            })
          })])];
        }),
        _: 1
      }, 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, _ctx.showFormAddNew]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(ListJtlAuthorizations), {
        onEmptyResults: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.showFormAddNew = true;
        })
      })]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/JtlIntegration.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings/JtlIntegration.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function JtlIntegrationvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL Integration"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hinzufügen"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL Integration hinzufügen"])}
        }
      },
      "de-AT": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL Integration"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hinzufügen"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL Integration hinzufügen"])}
        }
      },
      "de-CH": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL Integration"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hinzufügen"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL Integration hinzufügen"])}
        }
      },
      "en-US": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integration"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add JTL integration"])}
        }
      },
      "en-GB": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integration"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add JTL integration"])}
        }
      },
      "it-IT": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrazione JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aggiungi integrazione JTL"])}
        }
      },
      "fr-FR": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intégration JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter l'intégration JTL"])}
        }
      },
      "es-ES": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integración JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar integración JTL"])}
        }
      },
      "pl-PL": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integracja JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj integrację JTL"])}
        }
      },
      "nl-NL": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL-integratie"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toevoegen"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL-integratie toevoegen"])}
        }
      },
      "bg-BG": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL интеграция"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавяне"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавете JTL интеграция"])}
        }
      },
      "bs-BA": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integracija"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodati"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodajte JTL integraciju"])}
        }
      },
      "zh-CN": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL集成"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["添加"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["添加 JTL 集成"])}
        }
      },
      "da-DK": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integration"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilføje"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilføj JTL-integration"])}
        }
      },
      "et-EE": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integratsioon"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lisama"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lisa JTL-i integratsioon"])}
        }
      },
      "fi-FI": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL-integraatio"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lisätä"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lisää JTL-integraatio"])}
        }
      },
      "el-GR": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενσωμάτωση JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προσθήκη"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προσθήκη ενσωμάτωσης JTL"])}
        }
      },
      "he-IL": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אינטגרציה של JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהוֹסִיף"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הוסף שילוב JTL"])}
        }
      },
      "ga-IE": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comhtháthú JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir leis"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuir comhtháthú JTL leis"])}
        }
      },
      "ja-JP": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL統合"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["追加"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL統合を追加する"])}
        }
      },
      "hr-HR": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integracija"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodati"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodajte JTL integraciju"])}
        }
      },
      "lv-LV": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integrācija"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pievienot"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pievienojiet JTL integrāciju"])}
        }
      },
      "lt-LT": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integracija"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Papildyti"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pridėti JTL integraciją"])}
        }
      },
      "pt-PT": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integração JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adicionar"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adicionar integração JTL"])}
        }
      },
      "ro-RO": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrarea JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adăuga"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adăugați integrarea JTL"])}
        }
      },
      "ru-RU": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Интеграция JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавлять"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добавить интеграцию с JTL"])}
        }
      },
      "sv-SE": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integration"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lägg till"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lägg till JTL-integration"])}
        }
      },
      "sk-SK": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integrácia"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pridať"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pridajte integráciu JTL"])}
        }
      },
      "cs-CZ": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrace JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přidat"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přidejte integraci JTL"])}
        }
      },
      "tr-TR": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL entegrasyonu"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ekle"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL entegrasyonu ekleyin"])}
        }
      },
      "hu-HU": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integráció"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hozzáadás"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integráció hozzáadása"])}
        }
      },
      "ar-AE": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تكامل JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يضيف"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أضف تكامل JTL"])}
        }
      },
      "fr-BE": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intégration JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter l'intégration JTL"])}
        }
      },
      "fr-LU": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intégration JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajouter l'intégration JTL"])}
        }
      },
      "mt-MT": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrazzjoni JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żid"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Żid l-integrazzjoni JTL"])}
        }
      },
      "sl-SI": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL integracija"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodaj"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodajte integracijo JTL"])}
        }
      },
      "el-CY": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενσωμάτωση JTL"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προσθήκη"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προσθήκη ενσωμάτωσης JTL"])}
        }
      },
      "tr-CY": {
        "jtlIntegration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL entegrasyonu"])}
        },
        "addNew": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ekle"])}
        },
        "addJtlAuthorization": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["JTL entegrasyonu ekleyin"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings/JtlIntegration.vue


/* custom blocks */
;
if (typeof JtlIntegrationvue_type_custom_index_0_blockType_i18n === 'function') JtlIntegrationvue_type_custom_index_0_blockType_i18n(JtlIntegrationvue_type_script_setup_true_lang_js)


const JtlIntegration_exports_ = JtlIntegrationvue_type_script_setup_true_lang_js;

/* harmony default export */ var JtlIntegration = (JtlIntegration_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings.vue?vue&type=script&setup=true&lang=js




var IntegrationSettingsvue_type_script_setup_true_lang_js_default_ = {
  name: "IntegrationSettings",
  components: {
    AmazonIntegration: AmazonIntegration,
    JtlIntegration: JtlIntegration
  }
};

/* harmony default export */ var IntegrationSettingsvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(IntegrationSettingsvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_DpPageSection = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpPageSection");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('integrations.title')), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpPageSection, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(AmazonIntegration)), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(JtlIntegration))];
        }),
        _: 1
      })]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/IntegrationSettings.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function IntegrationSettingsvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationseinstellungen"])}
        }
      },
      "de-AT": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationseinstellungen"])}
        }
      },
      "de-CH": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationseinstellungen"])}
        }
      },
      "en-US": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integration settings"])}
        }
      },
      "en-GB": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integration Settings"])}
        }
      },
      "it-IT": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni di integrazione"])}
        }
      },
      "fr-FR": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'intégration"])}
        }
      },
      "es-ES": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de integración"])}
        }
      },
      "pl-PL": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia integracji"])}
        }
      },
      "nl-NL": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integratie-instellingen"])}
        }
      },
      "bg-BG": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки за интеграция"])}
        }
      },
      "bs-BA": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke integracije"])}
        }
      },
      "zh-CN": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["集成设置"])}
        }
      },
      "da-DK": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationsindstillinger"])}
        }
      },
      "et-EE": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integreerimise seaded"])}
        }
      },
      "fi-FI": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrointiasetukset"])}
        }
      },
      "el-GR": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ενοποίησης"])}
        }
      },
      "he-IL": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות שילוב"])}
        }
      },
      "ga-IE": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe comhtháthaithe"])}
        }
      },
      "ja-JP": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["統合設定"])}
        }
      },
      "hr-HR": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke integracije"])}
        }
      },
      "lv-LV": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrācijas iestatījumi"])}
        }
      },
      "lt-LT": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integravimo parametrai"])}
        }
      },
      "pt-PT": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações de integração"])}
        }
      },
      "ro-RO": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări de integrare"])}
        }
      },
      "ru-RU": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки интеграции"])}
        }
      },
      "sv-SE": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrationsinställningar"])}
        }
      },
      "sk-SK": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia integrácie"])}
        }
      },
      "cs-CZ": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení integrace"])}
        }
      },
      "tr-TR": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entegrasyon ayarları"])}
        }
      },
      "hu-HU": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Integrációs beállítások"])}
        }
      },
      "ar-AE": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات التكامل"])}
        }
      },
      "fr-BE": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'intégration"])}
        }
      },
      "fr-LU": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres d'intégration"])}
        }
      },
      "mt-MT": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is-settings tal-integrazzjoni"])}
        }
      },
      "sl-SI": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve integracije"])}
        }
      },
      "el-CY": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις ενοποίησης"])}
        }
      },
      "tr-CY": {
        "integrations": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entegrasyon ayarları"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/CompanySettings/IntegrationSettings.vue


/* custom blocks */
;
if (typeof IntegrationSettingsvue_type_custom_index_0_blockType_i18n === 'function') IntegrationSettingsvue_type_custom_index_0_blockType_i18n(IntegrationSettingsvue_type_script_setup_true_lang_js)


const IntegrationSettings_exports_ = IntegrationSettingsvue_type_script_setup_true_lang_js;

/* harmony default export */ var IntegrationSettings = (IntegrationSettings_exports_);
;// CONCATENATED MODULE: ./src/routes/companySettingsRoutes.js


var companySettingsRoutes = [{
  path: '/company-settings',
  component: CompanySettings,
  children: [{
    path: 'integrations',
    component: IntegrationSettings
  }]
}];
/* harmony default export */ var routes_companySettingsRoutes = (companySettingsRoutes);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AdminSettings.vue?vue&type=script&setup=true&lang=js



var AdminSettingsvue_type_script_setup_true_lang_js_hoisted_1 = {
  key: 1
};



var AdminSettingsvue_type_script_setup_true_lang_js_default_ = {
  name: 'AdminSettings',
  computed: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useAuthStore, ['user'])), {}, {
    renderAdminSettings: function renderAdminSettings() {
      return findIndex_default()(this.user.roles, function (item) {
        return item === 'global:admin';
      }) !== -1;
    }
  })
};

/* harmony default export */ var AdminSettingsvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(AdminSettingsvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_router_view = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("router-view");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h1", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('adminSettings.title')), 1), _ctx.renderAdminSettings ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_router_view, {
        key: 0
      })) : ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("p", AdminSettingsvue_type_script_setup_true_lang_js_hoisted_1, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('noPermission.label')), 1))]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AdminSettings.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AdminSettings.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function AdminSettingsvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratoreinstellungen"])}
        }
      },
      "de-AT": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratoreinstellungen"])}
        }
      },
      "de-CH": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratoreinstellungen"])}
        }
      },
      "en-US": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrator settings"])}
        }
      },
      "en-GB": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrator settings"])}
        }
      },
      "it-IT": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni amministratore"])}
        }
      },
      "fr-FR": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres administrateur"])}
        }
      },
      "es-ES": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuraciones de administrador"])}
        }
      },
      "pl-PL": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia administratora"])}
        }
      },
      "nl-NL": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beheerdersinstellingen"])}
        }
      },
      "bg-BG": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки на администратора"])}
        }
      },
      "bs-BA": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke administratora"])}
        }
      },
      "zh-CN": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管理员设置"])}
        }
      },
      "da-DK": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratorindstillinger"])}
        }
      },
      "et-EE": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administraatori seaded"])}
        }
      },
      "fi-FI": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Järjestelmänvalvojan asetukset"])}
        }
      },
      "el-GR": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις διαχειριστή"])}
        }
      },
      "he-IL": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות מנהל"])}
        }
      },
      "ga-IE": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe riarthóra"])}
        }
      },
      "ja-JP": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["管理者設定"])}
        }
      },
      "hr-HR": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke administratora"])}
        }
      },
      "lv-LV": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratora iestatījumi"])}
        }
      },
      "lt-LT": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratoriaus nustatymai"])}
        }
      },
      "pt-PT": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações de administrador"])}
        }
      },
      "ro-RO": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări administrator"])}
        }
      },
      "ru-RU": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки администратора"])}
        }
      },
      "sv-SE": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administratörsinställningar"])}
        }
      },
      "sk-SK": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia správcu"])}
        }
      },
      "cs-CZ": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení správce"])}
        }
      },
      "tr-TR": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yönetici ayarları"])}
        }
      },
      "hu-HU": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rendszergazda beállításai"])}
        }
      },
      "ar-AE": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات المسؤول"])}
        }
      },
      "fr-BE": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres administrateur"])}
        }
      },
      "fr-LU": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres administrateur"])}
        }
      },
      "mt-MT": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Is-settings tal-amministratur"])}
        }
      },
      "sl-SI": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve skrbnika"])}
        }
      },
      "el-CY": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις διαχειριστή"])}
        }
      },
      "tr-CY": {
        "adminSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yönetici ayarları"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AdminSettings.vue


/* custom blocks */
;
if (typeof AdminSettingsvue_type_custom_index_0_blockType_i18n === 'function') AdminSettingsvue_type_custom_index_0_blockType_i18n(AdminSettingsvue_type_script_setup_true_lang_js)


const AdminSettings_exports_ = AdminSettingsvue_type_script_setup_true_lang_js;

/* harmony default export */ var AdminSettings = (AdminSettings_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AdminSettings/CompanyAdministration.vue?vue&type=script&setup=true&lang=js







var CompanyAdministrationvue_type_script_setup_true_lang_js_hoisted_1 = {
  class: "partition depth-1"
};
var CompanyAdministrationvue_type_script_setup_true_lang_js_hoisted_2 = {
  style: {
    "margin-top": "1rem",
    "margin-bottom": "1rem",
    "text-align": "center"
  }
};
var CompanyAdministrationvue_type_script_setup_true_lang_js_hoisted_3 = {
  style: {
    "display": "inline-flex"
  }
};
var CompanyAdministrationvue_type_script_setup_true_lang_js_hoisted_4 = {
  style: {
    "display": "inline-flex"
  }
};

var CompanyAdministrationvue_type_script_setup_true_lang_js_hoisted_5 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("   ");

var CompanyAdministrationvue_type_script_setup_true_lang_js_hoisted_6 = {
  style: {
    "margin-top": "1rem",
    "margin-bottom": "1rem",
    "text-align": "center"
  }
};
var CompanyAdministrationvue_type_script_setup_true_lang_js_default_ = {
  name: "CompanyAdministration"
};







/* harmony default export */ var CompanyAdministrationvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(CompanyAdministrationvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    var loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    var search = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)('');
    var missingNameLegal = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    var includeDutyPay = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    var missingCustomerNumber = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    var companies = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    var columns = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([{
      prop: "nameLegal",
      label: t("companies.name.legal.label")
    }, {
      prop: "customerNumber",
      label: t("companies.customer.number.label")
    }, {
      prop: "users",
      label: t("companies.users.label")
    }]);
    var tokens = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    var filter = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      var filter = [];

      if (includeDutyPay.value) {
        filter.push("includeDutyPay");
      }

      return filter;
    });

    function getNextPage() {
      return _getNextPage.apply(this, arguments);
    }

    function _getNextPage() {
      _getNextPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getCompanies((0,external_lodash_.last)(tokens.value));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getNextPage.apply(this, arguments);
    }

    function getPreviousPage() {
      return _getPreviousPage.apply(this, arguments);
    }

    function _getPreviousPage() {
      _getPreviousPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var token;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tokens.value.pop();
                tokens.value.pop();
                token = "";

                if (tokens.value.length >= 0) {
                  token = (0,external_lodash_.last)(tokens.value);
                }

                _context3.next = 6;
                return getCompanies(token);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getPreviousPage.apply(this, arguments);
    }

    var envStore = (0,store_modules_.useEnvStore)();

    function getCompanies() {
      return _getCompanies.apply(this, arguments);
    }

    function _getCompanies() {
      _getCompanies = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var token,
            err,
            res,
            _yield$to,
            _yield$to2,
            _args4 = arguments;

        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                token = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : "";
                loading.value = true;
                _context4.next = 4;
                return (0,external_await_to_js_.to)(utilities_.interceptor.get("".concat(envStore.apiUrls.dutypay, "/api/v0/companies-list"), {
                  params: {
                    token: token,
                    filter: filter.value.join(","),
                    search: search.value
                  }
                }));

              case 4:
                _yield$to = _context4.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];

                if (!err) {
                  _context4.next = 10;
                  break;
                }

                throw err;

              case 10:
                companies.value = res.data.companies;

                if (res.data.token !== (0,external_lodash_.last)(tokens.value)) {
                  tokens.value.push(res.data.token);
                }

                loading.value = false;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _getCompanies.apply(this, arguments);
    }

    function toggleCompanyUserRelationship(_x, _x2) {
      return _toggleCompanyUserRelationship.apply(this, arguments);
    }

    function _toggleCompanyUserRelationship() {
      _toggleCompanyUserRelationship = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(companyId, userId) {
        var err, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                loading.value = true;
                _context5.next = 3;
                return (0,external_await_to_js_.to)(utilities_.interceptor.post("".concat(envStore.apiUrls.dutypay, "/api/v0/toggle-user-company"), {
                  userId: userId,
                  companyId: companyId
                }));

              case 3:
                _yield$to3 = _context5.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 1);
                err = _yield$to4[0];

                if (!err) {
                  _context5.next = 8;
                  break;
                }

                throw err;

              case 8:
                _context5.next = 10;
                return getCompanies((0,external_lodash_.last)((0,external_lodash_.dropRight)(tokens.value)) || '');

              case 10:
                loading.value = false;

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _toggleCompanyUserRelationship.apply(this, arguments);
    }

    function applyFilter() {
      return _applyFilter.apply(this, arguments);
    }

    function _applyFilter() {
      _applyFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                tokens.value = [];
                _context6.next = 3;
                return getCompanies();

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _applyFilter.apply(this, arguments);
    }

    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCompanies();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      var _component_el_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-input");

      var _component_el_form_item = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-form-item");

      var _component_el_checkbox = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-checkbox");

      var _component_el_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-col");

      var _component_el_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-row");

      var _component_el_form = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-form");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_router_link = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("router-link");

      var _component_DpCopyToClipboard = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCopyToClipboard");

      var _component_el_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-button");

      var _component_el_tooltip = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-tooltip");

      var _component_DpTable = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpTable");

      var _component_DpPageSection = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpPageSection");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("companyAdministration.title")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpPageSection, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", CompanyAdministrationvue_type_script_setup_true_lang_js_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h4", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("filter.label")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form, {
            "label-position": "top",
            onSubmit: _cache[3] || (_cache[3] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)(function () {}, ["prevent"]))
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form_item, null, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_input, {
                    onKeydown: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)(applyFilter, ["enter"]),
                    onClear: applyFilter,
                    size: "large",
                    modelValue: search.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return search.value = $event;
                    }),
                    clearable: true,
                    placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('search.placeholder')
                  }, null, 8, ["onKeydown", "modelValue", "placeholder"])];
                }),
                _: 1
              }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, {
                gutter: 20
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
                    xl: {
                      span: 8
                    },
                    sm: {
                      span: 12
                    },
                    xs: {
                      span: 24
                    }
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_checkbox, {
                        modelValue: missingNameLegal.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                          return missingNameLegal.value = $event;
                        }),
                        onChange: applyFilter
                      }, {
                        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('filter.name.legal.missing.label')), 1)];
                        }),
                        _: 1
                      }, 8, ["modelValue"])];
                    }),
                    _: 1
                  }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
                    xl: {
                      span: 8
                    },
                    sm: {
                      span: 12
                    },
                    xs: {
                      span: 24
                    }
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_checkbox, {
                        modelValue: missingCustomerNumber.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                          return missingCustomerNumber.value = $event;
                        }),
                        onChange: applyFilter
                      }, {
                        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('filter.customer.number.missing.label')), 1)];
                        }),
                        _: 1
                      }, 8, ["modelValue"])];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          })]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", CompanyAdministrationvue_type_script_setup_true_lang_js_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            onClick: _cache[4] || (_cache[4] = function ($event) {
              return getPreviousPage();
            })
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("previousPage.buttonLabel")), 1)];
            }),
            _: 1
          }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            onClick: _cache[5] || (_cache[5] = function ($event) {
              return getNextPage();
            })
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("nextPage.buttonLabel")), 1)];
            }),
            _: 1
          })]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpTable, {
            data: companies.value,
            reference: "companies",
            columns: columns.value,
            size: 'large',
            class: "settings-pages__admin-settings__company-administration__dp-table"
          }, {
            nameLegal: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", CompanyAdministrationvue_type_script_setup_true_lang_js_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_router_link, {
                to: {
                  name: 'companyDetails',
                  params: {
                    companyId: prop.row.id
                  }
                }
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.name ? prop.row.name.legal : ""), 1)];
                }),
                _: 2
              }, 1032, ["to"]), prop.row.name.legal ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpCopyToClipboard, {
                key: 0,
                value: prop.row.name ? prop.row.name.legal : '',
                inline: true,
                label: ' '
              }, null, 8, ["value"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])];
            }),
            customerNumber: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", CompanyAdministrationvue_type_script_setup_true_lang_js_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.customer ? prop.row.customer.number : "") + " ", 1), prop.row.customer ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpCopyToClipboard, {
                key: 0,
                value: prop.row.customer ? prop.row.customer.number : '',
                inline: true,
                label: ' '
              }, null, 8, ["value"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)])];
            }),
            users: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(prop.row.users, function (c) {
                return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                  key: c.id,
                  style: {
                    "margin-top": "5px",
                    "margin-bottom": "5px"
                  }
                }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_tooltip, {
                  placement: "top",
                  content: c.deleted == 1 ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.users.pressToActivate.tooltip.label') : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.users.pressToDeactivate.tooltip.label')
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_button, {
                      icon: c.deleted == 1 ? 'el-icon-close' : 'el-icon-check',
                      type: c.deleted == 1 ? 'danger' : 'success',
                      size: "mini",
                      onClick: function onClick($event) {
                        return toggleCompanyUserRelationship(c.company, c.id);
                      }
                    }, null, 8, ["icon", "type", "onClick"])];
                  }),
                  _: 2
                }, 1032, ["content"]), CompanyAdministrationvue_type_script_setup_true_lang_js_hoisted_5, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_router_link, {
                  to: {
                    name: 'userDetails',
                    params: {
                      userId: c.id
                    }
                  }
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(c.email), 1)];
                  }),
                  _: 2
                }, 1032, ["to"])]);
              }), 128))], 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, !!prop.row.users.length]])];
            }),
            _: 1
          }, 8, ["data", "columns"])), [[_directive_loading, loading.value]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", CompanyAdministrationvue_type_script_setup_true_lang_js_hoisted_6, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            onClick: _cache[6] || (_cache[6] = function ($event) {
              return getPreviousPage();
            })
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("previousPage.buttonLabel")), 1)];
            }),
            _: 1
          }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            onClick: _cache[7] || (_cache[7] = function ($event) {
              return getNextPage();
            })
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("nextPage.buttonLabel")), 1)];
            }),
            _: 1
          })])];
        }),
        _: 1
      })]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AdminSettings/CompanyAdministration.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AdminSettings/CompanyAdministration.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function CompanyAdministrationvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechtsgültiger Unternehmensname"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundennummer"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskontenverwaltung"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorherige Seite"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nächste Seite"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Aktivieren klicken"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Deaktivieren klicken"])}
              }
            }
          }
        }
      },
      "de-AT": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechtsgültiger Unternehmensname"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundennummer"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskontenverwaltung"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorherige Seite"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nächste Seite"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Aktivieren klicken"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Deaktivieren klicken"])}
              }
            }
          }
        }
      },
      "de-CH": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechtsgültiger Unternehmensname"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundennummer"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmenskontenverwaltung"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorherige Seite"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nächste Seite"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Aktivieren klicken"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Deaktivieren klicken"])}
              }
            }
          }
        }
      },
      "en-US": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legal company name"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customer number"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company account administration"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous page"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next page"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to activate"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to deactivate"])}
              }
            }
          }
        }
      },
      "en-GB": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legal company name"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customer number"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company account administration"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous page"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next page"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to activate"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to deactivate"])}
              }
            }
          }
        }
      },
      "it-IT": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricerca"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricerca"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome della società legale"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numero cliente"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amministrazione dell'account aziendale"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagina precedente"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagina successiva"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clicca per attivare"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clicca per disattivare"])}
              }
            }
          }
        }
      },
      "fr-FR": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom légal de l'entreprise"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de client"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des comptes d'entreprise"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page précédente"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page suivante"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour activer"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour désactiver"])}
              }
            }
          }
        }
      },
      "es-ES": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buscar"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buscar"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre legal de la empresa"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de cliente"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administración de cuentas de empresa"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagina anterior"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siguiente página"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haga clic para activar"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haga clic para desactivar"])}
              }
            }
          }
        }
      },
      "pl-PL": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szukaj"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szukaj"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prawna nazwa firmy"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numer klienta"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zarządzanie kontem firmowym"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poprzednia strona"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Następna strona"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknij, aby aktywować"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknij, aby dezaktywować"])}
              }
            }
          }
        }
      },
      "nl-NL": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoeken"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoeken"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wettelijke bedrijfsnaam"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klantnummer"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijfsaccount administratie"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorige bladzijde"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volgende pagina"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik om te activeren"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik om te deactiveren"])}
              }
            }
          }
        }
      },
      "bg-BG": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Търсене"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Търсене"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Име на юридическото дружество"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Клиентски номер"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Администрация на фирмена сметка"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Предишна страница"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Следваща страница"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Щракнете, за да активирате"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Щракнете, за да деактивирате"])}
              }
            }
          }
        }
      },
      "bs-BA": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Traži"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Traži"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pravno ime kompanije"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj kupca"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija računa kompanije"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prethodna stranica"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sljedeća stranica"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite da biste aktivirali"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite da biste deaktivirali"])}
              }
            }
          }
        }
      },
      "zh-CN": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["法定公司名称"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顾客号码"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司账户管理"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上一页"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下一页"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["点击激活"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["单击以停用"])}
              }
            }
          }
        }
      },
      "da-DK": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Søg"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Søg"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juridisk firmanavn"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundenummer"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration af virksomhedskonto"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forrige side"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Næste side"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik for at aktivere"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik for at deaktivere"])}
              }
            }
          }
        }
      },
      "et-EE": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otsing"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otsing"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legaalne ettevõtte nimi"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliendi number"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte konto haldamine"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eelmine leht"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Järgmine leht"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveerimiseks klõpsake"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveerimiseks klõpsake"])}
              }
            }
          }
        }
      },
      "fi-FI": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hae"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hae"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Laillinen yrityksen nimi"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asiakasnumero"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yritystilin hallinta"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edellinen sivu"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seuraava sivu"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoi napsauttamalla"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista käytöstä napsauttamalla"])}
              }
            }
          }
        }
      },
      "el-GR": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αναζήτηση"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αναζήτηση"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Νομικό όνομα εταιρείας"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αριθμός των πελατών"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαχείριση εταιρικού λογαριασμού"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προηγούμενη σελίδα"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επόμενη σελίδα"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για ενεργοποίηση"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για απενεργοποίηση"])}
              }
            }
          }
        }
      },
      "he-IL": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחפש"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחפש"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם חברה חוקי"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מספר לקוח"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ניהול חשבון החברה"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["עמוד קודם"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["עמוד הבא"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחץ להפעלה"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחץ כדי להשבית"])}
              }
            }
          }
        }
      },
      "ga-IE": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuardaigh"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuardaigh"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ainm cuideachta dlí"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uimhir an chustaiméara"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Riarachán cuntas cuideachta"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Leathanach roimhe seo"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An chéad leathanach eile"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliceáil chun gníomhachtú"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliceáil chun díghníomhachtú"])}
              }
            }
          }
        }
      },
      "ja-JP": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["探す"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["探す"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正式な会社名"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顧客番号"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業アカウント管理"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["前のページ"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["次のページ"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["クリックしてアクティブ化"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["クリックして非アクティブ化します"])}
              }
            }
          }
        }
      },
      "hr-HR": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Traži"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Traži"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pravni naziv tvrtke"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj kupca"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija računa tvrtke"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prethodna stranica"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sljedeća stranica"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za aktivaciju"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za deaktiviranje"])}
              }
            }
          }
        }
      },
      "lv-LV": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meklēt"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meklēt"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legāls uzņēmuma nosaukums"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klienta numurs"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uzņēmuma konta administrēšana"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iepriekšējā lapa"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nākamā lapaspuse"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Noklikšķiniet, lai aktivizētu"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Noklikšķiniet, lai deaktivizētu"])}
              }
            }
          }
        }
      },
      "lt-LT": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paieška"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paieška"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teisėtas įmonės pavadinimas"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliento numeris"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės sąskaitos administravimas"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ankstesnis puslapis"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kitas puslapis"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spustelėkite, kad suaktyvintumėte"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spustelėkite, kad išjungtumėte"])}
              }
            }
          }
        }
      },
      "pt-PT": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Procurar"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Procurar"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Razão Social da empresa"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número do cliente"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administração de contas corporativas"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Página anterior"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Próxima página"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clique para ativar"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clique para desativar"])}
              }
            }
          }
        }
      },
      "ro-RO": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Căutare"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Căutare"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Denumirea juridică a companiei"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numarul clientului"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrarea contului companiei"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagina precedentă"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagina următoare"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faceți clic pentru a activa"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faceți clic pentru a dezactiva"])}
              }
            }
          }
        }
      },
      "ru-RU": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поиск"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поиск"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Название юридической компании"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер клиента"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Управление корпоративным аккаунтом"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Предыдущая страница"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Следующая страница"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нажмите, чтобы активировать"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нажмите, чтобы отключить"])}
              }
            }
          }
        }
      },
      "sv-SE": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sök"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sök"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juridiskt företagsnamn"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundnummer"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administration av företagskonton"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Föregående sida"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nästa sida"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klicka för att aktivera"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klicka för att inaktivera"])}
              }
            }
          }
        }
      },
      "sk-SK": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhľadávanie"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhľadávanie"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oficiálny názov spoločnosti"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zákaznícke číslo"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa firemného účtu"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Predchádzajúca strana"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ďalšia strana"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivujte kliknutím"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknutím deaktivujete"])}
              }
            }
          }
        }
      },
      "cs-CZ": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhledávání"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhledávání"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oficiální název společnosti"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zákaznické číslo"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa firemního účtu"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Předchozí stránka"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Další strana"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivujte kliknutím"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknutím deaktivujete"])}
              }
            }
          }
        }
      },
      "tr-TR": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arama"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arama"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yasal şirket adı"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Müşteri numarası"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket hesap yönetimi"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Önceki sayfa"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sonraki Sayfa"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktif etmek için TIKLAYINIZ"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakmak için tıklayın"])}
              }
            }
          }
        }
      },
      "hu-HU": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keresés"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keresés"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legális cégnév"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ügyfélszám"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalati számla adminisztráció"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Előző oldal"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Következő oldal"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kattintson az aktiváláshoz"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kattintson a deaktiváláshoz"])}
              }
            }
          }
        }
      },
      "ar-AE": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بحث"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بحث"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اسم الشركة القانوني"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم العميل"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إدارة حساب الشركة"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الصفحة السابقة"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الصفحة التالية"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انقر للتفعيل"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انقر لإلغاء التنشيط"])}
              }
            }
          }
        }
      },
      "fr-BE": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom légal de l'entreprise"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de client"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des comptes d'entreprise"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page précédente"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page suivante"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour activer"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour désactiver"])}
              }
            }
          }
        }
      },
      "fr-LU": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom légal de l'entreprise"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de client"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des comptes d'entreprise"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page précédente"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page suivante"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour activer"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour désactiver"])}
              }
            }
          }
        }
      },
      "mt-MT": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tfittxija"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tfittxija"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isem tal-kumpanija legali"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numru tal-klijent"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amministrazzjoni tal-kont tal-kumpanija"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paġna ta 'qabel"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-paġna li jmiss"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikklikkja biex tattiva"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikklikkja biex tiddiżattiva"])}
              }
            }
          }
        }
      },
      "sl-SI": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iskanje"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iskanje"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pravno ime podjetja"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Številka kupca"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija računa podjetja"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prejšnja stran"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naslednja stran"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za aktivacijo"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za deaktiviranje"])}
              }
            }
          }
        }
      },
      "el-CY": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αναζήτηση"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αναζήτηση"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Νομικό όνομα εταιρείας"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αριθμός των πελατών"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαχείριση εταιρικού λογαριασμού"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προηγούμενη σελίδα"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επόμενη σελίδα"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για ενεργοποίηση"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για απενεργοποίηση"])}
              }
            }
          }
        }
      },
      "tr-CY": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arama"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arama"])}
        },
        "companies": {
          "sp": {
            "company": {
              "id": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
              }
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yasal şirket adı"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Müşteri numarası"])}
            }
          }
        },
        "companyAdministraton": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket hesap yönetimi"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Önceki sayfa"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sonraki Sayfa"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktif etmek için TIKLAYINIZ"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakmak için tıklayın"])}
              }
            }
          }
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AdminSettings/CompanyAdministration.vue


/* custom blocks */
;
if (typeof CompanyAdministrationvue_type_custom_index_0_blockType_i18n === 'function') CompanyAdministrationvue_type_custom_index_0_blockType_i18n(CompanyAdministrationvue_type_script_setup_true_lang_js)


const CompanyAdministration_exports_ = CompanyAdministrationvue_type_script_setup_true_lang_js;

/* harmony default export */ var CompanyAdministration = (CompanyAdministration_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AdminSettings/CompanyDetails.vue?vue&type=script&setup=true&lang=js











var CompanyDetailsvue_type_script_setup_true_lang_js_default_ = {
  name: "CompanyDetails",
  components: {},
  props: {
    companyId: {
      required: true
    }
  },
  computed: _objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ["apiUrls"])),
  data: function data() {
    return {
      loading: false,
      company: {},
      userColumns: [{
        prop: "email",
        label: this.$t("companies.user.email.label")
      }, {
        prop: "name",
        label: this.$t("companies.user.name.label")
      }, {
        prop: "deleted",
        label: this.$t("companies.user.status.label")
      }]
    };
  },
  methods: {
    getCompany: function getCompany() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var err, res, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return (0,external_await_to_js_.to)(_this.$http.get("".concat(_this.apiUrls.dutypay, "/api/v0/companies/").concat(_this.companyId), {
                  params: {}
                }));

              case 3:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];

                if (!err) {
                  _context.next = 9;
                  break;
                }

                throw err;

              case 9:
                _this.company = res.data;
                _this.loading = false;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    toggleCompanyUserRelationship: function toggleCompanyUserRelationship(userId) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var err, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return (0,external_await_to_js_.to)(_this2.$http.post("".concat(_this2.apiUrls.dutypay, "/api/v0/toggle-user-company"), {
                  userId: userId,
                  companyId: _this2.companyId
                }));

              case 3:
                _yield$to3 = _context2.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 1);
                err = _yield$to4[0];

                if (!err) {
                  _context2.next = 8;
                  break;
                }

                throw err;

              case 8:
                _context2.next = 10;
                return _this2.getCompany();

              case 10:
                _this2.loading = false;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.getCompany();

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};

/* harmony default export */ var CompanyDetailsvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(CompanyDetailsvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_DpSimpleCrud = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpSimpleCrud");

      var _component_router_link = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("router-link");

      var _component_el_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-button");

      var _component_el_tooltip = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-tooltip");

      var _component_DpTable = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpTable");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("companyDetails.title")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpSimpleCrud, {
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('companyName.label'),
        value: _ctx.company.name,
        "key-map": {
          legal: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.name.legal.label')
        },
        "read-only": ""
      }, null, 8, ["headline", "value", "key-map"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpSimpleCrud, {
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('companyInfo.label'),
        value: _ctx.company.customer,
        "key-map": {
          number: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.customer.number.label')
        },
        "read-only": ""
      }, null, 8, ["headline", "value", "key-map"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("companyUsers.label")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpTable, {
        data: _ctx.company.users,
        columns: _ctx.userColumns,
        size: 'large'
      }, {
        name: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.name.given + " " + prop.row.name.family), 1)];
        }),
        email: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_router_link, {
            to: {
              'name': 'userDetails',
              'params': {
                'userId': prop.row.id
              }
            }
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.email), 1)];
            }),
            _: 2
          }, 1032, ["to"])];
        }),
        deleted: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_tooltip, {
            placement: "top",
            content: prop.row.deleted == 1 ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.users.pressToActivate.tooltip.label') : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.users.pressToDeactivate.tooltip.label')
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_button, {
                icon: prop.row.deleted == 1 ? 'el-icon-close' : 'el-icon-check',
                type: prop.row.deleted == 1 ? 'danger' : 'success',
                size: "mini",
                onClick: function onClick($event) {
                  return _ctx.toggleCompanyUserRelationship(prop.row.id);
                }
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.deleted == 1 ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.users.deactivated.buttonLabel') : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.users.activated.buttonLabel')), 1)];
                }),
                _: 2
              }, 1032, ["icon", "type", "onClick"])];
            }),
            _: 2
          }, 1032, ["content"])];
        }),
        _: 1
      }, 8, ["data", "columns"])]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AdminSettings/CompanyDetails.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-56.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-56.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-56.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AdminSettings/CompanyDetails.vue?vue&type=style&index=0&id=832833dc&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/pages/AdminSettings/CompanyDetails.vue?vue&type=style&index=0&id=832833dc&scoped=true&lang=css

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AdminSettings/CompanyDetails.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function CompanyDetailsvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primäre E-Mail-Adresse"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Aktivieren klicken"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Deaktivieren klicken"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviert"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechtsgültiger Unternehmensname"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundennummer"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmensinformationen"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer des Unternehmens"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundendaten"])}
        }
      },
      "de-AT": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primäre E-Mail-Adresse"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Aktivieren klicken"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Deaktivieren klicken"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviert"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechtsgültiger Unternehmensname"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundennummer"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmensinformationen"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer des Unternehmens"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundendaten"])}
        }
      },
      "de-CH": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primäre E-Mail-Adresse"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Aktivieren klicken"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Deaktivieren klicken"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviert"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechtsgültiger Unternehmensname"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundennummer"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmensinformationen"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzer des Unternehmens"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundendaten"])}
        }
      },
      "en-US": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primary e-mail address"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to activate"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to deactivate"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivated"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legal company name"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customer number"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company information"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company users"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customer data"])}
        }
      },
      "en-GB": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primary e-mail address"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to activate"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to deactivate"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivated"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legal company name"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customer number"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company information"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company users"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Customer data"])}
        }
      },
      "it-IT": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indirizzo e-mail principale"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stato"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anagrafica Azienda"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clicca per attivare"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clicca per disattivare"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disattivato"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome della società legale"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numero cliente"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informazioni sull'azienda"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utenti aziendali"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dati dei clienti"])}
        }
      },
      "fr-FR": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail principale"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour activer"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour désactiver"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivé"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom légal de l'entreprise"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de client"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations sur la société"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisateurs de l'entreprise"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Données client"])}
        }
      },
      "es-ES": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dirección de correo principal"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estado"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compañías"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haga clic para activar"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haga clic para desactivar"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activada"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desactivado"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre legal de la empresa"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número de cliente"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Información de la empresa"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuarios de la empresa"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos de los clientes"])}
        }
      },
      "pl-PL": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podstawowy adres e-mail"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firmy"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknij, aby aktywować"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknij, aby dezaktywować"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowano"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezaktywowane"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prawna nazwa firmy"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numer klienta"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacje o firmie"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Użytkownicy firmowi"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dane klienta"])}
        }
      },
      "nl-NL": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primaire email adres"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toestand"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijven"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik om te activeren"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik om te deactiveren"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gedeactiveerd"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wettelijke bedrijfsnaam"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klantnummer"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijfsinformatie"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijfsgebruikers"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klantgegevens"])}
        }
      },
      "bg-BG": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Основен имейл адрес"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cтатус"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фирми"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Щракнете, за да активирате"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Щракнете, за да деактивирате"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирано"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивиран"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Име на юридическото дружество"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Клиентски номер"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Информация за компанията"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потребители на компанията"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Данни за клиенти"])}
        }
      },
      "bs-BA": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primarna adresa e-pošte"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statusa"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompanije"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite da biste aktivirali"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite da biste deaktivirali"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirano"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pravno ime kompanije"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj kupca"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podaci o kompaniji"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korisnici kompanije"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podaci o kupcima"])}
        }
      },
      "zh-CN": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["主要电子邮件地址"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司介绍"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["点击激活"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["单击以停用"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已激活"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已停用"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["法定公司名称"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顾客号码"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司信息"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司用户"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["客户资料"])}
        }
      },
      "da-DK": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primær e-mail-adresse"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomheder"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik for at aktivere"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik for at deaktivere"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveret"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveret"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juridisk firmanavn"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundenummer"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomhedsoplysninger"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomhedsbrugere"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundedata"])}
        }
      },
      "et-EE": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Peamine e-posti aadress"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Staatus"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtted"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveerimiseks klõpsake"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveerimiseks klõpsake"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeritud"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveeritud"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legaalne ettevõtte nimi"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliendi number"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte info"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtte kasutajad"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliendi andmed"])}
        }
      },
      "fi-FI": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ensisijainen sähköpostiosoite"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tila"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["yritys"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoi napsauttamalla"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista käytöstä napsauttamalla"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoitu"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei käytössä"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Laillinen yrityksen nimi"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asiakasnumero"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yrityksen tiedot"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yrityksen käyttäjät"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asiakastiedot"])}
        }
      },
      "el-GR": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κύρια διεύθυνση email"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["κατάσταση"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρείες"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για ενεργοποίηση"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για απενεργοποίηση"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποιήθηκε"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Νομικό όνομα εταιρείας"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αριθμός των πελατών"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στοιχεία της εταιρείας"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Χρήστες της εταιρείας"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στοιχεία πελάτη"])}
        }
      },
      "he-IL": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["כתובת דוא＂ל ראשית"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סטָטוּס"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חברות"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחץ להפעלה"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחץ כדי להשבית"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מופעל"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מושבת"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם חברה חוקי"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מספר לקוח"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["פרטי החברה"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["משתמשי החברה"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["נתוני לקוחות"])}
        }
      },
      "ga-IE": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seoladh ríomhphoist bunscoile"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stádas"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuideachtaí"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliceáil chun gníomhachtú"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliceáil chun díghníomhachtú"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaithe"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Díghníomhachtaithe"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ainm cuideachta dlí"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uimhir an chustaiméara"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faisnéis cuideachta"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Úsáideoirí cuideachta"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sonraí custaiméirí"])}
        }
      },
      "ja-JP": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["プライマリメールアドレス"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状態"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["クリックしてアクティブ化"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["クリックして非アクティブ化します"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティブ化"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["非アクティブ化"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正式な会社名"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顧客番号"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会社情報"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会社のユーザー"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["顧客データ"])}
        }
      },
      "hr-HR": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primarna adresa e-pošte"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tvrtka"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za aktivaciju"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za deaktiviranje"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirano"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pravni naziv tvrtke"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Broj kupca"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podaci o tvrtki"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Korisnici tvrtke"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podaci o klijentima"])}
        }
      },
      "lv-LV": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Galvenā e-pasta adrese"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statusu"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompānijas"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Noklikšķiniet, lai aktivizētu"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Noklikšķiniet, lai deaktivizētu"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēts"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivizēts"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legāls uzņēmuma nosaukums"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klienta numurs"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompānijas informācija"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uzņēmuma lietotāji"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klienta dati"])}
        }
      },
      "lt-LT": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagrindinis el. Pašto adresas"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statusas"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spustelėkite, kad suaktyvintumėte"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spustelėkite, kad išjungtumėte"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinta"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išjungta"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teisėtas įmonės pavadinimas"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliento numeris"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompanijos informacija"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės vartotojai"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliento duomenys"])}
        }
      },
      "pt-PT": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Endereço de email primário"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empresas"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clique para ativar"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clique para desativar"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativado"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desativado"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Razão Social da empresa"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número do cliente"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informações da Empresa"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Usuários da empresa"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dados do cliente"])}
        }
      },
      "ro-RO": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresa principala de email"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stare"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["întreprindere"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faceți clic pentru a activa"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faceți clic pentru a dezactiva"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activat"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezactivat"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Denumirea juridică a companiei"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numarul clientului"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informatiile Companiei"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilizatorii companiei"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datele despre consumator"])}
        }
      },
      "ru-RU": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Основной адрес электронной почты"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["положение дел"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Компании"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нажмите, чтобы активировать"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нажмите, чтобы отключить"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировано"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивировано"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Название юридической компании"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер клиента"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Информация о компании"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пользователи компании"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Данные клиентов"])}
        }
      },
      "sv-SE": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primär e-postadress"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företag"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klicka för att aktivera"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klicka för att inaktivera"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiverad"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inaktiverad"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Juridiskt företagsnamn"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kundnummer"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företagsinformation"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företagets användare"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konsument data"])}
        }
      },
      "sk-SK": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primárna e-mailová adresa"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavenie"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podnik"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivujte kliknutím"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknutím deaktivujete"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivované"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivované"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oficiálny názov spoločnosti"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zákaznícke číslo"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informácie o spoločnosti"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Používatelia spoločnosti"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Údaje o zákazníkoch"])}
        }
      },
      "cs-CZ": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primární e-mailová adresa"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavení"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["společnost"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivujte kliknutím"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknutím deaktivujete"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivováno"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivováno"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oficiální název společnosti"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zákaznické číslo"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informace o společnosti"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uživatelé společnosti"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Údaje o zákaznících"])}
        }
      },
      "tr-TR": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Birincil e-posta adresi"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Durum"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["şirket"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktif etmek için TIKLAYINIZ"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakmak için tıklayın"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakıldı"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yasal şirket adı"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Müşteri numarası"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Bilgisi"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket kullanıcıları"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Müşteri bilgisi"])}
        }
      },
      "hu-HU": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elsődleges e-mail cím"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Állapot"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalat"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kattintson az aktiváláshoz"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kattintson a deaktiváláshoz"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivált"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiválva"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Legális cégnév"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ügyfélszám"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Céginformáció"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalati felhasználók"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ügyféladatok"])}
        }
      },
      "ar-AE": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان البريد الإلكتروني الرئيسي"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الحالة"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الشركات"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انقر للتفعيل"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انقر لإلغاء التنشيط"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معطل"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اسم الشركة القانوني"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم العميل"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معلومات الشركة"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مستخدمو الشركة"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بيانات العميل"])}
        }
      },
      "fr-BE": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail principale"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour activer"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour désactiver"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivé"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom légal de l'entreprise"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de client"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations sur la société"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisateurs de l'entreprise"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Données client"])}
        }
      },
      "fr-LU": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail principale"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour activer"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour désactiver"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivé"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom légal de l'entreprise"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de client"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations sur la société"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisateurs de l'entreprise"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Données client"])}
        }
      },
      "mt-MT": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indirizz tal-email primarju"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kumpaniji"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikklikkja biex tattiva"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikklikkja biex tiddiżattiva"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivat"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Diżattivat"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isem tal-kumpanija legali"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numru tal-klijent"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informazzjoni dwar il-kumpanija"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utenti tal-kumpanija"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dejta tal-klijent"])}
        }
      },
      "sl-SI": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primarni e-poštni naslov"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stanje"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["podjetje"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za aktivacijo"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za deaktiviranje"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirano"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pravno ime podjetja"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Številka kupca"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podatki o podjetju"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uporabniki podjetja"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podatki o strankah"])}
        }
      },
      "el-CY": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κύρια διεύθυνση email"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["κατάσταση"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρείες"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για ενεργοποίηση"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για απενεργοποίηση"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποιήθηκε"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Νομικό όνομα εταιρείας"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αριθμός των πελατών"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στοιχεία της εταιρείας"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Χρήστες της εταιρείας"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Στοιχεία πελάτη"])}
        }
      },
      "tr-CY": {
        "companies": {
          "user": {
            "email": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Birincil e-posta adresi"])}
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Durum"])}
            }
          }
        },
        "companyName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["şirket"])}
        },
        "company": {
          "users": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktif etmek için TIKLAYINIZ"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakmak için tıklayın"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
            },
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakıldı"])}
            }
          },
          "name": {
            "legal": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yasal şirket adı"])}
            }
          },
          "customer": {
            "number": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Müşteri numarası"])}
            }
          }
        },
        "companyDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket Bilgisi"])}
        },
        "companyUsers": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Şirket kullanıcıları"])}
        },
        "companyInfo": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Müşteri bilgisi"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AdminSettings/CompanyDetails.vue



;
/* custom blocks */

if (typeof CompanyDetailsvue_type_custom_index_0_blockType_i18n === 'function') CompanyDetailsvue_type_custom_index_0_blockType_i18n(CompanyDetailsvue_type_script_setup_true_lang_js)


;
const CompanyDetails_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(CompanyDetailsvue_type_script_setup_true_lang_js, [['__scopeId',"data-v-832833dc"]])

/* harmony default export */ var CompanyDetails = (CompanyDetails_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AdminSettings/UserAdministration.vue?vue&type=script&setup=true&lang=js







var UserAdministrationvue_type_script_setup_true_lang_js_hoisted_1 = {
  class: "partition depth-1"
};
var UserAdministrationvue_type_script_setup_true_lang_js_hoisted_2 = {
  style: {
    "margin-top": "1rem",
    "margin-bottom": "1rem",
    "text-align": "center"
  }
};
var UserAdministrationvue_type_script_setup_true_lang_js_hoisted_3 = {
  style: {
    "display": "inline-flex"
  }
};
var UserAdministrationvue_type_script_setup_true_lang_js_hoisted_4 = {
  style: {
    "display": "inline-flex"
  }
};
var UserAdministrationvue_type_script_setup_true_lang_js_hoisted_5 = {
  style: {
    "display": "inline-flex"
  }
};
var UserAdministrationvue_type_script_setup_true_lang_js_hoisted_6 = {
  style: {
    "display": "inline-flex"
  }
};

var UserAdministrationvue_type_script_setup_true_lang_js_hoisted_7 = /*#__PURE__*/(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)("   ");

var UserAdministrationvue_type_script_setup_true_lang_js_hoisted_8 = {
  style: {
    "margin-top": "1rem",
    "margin-bottom": "1rem",
    "text-align": "center"
  }
};
var UserAdministrationvue_type_script_setup_true_lang_js_default_ = {
  name: "UserAdministration"
};






/* harmony default export */ var UserAdministrationvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(UserAdministrationvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    var loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    var search = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)('');
    var includeDutyPay = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)(false);
    var users = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    var tokens = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.ref)([]);
    var columns = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      return [{
        prop: "activated",
        label: t("activated.label")
      }, {
        prop: "email",
        label: t("email.label")
      }, {
        prop: "nameGiven",
        label: t("name.given.label")
      }, {
        prop: "nameFamily",
        label: t("name.family.label")
      }, {
        prop: "companies",
        label: t("companies.label")
      }];
    });
    var filter = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.computed)(function () {
      var filter = [];

      if (includeDutyPay.value) {
        filter.push("includeDutyPay");
      }

      return filter;
    });

    function getNextPage() {
      return _getNextPage.apply(this, arguments);
    }

    function _getNextPage() {
      _getNextPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getUsers((0,external_lodash_.last)(tokens.value));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getNextPage.apply(this, arguments);
    }

    function getPreviousPage() {
      return _getPreviousPage.apply(this, arguments);
    }

    function _getPreviousPage() {
      _getPreviousPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var token;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tokens.value.pop();
                tokens.value.pop();
                token = "";

                if (tokens.value.length >= 0) {
                  token = (0,external_lodash_.last)(tokens.value);
                }

                _context3.next = 6;
                return getUsers(token.value);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _getPreviousPage.apply(this, arguments);
    }

    var envStore = (0,store_modules_.useEnvStore)();

    function getUsers() {
      return _getUsers.apply(this, arguments);
    }

    function _getUsers() {
      _getUsers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var token,
            err,
            res,
            _yield$to,
            _yield$to2,
            _args4 = arguments;

        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                token = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : "";
                loading.value = true;
                _context4.next = 4;
                return (0,external_await_to_js_.to)(utilities_.interceptor.get("".concat(envStore.apiUrls.dutypay, "/api/v0/users-list"), {
                  params: {
                    token: token,
                    filter: filter.value.join(","),
                    search: search.value
                  }
                }));

              case 4:
                _yield$to = _context4.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];

                if (!err) {
                  _context4.next = 10;
                  break;
                }

                throw err;

              case 10:
                users.value = res.data.users;

                if (res.data.token !== (0,external_lodash_.last)(tokens.value)) {
                  tokens.value.push(res.data.token);
                }

                loading.value = false;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _getUsers.apply(this, arguments);
    }

    function toggleCompanyUserRelationship(_x, _x2) {
      return _toggleCompanyUserRelationship.apply(this, arguments);
    }

    function _toggleCompanyUserRelationship() {
      _toggleCompanyUserRelationship = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(companyId, userId) {
        var err, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                loading.value = true;
                _context5.next = 3;
                return (0,external_await_to_js_.to)(utilities_.interceptor.post("".concat(envStore.apiUrls.dutypay, "/api/v0/toggle-user-company"), {
                  userId: userId,
                  companyId: companyId
                }));

              case 3:
                _yield$to3 = _context5.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 1);
                err = _yield$to4[0];

                if (!err) {
                  _context5.next = 8;
                  break;
                }

                throw err;

              case 8:
                _context5.next = 10;
                return getUsers((0,external_lodash_.last)((0,external_lodash_.dropRight)(tokens.value)) || '');

              case 10:
                loading.value = false;

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
      return _toggleCompanyUserRelationship.apply(this, arguments);
    }

    function toggleUserActivated(_x3, _x4) {
      return _toggleUserActivated.apply(this, arguments);
    }

    function _toggleUserActivated() {
      _toggleUserActivated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(userId, activated) {
        var err, _yield$to5, _yield$to6;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                loading.value = true;
                _context6.next = 3;
                return (0,external_await_to_js_.to)(utilities_.interceptor.post("".concat(envStore.apiUrls.dutypay, "/api/v0/toggle-user-activated"), {
                  userId: userId,
                  activated: activated
                }));

              case 3:
                _yield$to5 = _context6.sent;
                _yield$to6 = _slicedToArray(_yield$to5, 1);
                err = _yield$to6[0];

                if (!err) {
                  _context6.next = 8;
                  break;
                }

                throw err;

              case 8:
                _context6.next = 10;
                return getUsers((0,external_lodash_.last)((0,external_lodash_.dropRight)(tokens.value)) || '');

              case 10:
                loading.value = false;

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _toggleUserActivated.apply(this, arguments);
    }

    function applyFilter() {
      return _applyFilter.apply(this, arguments);
    }

    function _applyFilter() {
      _applyFilter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                tokens.value = [];
                _context7.next = 3;
                return getUsers();

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
      return _applyFilter.apply(this, arguments);
    }

    (0,external_commonjs_vue_commonjs2_vue_root_Vue_.onMounted)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getUsers();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      var _component_el_input = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-input");

      var _component_el_form_item = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-form-item");

      var _component_el_checkbox = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-checkbox");

      var _component_el_col = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-col");

      var _component_el_row = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-row");

      var _component_el_form = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-form");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_el_switch = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-switch");

      var _component_router_link = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("router-link");

      var _component_DpCopyToClipboard = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpCopyToClipboard");

      var _component_el_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-button");

      var _component_el_tooltip = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-tooltip");

      var _component_DpTable = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpTable");

      var _component_DpPageSection = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpPageSection");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("userAdministration.title")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpPageSection, null, {
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", UserAdministrationvue_type_script_setup_true_lang_js_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h4", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("filter.label")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form, {
            "label-position": "top",
            onSubmit: _cache[2] || (_cache[2] = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withModifiers)(function () {}, ["prevent"]))
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_form_item, null, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_input, {
                    onKeydown: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withKeys)(applyFilter, ["enter"]),
                    onClear: applyFilter,
                    size: "large",
                    modelValue: search.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return search.value = $event;
                    }),
                    clearable: true,
                    placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('search.placeholder')
                  }, null, 8, ["onKeydown", "modelValue", "placeholder"])];
                }),
                _: 1
              }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_row, {
                gutter: 20
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_col, {
                    xl: {
                      span: 8
                    },
                    sm: {
                      span: 12
                    },
                    xs: {
                      span: 24
                    }
                  }, {
                    default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                      return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_checkbox, {
                        modelValue: includeDutyPay.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                          return includeDutyPay.value = $event;
                        }),
                        onChange: applyFilter
                      }, {
                        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("filter.include.dutypay.users.label")), 1)];
                        }),
                        _: 1
                      }, 8, ["modelValue"])];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          })]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", UserAdministrationvue_type_script_setup_true_lang_js_hoisted_2, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return getPreviousPage();
            })
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("previousPage.buttonLabel")), 1)];
            }),
            _: 1
          }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            onClick: _cache[4] || (_cache[4] = function ($event) {
              return getNextPage();
            })
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("nextPage.buttonLabel")), 1)];
            }),
            _: 1
          })]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpTable, {
            data: users.value,
            columns: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(columns),
            size: 'large'
          }, {
            activated: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", UserAdministrationvue_type_script_setup_true_lang_js_hoisted_3, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_switch, {
                modelValue: prop.row.activated,
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return prop.row.activated = $event;
                },
                "active-color": "#13ce66",
                "inactive-color": "#666666",
                onChange: function onChange($event) {
                  return toggleUserActivated(prop.row.id, prop.row.activated);
                }
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])])];
            }),
            email: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", UserAdministrationvue_type_script_setup_true_lang_js_hoisted_4, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_router_link, {
                to: {
                  name: 'userDetails',
                  params: {
                    userId: prop.row.id
                  }
                }
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.email), 1)];
                }),
                _: 2
              }, 1032, ["to"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCopyToClipboard, {
                value: prop.row.email,
                inline: true,
                label: ' '
              }, null, 8, ["value"])])];
            }),
            nameGiven: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", UserAdministrationvue_type_script_setup_true_lang_js_hoisted_5, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.name.given) + " ", 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCopyToClipboard, {
                value: prop.row.name.given,
                inline: true,
                label: ' '
              }, null, 8, ["value"])])];
            }),
            nameFamily: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", UserAdministrationvue_type_script_setup_true_lang_js_hoisted_6, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.name.family) + " ", 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpCopyToClipboard, {
                value: prop.row.name.family,
                inline: true,
                label: ' '
              }, null, 8, ["value"])])];
            }),
            companies: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", null, [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(prop.row.companies, function (c) {
                return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", {
                  key: c.id,
                  style: {
                    "margin-top": "5px",
                    "margin-bottom": "5px"
                  }
                }, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_tooltip, {
                  placement: "top",
                  content: c.deleted == 1 ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('user.companies.pressToActivate.tooltip.label') : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('user.companies.pressToDeactivate.tooltip.label')
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_button, {
                      icon: c.deleted == 1 ? 'el-icon-close' : 'el-icon-check',
                      type: c.deleted == 1 ? 'danger' : 'success',
                      size: "mini",
                      onClick: function onClick($event) {
                        return toggleCompanyUserRelationship(c.id, c.user);
                      }
                    }, null, 8, ["icon", "type", "onClick"])];
                  }),
                  _: 2
                }, 1032, ["content"]), UserAdministrationvue_type_script_setup_true_lang_js_hoisted_7, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_router_link, {
                  to: {
                    name: 'companyDetails',
                    params: {
                      companyId: c.id
                    }
                  }
                }, {
                  default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                    return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(c.legal + " (" + c.number + ")"), 1)];
                  }),
                  _: 2
                }, 1032, ["to"])]);
              }), 128))], 512), [[external_commonjs_vue_commonjs2_vue_root_Vue_.vShow, !!prop.row.companies]])];
            }),
            _: 1
          }, 8, ["data", "columns"])), [[_directive_loading, loading.value]]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", UserAdministrationvue_type_script_setup_true_lang_js_hoisted_8, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            onClick: _cache[5] || (_cache[5] = function ($event) {
              return getPreviousPage();
            })
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("previousPage.buttonLabel")), 1)];
            }),
            _: 1
          }), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            onClick: _cache[6] || (_cache[6] = function ($event) {
              return getNextPage();
            })
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("nextPage.buttonLabel")), 1)];
            }),
            _: 1
          })])];
        }),
        _: 1
      })]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AdminSettings/UserAdministration.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AdminSettings/UserAdministration.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function UserAdministrationvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerverwaltung"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorherige Seite"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nächste Seite"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorname"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familienname"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Aktivieren klicken"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Deaktivieren klicken"])}
              }
            }
          }
        }
      },
      "de-AT": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerverwaltung"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorherige Seite"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nächste Seite"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorname"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familienname"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Aktivieren klicken"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Deaktivieren klicken"])}
              }
            }
          }
        }
      },
      "de-CH": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerverwaltung"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorherige Seite"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nächste Seite"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorname"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familienname"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Aktivieren klicken"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Deaktivieren klicken"])}
              }
            }
          }
        }
      },
      "en-US": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User administration"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous page"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next page"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Given name"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Family name"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to activate"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to deactivate"])}
              }
            }
          }
        }
      },
      "en-GB": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User administration"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous page"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next page"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Given name"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Family name"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to activate"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to deactivate"])}
              }
            }
          }
        }
      },
      "it-IT": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amministrazione utenti"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricerca"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricerca"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagina precedente"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagina successiva"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome di battesimo"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cognome"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anagrafica Azienda"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clicca per attivare"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clicca per disattivare"])}
              }
            }
          }
        }
      },
      "fr-FR": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des utilisateurs"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page précédente"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page suivante"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour activer"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour désactiver"])}
              }
            }
          }
        }
      },
      "es-ES": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administración de Usuario"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buscar"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buscar"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagina anterior"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siguiente página"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Correo electrónico"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre propio"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apellido"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compañías"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haga clic para activar"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haga clic para desactivar"])}
              }
            }
          }
        }
      },
      "pl-PL": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracja użytkownika"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szukaj"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Szukaj"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poprzednia strona"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Następna strona"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Imię"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwisko rodowe"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firmy"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknij, aby aktywować"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknij, aby dezaktywować"])}
              }
            }
          }
        }
      },
      "nl-NL": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruikersadministratie"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoeken"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zoeken"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorige bladzijde"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volgende pagina"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voornaam"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Achternaam"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijven"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik om te activeren"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik om te deactiveren"])}
              }
            }
          }
        }
      },
      "bg-BG": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Администрация на потребителя"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Търсене"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Търсене"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Предишна страница"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Следваща страница"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имейл"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Първо име"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фамилно име"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фирми"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Щракнете, за да активирате"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Щракнете, за да деактивирате"])}
              }
            }
          }
        }
      },
      "bs-BA": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija korisnika"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Traži"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Traži"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prethodna stranica"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sljedeća stranica"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pošta"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ime"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prezime"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompanije"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite da biste aktivirali"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite da biste deaktivirali"])}
              }
            }
          }
        }
      },
      "zh-CN": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用户管理"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["搜索"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["上一页"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["下一页"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["电子邮件"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["姓"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司介绍"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["点击激活"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["单击以停用"])}
              }
            }
          }
        }
      },
      "da-DK": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brugeradministration"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Søg"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Søg"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forrige side"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Næste side"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fornavn"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familie navn"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomheder"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik for at aktivere"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik for at deaktivere"])}
              }
            }
          }
        }
      },
      "et-EE": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kasutaja haldus"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otsing"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otsing"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eelmine leht"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Järgmine leht"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-post"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eesnimi"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Perekonnanimi"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtted"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveerimiseks klõpsake"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveerimiseks klõpsake"])}
              }
            }
          }
        }
      },
      "fi-FI": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käyttäjien hallinta"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hae"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hae"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edellinen sivu"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seuraava sivu"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sähköposti"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etunimi"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sukunimi"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["yritys"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoi napsauttamalla"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista käytöstä napsauttamalla"])}
              }
            }
          }
        }
      },
      "el-GR": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαχείριση χρηστών"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αναζήτηση"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αναζήτηση"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προηγούμενη σελίδα"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επόμενη σελίδα"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ονομα"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οικογενειακό όνομα"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρείες"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για ενεργοποίηση"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για απενεργοποίηση"])}
              }
            }
          }
        }
      },
      "he-IL": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ניהול משתמשים"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחפש"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחפש"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["עמוד קודם"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["עמוד הבא"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אימייל"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם פרטי"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם משפחה"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חברות"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחץ להפעלה"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחץ כדי להשבית"])}
              }
            }
          }
        }
      },
      "ga-IE": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Riarachán úsáideora"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuardaigh"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuardaigh"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Leathanach roimhe seo"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An chéad leathanach eile"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ríomhphost"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ainm"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ainm clainne"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuideachtaí"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliceáil chun gníomhachtú"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliceáil chun díghníomhachtú"])}
              }
            }
          }
        }
      },
      "ja-JP": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザー管理"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["探す"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["探す"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["前のページ"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["次のページ"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eメール"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ファーストネーム"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["苗字"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["クリックしてアクティブ化"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["クリックして非アクティブ化します"])}
              }
            }
          }
        }
      },
      "hr-HR": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija korisnika"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Traži"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Traži"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prethodna stranica"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sljedeća stranica"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pošta"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ime"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prezime"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tvrtka"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za aktivaciju"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za deaktiviranje"])}
              }
            }
          }
        }
      },
      "lv-LV": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lietotāju administrēšana"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meklēt"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Meklēt"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iepriekšējā lapa"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nākamā lapaspuse"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pasts"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vārds"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uzvārds"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompānijas"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Noklikšķiniet, lai aktivizētu"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Noklikšķiniet, lai deaktivizētu"])}
              }
            }
          }
        }
      },
      "lt-LT": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vartotojo administravimas"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paieška"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paieška"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ankstesnis puslapis"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kitas puslapis"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["El. paštas"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pirmas vardas"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pavardė"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spustelėkite, kad suaktyvintumėte"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spustelėkite, kad išjungtumėte"])}
              }
            }
          }
        }
      },
      "pt-PT": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administração do usuário"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Procurar"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Procurar"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Página anterior"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Próxima página"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primeiro nome"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sobrenome"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empresas"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clique para ativar"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clique para desativar"])}
              }
            }
          }
        }
      },
      "ro-RO": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrarea utilizatorilor"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Căutare"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Căutare"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagina precedentă"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagina următoare"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nume"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nume de familie"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["întreprindere"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faceți clic pentru a activa"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faceți clic pentru a dezactiva"])}
              }
            }
          }
        }
      },
      "ru-RU": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Администрирование пользователей"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поиск"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поиск"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Предыдущая страница"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Следующая страница"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Эл. почта"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фамилия"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Компании"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нажмите, чтобы активировать"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нажмите, чтобы отключить"])}
              }
            }
          }
        }
      },
      "sv-SE": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Användaradministration"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sök"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sök"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Föregående sida"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nästa sida"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-post"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Förnamn"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Efternamn"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företag"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klicka för att aktivera"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klicka för att inaktivera"])}
              }
            }
          }
        }
      },
      "sk-SK": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administrácia užívateľov"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhľadávanie"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhľadávanie"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Predchádzajúca strana"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ďalšia strana"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Krstné meno"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Priezvisko"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podnik"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivujte kliknutím"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknutím deaktivujete"])}
              }
            }
          }
        }
      },
      "cs-CZ": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Správa uživatelů"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhledávání"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyhledávání"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Předchozí stránka"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Další strana"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailem"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jméno"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rodinné jméno"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["společnost"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivujte kliknutím"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknutím deaktivujete"])}
              }
            }
          }
        }
      },
      "tr-TR": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı yönetimi"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arama"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arama"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Önceki sayfa"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sonraki Sayfa"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İsim"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soyadı"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["şirket"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktif etmek için TIKLAYINIZ"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakmak için tıklayın"])}
              }
            }
          }
        }
      },
      "hu-HU": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Felhasználói adminisztráció"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keresés"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keresés"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Előző oldal"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Következő oldal"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keresztnév"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Családnév"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalat"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kattintson az aktiváláshoz"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kattintson a deaktiváláshoz"])}
              }
            }
          }
        }
      },
      "ar-AE": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إدارة المستخدم"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بحث"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بحث"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الصفحة السابقة"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الصفحة التالية"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["البريد الإلكتروني"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الاسم الأول"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اسم العائلة"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الشركات"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انقر للتفعيل"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انقر لإلغاء التنشيط"])}
              }
            }
          }
        }
      },
      "fr-BE": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des utilisateurs"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page précédente"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page suivante"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour activer"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour désactiver"])}
              }
            }
          }
        }
      },
      "fr-LU": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestion des utilisateurs"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chercher"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page précédente"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Page suivante"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour activer"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour désactiver"])}
              }
            }
          }
        }
      },
      "mt-MT": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Amministrazzjoni tal-utent"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tfittxija"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tfittxija"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paġna ta 'qabel"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Il-paġna li jmiss"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isem"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isem tal-familja"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kumpaniji"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikklikkja biex tattiva"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikklikkja biex tiddiżattiva"])}
              }
            }
          }
        }
      },
      "sl-SI": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Administracija uporabnikov"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iskanje"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iskanje"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prejšnja stran"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Naslednja stran"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-pošta"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ime"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Priimek"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["podjetje"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za aktivacijo"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za deaktiviranje"])}
              }
            }
          }
        }
      },
      "el-CY": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Διαχείριση χρηστών"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αναζήτηση"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αναζήτηση"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Προηγούμενη σελίδα"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επόμενη σελίδα"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ονομα"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οικογενειακό όνομα"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρείες"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για ενεργοποίηση"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για απενεργοποίηση"])}
              }
            }
          }
        }
      },
      "tr-CY": {
        "userAdministration": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı yönetimi"])}
        },
        "filter": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arama"])}
        },
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arama"])}
        },
        "previousPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Önceki sayfa"])}
        },
        "nextPage": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sonraki Sayfa"])}
        },
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-posta"])}
        },
        "name": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İsim"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soyadı"])}
          }
        },
        "companies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["şirket"])}
        },
        "user": {
          "companies": {
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktif etmek için TIKLAYINIZ"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakmak için tıklayın"])}
              }
            }
          }
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AdminSettings/UserAdministration.vue


/* custom blocks */
;
if (typeof UserAdministrationvue_type_custom_index_0_blockType_i18n === 'function') UserAdministrationvue_type_custom_index_0_blockType_i18n(UserAdministrationvue_type_script_setup_true_lang_js)


const UserAdministration_exports_ = UserAdministrationvue_type_script_setup_true_lang_js;

/* harmony default export */ var UserAdministration = (UserAdministration_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AdminSettings/UserDetails.vue?vue&type=script&setup=true&lang=js











var UserDetailsvue_type_script_setup_true_lang_js_default_ = {
  name: "UserDetails",
  components: {},
  props: {
    userId: {
      required: true
    }
  },
  computed: _objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ["apiUrls"])),
  data: function data() {
    return {
      loading: false,
      user: {},
      companyColumns: [{
        prop: "spCompanyId",
        label: this.$t("user.companies.sp.company.id.label")
      }, {
        prop: "nameLegal",
        label: this.$t("user.companies.name.legal.label")
      }, {
        prop: "status",
        label: this.$t("user.companies.status.label")
      }]
    };
  },
  methods: {
    getUser: function getUser() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var err, res, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.next = 3;
                return (0,external_await_to_js_.to)(_this.$http.get("".concat(_this.apiUrls.dutypay, "/api/v0/users/").concat(_this.userId), {
                  params: {}
                }));

              case 3:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];

                if (!err) {
                  _context.next = 9;
                  break;
                }

                throw err;

              case 9:
                _this.user = res.data;
                _this.loading = false;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    toggleCompanyUserRelationship: function toggleCompanyUserRelationship(companyId) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var err, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return (0,external_await_to_js_.to)(_this2.$http.post("".concat(_this2.apiUrls.dutypay, "/api/v0/toggle-user-company"), {
                  userId: _this2.userId,
                  companyId: companyId
                }));

              case 3:
                _yield$to3 = _context2.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 1);
                err = _yield$to4[0];

                if (!err) {
                  _context2.next = 8;
                  break;
                }

                throw err;

              case 8:
                _context2.next = 10;
                return _this2.getUser();

              case 10:
                _this2.loading = false;

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.getUser();

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};

/* harmony default export */ var UserDetailsvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(UserDetailsvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_DpSimpleCrud = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpSimpleCrud");

      var _component_router_link = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("router-link");

      var _component_el_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-button");

      var _component_el_tooltip = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-tooltip");

      var _component_DpTable = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpTable");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("userDetails.title")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpSimpleCrud, {
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.label'),
        value: _ctx.user.name,
        "key-map": {
          given: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('user.name.given.label'),
          additional: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('user.name.additional.label'),
          family: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('user.name.family.label')
        },
        "read-only": ""
      }, null, 8, ["headline", "value", "key-map"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpSimpleCrud, {
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('email.label'),
        value: {
          email: _ctx.user.email
        },
        "key-map": {
          email: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('user.email.label')
        },
        "read-only": ""
      }, null, 8, ["headline", "value", "key-map"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("h2", null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)("userCompanies.label")), 1), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpTable, {
        data: _ctx.user.companies,
        columns: _ctx.companyColumns,
        size: 'large'
      }, {
        spCompanyId: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.sp.company.id), 1)];
        }),
        nameLegal: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_router_link, {
            to: {
              'name': 'companyDetails',
              'params': {
                'companyId': prop.row.id
              }
            }
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.name.legal), 1)];
            }),
            _: 2
          }, 1032, ["to"])];
        }),
        status: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function (prop) {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_tooltip, {
            placement: "top",
            content: prop.row.deleted == 1 ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('user.companies.pressToActivate.tooltip.label') : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('user.companies.pressToDeactivate.tooltip.label')
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_button, {
                icon: prop.row.deleted == 1 ? 'el-icon-close' : 'el-icon-check',
                type: prop.row.deleted == 1 ? 'danger' : 'success',
                size: "mini",
                onClick: function onClick($event) {
                  return _ctx.toggleCompanyUserRelationship(prop.row.id);
                }
              }, {
                default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
                  return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)(prop.row.deleted == 1 ? (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('user.companies.deactivated.buttonLabel') : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('user.companies.activated.buttonLabel')), 1)];
                }),
                _: 2
              }, 1032, ["icon", "type", "onClick"])];
            }),
            _: 2
          }, 1032, ["content"])];
        }),
        _: 1
      }, 8, ["data", "columns"])]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AdminSettings/UserDetails.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-56.use[0]!./node_modules/css-loader/dist/cjs.js??clonedRuleSet-56.use[1]!./node_modules/vue-loader/dist/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-56.use[2]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AdminSettings/UserDetails.vue?vue&type=style&index=0&id=c9e603f2&scoped=true&lang=css
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/pages/AdminSettings/UserDetails.vue?vue&type=style&index=0&id=c9e603f2&scoped=true&lang=css

;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AdminSettings/UserDetails.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function UserDetailsvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primäre E-Mail-Adresse"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primäre E-Mail-Adresse"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorname"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familienname"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviert"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Aktivieren klicken"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Deaktivieren klicken"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerinformationen"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Namen"])}
        }
      },
      "de-AT": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primäre E-Mail-Adresse"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primäre E-Mail-Adresse"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorname"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familienname"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviert"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Aktivieren klicken"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Deaktivieren klicken"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerinformationen"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Namen"])}
        }
      },
      "de-CH": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primäre E-Mail-Adresse"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primäre E-Mail-Adresse"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorname"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familienname"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiviert"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Aktivieren klicken"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Deaktivieren klicken"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviert"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Benutzerinformationen"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Namen"])}
        }
      },
      "en-US": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primary e-mail address"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primary e-mail address"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Given name"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Family name"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivated"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to activate"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to deactivate"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User information"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Names"])}
        }
      },
      "en-GB": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primary e-mail address"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primary e-mail address"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Given name"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Family name"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deactivated"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to activate"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to deactivate"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activated"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Company"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User information"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Names"])}
        }
      },
      "it-IT": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indirizzo e-mail principale"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indirizzo e-mail principale"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome di battesimo"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cognome"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Disattivato"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clicca per attivare"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stato"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anagrafica Azienda"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clicca per disattivare"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivato"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anagrafica Azienda"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informazioni utente"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nomi"])}
        }
      },
      "fr-FR": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail principale"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail principale"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivé"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour activer"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour désactiver"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations de l'utilisateur"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Des noms"])}
        }
      },
      "es-ES": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dirección de correo principal"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dirección de correo principal"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre propio"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apellido"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desactivado"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haga clic para activar"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estado"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compañías"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Haga clic para desactivar"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activada"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compañías"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacion del usuario"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombres"])}
        }
      },
      "pl-PL": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podstawowy adres e-mail"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podstawowy adres e-mail"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Imię"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwisko rodowe"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezaktywowane"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknij, aby aktywować"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firmy"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknij, aby dezaktywować"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowano"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Firmy"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacje o użytkowniku"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwy"])}
        }
      },
      "nl-NL": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primaire email adres"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primaire email adres"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voornaam"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Achternaam"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gedeactiveerd"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik om te activeren"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toestand"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijven"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik om te deactiveren"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geactiveerd"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bedrijven"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gebruikers informatie"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Namen"])}
        }
      },
      "bg-BG": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Основен имейл адрес"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Основен имейл адрес"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Първо име"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фамилно име"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивиран"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Щракнете, за да активирате"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cтатус"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фирми"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Щракнете, за да деактивирате"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активирано"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фирми"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Информация за потребителя"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имена"])}
        }
      },
      "bs-BA": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primarna adresa e-pošte"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primarna adresa e-pošte"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ime"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prezime"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirano"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite da biste aktivirali"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statusa"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompanije"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite da biste deaktivirali"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompanije"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacije o korisniku"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Imena"])}
        }
      },
      "zh-CN": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["主要电子邮件地址"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["主要电子邮件地址"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["姓"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已停用"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["点击激活"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司介绍"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["单击以停用"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已激活"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公司介绍"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用户信息"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["姓名"])}
        }
      },
      "da-DK": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primær e-mail-adresse"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primær e-mail-adresse"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fornavn"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familie navn"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveret"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik for at aktivere"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomheder"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klik for at deaktivere"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveret"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Virksomheder"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brugeroplysninger"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Navne"])}
        }
      },
      "et-EE": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Peamine e-posti aadress"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Peamine e-posti aadress"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eesnimi"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Perekonnanimi"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveeritud"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveerimiseks klõpsake"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Staatus"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtted"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiveerimiseks klõpsake"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiveeritud"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ettevõtted"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kasutaja teave"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nimed"])}
        }
      },
      "fi-FI": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ensisijainen sähköpostiosoite"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ensisijainen sähköpostiosoite"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etunimi"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sukunimi"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei käytössä"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoi napsauttamalla"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tila"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["yritys"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Poista käytöstä napsauttamalla"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivoitu"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["yritys"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Käyttäjän tiedot"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nimet"])}
        }
      },
      "el-GR": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κύρια διεύθυνση email"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κύρια διεύθυνση email"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ονομα"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οικογενειακό όνομα"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποιήθηκε"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για ενεργοποίηση"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["κατάσταση"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρείες"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για απενεργοποίηση"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρείες"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Πληροφορίες χρήστη"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ονόματα"])}
        }
      },
      "he-IL": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["כתובת דוא＂ל ראשית"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["כתובת דוא＂ל ראשית"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם פרטי"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם משפחה"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מושבת"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחץ להפעלה"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["סטָטוּס"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חברות"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לחץ כדי להשבית"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מופעל"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חברות"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["מידע משתמש"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שמות"])}
        }
      },
      "ga-IE": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seoladh ríomhphoist bunscoile"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seoladh ríomhphoist bunscoile"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ainm"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ainm clainne"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Díghníomhachtaithe"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliceáil chun gníomhachtú"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stádas"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuideachtaí"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliceáil chun díghníomhachtú"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gníomhachtaithe"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuideachtaí"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faisnéis úsáideora"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ainmneacha"])}
        }
      },
      "ja-JP": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["プライマリメールアドレス"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["プライマリメールアドレス"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ファーストネーム"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["苗字"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["非アクティブ化"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["クリックしてアクティブ化"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状態"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["クリックして非アクティブ化します"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アクティブ化"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["企業"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザー情報"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名前"])}
        }
      },
      "hr-HR": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primarna adresa e-pošte"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primarna adresa e-pošte"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ime"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prezime"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirano"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za aktivaciju"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tvrtka"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za deaktiviranje"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiviran"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tvrtka"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacije o korisniku"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Imena"])}
        }
      },
      "lv-LV": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Galvenā e-pasta adrese"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Galvenā e-pasta adrese"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vārds"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uzvārds"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivizēts"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Noklikšķiniet, lai aktivizētu"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statusu"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompānijas"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Noklikšķiniet, lai deaktivizētu"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivizēts"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kompānijas"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informācija par lietotāju"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vārdi"])}
        }
      },
      "lt-LT": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagrindinis el. Pašto adresas"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagrindinis el. Pašto adresas"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pirmas vardas"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pavardė"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Išjungta"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spustelėkite, kad suaktyvintumėte"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statusas"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Spustelėkite, kad išjungtumėte"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suaktyvinta"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Įmonės"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vartotojo informacija"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vardai"])}
        }
      },
      "pt-PT": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Endereço de email primário"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Endereço de email primário"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primeiro nome"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sobrenome"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Desativado"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clique para ativar"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empresas"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clique para desativar"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativado"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empresas"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informação do usuário"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nomes"])}
        }
      },
      "ro-RO": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresa principala de email"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresa principala de email"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nume"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nume de familie"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dezactivat"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faceți clic pentru a activa"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stare"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["întreprindere"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Faceți clic pentru a dezactiva"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activat"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["întreprindere"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informații despre utilizator"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numele"])}
        }
      },
      "ru-RU": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Основной адрес электронной почты"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Основной адрес электронной почты"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фамилия"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Деактивировано"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нажмите, чтобы активировать"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["положение дел"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Компании"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нажмите, чтобы отключить"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активировано"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Компании"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Информация о пользователе"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имена"])}
        }
      },
      "sv-SE": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primär e-postadress"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primär e-postadress"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Förnamn"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Efternamn"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inaktiverad"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klicka för att aktivera"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företag"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Klicka för att inaktivera"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiverad"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Företag"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Användar information"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Namn"])}
        }
      },
      "sk-SK": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primárna e-mailová adresa"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primárna e-mailová adresa"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Krstné meno"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Priezvisko"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivované"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivujte kliknutím"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavenie"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podnik"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknutím deaktivujete"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivované"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Podnik"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informácie o užívateľovi"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mená"])}
        }
      },
      "cs-CZ": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primární e-mailová adresa"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primární e-mailová adresa"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jméno"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rodinné jméno"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivováno"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivujte kliknutím"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavení"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["společnost"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknutím deaktivujete"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivováno"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["společnost"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uživatelské informace"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jména"])}
        }
      },
      "tr-TR": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Birincil e-posta adresi"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Birincil e-posta adresi"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İsim"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soyadı"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakıldı"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktif etmek için TIKLAYINIZ"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Durum"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["şirket"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakmak için tıklayın"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["şirket"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı bilgisi"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İsimler"])}
        }
      },
      "hu-HU": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elsődleges e-mail cím"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elsődleges e-mail cím"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keresztnév"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Családnév"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktiválva"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kattintson az aktiváláshoz"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Állapot"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalat"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kattintson a deaktiváláshoz"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivált"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vállalat"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Felhasználói információ"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nevek"])}
        }
      },
      "ar-AE": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان البريد الإلكتروني الرئيسي"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان البريد الإلكتروني الرئيسي"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الاسم الأول"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اسم العائلة"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معطل"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انقر للتفعيل"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الحالة"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الشركات"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انقر لإلغاء التنشيط"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم التنشيط"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الشركات"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معلومات المستخدم"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الأسماء"])}
        }
      },
      "fr-BE": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail principale"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail principale"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivé"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour activer"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour désactiver"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations de l'utilisateur"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Des noms"])}
        }
      },
      "fr-LU": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail principale"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adresse e-mail principale"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Désactivé"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour activer"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquez pour désactiver"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activé"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entreprises"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations de l'utilisateur"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Des noms"])}
        }
      },
      "mt-MT": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indirizz tal-email primarju"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indirizz tal-email primarju"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isem"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isem tal-familja"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Diżattivat"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikklikkja biex tattiva"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kumpaniji"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikklikkja biex tiddiżattiva"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Attivat"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kumpaniji"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informazzjoni għall-utent"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ismijiet"])}
        }
      },
      "sl-SI": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primarni e-poštni naslov"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primarni e-poštni naslov"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ime"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Priimek"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Deaktivirano"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za aktivacijo"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stanje"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["podjetje"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kliknite za deaktiviranje"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktivirano"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["podjetje"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacije o uporabniku"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Imena"])}
        }
      },
      "el-CY": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κύρια διεύθυνση email"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κύρια διεύθυνση email"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ονομα"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οικογενειακό όνομα"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Απενεργοποιήθηκε"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για ενεργοποίηση"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["κατάσταση"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρείες"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Κάντε κλικ για απενεργοποίηση"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ενεργοποιήθηκε"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Εταιρείες"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Πληροφορίες χρήστη"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ονόματα"])}
        }
      },
      "tr-CY": {
        "email": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Birincil e-posta adresi"])}
        },
        "user": {
          "email": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Birincil e-posta adresi"])}
          },
          "name": {
            "given": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İsim"])}
            },
            "family": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soyadı"])}
            }
          },
          "companies": {
            "deactivated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakıldı"])}
            },
            "sp": {
              "company": {
                "id": {
                  "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SharePoint-GUID"])}
                }
              }
            },
            "pressToActivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktif etmek için TIKLAYINIZ"])}
              }
            },
            "status": {
              "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Durum"])}
            },
            "name": {
              "legal": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["şirket"])}
              }
            },
            "pressToDeactivate": {
              "tooltip": {
                "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Devre dışı bırakmak için tıklayın"])}
              }
            },
            "activated": {
              "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etkinleştirildi"])}
            }
          }
        },
        "userCompanies": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["şirket"])}
        },
        "userDetails": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı bilgisi"])}
        },
        "userName": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İsimler"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AdminSettings/UserDetails.vue



;
/* custom blocks */

if (typeof UserDetailsvue_type_custom_index_0_blockType_i18n === 'function') UserDetailsvue_type_custom_index_0_blockType_i18n(UserDetailsvue_type_script_setup_true_lang_js)


;
const UserDetails_exports_ = /*#__PURE__*/(0,exportHelper/* default */.Z)(UserDetailsvue_type_script_setup_true_lang_js, [['__scopeId',"data-v-c9e603f2"]])

/* harmony default export */ var UserDetails = (UserDetails_exports_);
;// CONCATENATED MODULE: ./src/routes/adminSettingsRoutes.js





var adminSettingsRoutes = [{
  path: '/admin-settings',
  component: AdminSettings,
  children: [{
    path: 'companies',
    component: CompanyAdministration
  }, {
    path: 'companies/:companyId',
    component: CompanyDetails,
    name: 'companyDetails',
    props: true
  }, {
    path: 'users',
    component: UserAdministration
  }, {
    path: 'users/:userId',
    component: UserDetails,
    name: 'userDetails',
    props: true
  }]
}];
/* harmony default export */ var routes_adminSettingsRoutes = (adminSettingsRoutes);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/reminder/ReminderSelectCompany.vue?vue&type=script&setup=true&lang=js



var ReminderSelectCompanyvue_type_script_setup_true_lang_js_hoisted_1 = {
  class: "text-align-center",
  style: {
    "margin": "2rem 1rem"
  }
};





var ReminderSelectCompany = {
  name: "ReminderSelectCompany",
  computed: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useCompanyStore, ['companies', 'areCompaniesFetched', 'hasCompanies', 'selectedCompany', 'hasSelectedCompany'])), {}, {
    companySwitch: function companySwitch() {
      var i18nLocale = this.$i18n.locale;

      var label = function label(row) {
        return isEmpty_default()(get_default()(row, "translations.name.legal.".concat(i18nLocale), undefined)) ? get_default()(row, "name.legal", undefined) : get_default()(row, "translations.name.legal.".concat(i18nLocale), undefined);
      };

      return {
        selectedCompany: {
          companyId: get_default()(this.selectedCompany, 'id', '')
        },
        companiesList: map_default()(this.companies, function (row) {
          return {
            label: label(row),
            companyId: row.id
          };
        })
      };
    },
    showReminder: function showReminder() {
      return !this.hasSelectedCompany && this.areCompaniesFetched && this.hasCompanies;
    }
  }),
  methods: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapActions)(store_modules_.useCompanyStore, ['setCompany'])), {}, {
    selectCompany: function selectCompany(companyId) {
      this.setCompany(companyId);
      location.reload();
    }
  })
};
var ReminderSelectCompanyvue_type_script_setup_true_lang_js_default_ = ReminderSelectCompany;

/* harmony default export */ var ReminderSelectCompanyvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(ReminderSelectCompanyvue_type_script_setup_true_lang_js_default_, {
  __name: 'ReminderSelectCompany',
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_el_option = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-option");

      var _component_el_select = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-select");

      var _component_DpReminder = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpReminder");

      return _ctx.showReminder ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpReminder, {
        key: 0,
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('headline.label'),
        description: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('description.label'),
        closable: false
      }, {
        extraContent: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementVNode)("div", ReminderSelectCompanyvue_type_script_setup_true_lang_js_hoisted_1, [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_el_select, {
            modelValue: _ctx.companySwitch.selectedCompany,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.companySwitch.selectedCompany = $event;
            }),
            "value-key": "companyId",
            onChange: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.selectCompany($event.companyId);
            }),
            filterable: "",
            "default-first-option": true,
            placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('company.placeholder'),
            "popper-class": "reminder__select-company__select__popper-dropdown"
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)(external_commonjs_vue_commonjs2_vue_root_Vue_.Fragment, null, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.renderList)(_ctx.companySwitch.companiesList, function (company, index) {
                return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_option, {
                  key: "company-switch-".concat(index),
                  label: company.label,
                  value: company
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue", "placeholder"])])];
        }),
        _: 1
      }, 8, ["headline", "description"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
    };
  }
}));
;// CONCATENATED MODULE: ./src/reminder/ReminderSelectCompany.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/reminder/ReminderSelectCompany.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function ReminderSelectCompanyvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bitte wähle ein Unternehmen aus"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wähle ein Unternehmen, dass deinem Benutzerkonto zugewiesen ist."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zugewiesene Unternehmen"])}
        }
      },
      "de-AT": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bitte wähle ein Unternehmen aus"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wähle ein Unternehmen, dass deinem Benutzerkonto zugewiesen ist."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zugewiesene Unternehmen"])}
        }
      },
      "de-CH": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bitte wähle ein Unternehmen aus"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wähle ein Unternehmen, dass deinem Benutzerkonto zugewiesen ist."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zugewiesene Unternehmen"])}
        }
      },
      "en-US": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please select a company"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choose a company that is assigned to your user account."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assigned companies"])}
        }
      },
      "en-GB": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please select a company"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choose a company that is assigned to your user account."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assigned companies"])}
        }
      },
      "it-IT": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona un'azienda"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scegli un'azienda assegnata al tuo account utente."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Società assegnate"])}
        }
      },
      "fr-FR": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez sélectionner une entreprise"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choisissez une société attribuée à votre compte utilisateur."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sociétés affectées"])}
        }
      },
      "es-ES": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccione una empresa"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Elija una empresa que esté asignada a su cuenta de usuario."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empresas asignadas"])}
        }
      },
      "pl-PL": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz firmę"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz firmę, która jest przypisana do Twojego konta użytkownika."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Przypisane firmy"])}
        }
      },
      "nl-NL": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecteer een bedrijf"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kies een bedrijf dat is toegewezen aan uw gebruikersaccount."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toegewezen bedrijven"])}
        }
      },
      "bg-BG": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Моля, изберете фирма"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Изберете компания, която е присвоена на вашия потребителски акаунт."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Възложени фирми"])}
        }
      },
      "bs-BA": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Molimo odaberite kompaniju"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izaberite kompaniju koja je dodijeljena vašem korisničkom računu."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodijeljene kompanije"])}
        }
      },
      "zh-CN": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择公司"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择分配给您的用户帐户的公司。"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["指定公司"])}
        }
      },
      "da-DK": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vælg et firma"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vælg et firma, der er tildelt din brugerkonto."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tildelte virksomheder"])}
        }
      },
      "et-EE": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valige ettevõte"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valige ettevõte, mis on määratud teie kasutajakontole."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Määratud ettevõtted"])}
        }
      },
      "fi-FI": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valitse yritys"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valitse yritys, joka on määritetty käyttäjätilillesi."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siirretyt yritykset"])}
        }
      },
      "el-GR": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιλέξτε εταιρεία"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιλέξτε μια εταιρεία που έχει αντιστοιχιστεί στο λογαριασμό χρήστη σας."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ανατεθείσες εταιρείες"])}
        }
      },
      "he-IL": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אנא בחר חברה"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["בחר חברה שמוקצה לחשבון המשתמש שלך."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["חברות שהוקצו"])}
        }
      },
      "ga-IE": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roghnaigh cuideachta le do thoil"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roghnaigh cuideachta atá sannta do do chuntas úsáideora."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cuideachtaí sannta"])}
        }
      },
      "ja-JP": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会社を選択してください"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ユーザーアカウントに割り当てられている会社を選択してください。"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["割り当てられた会社"])}
        }
      },
      "hr-HR": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odaberite tvrtku"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odaberite tvrtku koja je dodijeljena vašem korisničkom računu."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodijeljene tvrtke"])}
        }
      },
      "lv-LV": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lūdzu, izvēlieties uzņēmumu"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izvēlieties uzņēmumu, kas piešķirts jūsu lietotāja kontam."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Piešķirtie uzņēmumi"])}
        }
      },
      "lt-LT": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pasirinkite įmonę"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pasirinkite įmonę, kuri priskirta jūsų vartotojo paskyrai."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paskirtos įmonės"])}
        }
      },
      "pt-PT": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecione uma empresa"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Escolha uma empresa atribuída à sua conta de usuário."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Empresas atribuídas"])}
        }
      },
      "ro-RO": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vă rugăm să selectați o companie"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alegeți o companie care este alocată contului dvs. de utilizator."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Companii atribuite"])}
        }
      },
      "ru-RU": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пожалуйста, выберите компанию"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выберите компанию, которая привязана к вашей учетной записи."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Назначенные компании"])}
        }
      },
      "sv-SE": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Välj ett företag"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Välj ett företag som tilldelats ditt användarkonto."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tilldelade företag"])}
        }
      },
      "sk-SK": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte spoločnosť"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte spoločnosť, ktorá je priradená k vášmu používateľskému účtu."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pridelené spoločnosti"])}
        }
      },
      "cs-CZ": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte společnost"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte společnost, která je přiřazena k vašemu uživatelskému účtu."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přiřazené společnosti"])}
        }
      },
      "tr-TR": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lütfen bir şirket seçin"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı hesabınıza atanmış bir şirket seçin."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atanmış şirketler"])}
        }
      },
      "hu-HU": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Válasszon egy vállalatot"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Válasszon egy vállalatot, amely a felhasználói fiókjához van hozzárendelve."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kiosztott vállalatok"])}
        }
      },
      "ar-AE": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجاء تحديد شركة"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختر شركة تم تخصيصها لحساب المستخدم الخاص بك."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الشركات المعينة"])}
        }
      },
      "fr-BE": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez sélectionner une entreprise"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choisissez une société attribuée à votre compte utilisateur."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sociétés affectées"])}
        }
      },
      "fr-LU": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez sélectionner une entreprise"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choisissez une société attribuée à votre compte utilisateur."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sociétés affectées"])}
        }
      },
      "mt-MT": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jekk jogħġbok agħżel kumpanija"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agħżel kumpanija li hija assenjata għall-kont tal-utent tiegħek."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kumpaniji assenjati"])}
        }
      },
      "sl-SI": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izberite podjetje"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izberite podjetje, ki je dodeljeno vašemu uporabniškemu računu."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dodeljena podjetja"])}
        }
      },
      "el-CY": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιλέξτε εταιρεία"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιλέξτε μια εταιρεία που έχει αντιστοιχιστεί στο λογαριασμό χρήστη σας."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ανατεθείσες εταιρείες"])}
        }
      },
      "tr-CY": {
        "headline": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lütfen bir şirket seçin"])}
        },
        "description": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kullanıcı hesabınıza atanmış bir şirket seçin."])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Atanmış şirketler"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/reminder/ReminderSelectCompany.vue


/* custom blocks */
;
if (typeof ReminderSelectCompanyvue_type_custom_index_0_blockType_i18n === 'function') ReminderSelectCompanyvue_type_custom_index_0_blockType_i18n(ReminderSelectCompanyvue_type_script_setup_true_lang_js)


const ReminderSelectCompany_exports_ = ReminderSelectCompanyvue_type_script_setup_true_lang_js;

/* harmony default export */ var reminder_ReminderSelectCompany = (ReminderSelectCompany_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/AccountInformation/UserNameForm.vue?vue&type=script&setup=true&lang=js











var UserNameFormvue_type_script_setup_true_lang_js_default_ = {
  name: "UserNameForm",
  data: function data() {
    return {
      loading: false,
      userName: {
        given: "",
        family: "",
        additional: ""
      }
    };
  },
  computed: _objectSpread2(_objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useAuthStore, ['user'])), (0,external_pinia_.mapState)(store_modules_.useEnvStore, ['apiUrls'])), {}, {
    editable: function editable() {
      return this.apiUrls && this.apiUrls.dutypay && this.user && this.user.id;
    }
  }),
  methods: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapActions)(store_modules_.useAuthStore, ['refreshUser'])), {}, {
    setLoading: function setLoading() {
      this.loading = true;
      this.$emit('emit-loading', this.loading);
    },
    unsetLoading: function unsetLoading() {
      this.loading = false;
      this.$emit('emit-loading', this.loading);
    },
    closeForm: function closeForm() {
      this.getUser();
      this.$emit('trigger-form-saved');
    },
    saveUser: function saveUser() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var err, res, _yield$to, _yield$to2;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.editable) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.setLoading();

                _context.next = 5;
                return (0,external_await_to_js_.to)(_this.$http.patch("".concat(_this.apiUrls.dutypay) + '/api/v0/users/' + _this.user.id, {
                  accountSetupCompleted: true,
                  name: _this.userName
                }));

              case 5:
                _yield$to = _context.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];
                // TODO: Refresh user object
                _this.loading = false;

                if (!err) {
                  _context.next = 12;
                  break;
                }

                throw err;

              case 12:
                _this.unsetLoading();

                return _context.abrupt("return", res);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getUser: function getUser() {
      this.userName = this.user.name;
      this.$emit('emit-data', this.userName);
    }
  }),
  created: function created() {
    this.$emit('emit-labels', this.labels);
  },
  mounted: function mounted() {
    this.getUser();
  }
};

/* harmony default export */ var UserNameFormvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(UserNameFormvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_DpFeedforward = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpFeedforward");

      var _component_DpInputCustom = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpInputCustom");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_DpForm = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpForm");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [!_ctx.editable ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpFeedforward, {
        key: 0,
        type: "error",
        title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('feedforward.error.title'),
        message: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('feedforward.error.message')
      }, null, 8, ["title", "message"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpForm, {
        modelValue: _ctx.userName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(userName) ? userName.value = $event : null;
        }),
        action: _ctx.saveUser,
        reference: "userName"
      }, (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createSlots)({
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpInputCustom, {
            value: _ctx.userName.given,
            tooltip: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.given.tooltip.label'),
            placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.given.placeholder.label'),
            label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.given.label'),
            required: ""
          }, null, 8, ["value", "tooltip", "placeholder", "label"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpInputCustom, {
            value: _ctx.userName.additional,
            tooltip: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.additional.tooltip.label'),
            placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.additional.placeholder.label'),
            label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.additional.label'),
            required: ""
          }, null, 8, ["value", "tooltip", "placeholder", "label"]), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpInputCustom, {
            value: _ctx.userName.family,
            tooltip: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.family.tooltip.label'),
            placeholder: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.family.placeholder.label'),
            label: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('userName.family.label'),
            required: ""
          }, null, 8, ["value", "tooltip", "placeholder", "label"])];
        }),
        _: 2
      }, [_ctx.user.firstName && _ctx.user.lastName ? {
        name: "secondaryButton",
        fn: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_dp_button, {
            purpose: "secondaryAction",
            onClick: _ctx.closeForm
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('cancel.buttonLabel')), 1)];
            }),
            _: 1
          }, 8, ["onClick"])];
        })
      } : undefined]), 1032, ["modelValue", "action"])), [[_directive_loading, _ctx.loading]])]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/AccountSettings/AccountInformation/UserNameForm.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/AccountSettings/AccountInformation/UserNameForm.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function UserNameFormvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorname"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familienname"])}
          }
        }
      },
      "de-AT": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorname"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familienname"])}
          }
        }
      },
      "de-CH": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vorname"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familienname"])}
          }
        }
      },
      "en-US": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Given name"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Family name"])}
          }
        }
      },
      "en-GB": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Given name"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Family name"])}
          }
        }
      },
      "it-IT": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nome di battesimo"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cognome"])}
          }
        }
      },
      "fr-FR": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])}
          }
        }
      },
      "es-ES": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre propio"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Apellido"])}
          }
        }
      },
      "pl-PL": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Imię"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwisko rodowe"])}
          }
        }
      },
      "nl-NL": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voornaam"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Achternaam"])}
          }
        }
      },
      "bg-BG": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Първо име"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фамилно име"])}
          }
        }
      },
      "bs-BA": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ime"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prezime"])}
          }
        }
      },
      "zh-CN": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["姓"])}
          }
        }
      },
      "da-DK": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fornavn"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Familie navn"])}
          }
        }
      },
      "et-EE": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eesnimi"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Perekonnanimi"])}
          }
        }
      },
      "fi-FI": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Etunimi"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sukunimi"])}
          }
        }
      },
      "el-GR": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ονομα"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οικογενειακό όνομα"])}
          }
        }
      },
      "he-IL": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם פרטי"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["שם משפחה"])}
          }
        }
      },
      "ga-IE": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ainm"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ainm clainne"])}
          }
        }
      },
      "ja-JP": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ファーストネーム"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["苗字"])}
          }
        }
      },
      "hr-HR": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ime"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prezime"])}
          }
        }
      },
      "lv-LV": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vārds"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Uzvārds"])}
          }
        }
      },
      "lt-LT": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pirmas vardas"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pavardė"])}
          }
        }
      },
      "pt-PT": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Primeiro nome"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sobrenome"])}
          }
        }
      },
      "ro-RO": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nume"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nume de familie"])}
          }
        }
      },
      "ru-RU": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фамилия"])}
          }
        }
      },
      "sv-SE": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Förnamn"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Efternamn"])}
          }
        }
      },
      "sk-SK": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Krstné meno"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Priezvisko"])}
          }
        }
      },
      "cs-CZ": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jméno"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rodinné jméno"])}
          }
        }
      },
      "tr-TR": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İsim"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soyadı"])}
          }
        }
      },
      "hu-HU": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keresztnév"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Családnév"])}
          }
        }
      },
      "ar-AE": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الاسم الأول"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اسم العائلة"])}
          }
        }
      },
      "fr-BE": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])}
          }
        }
      },
      "fr-LU": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prénom"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom de famille"])}
          }
        }
      },
      "mt-MT": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isem"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Isem tal-familja"])}
          }
        }
      },
      "sl-SI": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ime"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Priimek"])}
          }
        }
      },
      "el-CY": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ονομα"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Οικογενειακό όνομα"])}
          }
        }
      },
      "tr-CY": {
        "userName": {
          "given": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İsim"])}
          },
          "family": {
            "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soyadı"])}
          }
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/AccountSettings/AccountInformation/UserNameForm.vue


/* custom blocks */
;
if (typeof UserNameFormvue_type_custom_index_0_blockType_i18n === 'function') UserNameFormvue_type_custom_index_0_blockType_i18n(UserNameFormvue_type_script_setup_true_lang_js)


const UserNameForm_exports_ = UserNameFormvue_type_script_setup_true_lang_js;

/* harmony default export */ var UserNameForm = (UserNameForm_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/reminder/ReminderEnterUserName.vue?vue&type=script&setup=true&lang=js






var ReminderEnterUserName = {
  name: "ReminderEnterUserName",
  components: {
    UserNameForm: UserNameForm
  },
  computed: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useAuthStore, ['hasUserName', 'isUserFetched'])), {}, {
    showReminder: function showReminder() {
      return this.isUserFetched && !this.hasUserName;
    }
  })
};
var ReminderEnterUserNamevue_type_script_setup_true_lang_js_default_ = ReminderEnterUserName;

/* harmony default export */ var ReminderEnterUserNamevue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(ReminderEnterUserNamevue_type_script_setup_true_lang_js_default_, {
  __name: 'ReminderEnterUserName',
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_DpReminder = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpReminder");

      return _ctx.showReminder ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpReminder, {
        key: 0,
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('headline.label'),
        description: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('description.label'),
        closable: false
      }, {
        extraContent: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(UserNameForm))];
        }),
        _: 1
      }, 8, ["headline", "description"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
    };
  }
}));
;// CONCATENATED MODULE: ./src/reminder/ReminderEnterUserName.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/reminder/ReminderEnterUserName.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function ReminderEnterUserNamevue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      
    }
  })
}

;// CONCATENATED MODULE: ./src/reminder/ReminderEnterUserName.vue


/* custom blocks */
;
if (typeof ReminderEnterUserNamevue_type_custom_index_0_blockType_i18n === 'function') ReminderEnterUserNamevue_type_custom_index_0_blockType_i18n(ReminderEnterUserNamevue_type_script_setup_true_lang_js)


const ReminderEnterUserName_exports_ = ReminderEnterUserNamevue_type_script_setup_true_lang_js;

/* harmony default export */ var reminder_ReminderEnterUserName = (ReminderEnterUserName_exports_);
// EXTERNAL MODULE: ./node_modules/lodash/indexOf.js
var indexOf = __webpack_require__(3651);
var indexOf_default = /*#__PURE__*/__webpack_require__.n(indexOf);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/CompanyInformation/BasicInformation/CompanyLegalNameForm.vue?vue&type=script&setup=true&lang=js













var CompanyLegalNameFormvue_type_script_setup_true_lang_js_default_ = {
  name: "CompanyLegalNameForm",
  props: {
    required: {
      type: Array
    }
  },
  data: function data() {
    return {
      loading: false,
      basicInformation: {
        legalName: ''
      },
      labels: {
        legalName: ''
      }
    };
  },
  computed: _objectSpread2(_objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useEnvStore, ['apiUrls'])), (0,external_pinia_.mapState)(store_modules_.useCompanyStore, ['selectedCompany', 'hasSelectedCompany', 'hasCompanies'])), {}, {
    companyId: function companyId() {
      return this.selectedCompany.id || undefined;
    },
    editable: function editable() {
      return !this.hasCompanies && !this.hasSelectedCompany || this.hasSelectedCompany && this.selectedCompany.id && this.apiUrls && this.apiUrls.dutypay;
    },
    getInformation: function getInformation() {
      return this.hasSelectedCompany && this.selectedCompany.id && this.apiUrls && this.apiUrls.dutypay;
    }
  }),
  methods: {
    setLoading: function setLoading() {
      this.loading = true;
      this.$emit('emit-loading', this.loading);
    },
    unsetLoading: function unsetLoading() {
      this.loading = false;
      this.$emit('emit-loading', this.loading);
    },
    closeForm: function closeForm() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.getBasicInformation();

              case 2:
                _this.$emit('trigger-form-saved');

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getFormInput: function getFormInput() {
      return {
        name: {
          legal: this.basicInformation.legalName
        }
      };
    },
    saveBasicInformation: function saveBasicInformation() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var err, res, _yield$to, _yield$to2, _yield$to3, _yield$to4;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.setLoading();

                if (!(_this2.companyId !== undefined)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 4;
                return (0,external_await_to_js_.to)(_this2.$http.patch("".concat(_this2.apiUrls.dutypay, "/api/v0/companies/").concat(_this2.companyId), _this2.getFormInput));

              case 4:
                _yield$to = _context2.sent;
                _yield$to2 = _slicedToArray(_yield$to, 2);
                err = _yield$to2[0];
                res = _yield$to2[1];
                _context2.next = 17;
                break;

              case 10:
                _context2.next = 12;
                return (0,external_await_to_js_.to)(_this2.$http.post("".concat(_this2.apiUrls.dutypay, "/api/v0/companies"), _this2.getFormInput));

              case 12:
                _yield$to3 = _context2.sent;
                _yield$to4 = _slicedToArray(_yield$to3, 2);
                err = _yield$to4[0];
                res = _yield$to4[1];

                _this2.$emit('emit-company-created', res.data.id);

              case 17:
                _this2.unsetLoading();

                if (!err) {
                  _context2.next = 20;
                  break;
                }

                throw err;

              case 20:
                _context2.next = 22;
                return _this2.closeForm();

              case 22:
                return _context2.abrupt("return", res);

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getBasicInformation: function getBasicInformation() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result, err, _yield$to5, _yield$to6;

        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.setLoading();

                _context3.next = 3;
                return (0,external_await_to_js_.to)(_this3.$http.get("".concat(_this3.apiUrls.dutypay, "/api/v0/companies/").concat(_this3.companyId)));

              case 3:
                _yield$to5 = _context3.sent;
                _yield$to6 = _slicedToArray(_yield$to5, 2);
                err = _yield$to6[0];
                result = _yield$to6[1];

                _this3.unsetLoading();

                if (!err) {
                  _context3.next = 12;
                  break;
                }

                throw err;

              case 12:
                _this3.basicInformation.legalName = result.data.name.legal || '';

                _this3.$emit('emit-data', _this3.basicInformation);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    isRequired: function isRequired(key) {
      if (this.required === undefined) return false;
      return indexOf_default()(this.required, key) !== -1;
    }
  },
  created: function created() {
    this.$emit('emit-labels', this.labels);
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!_this4.getInformation) {
                _context4.next = 3;
                break;
              }

              _context4.next = 3;
              return _this4.getBasicInformation();

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};

/* harmony default export */ var CompanyLegalNameFormvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(CompanyLegalNameFormvue_type_script_setup_true_lang_js_default_, {
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_el_alert = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("el-alert");

      var _component_DpInputCompanyLegalName = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpInputCompanyLegalName");

      var _component_dp_button = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("dp-button");

      var _component_DpForm = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpForm");

      var _directive_loading = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveDirective)("loading");

      return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createElementBlock)("div", null, [_ctx.editable ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_el_alert, {
        key: 0,
        title: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('feedforward.error.title'),
        type: "error",
        description: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('feedforward.error.message'),
        "show-icon": "",
        closable: false
      }, null, 8, ["title", "description"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withDirectives)(((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpForm, {
        modelValue: _ctx.basicInformation,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return (0,external_commonjs_vue_commonjs2_vue_root_Vue_.isRef)(basicInformation) ? basicInformation.value = $event : null;
        }),
        action: _ctx.saveBasicInformation,
        reference: "companyBasicInformation"
      }, {
        secondaryButton: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [!!_ctx.companyId ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_dp_button, {
            key: 0,
            purpose: "secondaryAction",
            onClick: _ctx.closeForm
          }, {
            default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
              return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createTextVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.toDisplayString)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('cancel.buttonLabel')), 1)];
            }),
            _: 1
          }, 8, ["onClick"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true)];
        }),
        default: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)(_component_DpInputCompanyLegalName, {
            modelValue: _ctx.basicInformation.legalName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.basicInformation.legalName = $event;
            }),
            prop: "legalName",
            required: "",
            tooltip: "",
            onLoad: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.labels.legalName = $event.label;
            })
          }, null, 8, ["modelValue"])];
        }),
        _: 1
      }, 8, ["modelValue", "action"])), [[_directive_loading, _ctx.loading]])]);
    };
  }
}));
;// CONCATENATED MODULE: ./src/pages/CompanySettings/CompanyInformation/BasicInformation/CompanyLegalNameForm.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/pages/CompanySettings/CompanyInformation/BasicInformation/CompanyLegalNameForm.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function CompanyLegalNameFormvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de-DE": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        }
      },
      "de-AT": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        }
      },
      "de-CH": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abbrechen"])}
        }
      },
      "en-US": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        }
      },
      "en-GB": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])}
        }
      },
      "it-IT": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annulla"])}
        }
      },
      "fr-FR": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        }
      },
      "es-ES": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])}
        }
      },
      "pl-PL": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anuluj"])}
        }
      },
      "nl-NL": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afbreken"])}
        }
      },
      "bg-BG": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прекратяване"])}
        }
      },
      "bs-BA": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        }
      },
      "zh-CN": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中止"])}
        }
      },
      "da-DK": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        }
      },
      "et-EE": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Katkesta"])}
        }
      },
      "fi-FI": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keskeyttää"])}
        }
      },
      "el-GR": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Αποβάλλω"])}
        }
      },
      "he-IL": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["לְהַפִּיל"])}
        }
      },
      "ga-IE": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ginmhilleadh"])}
        }
      },
      "ja-JP": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["アボート"])}
        }
      },
      "hr-HR": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekid"])}
        }
      },
      "lv-LV": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pārtraukt"])}
        }
      },
      "lt-LT": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nutraukti"])}
        }
      },
      "pt-PT": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abortar"])}
        }
      },
      "ro-RO": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abandonați"])}
        }
      },
      "ru-RU": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Прервать"])}
        }
      },
      "sv-SE": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avbryta"])}
        }
      },
      "sk-SK": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abort"])}
        }
      },
      "cs-CZ": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Přerušit"])}
        }
      },
      "tr-TR": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        }
      },
      "hu-HU": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mégse"])}
        }
      },
      "ar-AE": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إحباط"])}
        }
      },
      "fr-BE": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        }
      },
      "fr-LU": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])}
        }
      },
      "mt-MT": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ikkanċella"])}
        }
      },
      "sl-SI": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prekini"])}
        }
      },
      "el-CY": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Άκυρο"])}
        }
      },
      "tr-CY": {
        "cancel": {
          "buttonLabel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["İptal"])}
        }
      }
    }
  })
}

;// CONCATENATED MODULE: ./src/pages/CompanySettings/CompanyInformation/BasicInformation/CompanyLegalNameForm.vue


/* custom blocks */
;
if (typeof CompanyLegalNameFormvue_type_custom_index_0_blockType_i18n === 'function') CompanyLegalNameFormvue_type_custom_index_0_blockType_i18n(CompanyLegalNameFormvue_type_script_setup_true_lang_js)


const CompanyLegalNameForm_exports_ = CompanyLegalNameFormvue_type_script_setup_true_lang_js;

/* harmony default export */ var CompanyLegalNameForm = (CompanyLegalNameForm_exports_);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-84.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/reminder/ReminderEnterCompanyInformation.vue?vue&type=script&setup=true&lang=js






var ReminderEnterCompanyInformation = {
  name: "ReminderEnterCompanyInformation",
  components: {
    CompanyLegalNameForm: CompanyLegalNameForm
  },
  computed: _objectSpread2(_objectSpread2({}, (0,external_pinia_.mapState)(store_modules_.useCompanyStore, ['hasCompanies', 'areCompaniesFetched'])), {}, {
    showReminder: function showReminder() {
      return this.areCompaniesFetched && !this.hasCompanies;
    }
  }),
  methods: _objectSpread2({}, (0,external_pinia_.mapActions)(store_modules_.useCompanyStore, ['setCompany']))
};
var ReminderEnterCompanyInformationvue_type_script_setup_true_lang_js_default_ = ReminderEnterCompanyInformation;

/* harmony default export */ var ReminderEnterCompanyInformationvue_type_script_setup_true_lang_js = (/*#__PURE__*/Object.assign(ReminderEnterCompanyInformationvue_type_script_setup_true_lang_js_default_, {
  __name: 'ReminderEnterCompanyInformation',
  setup: function setup(__props) {
    var _useI18n = (0,external_vue_i18n_.useI18n)(),
        t = _useI18n.t;

    return function (_ctx, _cache) {
      var _component_DpReminder = (0,external_commonjs_vue_commonjs2_vue_root_Vue_.resolveComponent)("DpReminder");

      return _ctx.showReminder ? ((0,external_commonjs_vue_commonjs2_vue_root_Vue_.openBlock)(), (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createBlock)(_component_DpReminder, {
        key: 0,
        headline: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('headline.label'),
        description: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(t)('description.label'),
        closable: false
      }, {
        extraContent: (0,external_commonjs_vue_commonjs2_vue_root_Vue_.withCtx)(function () {
          return [(0,external_commonjs_vue_commonjs2_vue_root_Vue_.createVNode)((0,external_commonjs_vue_commonjs2_vue_root_Vue_.unref)(CompanyLegalNameForm), {
            onEmitCompanyCreated: _cache[0] || (_cache[0] = function ($event) {
              return _ctx.setCompany($event);
            })
          })];
        }),
        _: 1
      }, 8, ["headline", "description"])) : (0,external_commonjs_vue_commonjs2_vue_root_Vue_.createCommentVNode)("", true);
    };
  }
}));
;// CONCATENATED MODULE: ./src/reminder/ReminderEnterCompanyInformation.vue?vue&type=script&setup=true&lang=js
 
;// CONCATENATED MODULE: ./node_modules/@intlify/vue-i18n-loader/lib/index.js!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/reminder/ReminderEnterCompanyInformation.vue?vue&type=custom&index=0&blockType=i18n
/* harmony default export */ function ReminderEnterCompanyInformationvue_type_custom_index_0_blockType_i18n(Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      
    }
  })
}

;// CONCATENATED MODULE: ./src/reminder/ReminderEnterCompanyInformation.vue


/* custom blocks */
;
if (typeof ReminderEnterCompanyInformationvue_type_custom_index_0_blockType_i18n === 'function') ReminderEnterCompanyInformationvue_type_custom_index_0_blockType_i18n(ReminderEnterCompanyInformationvue_type_script_setup_true_lang_js)


const ReminderEnterCompanyInformation_exports_ = ReminderEnterCompanyInformationvue_type_script_setup_true_lang_js;

/* harmony default export */ var reminder_ReminderEnterCompanyInformation = (ReminderEnterCompanyInformation_exports_);
;// CONCATENATED MODULE: ./src/lib.js








;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=dutypay-settings-pages.umd.js.map